import { Component, ElementRef, HostListener, ViewChild, Directive, OnInit, OnDestroy } from '@angular/core';
import { BrowserProvider } from 'ethers';
import { DecimalCommaFixDirective } from '../directives/decimal-comma-fix.directive';
import { SwapApiService } from '../services/swap-api.service';
import { BridgeApiService } from '../services/bridge-api.service';
import { WalletService } from '../services/wallet.service';
import { WalletConnectorService } from '../services/wallet-connector.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { QuotePreviewComponent } from '../quote-preview/quote-preview.component';
import { QuotePreviewV2Component } from '../quote-preview/quote-preview-v2.component';
import { QuotePreviewComponentV3 } from '../quote-preview/quote-preview-v3.component';
import { QuotePreviewComponentV4 } from '../quote-preview/quote-preview-v4.component';
import { DebugTelemetryService } from '../core/debug-telemetry.service';
import { NgOptimizedImage } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router'; // 👈 AJOUT
import { ethers } from 'ethers';
import { parseUnits } from 'ethers';
import { JsonRpcProvider } from 'ethers';
import { Interface, hexlify } from 'ethers';
import { CtaParams } from '../seo/seo-content.service';
import { Input } from '@angular/core';
import { isAddress } from 'ethers';
import { ZeroAddress } from 'ethers';
import { AfterViewInit } from '@angular/core';
import { Contract, formatUnits, toBigInt } from 'ethers';
import ABI from '../abis/FillOrder.json';
import { SettingsComponent } from '../settings/settings.component';
import SignClient from "@walletconnect/sign-client";
import { async, firstValueFrom } from 'rxjs';
import { encodePermitSingle } from './permit2-helpers';
import { Subscription } from 'rxjs';
import { PriceService } from '../services/price.service';
import { environment } from '../../environments/environment';
import { BlurOnClickDirective } from '../directives/blur-on-click.directive';
import { ActivatedRoute } from '@angular/router';
import { Params } from '@angular/router';
import { TokenSelectorComponent } from '../token-selector/token-selector.component';
import { SideNavComponent } from '../side-nav/side-nav.component';
import { TypedDataDomain } from 'ethers';
import { timeout } from 'rxjs/operators';
import { DeeplinkGate } from '../services/deeplink-gate';
import { BalanceValidatorService } from '../services/balance-validator.service';
import { WalletConnectV2Service } from '../services/walletconnect-v2.service';
import { NativeTokenPriceService } from '../services/native-token-price.service';
import { WalletGatekeeperService } from '../services/wallet-gatekeeper.service';
import type { UniversalSeoResolved } from '../seo/seo-universal.resolver';
import { TOKENS_SSR_KEY, CHAIN_SSR_KEY } from '../resolvers/tokens.resolver';
import { isPlatformBrowser } from '@angular/common';
import { makeStateKey, TransferState } from '@angular/core';
import { FooterNavComponent } from '../footer-nav/footer-nav.component';
import { Inject, PLATFORM_ID } from '@angular/core';
import { ConnectWalletLegacyComponent } from '../connect-wallet/connect-wallet-legacy.component';
import { TokenPortfolioCacheService } from '../services/token-portfolio-cache.service';
import {
  PERMIT2_ADDRESS,
  PermitSingle,
  AllowanceTransfer
} from '@uniswap/permit2-sdk';
import { ChangeDetectorRef, NgZone } from '@angular/core';
import ERC20_ABI from '../abis/ERC20.json'; // Minimal ERC-20 ABI
import { createAppKit } from '@reown/appkit';
// imports à ajouter
import { AppSeoService } from '../seo/seo.service';       // ton service meta (ou équivalent)
import { SeoContentService, ResolvedSeo } from '../seo/seo-content.service';
import { DomSanitizer } from '@angular/platform-browser';


// ou simplement: let appKit: any;  // si tu veux être pragmatique

import { EthersAdapter } from '@reown/appkit-adapter-ethers';
import * as net from '@reown/appkit/networks'
import * as networks from '@reown/appkit/networks';

// Ethers v6: Transaction* types are top-level exports (no `providers` namespace)
type TxResponse = import('ethers').TransactionResponse;
type TxRequest = import('ethers').TransactionRequest;

// If you ever need to compile against ethers v5 types instead, use:
// import type { TransactionResponse as V5TxResponse,
//               TransactionRequest  as V5TxRequest } from '@ethersproject/abstract-provider';
// type TxResponse = V5TxResponse;
// type TxRequest  = V5TxRequest;
// ─────────────────────────────────────────────────────────────
// Helpers globaux d’armement / cooldown deeplink (parité Bridge)
// ─────────────────────────────────────────────────────────────
function safeJson(obj: any, depth: number = 2): string {
  const seen = new WeakSet();
  const recur = (value: any, level: number): any => {
    if (value === null || typeof value !== 'object') return value;
    if (seen.has(value)) return '[Circular]';
    if (level <= 0) return '[MaxDepth]';
    seen.add(value);

    if (Array.isArray(value)) {
      return value.slice(0, 10).map(v => recur(v, level - 1));
    }

    const out: any = {};
    Object.keys(value).slice(0, 20).forEach(k => {
      try {
        out[k] = recur((value as any)[k], level - 1);
      } catch {
        out[k] = '[Error]';
      }
    });
    return out;
  };

  try {
    return JSON.stringify(recur(obj, depth), null, 2);
  } catch {
    return '[Unserializable]';
  }
}
function balanceKey(address: string, chainId: number): string {
  return `${(address || '').toLowerCase()}_${chainId}`;
}
export function setAllowWcDeeplinkFor(ms = 12_000): void {
  try {
    const until = Date.now() + ms;
    sessionStorage.setItem('st/allowWcDeeplinkUntil', String(until));
  } catch { /* noop */ }
}
export function clearAllowWcDeeplink(): void {
  try {
    sessionStorage.removeItem('st/allowWcDeeplinkUntil');
    // 🧹 important: on nettoie aussi l’ID d’autorisation lié au run
    sessionStorage.removeItem('st/allowWcRunId');
  } catch { /* noop */ }
}

const WC_QUOTE_COOLDOWN_MS = 4000;
// Logos locaux pour rendu instantané (au-dessus de la ligne de flottaison)
const LOCAL_TOKEN_LOGO: Record<string, string> = {
  USDC: 'assets/tokens/usdc.webp',
  ETH: 'assets/tokens/ethereum.webp',
  MATIC: 'assets/tokens/matic.png',
  BNB: 'assets/tokens/bnb.webp',
  USDT: 'assets/tokens/usdt.webp',     // ajoute le fichier si tu l’as
  // fallback générique si besoin
  UNKNOWN: 'assets/tokens/unknown-token.webp'
};

// Paires par défaut pour "hot start" selon le réseau
const HOT_START_DEFAULTS: Record<number, { sell: string; buy: string }> = {
  1: { sell: 'USDC', buy: 'ETH' }, // Ethereum
  42161: { sell: 'USDC', buy: 'ETH' }, // Arbitrum
  137: { sell: 'USDC', buy: 'MATIC' }, // Polygon (Inde plus tard)
  56: { sell: 'USDT', buy: 'BNB' }, // BNB Chain
};


// 🔎 Mapping régional minimal (langue navigateur → pays → chainId)
const REGIONAL_HOTSTART: Record<string, { chainId: number }> = {
  IN: { chainId: 137 }, // Inde → Polygon
  VN: { chainId: 56 }, // Vietnam → BNB Chain
  ID: { chainId: 56 }, // Indonésie → BNB Chain
};

function detectCountryFromLang(): string | null {
  try {
    const lang = (navigator?.language || navigator?.languages?.[0] || '').toUpperCase();
    // ex: "hi-IN", "vi-VN", "id-ID"
    const cc = lang.includes('-') ? lang.split('-')[1] : '';
    return cc || null;
  } catch { return null; }
}

function pickRegionalChainId(): number | null {
  const cc = detectCountryFromLang();
  const hit = cc ? REGIONAL_HOTSTART[cc] : undefined;
  return hit ? hit.chainId : null;
}

// Helper: muter une seule fois display_uri après hard reload
function setWcSuppressOnce(ms = 5000) {
  try {
    const until = Date.now() + ms;
    sessionStorage.setItem('st/suppressWcUriUntil', String(until));
    console.warn(`[WC] set suppress-once until=${until} (+${ms}ms)`);
  } catch { }
}






async function abortWalletConnectSoft(this: any, reason = 'quote-switch') {
  const log = (m: string, o?: any) =>
    this?.addLog ? this.addLog(`[WC][SOFT] ${m}${o ? ' ' + JSON.stringify(o) : ''}`) : console.warn('[WC][SOFT]', m, o ?? '');
  try {
    log('begin', { reason });
    try {
      await this.appKitModal?.close?.();
      log('modal.close ok');
    } catch (e: any) {
      log('modal.close error', { err: e?.message || String(e) });
    }

    // NE PAS disconnect()/delete pairings ici → on garde la session active
    // ❌ NE PLUS TOUCHER au flux global wcUri$ (on le garde pour debug et pour les prochains runs)
    try {
      this._wcShown = false;
      // On peut vider l'URI purement UI si tu veux forcer la modale à se refermer,
      // mais sans faire de .next(null) sur le Subject partagé.
      this.wcUri = '';
      log('ui uri reset (soft, wcUri$ conservé)');
    } catch { }

    log('end', { ok: true });
  } catch (e: any) {
    log('fatal', { err: e?.message || String(e) });
  }
}









async function abortWalletConnectSafely(this: any, reason = 'timeout') {
  const log = (m: string, o?: any) =>
    this?.addLog ? this.addLog(`[WC][ABORT] ${m}${o ? ' ' + JSON.stringify(o) : ''}`) : console.warn('[WC][ABORT]', m, o ?? '');

  try {
    log('begin', { reason });

    // 1) Fermer la modale si ouverte
    try {
      await this.appKitModal?.close?.();
      log('modal.close ok');
    } catch (e: any) {
      log('modal.close error', { err: e?.message || String(e) });
    }

    // 2) Déconnecter le provider (universal-provider)
    try {
      await this.wc?.disconnect?.();
      log('wc.disconnect ok');
    } catch (e: any) {
      log('wc.disconnect error', { err: e?.message || String(e) });
    }

    // 3) Nettoyer les pairings orphelins
    try {
      const sc: any =
        (this.wc as any)?._signClient ||
        (this as any).signClient ||
        (this as any).appKit?.signClient;

      if (!sc?.core?.pairing) {
        log('no signClient.pairing found → skip');
      } else {
        const raw =
          sc.core.pairing.getPairings?.() ||
          sc.core.pairing.pairings?.values?.() ||
          sc.pairing?.getAll?.() ||
          [];
        const list = Array.isArray(raw) ? raw : Array.from(raw || []);
        log('pairings.list', { count: list.length });

        for (const p of list) {
          const topic = p?.topic;
          try {
            await sc.core.pairing.delete?.(topic, { code: 5000, message: `abort:${reason}` });
            log('pairing.delete ok', { topic });
          } catch (e: any) {
            log('pairing.delete error', { topic, err: e?.message || String(e) });
          }
        }
      }
    } catch (e: any) {
      log('pairings cleanup error (outer)', { err: e?.message || String(e) });
    }

    // 4) Annuler toute proposal / pending request (best-effort)
    try {
      const sc: any =
        (this.wc as any)?._signClient ||
        (this as any).signClient ||
        (this as any).appKit?.signClient;

      const pendings =
        sc?.pendingRequest?.values?.() ||
        sc?.core?.history?.records?.values?.() ||
        [];
      const arr = Array.isArray(pendings) ? pendings : Array.from(pendings || []);
      if (arr.length) log('pending.clear maybe', { count: arr.length });
      // pas d’API standard cross-version → log only
    } catch (e: any) {
      log('pending cleanup error (outer)', { err: e?.message || String(e) });
    }

    // 5) Reset UI
    try {
      this._wcShown = false;
      this._wcLastUri = null;
      this._wcUri$?.next(null);
      try { sessionStorage.removeItem('st/wcLastUri'); } catch { }
      log('ui reset done');
    } catch { }

    // 6) Programmer la suppression de display_uri juste après reload
    setWcSuppressOnce(5000);
    log('suppress-once set (5s)');

    log('end', { ok: true, reason });
  } catch (e: any) {
    log('fatal error', { err: e?.message || String(e) });
  }
}

const FEEDS: Record<number, string> = {
  1: "0x5f4eC3Df9cbd43714FE2740f5E3616155c5b8419", // ETH/USD
  42161: "0x639Fe6ab55C921f74e7fac1ee960C0B6293ba612", // Arbitrum ETH/USD
  137: "0xab594600376ec9fd91f8e885dadf0ce036862de0", // Polygon MATIC/USD
  10: "0x13e3ee699d1909e989722e753853ae30b17e08c5", // Optimism ETH/USD
  8453: "0x4d96b5df8d6794a3a3bf1a9e6519733b94e5b8a1", // Base ETH/USD
  43114: "0x0a77230d17318075983913bc2145db16c7366156", // Avalanche AVAX/USD
};


const FEED_ABI = [
  "function latestRoundData() view returns (uint80 roundId, int256 answer, uint256 startedAt, uint256 updatedAt, uint80 answeredInRound)",
  "function decimals() view returns (uint8)"
] as const;
function isL2Chain(id: number) {
  return [42161, 42170, 10, 8453, 84531, 59144, 7777777].includes(id);
}
// à mettre dans le même fichier que fetchQuote (ou util local)
function normalizeAltRoute(r: any, data: any, nativeUsd: number, debug: boolean = true) {
  console.log('[SWAP][ALT][NORM][IN]');
  const out = { ...r };
  const id =
    r?.providerName ||
    r?.tool ||
    r?.provider ||
    r?.routeId ||
    r?.id ||
    r?.name ||
    'alt';

  // ----  A. Flatten "received amount" ----
  const est = r?.estimate ?? r?.Estimate ?? r?.step?.estimate ?? null;
  const toTok = est?.toToken ?? r?.toToken ?? r?.action?.toToken ?? null;

  out.toAmountRaw = String(est?.toAmount ?? r?.toAmountRaw ?? 0);
  out.toAmountUsd = est?.toAmountUSD ?? r?.toAmountUsd ?? null;
  out.toTokenDecimals = Number(
    r?.toTokenDecimals ??
    toTok?.decimals ??
    data?.buyTokenDecimals ??
    data?.BuyTokenDecimals ??
    18
  );
  out.buyTokenSymbol =
    out.buyTokenSymbol ?? toTok?.symbol ?? data?.buyTokenSymbol ?? data?.BuyTokenSymbol;

  if (!out.formattedBuyAmount && out.toAmountRaw && out.toTokenDecimals >= 0) {
    out.formattedBuyAmount = Number(out.toAmountRaw) / Math.pow(10, out.toTokenDecimals);
  }

  // Prix unitaire USD du token reçu (pour la ligne "≈ ... USD")
  out.buyTokenUsdPrice = Number(
    out.buyTokenUsdPrice ?? data?.buyTokenUsdPrice ?? data?.BuyTokenUsdPrice ?? 0
  );

  // ----  B. Mirror des frais LiFi -> clés "lifi*" attendues par le template ----
  out.lifiEstimatedGas =
    out.lifiEstimatedGas ?? out.estimatedGas ?? out.EstimatedGas ?? est?.gasCosts?.[0]?.estimate ?? null;
  out.lifiGasPriceWei =
    out.lifiGasPriceWei ?? out.gasPriceWei ?? out.GasPriceWei ?? est?.gasCosts?.[0]?.price ?? null;
  out.lifiGasAmountWei =
    out.lifiGasAmountWei ?? out.gasAmountWei ?? out.GasAmountWei ?? est?.gasCosts?.[0]?.amount ?? null;
  out.lifiGasFeeUsd =
    out.lifiGasFeeUsd ?? out.gasFeeUsd ?? out.GasFeeUsd ?? est?.gasCosts?.[0]?.amountUSD ?? null;
  out.lifiGasTokenPriceUsd =
    out.lifiGasTokenPriceUsd ??
    out.gasTokenPriceUsd ??
    out.GasTokenPriceUsd ??
    data?.gasTokenPriceUsd ??
    data?.GasTokenPriceUsd ??
    nativeUsd ??
    null;

  // --- DEBUG (avant flatten MM) ---
  if (debug) {
    console.log('[SWAP][ALT][NORM][IN]', id, {
      hasSingleRoutes: Array.isArray(r?.singleRoutes),
      singleRoutesLen: r?.singleRoutes?.length ?? 0,
      topLevel: {
        mmExpected: r?.mmExpectedNetworkFeeWei ?? null,
        mmNetwork: r?.mmNetworkFeeWei ?? null,
        mmMax: r?.mmMaxNetworkFeeWei ?? null,
      },
      sr0: {
        mmExpected: r?.singleRoutes?.[0]?.mmExpectedNetworkFeeWei ?? null,
        mmNetwork: r?.singleRoutes?.[0]?.mmNetworkFeeWei ?? null,
        mmMax: r?.singleRoutes?.[0]?.mmMaxNetworkFeeWei ?? null,
      },
    });
  }

  // ----  C. MM-like (gating) : remonter les champs depuis singleRoutes[0] si absents au niveau route ----
  const sr0 = r?.singleRoutes?.[0] ?? null;
  out.mmExpectedNetworkFeeWei =
    out.mmExpectedNetworkFeeWei ?? sr0?.mmExpectedNetworkFeeWei ?? r?.mmExpectedNetworkFeeWei ?? null;
  out.mmNetworkFeeWei =
    out.mmNetworkFeeWei ?? sr0?.mmNetworkFeeWei ?? r?.mmNetworkFeeWei ?? null;
  out.mmMaxNetworkFeeWei =
    out.mmMaxNetworkFeeWei ?? sr0?.mmMaxNetworkFeeWei ?? r?.mmMaxNetworkFeeWei ?? null;

  // (optionnel) symbol du gas token si utile côté UI/gating
  out.gasTokenSymbol = out.gasTokenSymbol ?? data?.gasTokenSymbol ?? data?.GasTokenSymbol ?? 'ETH';

  // --- DEBUG (après flatten MM) ---
  if (debug) {
    const price = Number(out.lifiGasTokenPriceUsd ?? nativeUsd ?? data?.gasTokenPriceUsd ?? 0);
    const toEth = (w: any) => {
      try {
        if (w == null) return 0;
        const n = typeof w === 'bigint' ? Number(w) : Number(String(w).startsWith('0x') ? BigInt(w) : Number(w));
        return n / 1e18;
      } catch { return 0; }
    };
    const expEth = toEth(out.mmExpectedNetworkFeeWei);
    const netEth = toEth(out.mmNetworkFeeWei);
    const maxEth = toEth(out.mmMaxNetworkFeeWei);
    console.log('[SWAP][ALT][NORM][OUT]', id, {
      mmExpectedWei: out.mmExpectedNetworkFeeWei ?? null,
      mmNetworkWei: out.mmNetworkFeeWei ?? null,
      mmMaxWei: out.mmMaxNetworkFeeWei ?? null,
      mmExpectedEth: expEth,
      mmNetworkEth: netEth,
      mmMaxEth: maxEth,
      mmExpectedUsd: expEth > 0 && price ? expEth * price : null,
      reason:
        (out.mmExpectedNetworkFeeWei ? 'expected_at_route' :
          sr0?.mmExpectedNetworkFeeWei ? 'expected_from_sr0' :
            out.mmNetworkFeeWei ? 'fallback_mmNetwork' :
              out.mmMaxNetworkFeeWei ? 'fallback_mmMax' : 'missing_all'),
    });
  }

  return out;
}

// Helpers de typage
type Ongoing = 'pending' | 'approve';
type Terminal = 'success' | 'error' | 'cancelled';

function isOngoing(s: SwapStatus): s is Ongoing {
  return s === 'pending' || s === 'approve';
}
function isTerminal(s: SwapStatus): s is Terminal {
  return s === 'success' || s === 'error' || s === 'cancelled';
}


export async function getOnChainNativeUsd(chainId: number, provider: ethers.Provider): Promise<number | null> {
  try {
    const feedAddr = FEEDS[chainId];
    if (!feedAddr) return null;

    const feed = new ethers.Contract(feedAddr, FEED_ABI, provider);

    // ✅ Utiliser l’index signature
    const round = await feed["latestRoundData"]();
    const answer = round[1] as bigint;              // int256 → bigint en ethers v6
    const decimals = Number(await feed["decimals"]());

    if (answer <= 0n) return null;

    return Number(answer) / 10 ** decimals;
  } catch (e) {
    console.warn("[Chainlink] getOnChainNativeUsd failed:", e);
    return null;
  }
}

// --- Helpers gas/fees (ajouter hors classe) ---
export function sanitizeTxForWallet<T extends Record<string, any>>(tx: T): T {
  // retire tout ce qui “suggère par le site”
  const { gas, gasLimit, gasPrice, maxFeePerGas, maxPriorityFeePerGas, type, ...rest } = tx || {};
  return { ...rest } as T;
}

function hexToBigIntSafe(h?: string | null): bigint {
  try { return h ? BigInt(h) : 0n; } catch { return 0n; }
}

export async function getSuggestedEip1559Price(
  provider: ethers.Provider,
  speed: "slow" | "medium" | "fast" = "slow"
): Promise<{ priceWei: bigint; baseFeeWei: bigint; priorityWei: bigint; factor: number }> {

  // 1) Base fee du dernier bloc
  const rpc = provider as unknown as ethers.JsonRpcProvider;
  const latest = await rpc.send("eth_getBlockByNumber", ["latest", false]);
  const baseFeeWei = hexToBigIntSafe(latest?.baseFeePerGas);
  if (baseFeeWei === 0n) {
    // Chaîne sans EIP-1559 -> fallback eth_gasPrice
    const gasPriceHex = await rpc.send("eth_gasPrice", []);
    const gp = hexToBigIntSafe(gasPriceHex);
    return { priceWei: gp, baseFeeWei: 0n, priorityWei: 0n, factor: 1.0 };
  }

  // 2) Priority (tip)
  let priorityWei = 0n;
  try {
    const tipHex = await rpc.send("eth_maxPriorityFeePerGas", []);
    priorityWei = hexToBigIntSafe(tipHex);
  } catch {
    // RPC ne supporte pas -> plancher 1 gwei
    priorityWei = 1_000_000_000n;
  }

  // 3) Facteur selon la vitesse désirée
  const factor = speed === "fast" ? 1.5 : speed === "medium" ? 1.2 : 1.10;

  // 4) Prix suggéré = base * facteur + tip
  // (arrondi en bigint)
  const priceWei = (baseFeeWei * BigInt(Math.round(factor * 100))) / 100n + priorityWei;

  return { priceWei, baseFeeWei, priorityWei, factor };
}

// ---- SessionStore ultra simple ----------------------------------------------
const ST_SESSION_KEY = 'st/session/v1';

type SimpleSession = {
  address: string;
  chainId: number;
  providerType?: string; // (facultatif: 'walletconnect' | 'injected' etc.)
  ts: number;            // timestamp pour debug
};
let signClient: any;
async function initSignClient() {
  signClient = await SignClient.init({
    projectId: "ton_project_id_wc",
    relayUrl: "wss://relay.walletconnect.com",
    metadata: {
      name: "SwapTokens",
      description: "SwapTokens App",
      url: "https://swaptokens.app",
      icons: ["https://swaptokens.app/logo.png"],
    },
  });
}

// 🔌 1) Débrancher toutes les sessions & pairings WC v2
async function killWalletConnectV2(client?: SignClient) {
  try {
    if (!client) return;

    const sessions = client.session?.getAll?.() ?? [];
    for (const s of sessions) {
      await client.disconnect({
        topic: s.topic,
        reason: { code: 6000, message: 'USER_DISCONNECTED' }
      }).catch(() => { });
    }

    const pairings = client.core?.pairing?.getPairings?.() ?? [];
    for (const p of pairings) {
      await client.core?.pairing?.disconnect({ topic: p.topic }).catch(() => { });
    }
  } catch { }
}
// Fallbacks connus par chaîne (complets si tu veux)
const FALLBACK_TOKEN_ADDRESSES: Record<number, Record<string, string>> = {
  1: { // Ethereum
    USDT: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    USDC: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48'
  },
  137: { // Polygon
    USDT: '0xC2132D05D31c914a87C6611C10748AEb04B58e8F',
    // USDC natif (Circle)
    USDC: '0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359',
    // USDC bridgé (ex-USDC.e)
    'USDC.E': '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174'
  },
  42161: { // Arbitrum
    USDT: '0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9',
    USDC: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831'
  },
  56: { // BNB Chain
    USDT: '0x55d398326f99059fF775485246999027B3197955'
  }
};

// 🧹 2) Purger l’IndexedDB (WalletConnect/AppKit)
async function purgeWCIndexedDB() {
  try {
    // @ts-ignore
    const dbs = await indexedDB.databases?.();
    if (!dbs) return;
    for (const db of dbs) {
      const name = (db.name || '').toLowerCase();
      if (name.includes('walletconnect') || name.includes('appkit') || name.includes('wagmi')) {
        await new Promise<void>(res => {
          const req = indexedDB.deleteDatabase(db.name!);
          req.onsuccess = req.onerror = req.onblocked = () => res();
        });
      }
    }
  } catch { }
}

// 🧯 3) Teardown AppKit/modal pour stopper la réhydratation
function teardownAppKit(modal?: any) {
  try { modal?.removeAllListeners?.(); } catch { }
  (window as any).walletConnectProvider = undefined;
}

function loadSimpleSession(): SimpleSession | null {
  const raw = localStorage.getItem(ST_SESSION_KEY);
  if (!raw) return null;
  try { return JSON.parse(raw); } catch { return null; }
}
async function backupSession() {
  const sessions = signClient.session.getAll();
  if (sessions.length > 0) {
    const session = sessions[0];
    localStorage.setItem("wc_session_backup", JSON.stringify(session));
    console.log("💾 Session backup:", session.topic, session.expiry);
  } else {
    console.log("ℹ️ Pas de session active à sauvegarder");
  }
}
function saveSimpleSession(s: SimpleSession) {
  localStorage.setItem(ST_SESSION_KEY, JSON.stringify(s));
}
let modal: ReturnType<typeof createAppKit> | undefined;
function isEip1193(p: any): boolean {
  return !!p && typeof p.request === 'function';
}

function initAppKit(projectId: string) {
  if (modal) return;
  const adapter = new EthersAdapter();

  console.log('[APPKIT] init...');
  modal = createAppKit({
    adapters: [adapter],
    networks: [
      networks.mainnet,
      networks.arbitrum,
      networks.polygon,   // ✅ Polygon
      networks.bsc     // ✅ BNB Chain
    ],
    projectId,
    metadata: {
      name: 'SwapTokens',
      description: 'Swap & Bridge',
      url: 'https://swaptokens-zeta.vercel.app',
      icons: ['https://swaptokens-zeta.vercel.app/assets/icon-512.png']
    },
    // ⬇️ Désactive tout sauf les connexions “wallet”
    features: {
      analytics: true,   // garde si tu veux la télémétrie
      email: false,      // ❌ pas de login email
      socials: false,    // ❌ pas de login socials
      onramp: false,     // ❌ pas d'achat CB/on-ramp
      swaps: false,      // ❌ pas de swap intégré AppKit (tu as déjà ton flow)
      send: false        // ❌ pas de “send” AppKit
      // (ajoute d'autres flags présents dans ta version si besoin, tous à false)
    }
  });
  console.log('[APPKIT] ready');

  // ✅ expose globalement pour debug / rehydration
  (window as any).appKitModal = modal;

  // ✅ s'abonne aux events pour auto-réattache
  try {
    // Certaines versions émettent { type: 'CONNECT_SUCCESS' } ou { event: 'session_update' }
    (modal as any)?.subscribe?.((evt: any) => {
      try {
        const type = evt?.type || evt?.event || '(unknown)';
        console.log('[APPKIT][event]', type, evt);
        if (type === 'CONNECT_SUCCESS' || type === 'session_update') {
          console.log('[APPKIT] 🔁 trigger softReloadWalletSession()');
          // On relance la reconnexion silencieuse
          (window as any)?.ngComponentRef?.instance?.softReloadWalletSession?.(0);
        }
      } catch (e) {
        console.warn('[APPKIT][event] error', e);
      }
    });
  } catch (err) {
    console.warn('[APPKIT][subscribe] unavailable', err);
  }

  return modal; // ✅ renvoie toujours la même instance
}

const ALLOWANCE_TRANSFER_ABI = [
  "function permit(address owner, (address token,uint160 amount,uint48 expiration,uint48 nonce) details, address spender, uint256 sigDeadline, bytes signature)"
];

const tokenDecimalsMap: Record<string, number> = {
  ETH: 18,
  USDC: 6,
  USDT: 6,
  MATIC: 18,
  BNB: 18,
  // ajoute ici les tokens que tu utilises
};

const L = {
  d: (tag: string, ...v: any[]) => console.debug(`%c[DEBUG] ${tag}`, 'color:#7c3aed', ...v),
  i: (tag: string, ...v: any[]) => console.info(`%c[INFO ] ${tag}`, 'color:#10b981;font-weight:bold;', ...v),
  w: (tag: string, ...v: any[]) => console.warn(`%c[WARN ] ${tag}`, 'color:#eab308;font-weight:bold;', ...v),
  e: (tag: string, ...v: any[]) => console.error(`%c[ERROR] ${tag}`, 'color:#ef4444;font-weight:bold;', ...v),
};

export const OPENOCEAN_ROUTER = '0x6352a56caadC4F1E25CD6c75970Fa768A3304e64';

export const TOKEN_ADDRESS_MAP: Record<string, string> = {
  USDC: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
  USDT: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
  DAI: '0x6B175474E89094C44Da98b954EedeAC495271d0F',
  ETH: '0xC02aaa39b223FE8D0A0e5C4F27eAD9083C756Cc2',
  WBTC: '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599',
  MATIC: '0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0'
};
// swap.component.ts (en haut du fichier – hors de la classe)
export const CHAIN_MAP: Record<number, { icon: string; name: string }> = {
  1: { icon: 'assets/chains/ethereum-eth-logo.svg', name: 'Ethereum' },
  42161: { icon: 'assets/chains/arbitrum-arb-logo.svg', name: 'Arbitrum' },
  137: { icon: 'assets/chains/polygon-matic-logo.svg', name: 'Polygon' },
  56: { icon: 'assets/chains/bnb-bnb-logo.svg', name: 'BNB Chain' },
};

export function formatTokenAmount(value: number): string {
  if (value === 0) return '0';
  if (value >= 1) return value.toFixed(4).replace(/\.?0+$/, '');
  if (value >= 0.01) return value.toFixed(5).replace(/\.?0+$/, '');
  if (value >= 0.000001) return value.toFixed(7).replace(/\.?0+$/, '');
  return value.toExponential(2); // ex: 1.23e-6
}

export async function disconnectWallet(this: any, forceKill = true): Promise<void> {
  try {
    logStep('DISCONNECT-START');
    /* ----------------------------------------------------------------
     * 1️⃣  Réinitialiser l’état du composant
     * ---------------------------------------------------------------- */
    this.takerAddress = null;
    this.provider = null;
    /*this.quote = null;*/
    this.signature = null;
    this.session = null;          // ← ajoute

    /* ----------------------------------------------------------------
     * 2️⃣  Purger le stockage local
     * ---------------------------------------------------------------- */
    localStorage.removeItem('wallet');
    localStorage.removeItem('walletconnect');
    localStorage.removeItem('walletconnect_session');
    localStorage.removeItem('wc_session_id');   // ← ajoute
    sessionStorage.removeItem('WC_DEFAULT_SESSION');

    /* ----------------------------------------------------------------
     * 3️⃣  Déconnecter WalletConnect v2 (mobile & desktop)
     * ---------------------------------------------------------------- */
    const wc: any = (window as any).walletConnectProvider;
    if (wc) {
      try {
        wc.removeAllListeners?.();

        if (typeof wc.disconnect === 'function') {
          await wc.disconnect(forceKill);
        } else if (typeof wc.close === 'function') {
          await wc.close();
        }

        wc.connector?.killSession?.();
      } catch (err) {
        console.warn('[disconnectWallet] WC disconnect error', err);
      }
    }
    delete (window as any).walletConnectProvider; // ← garantit qu’on repart de zéro

    /* ----------------------------------------------------------------
     * 4️⃣  Déconnecter l’extension MetaMask (desktop)
     * ---------------------------------------------------------------- */
    const eth: any = (window as any).ethereum;
    if (eth) {
      eth.removeAllListeners?.();
      if (typeof eth.disconnect === 'function') {
        try {
          await eth.disconnect();
        } catch {/* certaines extensions n’implémentent pas .disconnect() */ }
      }
    }

    /* ----------------------------------------------------------------
     * 5️⃣  (Optionnel) notifier ton backend de supprimer la session
     * ---------------------------------------------------------------- */
    const storedSessionId = localStorage.getItem('wc_session_id');
    if (storedSessionId) {
      fetch(`https://walletconnect-api.vercel.app/api/session?sessionId=${storedSessionId}`, {
        method: 'DELETE'
      }).catch(() => {/* silencieux */ });
    }
    //this.chainId = null;
    //this.chainInfo = null;
    /* ----------------------------------------------------------------
     * 6️⃣  Feedback utilisateur
     * ---------------------------------------------------------------- */
    console.log('[disconnectWallet] fully disconnected');
    const msg = await firstValueFrom(this.translate.get('WALLET_DISCONNECTED'));
    logStep('DISCONNECT-DONE');
    alert(msg);


  } catch (error) {
    console.error('[disconnectWallet] error', error);
    const fallback = await firstValueFrom(this.translate.get('WALLET_DISCONNECT_ERROR'));
    alert(fallback);
  }
}



function logStep(tag: string, ...msg: any[]) {
  const now = new Date().toISOString().split('T')[1].slice(0, 8); // HH:MM:SS
  console.log(`[WC][${now}] ${tag}`, ...msg);
}

type SwapStatus = 'idle' | 'approve' | 'pending' | 'success' | 'error' | 'cancelled';
type CtaParamsCompat = CtaParams & { from?: string; to?: string; chain?: string };

export const TOKEN_DECIMALS_MAP: Record<string, number> = {
  USDC: 6,
  USDT: 6,
  DAI: 18,
  ETH: 18,
  WBTC: 8,
  MATIC: 18
};

const ZERO = '0x0000000000000000000000000000000000000000';
const toAddr = (x: any) => String(x ?? '').trim().toLowerCase();
const isAddr = (a?: string) => {
  const s = toAddr(a);
  return !!(s && s.startsWith('0x') && s.length === 42 && s !== ZERO);
};

function pickSellTokenAddress(route: any, quote: any, ui?: any): string {
  const cands = [
    // standards intégrateurs
    route?.sellTokenAddress,
    route?.inTokenAddress,
    route?.sellToken?.address,
    route?.tokenIn?.address,
    route?.inToken?.address,

    // variantes côté "quote"
    quote?.sellTokenAddress,
    quote?.inTokenAddress,
    quote?.sellToken?.address,
    quote?.tokenIn?.address,
    quote?.inToken?.address,

    // fallback UI (si tu as un state local)
    ui?.sellToken?.address,

    // ULTRA fallback: ce que ta simu utilise déjà si tu as un utilitaire interne
    // getSellTokenAddress(route) // <- si tu as déjà cette fonction ailleurs
  ].map(toAddr);



  return cands.find(isAddr) || '';
}

// swap.component.ts (en haut du fichier)
const PENDING_SWAP_TX_KEY = 'swap/pendingTx/v1';
@Directive({
  selector: '[appFocusScrollGuard]',
  standalone: true
})
export class FocusScrollGuardDirective {
  private y = 0;
  private locked = false;

  @HostListener('focusin')
  onFocus() {
    if (this.locked) return;
    this.y = window.scrollY || document.documentElement.scrollTop || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${this.y}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    this.locked = true;
  }

  @HostListener('focusout')
  onBlur() {
    if (!this.locked) return;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    this.locked = false;
    window.scrollTo(0, this.y);
  }
}
@Component({
  selector: 'app-swap',
  standalone: true,
  templateUrl: './swap.component.html',
  styleUrls: ['./swap.component.scss'],
  imports: [
    QuotePreviewComponentV4, QuotePreviewComponentV3, QuotePreviewV2Component,
    CommonModule, FormsModule, QuotePreviewComponent, TranslateModule, RouterModule,
    SettingsComponent, BlurOnClickDirective, TokenSelectorComponent, SideNavComponent,
    NgOptimizedImage,
    FooterNavComponent,  // 👈 NEW
    FocusScrollGuardDirective,
    ConnectWalletLegacyComponent,
    DecimalCommaFixDirective
  ]
})

export class SwapComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('footerMenuRoot', { static: false }) footerMenuRoot?: ElementRef;
  @ViewChild('settingsRoot', { static: false }) settingsRoot?: ElementRef;
  @ViewChild('networkRoot', { static: false }) networkRoot?: ElementRef;
  @ViewChild('networkBuyRoot', { static: false }) networkBuyRoot?: ElementRef;
  @ViewChild('chainTrigger', { static: false }) chainTrigger?: ElementRef;
  @ViewChild('chainMenuRoot', { static: false }) chainMenuRoot?: ElementRef;
  @ViewChild('footerHost', { static: false, read: ElementRef }) footerHost?: ElementRef<HTMLElement>;
  @ViewChild('legacyConnect') legacyConnect?: ConnectWalletLegacyComponent;

  disconnectWalletLegacy(reason: string = 'swap-component'): void {
    this.addLog?.(`[SWAP] disconnectWallet -> forward to ConnectWalletLegacy (${reason})`);

    this.legacyConnect?.disconnectWallet?.();
  }

  connectWalletLegacy(reason: string = 'swap-component'): void {
    this.addLog?.(`[SWAP] connectWallet -> forward to ConnectWalletLegacy (${reason})`);

    this.legacyConnect?.connectWallet?.();
  }

  onQuoteRequestConnect(): void {
    this.onChildLogConsole?.('[quote][connect] requestConnect -> legacyConnect.connectWallet()');

      // 🔐 lock connect (20s safety window)
        this.connectInFlight = true;
      this.connectInFlightUntil = Date.now() + 20_000;
      this.addLog('[CONNECT][flag] connectInFlight=true (quote CTA)');

    try {
      // ⚠️ adapte le nom exact de la méthode publique exposée par ConnectWalletLegacyComponent
      // souvent: connectWallet() / openConnect() / connect()
      (this.legacyConnect as any)?.connectWallet?.();
    } catch (e: any) {
      console.error('[quote][connect] legacyConnect.connectWallet ERROR', e);
           // rollback si exception immédiate
             this.connectInFlight = false;
           this.connectInFlightUntil = 0;
           this.addLog('[CONNECT][flag] rollback connectInFlight=false (error)');
    }
  }
  showDebug = false;
  debugLogs: string[] = [];
  mmBaseFeeWei: bigint = 0n;
  mmTipWei: bigint = 0n;
  mmUnitWei: bigint = 0n;
  mmBufferedGasLimit: bigint = 0n;



  public onChildLogConsole = (m: string, extra?: any) => {
    console.log('[PARENT]', m, extra ?? '');
    this.addLog?.(`[legacy] ${m}${extra ? ' ' + (JSON.stringify(extra).slice(0, 1000)) : ''}`);
  };


  public onChildLog = (m: string) => this.addLog(m);

  get debugText() { return this.debugLogs.join('\n'); }
  public addLog(m: string) {
    const stamp = new Date().toISOString().slice(11, 19);
    this.debugLogs.push(`[${stamp}] ${m}`);
    console.log(m);
  }
  isDebugCollapsed = false;
  isMMInApp: boolean = false;
  hasMMExt: boolean = false;
  isMobile: boolean = false;
  availableTokens: any[] = [];
  filteredSellTokens: any[] = [];
  filteredBuyTokens: any[] = [];
  userCachedTokens: any[] = [];
  popularCachedTokens: any[] = [];
  tokenCachedBalances: Record<string, string> = {};
  sellAmount = '1';
  sellTokenSymbol = 'USDC';
  buyTokenSymbol = 'ETH';
  sellTokenAddress: string = '';
  buyTokenAddress: string = '';
  takerAddress: string | null = null;
  quote: any;
  sellTokenSearch: string = '';
  buyTokenSearch: string = '';
  signature: string | null = null;
  provider: BrowserProvider | null = null;
  tokenAddressMap = TOKEN_ADDRESS_MAP;
  objectKeys = Object.keys;
  quoteErrorMessage: string | null = null;
  tokenBalances: Record<string, string> = {};
  showSettings = false;
  showChainMenu = false;
  showBuyDropdown = false;
  priceMap: Record<string, number> = {};
  defaultFiat = localStorage.getItem('currency') || 'EUR';
  fullGasWei: bigint = 0n;
  gasPriceWei: bigint = 0n;
  nativeTokenUsd: number = 0;
  isLoadingQuote = false;
  showFooterMenu = false;
  rawProvider: any = null;
  validatingKey: string | null = null;
  // --- Gestion WalletConnect / persistance ---
  /* ------------------ propriétés manquantes pour le template ----------------- */
  showWcModal = false;   // ← le template s’en sert pour afficher la modale
  wcUri = '';      // ← idem (QR + deep-link)
  private session: any;  // ← seulement si tu veux réutiliser la session plus tard
  private lastSimFailedKey: string | null = null;
  private failedAltKeys = new Set<string>();
  /* -------------------------------------------------------------------------- */
  isConnected: boolean = false;
  encodeURIComponent = encodeURIComponent;
  // --- Permit2 -------------------------------------------------------------
  permit?: PermitSingle;          // objet PermitSingle généré
  permitSig?: string;             // signature EIP-712 du permit
  ultraMode: boolean = false;

  private readonly enablePermit2: boolean = false; // coupe Permit2 côté swap

  swapStatus: SwapStatus = 'idle';

  swapHash: string | null = null;
  swapError: string | null = null;
  public showSellDropdown = false;
  private nfCache = new Map<string, Intl.NumberFormat>();
  readonly CHAIN_MAP = CHAIN_MAP;
  private allTokens: any[] = [];
  tokensLoaded = false;
  availableNetworks = ['ethereum', 'arbitrum', 'optimism', 'polygon', 'bsc'];
  selectedNetwork = 1;
  selectedBuyNetwork = 1;
  showNetworkDropdown = false;
  showNetworkBuyDropdown = false;
  fiatRates: Record<string, number> = { USD: 1 };
  swapDisabled = true;
  swapReasons: string[] = [];
  reasonLabels: Record<string, string> = {};
  tBase = '';
  editorialH1 = '';
  editorialBody = '';
  faqJsonLd: string | null = null;
  seoResolved?: ResolvedSeo; // si pas déjà présent
  seoChainId: number | null = null;
  selectedAltKey: string | null = null;
  selectedAlternative: any | null = null;
  headerBackdropColor = '#0b1220';
  currentNativeBalanceWei: bigint = 0n;
  debugBypassGasCheck: boolean = true;
  allChainIds: number[] | undefined;
  private readonly debug = false;
  toggleFooterMenu() { this.showFooterMenu = !this.showFooterMenu; }
  closeFooterMenu() { this.showFooterMenu = false; }
  // swap.component.ts
  public needsApprovalMain: boolean = false;
  public needsApprovalForAlt: (r: any) => boolean = () => false;
  // ⬇️ juste sous tes propriétés existantes
  isCriticalAboveTheFold = true;         // pour le logo/token au dessus de la ligne de flottaison
  tokenImgSize = 24;                     // largeur/hauteur fixes pour éviter le CLS
  readonly ZERO_WEI: bigint = 0n;
  // ⬇️ TrackBy pour listes (évite re-rendus inutiles)
  trackBySymbol(_i: number, t: any) { return t?.symbol || _i; }

  onLegacyConnected(e: { address: string; chainId: number; providerType: string; provider: any }) {
    // Si tu veux laisser le composant faire la persistance basique, ne touche à rien.
    // Si tu préfères, tu peux aussi refaire ici:
    // this.provider = new BrowserProvider(e.provider); etc.

    this.takerAddress = e.address;
    this.isConnected = true;
    this.rawProvider = e.provider;
    try { this.provider = new BrowserProvider(e.provider); } catch { this.addLog("onLegacyConnected error"); }
       // ✅ IMPORTANT:
          // Ne pas écraser la chain UI avec la chain du provider (souvent 1),
          // sinon portfolio se bind sur ETH et on croit que Polygon n'a pas de fonds.
        const currentCid = Number(this.chainId || 0);
        const preferredCid = currentCid || e.chainId;
        if (preferredCid !== e.chainId) {
            this.addLog?.(`[wallet] legacy-connected chain mismatch | providerCid=${e.chainId} preferredCid=${preferredCid}`);
         }
    this.setChain(preferredCid);
    try { this.refreshTokensForChain(); } catch { /* noop */ }
    this.resumeOpenProbe('wallet-connected');   // 👈 réactive la sonde
    this.cd.detectChanges();

        // ✅ Portfolio: binder + warmUp immédiatement après connexion (CTA ou non)
          this.bindPortfolioIfReady('legacy-connected');
    
          // 🔐 Si connexion initiée via CTA quote, on garde le mutex jusqu'à "warmUp done"
          if (this.connectInFlight) {
              const key = balanceKey(e.address, e.chainId);
              this._connectUnlockAfterPortfolioKey = key;
        
                // on laisse plus large que 20s au cas où RPC lent / mobile
                this.connectInFlightUntil = Math.max(this.connectInFlightUntil, Date.now() + 30_000);
        
               this.addLog?.(`[CONNECT][flag] keep connectInFlight=true until portfolio ready | key=${key}`);
            }
  }

  onLegacyDisconnected() {
    this.isConnected = false;
    this.takerAddress = null;
    this.pauseOpenProbe('wallet-disconnected'); // 👈 re-pause
    this.cd.detectChanges();
  }

   // 🔐 Connect mutex (anti double modal / iOS AppKit)
   private connectInFlight = false;
 private connectInFlightUntil = 0;

   private isConnectInFlight(): boolean {
     return this.connectInFlight && Date.now() < this.connectInFlightUntil;
   }


  private _runSeq = 0;
  // Guard anti-doublon : empêche de relancer 2 watchers receipt pour le même hash
  private _receiptWatchKeys = new Set<string>();

  // Guard anti-flicker : empêche de repasser "pending" si déjà success sur le même hash/run
  private _successKeys = new Set<string>();
  private _deeplinkOpenedForRun: number | null = null;
  private _deeplinkReopenTimer?: any;
  private _vvSpacerEl?: HTMLDivElement;
  private _vvCleanup?: () => void;

  private _lastQuoteClickAt = 0;

  private _ctaTimer?: any;

  /** Hauteur mesurée du footer (réservée en padding-bottom). */
  footerHpx = 72;

  /** Padding-bottom utilisé comme reverse-spacer : hauteur footer + safe-area. */
  get footerPaddingBottom(): string {
    // calc() pour intégrer les insets iOS/Android sans reflow JS
    return '0px';
  }


  @HostListener('window:resize')
  @HostListener('window:orientationchange')
  onWinResize() { setTimeout(() => this.measureFooter(), 50); }


  // ─────────────────────────────────────────────────────────────
  // APEX RULE: no auto-deeplink, wallet opens ONLY from user action
  // ─────────────────────────────────────────────────────────────
  private walletOpenedForRun: Record<number, boolean> = {};
  private canOpenWallet(runId: number): boolean {
    return !this.walletOpenedForRun[runId];
  }

  private markWalletOpened(runId: number) {
    this.walletOpenedForRun[runId] = true;
    this.addLog?.(`[WALLET][USER] opened for runId=${runId}`);
  }

  // Called ONLY from a user click (button)
  openWalletFromUserAction(runId: number) {
    if (!this.canOpenWallet(runId)) {
      this.addLog?.(`[WALLET][SKIP] already opened for runId=${runId}`);
      return;
    }

    this.markWalletOpened(runId);

    this.addLog?.(`[WALLET][OPEN] user-click → opening wallet (runId=${runId})`);

    // ⛔️ NO auto logic here, no timing, no heuristics
    // Just the explicit wallet open
    // KISS: infer phase from current state (no HTML change needed)
    let phase: 'apprv' | 'trx' = 'trx';
    try {
      const m: any = (this as any).walletModal;
      if (m?.phase === 'approve') phase = 'apprv';
      else if (m?.phase === 'tx') phase = 'trx';
    } catch { }
    // swapStatus has priority if present
    if (this.swapStatus === 'approve') phase = 'apprv';
    if (this.swapStatus === 'pending') phase = 'trx';

    +     this.foregroundWalletExplicit(runId, phase);
  }

  // Hard rule: explicit foreground only
  private foregroundWalletExplicit(runId: number, phase: 'apprv' | 'trx'): void {
    try {
      this.addLog?.(`[WALLET][fg] explicit user click -> MetaMask | runId=${runId} phase=${phase}`);
      // ✅ correct signature: (runId, phase)
      this.foregroundMetaMaskGeneric(runId, phase);
    } catch (e) {
      this.addLog?.(`[WALLET][ERROR] foreground failed: ${e}`);
    }
  }



  private normalizeAmountForApi(raw: any): { rawStr: string; apiStr: string; num: number | null } {
    const rawStr = (raw ?? '').toString().trim();

    // normalize comma -> dot
    const apiStr = rawStr.replace(/,/g, '.');

    // accept only one dot; if multiple, keep first and merge rest (best-effort)
    const parts = apiStr.split('.');
    const cleaned = parts.length > 2 ? (parts[0] + '.' + parts.slice(1).join('')) : apiStr;

    const num = Number.parseFloat(cleaned);
    const ok = Number.isFinite(num) && num > 0;

    return { rawStr, apiStr: cleaned, num: ok ? num : null };
  }

  public isValidSellAmount(): boolean {
    const r = this.normalizeAmountForApi(this.sellAmount);
    return !!r.num;
  }

  /**
 * Optionnel : petit utilitaire local pour générer la clé d’un token
 */
  private tokenKey(t: { address: string; chainId: number }): string {
    return balanceKey(t.address, t.chainId);
  }
  // ─────────────────────────────────────────────────────────────
  // CancelFlowV1 — sidecar, add-only (aucune régression)
  // ─────────────────────────────────────────────────────────────
  // ─────────────────────────────────────────────────────────────
  // Shims for cancel-flow (add-only, safe no-ops if nothing to do)
  // Paste these inside the class SwapComponent (near other utils)
  // ─────────────────────────────────────────────────────────────

  // 1) Unified setter that uses your existing `swapStatus` field
  private setSwapStatusLocal(s: 'idle' | 'approve' | 'pending' | 'success' | 'error' | 'cancelled'): void {
    try {
      // if you already have a dedicated setter, call it here instead
      (this as any).swapStatus = s;
      this.cd?.detectChanges?.();
    } catch { /* no-op */ }
  }

  // 2) Soft abort (tries your existing helpers, never throws)
  private abortWalletConnectSoft(): void {
    try { (this as any).abortWalletConnectSafely?.(); } catch { }
    try { (this as any).abortWalletConnectSafe?.(); } catch { }
    try { (this as any).abortWalletConnect?.(); } catch { }

    // AppKit / WalletConnect modal close attempts (best-effort)
    try { (this as any).modal?.close?.(); } catch { }
    try { (window as any).modal?.close?.(); } catch { }
  }

  // 3) Soft close of any open modal/sheet (best-effort, never throws)
  private closeAnyOpenModalSoftly(): void {
    try { (this as any).modal?.close?.(); } catch { }
    try { (window as any).modal?.close?.(); } catch { }
    // Add any local refs you use (e.g., this.mmSheetRef?.dismiss?.())
    try { (this as any).mmSheetRef?.dismiss?.(); } catch { }
  }

  private cancelFlowV1 = {
    enabled: true,                                     // kill-switch
    timers: new Map<'apprv' | 'trx', number>(),
    hasHash: { apprv: false, trx: false } as Record<'apprv' | 'trx', boolean>,
    runId: 0
  };

  /**
 * Fin "logique" d'une phase (ex: approve terminé via pollAllowanceUntil).
 * On veut juste désarmer le timeout local (sinon faux cancel 30s après).
 * ⚠️ Ne marque PAS hasHash=true : on réserve ça au vrai hash wallet.
 */
  private cfDone(phase: 'apprv' | 'trx'): void {
    if (!this.cancelFlowV1.enabled) return;
    const t = this.cancelFlowV1.timers.get(phase);
    if (t) window.clearTimeout(t);
    this.cancelFlowV1.timers.delete(phase);
    this.addLog?.(`[cancel:done] phase=${phase} runId=${this.cancelFlowV1.runId}`);
  }
  private cfPreDeeplink(phase: 'apprv' | 'trx', runId?: number): void {
    if (!this.cancelFlowV1.enabled) return;

    // Si on entre en TRX, on ne veut PLUS jamais que le timer "approve" puisse tirer.
    // (sinon: faux cancel à t+30s alors qu'on est déjà en swap)
    if (phase === 'trx') {
      try { this.cfDone('apprv'); } catch { }
    }

    // if a runId is provided, record it for logging/timeout correlation
    if (typeof runId === 'number') {
      this.cancelFlowV1.runId = runId;
    }
    const ms = phase === 'apprv' ? 30_000 : 45_000;

    // armer timeout local (uniquement avant hash)
    const t = window.setTimeout(() => {
      if (this.cancelFlowV1.hasHash[phase]) return; // hash arrivé entretemps
      this.addLog?.(`[cancel:timeout] phase=${phase} ms=${ms} runId=${this.cancelFlowV1.runId}`);
      // ✅ APPROVE: ne PAS annuler le flow (on continue via pollAllowanceUntil).
      // On fait juste un cleanup deeplink/modal pour éviter les fenêtres fantômes.
      if (phase === 'apprv') {
        this.softCleanupAfterCancel('timeout', phase);
        return;
      }

      // ✅ TRX: ne PAS annuler automatiquement.
      // Sur iOS/WC, eth_sendTransaction peut ne jamais résoudre (pas de hash) alors que l'utilisateur a confirmé.
      // On nettoie juste les flags deeplink et on laisse le HASHLESS watcher décider du succès.
      this.softCleanupAfterCancel('timeout', phase);
    }, ms);

    // remplacer l’ancien timer si réarmé
    const prev = this.cancelFlowV1.timers.get(phase);
    if (prev) window.clearTimeout(prev);
    this.cancelFlowV1.timers.set(phase, t);

    // (optionnel) télémétrie d’annonce deeplink
    this.addLog?.(`deeplink:announce | phase=${phase} | runId=${this.cancelFlowV1.runId}`);
  }

  private cfOnHash(phase: 'apprv' | 'trx'): void {
    if (!this.cancelFlowV1.enabled) return;
    this.cancelFlowV1.hasHash[phase] = true;
    const t = this.cancelFlowV1.timers.get(phase);
    if (t) window.clearTimeout(t);
    this.cancelFlowV1.timers.delete(phase);
    // pas d’autre action: on laisse tes watchers/flows actuels gérer
  }

  private cfCancel(reason: 'user_rejected' | 'closed' | 'timeout', phase: 'apprv' | 'trx'): void {
    if (!this.cancelFlowV1.enabled) return;
    if (this.cancelFlowV1.hasHash[phase]) return; // si un hash existe, ce n’est plus un cancel local

    const t = this.cancelFlowV1.timers.get(phase);
    if (t) window.clearTimeout(t);
    this.cancelFlowV1.timers.delete(phase);

    this.addLog?.(`[cancel:${reason}] phase=${phase} runId=${this.cancelFlowV1.runId}`);
    this.setSwapStatusLocal('cancelled');
    this.softCleanupAfterCancel(reason, phase);
  }

  /** Nettoyage doux, sans casser tes sessions/process existants */
  private softCleanupAfterCancel(reason: string, phase: 'apprv' | 'trx') {
    try { this.clearAllowWcDeeplink?.(); } catch { }
    try { this.abortWalletConnectSoft?.(); } catch { }
    try { this.closeAnyOpenModalSoftly?.(); } catch { } // s'il existe déjà chez toi
    // NB: rien d’autre — on ne touche pas à tes watchers ni à la state machine existante
  }


  // ─────────────────────────────────────────────────────────────
  // Helpers globaux de gestion "allow deeplink"
  // ─────────────────────────────────────────────────────────────
  private setAllowWcDeeplinkFor(runId: number, ms = 45000): void {
    try {
      const until = Date.now() + Math.max(1000, ms);
      sessionStorage.setItem('st/allowWcDeeplinkUntil', String(until));
      sessionStorage.setItem('st/allowWcRunId', String(runId));
      sessionStorage.removeItem('st/skipWcDeeplinkOnce');
      this.addLog?.(`[SWAP][ALLOW] WC deeplink runId=${runId} until=${until}`);
    } catch { /* noop */ }
  }

  private clearAllowWcDeeplink(): void {
    try {
      sessionStorage.removeItem('st/allowWcDeeplinkUntil');
      sessionStorage.removeItem('st/allowWcRunId');
      sessionStorage.removeItem('st/skipWcDeeplinkOnce');
      this.addLog?.(`[deeplink][allow] cleared`);
    } catch { /* noop */ }
  }
  /**
 * Soft reload avant un NOUVEAU run utilisateur.
 * Objectif :
 *  - lever un cooldown global résiduel (st/suppressWcUriUntil)
 *  - nettoyer les flags deeplink "fantômes"
 *  - sans toucher au provider, wallet, balances, etc.
 */
  /**
 * Soft reload avant un NOUVEAU run utilisateur.
 * Objectif :
 *  - lever un cooldown global résiduel (st/suppressWcUriUntil)
 *  - nettoyer les flags deeplink "fantômes" + timers du run précédent
 *  - sans toucher au provider, wallet, balances, etc.
 */
  // deviens async
  /**
 * Soft reload avant un NOUVEAU run utilisateur.
 * Objectif :
 *  - lever un cooldown global résiduel (st/suppressWcUriUntil)
 *  - nettoyer les flags deeplink "fantômes" + timers du run précédent
 *  - sans toucher au provider, wallet, balances, etc.
 */
  // ctx = 'main' pour le CTA principal, 'alt' pour une alternative
  private async softReloadBeforeRunIfNeeded(ctx: 'main' | 'alt'): Promise<void> {
    try {
      const now = Date.now();

      // Compteur "softReload" pour savoir si on est au 1er / 2e / 3e run
      const softSeq = ((this as any)._softReloadSeq ?? 0) + 1;
      (this as any)._softReloadSeq = softSeq;

      // ───────────────────────────────────────────────
      // 1) Lire les flags deeplink / cooldown
      // ───────────────────────────────────────────────
      const sup = Number(sessionStorage.getItem('st/suppressWcUriUntil') || '0') || 0;
      const allow = Number(sessionStorage.getItem('st/allowWcDeeplinkUntil') || '0') || 0;
      const allowRunId = Number(sessionStorage.getItem('st/allowWcRunId') || '0') || 0;

      const left = sup > now ? sup - now : 0;
      const allowLeft = allow > now ? allow - now : 0;

      const hasCooldownActive = left > 0 || allowLeft > 0;

      // ───────────────────────────────────────────────
      // 2) État runtime réel (ce qui compte vraiment)
      // ───────────────────────────────────────────────
      const hasProvider = !!this.provider;
      const hasTaker = !!this.takerAddress;
      const hasQuoteOrAlt = !!this.quote || !!this.selectedAlternative;

      const stateClean = hasProvider && hasTaker && hasQuoteOrAlt;

      // ───────────────────────────────────────────────
      // 3) Historique de run (info)
      // ───────────────────────────────────────────────
      const seq = (this as any)._runSeq || 0;
      const cfRunId = (this as any).cancelFlowV1?.runId || 0;
      const prevRunFlag = allowRunId > 0 || seq > 0 || cfRunId > 0;

      // Vraie preuve qu'on a déjà envoyé un deeplink une fois
      const realDeeplinkSent = !!(this as any).__dlLast;

      // ───────────────────────────────────────────────
      // 4) Déterminer la chaîne attendue pour ce swap
      // ───────────────────────────────────────────────
      let expectedChainId: number | undefined;
      try {
        const q: any = this.quote;
        expectedChainId =
          (q?.fromChainId as number | undefined) ??
          (q?.chainId as number | undefined) ??
          ((this as any).chainId as number | undefined);
      } catch {
        expectedChainId = undefined;
      }

      this.addLog?.(
        `[softReload][matrix] ctx=${ctx} softSeq=${softSeq} ` +
        `clean=${stateClean} cooldownActive=${hasCooldownActive} ` +
        `prevRunFlag=${prevRunFlag} realDeeplinkSent=${realDeeplinkSent} ` +
        `expectedChainId=${expectedChainId ?? '(none)'}`
      );

      // ───────────────────────────────────────────────
      // CASE B — Pas clean (provider cassé / pas de taker / etc.)
      // 👉 Problème réel → detach obligatoire
      // ───────────────────────────────────────────────
      if (!stateClean) {
        this.addLog?.(
          `[softReload] DETACH (state NOT clean: provider=${hasProvider} taker=${hasTaker} quoteOrAlt=${hasQuoteOrAlt})`
        );
        this._runDetachSequence();
        return;
      }

      // À partir d'ici : stateClean = true

      // ───────────────────────────────────────────────
      // CASE HARD — 2ᵉ run ou plus
      // 👉 Hard reset complet de la session wallet avant nouveau run
      // ───────────────────────────────────────────────
      if (softSeq >= 2) {
        this.addLog?.(
          `[softReload][HARD] softSeq=${softSeq} (>=2) → hard reset wallet session before new run`
        );
        await this.hardResetWalletSessionForNewRun(ctx, softSeq);
        return;
      }

      // Ici on est forcément sur le 1er run (softSeq === 1)

      // ───────────────────────────────────────────────
      // CASE C — Vrai ancien run + cooldown encore actif
      // 👉 on fait un hard-soft detach pour éviter popup fantôme
      // (cas rare mais on garde la protection historique)
      // ───────────────────────────────────────────────
      if (realDeeplinkSent && hasCooldownActive) {
        this.addLog?.(
          `[softReload] DETACH (real previous deeplink + cooldown active → avoid phantom popup)`
        );
        /*   this._runDetachSequence();*/
        return;
      }

      // ───────────────────────────────────────────────
      // CASE A / D — État clean et pas de raison de detach
      // 👉 Pas de detach. On nettoie les flags deeplink…
      //    …et on force la chain si besoin.
      // ───────────────────────────────────────────────
      this.addLog?.(
        `[softReload] SKIP detach (clean state, provider intact)`
      );

      // Reset léger (deeplink / timers / cancelFlow)
      this._resetDeeplinkFlags();

      // 🟣 Forcer la chain à partir du 2ᵉ run (si on a une expectedChainId)
      // (ici softSeq === 1, mais on garde la signature homogène)
      await this._forceChainForRunIfNeeded(ctx, softSeq, expectedChainId);

    } catch (err: any) {
      this.addLog?.('[softReload] EXC ' + (err?.message || err));
    }
  }




  // 🔥 HARD RESET "F5-like" :
  // - détruit le provider / signer / taker côté front
  // - reset deeplink & timers
  // - relance restoreSession pour se rebrancher sur la session WC existante
  private async hardResetWalletSessionForNewRun(
    ctx: 'main' | 'alt',
    softSeq: number
  ): Promise<void> {
    this.addLog?.(
      `[softReload][HARD] ENTER ctx=${ctx} softSeq=${softSeq}`
    );

    try {
      // ─────────────────────────────────────────────
      // 1) Teardown AppKit / modal (comme en ngOnInit)
      // ─────────────────────────────────────────────
      const teardownAppKit = () => {
        try {
          const w: any = window as any;

          w?.appkit?.destroy?.();
          w?.appKit?.destroy?.();
          w?.modal?.destroy?.();

          try {
            w?.appkit?.getProvider?.()?.disconnect?.();
          } catch { /* no-op */ }
        } catch {
          // no-op, jamais faire planter le hard reset
        }
      };

      this.addLog?.('[softReload][HARD] teardownAppKit…');
      teardownAppKit();
      this.addLog?.('[softReload][HARD] teardownAppKit done');

      // ⚠️ IMPORTANT :
      // On NE tue PAS WalletConnect v2 ici.
      // => PAS de killWalletConnectV2()
      // => la session WC reste vivante côté mobile + storage

      // ─────────────────────────────────────────────
      // 2) Reset de l’état local du composant
      //    (provider / signer / taker + deeplink)
      // ─────────────────────────────────────────────
      try {
        // On détruit le provider JS comme après un F5
        (this as any).provider = null;
        (this as any).signer = null;
        this.takerAddress = null;

        // Flags deeplink internes
        try {
          (this as any).__dlLast = null;
          (this as any).__dlOpenedForRun = null;
        } catch { /* no-op */ }

        try {
          if ((this as any)._deeplinkReopenTimer) {
            clearTimeout((this as any)._deeplinkReopenTimer);
          }
          (this as any)._deeplinkReopenTimer = null;
        } catch { /* no-op */ }

        // Cancel flow V1 si présent
        try {
          (this as any).cancelFlowV1 = null;
        } catch { /* no-op */ }

        // Reset léger des flags liés au deeplink côté composant
        try {
          this._resetDeeplinkFlags?.();
          this.addLog?.('[softReload] deeplink/timers reset');
        } catch { /* no-op */ }

        this.addLog?.('[softReload][HARD] local component state reset done');
      } catch {
        // on ne veut pas bloquer le reste
      }

      // ─────────────────────────────────────────────
      // 3) Relancer la même logique de "restoreSession"
      //    que celle utilisée au boot (ngOnInit)
      //    → subscribeEvmChanges + restoreSessionDocStyle + restoreSessionIfAny
      // ─────────────────────────────────────────────
      try {
        const anyThis: any = this;

        this.addLog?.(
          '[softReload][HARD] RESTORE (ngOnInit-style) subscribeEvmChanges + restoreSessionDocStyle + restoreSessionIfAny'
        );

        // 3.1) Rebrancher les listeners EVM (comme en ngOnInit)
        if (typeof anyThis.subscribeEvmChanges === 'function') {
          try {
            this.addLog?.('[softReload][HARD] calling this.subscribeEvmChanges()');
            anyThis.subscribeEvmChanges();
          } catch (e: any) {
            this.addLog?.(
              '[softReload][HARD] subscribeEvmChanges EXC ' + (e?.message || e)
            );
          }
        }

        // 3.2) Doc-style restore (modal.getAddress / getWalletProvider)
        if (typeof anyThis.restoreSessionDocStyle === 'function') {
          this.addLog?.('[softReload][HARD] calling this.restoreSessionDocStyle()');
          await anyThis.restoreSessionDocStyle();
        }

        // 3.3) Grosse machine de rehydrate WC / EIP-1193
        if (typeof anyThis.restoreSessionIfAny === 'function') {
          this.addLog?.('[softReload][HARD] calling this.restoreSessionIfAny()');
          await anyThis.restoreSessionIfAny();
        } else {
          this.addLog?.(
            '[softReload][HARD] no restoreSessionIfAny on component (skipped)'
          );
        }
      } catch (err: any) {
        this.addLog?.(
          `[softReload][HARD] restore logic EXC ${err?.message || err}`
        );
      }

      this.addLog?.('[softReload][HARD] completed successfully');
    } catch (err: any) {
      this.addLog?.(
        '[softReload][HARD] EXC ' + (err?.message || err)
      );
    } finally {
      this.addLog?.('[softReload][HARD] EXIT');
    }
  }





  private async _forceChainForRunIfNeeded(
    ctx: 'main' | 'alt',
    softSeq: number,
    expectedChainId?: number
  ): Promise<void> {
    try {
      // 1) On ne force JAMAIS au premier run
      if (softSeq < 2) {
        this.addLog?.(
          `[NETWORK][FORCE] ctx=${ctx} softSeq=${softSeq} → skip (first run)`
        );
        return;
      }

      // 2) Sans chain attendue ou sans provider → on ne fait rien
      if (!expectedChainId || !this.provider) {
        this.addLog?.(
          `[NETWORK][FORCE] ctx=${ctx} softSeq=${softSeq} → skip (missing expectedChainId or provider)`
        );
        return;
      }

      const reason = `softReload:${ctx}:run#${softSeq}`;

      this.addLog?.(
        `[NETWORK][FORCE] ctx=${ctx} softSeq=${softSeq} → switchWalletNetworkSilent(${expectedChainId}) reason=${reason}`
      );

      await this.switchWalletNetworkSilent(expectedChainId, reason);

    } catch (err: any) {
      this.addLog?.(
        `[NETWORK][FORCE] ctx=${ctx} softSeq=${softSeq} → EXC wrapper: ${err?.message ?? err}`
      );
    }
  }


  private _resetDeeplinkFlags(): void {
    try { this.clearAllowWcDeeplink?.(); } catch { }
    try {
      sessionStorage.removeItem('st/allowWcDeeplinkUntil');
      sessionStorage.removeItem('st/allowWcRunId');
      sessionStorage.removeItem('st/skipWcDeeplinkOnce');
    } catch { }
    try {
      (this as any).__dlLock = false;
      (this as any).__dlLast = null;
      (this as any).__dlOpenedForRun = null;
    } catch { }
    try {
      const t = (this as any)._deeplinkReopenTimer;
      if (t) { clearTimeout(t); }
      (this as any)._deeplinkReopenTimer = null;
    } catch { }
    try {
      const cf: any = (this as any).cancelFlowV1;
      if (cf?.timers) {
        cf.timers.forEach((t: any) => { try { clearTimeout(t); } catch { } });
        cf.timers.clear?.();
        if (cf.hasHash) { cf.hasHash.apprv = false; cf.hasHash.trx = false; }
        cf.runId = 0; cf.phase = undefined; cf.lastPhase = undefined;
      }
    } catch { }
    this.addLog?.('[softReload] deeplink/timers reset');
  }

  private _runDetachSequence(): void {
    try {
      const had = !!this.provider || !!this.rawProvider;
      if (!had) {
        this.addLog?.('[softReload] detach skipped (no provider at all)');
        this._resetDeeplinkFlags();
        return;
      }
      this.addLog?.('[softReload] HARD-SOFT DETACH triggered');
      try { (this as any).provider = null; (this as any).rawProvider = null; } catch { }
      this.__restoreInFlight = false;
      this._resetDeeplinkFlags();
      void this.softReloadWalletSession(0);
    } catch (err: any) {
      this.addLog?.('[softReload] DETACH EXC ' + (err?.message || err));
    }
  }






  private measureFooter() {
    try {
      const el = this.footerHost?.nativeElement;
      if (!el) return;
      const h = Math.round(el.getBoundingClientRect().height || 0);
      if (h > 0 && h !== this.footerHpx) {
        this.footerHpx = h;
        this.cd?.detectChanges?.();
      }
    } catch { /* no-op */ }
  }

  /** Petit utilitaire: force un flush UI puis attend le frame suivant (rendu effectif). */
  private async safeRafTick(): Promise<void> {
    try { this.cd?.detectChanges?.(); } catch { }
    await Promise.resolve(); // microtask
    await new Promise<void>(r => requestAnimationFrame(() => r()));
  }

  /** Affiche un libellé CTA immédiat (sans délai), avec auto-clear optionnel. */
  private flashCtaNow(msg: string, ms?: number) {
    if (!msg) return;
    try { if (this._ctaTimer) clearTimeout(this._ctaTimer); } catch { }
    this.ctaLabel = msg;
    try { this.cd?.detectChanges?.(); } catch { }
    if (ms && ms > 0) {
      this._ctaTimer = setTimeout(() => {
        this.ctaLabel = null;
        try { this.cd?.detectChanges?.(); } catch { }
      }, ms);
    }
  }

  /** Phase pré-popup: annonce claire à l’utilisateur AVANT ouverture MetaMask (taguée par runId). */
  private async preDeeplinkAnnounce(
    ctx: 'main-cta' | 'alt-cta' | 'approve-cta' = 'main-cta',
    runId?: number
  ) {
    // 0) Trace d’entrée + cohérence runId
    this.addLog(`[UI] preDeeplinkAnnounce ctx=${ctx} runId=${runId ?? 'n/a'} currentSeq=${this._runSeq}`);
    if (typeof runId === 'number' && runId !== this._runSeq) {
      this.addLog(`[deeplink][pre] SKIP (stale runId=${runId} current=${this._runSeq})`);
      return;
    }

    // 1) Armer l’ouverture deeplink ~15s + nettoyer les flags résiduels
    try {
      const until = Date.now() + 15_000;
      sessionStorage.setItem('st/allowWcDeeplinkUntil', String(until));
      sessionStorage.setItem('st/allowWcRunId', String(this._runSeq));
      sessionStorage.removeItem('st/skipWcDeeplinkOnce');
      this.addLog(`[deeplink][pre] allow set | until=${until} runId=${this._runSeq}`);
    } catch (e: any) {
      this.addLog(`[deeplink][pre] allow set FAILED | ${e?.message || e}`);
    }

    // 2) MAJ du statut UI selon le contexte
    if (ctx === 'approve-cta') {
      this.swapStatus = 'approve';
      const msg = this.translate.instant('STATUS.APPROVING') || 'Approbation en cours…';
      // this.flashCtaNow(msg, 4000);
      this.addLog('[ui] status=approve (approve-cta)');
    } else {
      this.swapStatus = 'pending';
      const msg = this.translate.instant('STATUS.PENDING') || 'Transaction en cours…';
      // this.flashCtaNow(msg, 4000);
      this.addLog(`[ui] status=pending (${ctx})`);
    }

    // 3) Forcer un flush UI avant ouverture MetaMask/WC
    try { this.cd?.detectChanges?.(); } catch { /* noop */ }
    await this.safeRafTick(); // garantit un rendu avant ouverture de MetaMask / WC
    this.addLog('[deeplink][pre] UI flushed (safeRafTick done)');
  }





  kbOffset = 0;

  // 2) Abonnement VisualViewport
  private _vvHandlersAttached = false;
  private _onVvResize = () => {
    try {
      const vv = (window as any).visualViewport;
      if (!vv) { this.kbOffset = 0; return; }

      // Espace “mangé” par le clavier: innerHeight - (vv.height + vv.offsetTop)
      const eaten = (window.innerHeight || 0) - ((vv.height || 0) + (vv.offsetTop || 0));
      // On garde un offset >= 0 et on ajoute éventuellement le safe-area
      const safe = (window as any).CSS?.supports?.('height: env(safe-area-inset-bottom)') ? 0 : 0;
      this.kbOffset = Math.max(0, Math.ceil(eaten)) + safe;
      this.cd?.detectChanges?.();
    } catch {
      this.kbOffset = 0;
    }
  };




  /**
 * Entre deux quotes/CTA, impose un petit cooldown et “rafraîchit” la session WC
 * pour garantir l’apparition de la feuille de confirmation MetaMask.
 * - bloque tout deeplink automatique pendant WC_QUOTE_COOLDOWN_MS
 * - purge l’armement précédent
 * - reset visuel de l’URI (sans casser trop fort la session)
 */
  private async cooldownAndResetWcSession(ctx: 'main' | 'alt'): Promise<void> {
    try {
      this._lastQuoteClickAt = Date.now();
      // 1) Désarmer une éventuelle fenêtre “allow” précédente
      clearAllowWcDeeplink();

      // 2) Soft-reset PUREMENT UI : on ne touche plus au flux global wcUri$
      try { (this as any)._wcLastUri = null; } catch { }
      try { this.wcUri = ''; } catch { }

      // 3) Best-effort : soft close de la modale sans tuer la session/pairings
      try {
        await (abortWalletConnectSoft as any)?.call?.(this, `quote-switch:${ctx}`);
      } catch { }

      this.addLog(`[WC] cooldown+soft-reset done (${ctx})`);
    } catch {
      /* no-op */
    }
  }


  private _netSwitching = false;
  // ⬇️ ajoute cette méthode utilitaire dans la classe SwapComponent
  private async softReloadAfterNetworkSwitch(reason: string) {
    if (this._netSwitching) return;
    this._netSwitching = true;
    this.addLog(`🔧 soft-reload AFTER network switch (from init) | reason=${reason}`);

    // On ferme proprement la quote en cours
    /*  this.closeQuoteWithReason('softReloadAfterNetworkSwitch');*/

    try {
      // 1) Récupérer le provider EIP-1193 “source de vérité” (MM / WC)
      const eth: any = (window as any).ethereum || this.rawProvider;
      if (!eth || typeof eth.request !== 'function') {
        this.addLog('[soft-reload-from-init] aucun provider EIP-1193 dispo → abort');
        this._netSwitching = false;
        try { this.cd.detectChanges(); } catch { }
        return;
      }

      // 2) Rejouer EXACTEMENT la même mécanique que lors du boot :
      //    attachEthersProvider(eth) est ce qui, au ngOnInit, :
      //    - crée le BrowserProvider
      //    - lit chainId + address
      //    - aligne this.chainId, this.takerAddress
      //    - appelle setChain(...)
      //    - rafraîchit le solde natif
      await this.attachEthersProvider(eth);


      // 3) Ensuite on laisse le pipeline normal faire son travail :
      //    - chainId$ → setChain(...)
      //    - TokenPortfolioCacheService se rebind
      //    On peut juste relancer un refresh des tokens pour être sûr.
      try { await this.refreshTokensForChain(); } catch { }

      this.addLog('✅ soft-reload-from-init done (attachEthersProvider rejoué)');
    } catch (e) {
      this.addLog('[soft-reload-from-init] ERROR ' + (e as any)?.message);
    } finally {
      this._netSwitching = false;
      try { this.cd.detectChanges(); } catch { }
    }
  }


  private _activeReceiptWatchKey: string | null = null;
  private _finalizedReceiptWatchKey: string | null = null;

  private async watchSwapReceiptUntilFinal(
    hash: string,
    chainId: number,
    { initialDelayMs = 1200, maxDelayMs = 8000 } = {}
  ): Promise<void> {
    const watchRunId = this._runSeq;
    const watchKey = `${chainId}:${hash}:${watchRunId}`;

    // ✅ idempotent guard (si déjà finalisé, on ne refait pas la UI)
    if (this._finalizedReceiptWatchKey === watchKey) {
      this.addLog(`[SWAP][WATCH] already finalized → noop | key=${watchKey}`);
      return;
    }

    this.addLog(`[SWAP][WATCH] start hash=${hash} chainId=${chainId} runId=${watchRunId}`);
    this.swapHash = hash;
    this.swapError = null;

    // ⚠️ On force pending une seule fois au début
    if (this.swapStatus !== 'pending') {
      this.swapStatus = 'pending';
      this.cd?.detectChanges?.();
    }

    this.savePendingSwap(hash, chainId);

    const keep = this.provider;
    let delay = initialDelayMs;
    const sleep = (ms: number) => new Promise(r => setTimeout(r, ms));

    while (true) {
      try {
        // stale guard
        if (watchRunId !== this._runSeq) {
          this.addLog(`[SWAP][WATCH] abort (stale runId: started=${watchRunId}, current=${this._runSeq})`);
          return;
        }

        // réhydratation douce
        if (!this.provider) {
          await this.softReloadWalletSession?.(1200).catch(() => { });
        }

        const p = this.provider ?? keep;
        if (!p) {
          await sleep(delay);
          delay = Math.min(Math.round(delay * 1.5), maxDelayMs);
          continue;
        }

        const receipt = await p.getTransactionReceipt(hash).catch(() => null);
        if (!receipt) {
          await sleep(delay);
          delay = Math.min(Math.round(delay * 1.5), maxDelayMs);
          continue;
        }

        this.addLog(`[SWAP][WATCH] receipt block=${receipt.blockNumber} status=${receipt.status} runId=${watchRunId}`);

        // ✅ finalize once
        this._finalizedReceiptWatchKey = watchKey;

        if (Number(receipt.status) === 1) {
          if (this.swapStatus !== 'success') {
            this.swapStatus = 'success';
            this.swapError = null;
            this.flushBackendLogs('success').catch(() => { });
          } else {
            this.addLog(`[SWAP][WATCH] already success → noop | key=${watchKey}`);
          }
        } else {
          if (this.swapStatus !== 'error') {
            this.swapStatus = 'error';
            this.swapError = 'TX_REVERTED';
            this.flushBackendLogs('error', 'EXECUTION_REVERTED', 'Receipt status != 1').catch(() => { });
          } else {
            this.addLog(`[SWAP][WATCH] already error → noop | key=${watchKey}`);
          }
        }

        this.clearPendingSwap();
        this.cd?.detectChanges?.();
        return;

      } catch (e: any) {
        this.addLog(`[SWAP][WATCH][warn] ${e?.message || e}`);
        await sleep(delay);
        delay = Math.min(Math.round(delay * 1.5), maxDelayMs);
      }
    }
  }






  ctaLabel: string | null = null;

  private _ctaDelayTimer?: any;   // timer de délai avant affichage

  private flashCta(msg: string | null | undefined, visibleMs = 5000, delayMs = 0) {
    // Nettoie tout ce qui pourrait être en cours
    try { if (this._ctaTimer) clearTimeout(this._ctaTimer); } catch { }
    try { if (this._ctaDelayTimer) clearTimeout(this._ctaDelayTimer); } catch { }

    if (!msg) { this.ctaLabel = null; this.cd?.detectChanges?.(); return; }

    const showNow = () => {
      this.ctaLabel = msg;
      this.cd?.detectChanges?.();
      this._ctaTimer = setTimeout(() => {
        this.ctaLabel = null;
        this.cd?.detectChanges?.();
      }, visibleMs);
    };

    if (delayMs > 0) {
      this._ctaDelayTimer = setTimeout(showNow, delayMs);
    } else {
      showNow();
    }
  }

  // (optionnel) util pour annuler totalement un flash en attente
  private cancelCtaFlash() {
    try { if (this._ctaTimer) clearTimeout(this._ctaTimer); } catch { }
    try { if (this._ctaDelayTimer) clearTimeout(this._ctaDelayTimer); } catch { }
    this.ctaLabel = null;
    this.cd?.detectChanges?.();
  }

  private savePendingSwap(hash: string, chainId: number) {
    try { localStorage.setItem(PENDING_SWAP_TX_KEY, JSON.stringify({ hash, chainId, t: Date.now() })); } catch { }
  }
  private loadPendingSwap(): { hash: string; chainId: number } | null {
    try { return JSON.parse(localStorage.getItem(PENDING_SWAP_TX_KEY) || 'null'); } catch { return null; }
  }
  private clearPendingSwap() {
    try { localStorage.removeItem(PENDING_SWAP_TX_KEY); } catch { }
  }

  private __restoreInFlight = false;

  // Dans class SwapComponent
  private async softReloadWalletSession(delayMs = 0): Promise<void> {
    try {
      if (this.__restoreInFlight) {
        this.addLog?.('[restoreSession] softReloadWalletSession SKIP (already in flight)');
        return;
      }
      this.__restoreInFlight = true;
      this.addLog?.(`[restoreSession] softReloadWalletSession ENTER | delayMs=${delayMs}`);
      if (delayMs > 0) {
        await new Promise(r => setTimeout(r, delayMs));
      }

      // 1) Si un provider existe déjà, log + early-exit
      if (this.provider) {
        try {
          const net0 = await this.provider.getNetwork();
          this.addLog?.(`[restoreSession] provider already set | chainId=${Number(net0.chainId)} addrKnown=${!!this.takerAddress}`);
        } catch {
          this.addLog?.('[restoreSession] provider already set | getNetwork failed (will still proceed)');
        }
      }

      // 2) Source EIP-1193 potentielle
      const eth: any = (window as any).ethereum || this.rawProvider;
      const hasEth = !!eth;
      const hasReq = !!eth && typeof eth.request === 'function';
      const ctor = eth?.constructor?.name || '(unknown)';
      this.addLog?.(`[restoreSession] probe window/raw | hasEth=${hasEth} has.request=${hasReq} ctor=${ctor}`);

      if (!hasEth || !hasReq) {
        this.addLog?.('[restoreSession] no usable EIP-1193 → try WalletConnect rehydrate');
        // 🔹 Purge de petits flags qui peuvent empêcher l’ouverture de la modale
        try {
          sessionStorage.removeItem('st/skipAutoRestoreOnce');
          sessionStorage.removeItem('st/supAutoRestoreUntil');
          sessionStorage.removeItem('st/allowWcDeeplinkUntil');
        } catch { /* noop */ }

        // 🔹 Tenter d'obtenir un provider WC à partir d'une session existante (AppKit / Legacy)
        try {
          initAppKit('8d74b0ff39c361ecaa9c3dd96ac0055c'); // ✅ au lieu de this.initAppKit()
          this.addLog?.('[restoreSession] global initAppKit called');
        } catch (e: any) {
          this.addLog?.(`[restoreSession] initAppKit failed | ${e?.message || e}`);
        }

        let wcProv: any = null;
        try {
          // helper interne si présent
          wcProv = await (this as any).getWalletConnectProvider?.();
          if (!wcProv && (this as any).appKit?.getProvider) {
            wcProv = await (this as any).appKit.getProvider('eip155'); // best-effort
          }
        } catch (e: any) {
          this.addLog?.(`[restoreSession] get WC provider failed | ${e?.message || e}`);
        }

        if (wcProv && typeof wcProv.request === 'function') {
          this.addLog?.('[restoreSession] WC provider rehydrated → rebuild BrowserProvider');
          this.rawProvider = wcProv;
          try {
            this.provider = new BrowserProvider(wcProv);
            const net = await this.provider.getNetwork();
            const chainId = Number(net.chainId);
            let owner = '(n/a)'; try { owner = await this.provider.getSigner().then(s => s.getAddress()); } catch { }
            this.addLog?.(`[restoreSession] WC reattach OK | chainId=${chainId} owner=${owner}`);
            this.addLog?.('[restoreSession] softReloadWalletSession EXIT (ok/wc)');
            return;
          } catch (e: any) {
            this.addLog?.(`[restoreSession] BrowserProvider ctor (wc) FAILED | ${e?.message || e}`);
            // on tombera sur l’ouverture modale juste après
          }
        }

        // 🔹 Pas de session exploitable → ouverture de la modale Legacy (auto-connect)
        this.addLog?.('[restoreSession] no WC session usable → open legacy connect modal');
        try {
          await (this as any).openLegacyConnectModal?.();   // si dispo
        } catch {
          // fallback : certains projets nomment différemment
          try { await (this as any).connectLegacy?.(); } catch { }
        }
        this.addLog?.('[restoreSession] EXIT (modal opened)');
        return;
      }


      // 3) (Ré)injection
      this.rawProvider = eth;
      try {
        this.provider = new BrowserProvider(eth);
        this.addLog?.('[restoreSession] BrowserProvider constructed');
      } catch (e: any) {
        this.addLog?.(`[restoreSession] BrowserProvider ctor FAILED | ${e?.message || e}`);
        return;
      }

      // 4) Diagnostic réseau + adresse si possible
      try {
        const net = await this.provider.getNetwork();
        const chainId = Number(net.chainId);
        let owner = '(n/a)';
        try { owner = await this.provider.getSigner().then(s => s.getAddress()); } catch { }
        this.addLog?.(`[restoreSession] provider rebuilt | chainId=${chainId} owner=${owner}`);
      } catch (e: any) {
        this.addLog?.(`[restoreSession] getNetwork/signature probe FAILED | ${e?.message || e}`);
      }

      this.addLog?.('[restoreSession] softReloadWalletSession EXIT (ok)');
    } catch (e: any) {
      this.addLog?.(`[restoreSession] softReloadWalletSession ERROR | ${e?.message || e}`);
    } finally {
      this.__restoreInFlight = false;
    }
  }


  private lockChainToSeo = false; // empêche l'écrasement par le wallet tant qu'il est true
  @Input() swapPrefill?: {
    chainId: number;
    tokenIn: string;
    tokenOut: string;
  } | null;

  @Input() seoPage?: any;
  @ViewChild('mobileHeader') mobileHeader!: ElementRef<HTMLDivElement>;
  headerHpx = 72; // fallback
  constructor(
    private gate: WalletGatekeeperService,
    private nativeTokenPrice: NativeTokenPriceService,
    private wc2: WalletConnectV2Service,
    private balanceValidator: BalanceValidatorService,
    private wallet: WalletService,
    private swapApi: SwapApiService,
    private bridgeApi: BridgeApiService,
    private translate: TranslateService,
    private cd: ChangeDetectorRef,   // ⬅️ 1
    private zone: NgZone,            // ⬅️ 2
    private connector: WalletConnectorService,
    private price: PriceService,
    private route: ActivatedRoute,
    private seoContent: SeoContentService,
    private appSeo: AppSeoService,
    private sanitizer: DomSanitizer,
    private ts: TransferState,
    private dbg: DebugTelemetryService,
    private portfolio: TokenPortfolioCacheService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.reasonLabels = {
      // — SWAP-SPECIFIC KEYS —
      WALLET_DISCONNECTED: this.translate.instant('SWAP_REASON_WALLET_DISCONNECTED'),
      INVALID_AMOUNT: this.translate.instant('SWAP_REASON_INVALID_AMOUNT'),
      INSUFFICIENT_NATIVE_GAS: this.translate.instant('SWAP_REASON_INSUFFICIENT_NATIVE_GAS'),
      INSUFFICIENT_SELL_TOKEN: this.translate.instant('SWAP_REASON_INSUFFICIENT_SELL_TOKEN'),

      // (Optional) fallback aliases if some older code still emits BRIDGE_* during swap:
      BRIDGE_REASON_WALLET_DISCONNECTED: this.translate.instant('SWAP_REASON_WALLET_DISCONNECTED'),
      BRIDGE_REASON_INVALID_AMOUNT: this.translate.instant('SWAP_REASON_INVALID_AMOUNT'),
      BRIDGE_REASON_INSUFFICIENT_NATIVE_GAS: this.translate.instant('SWAP_REASON_INSUFFICIENT_NATIVE_GAS'),
      BRIDGE_REASON_INSUFFICIENT_SELL_TOKEN: this.translate.instant('SWAP_REASON_INSUFFICIENT_SELL_TOKEN'),
    };
    // Charger la langue sauvegardée au démarrage
    const savedLang = localStorage.getItem('lang') || 'en'; // Langue par défaut : 'en'
    /*    this.translate.use(savedLang); // Définir la langue au démarrage*/
    // Charger le thème sauvegardé au démarrage
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
      document.body.classList.remove('light-mode', 'dark-mode');
      document.body.classList.add(savedTheme + '-mode');
    } else {
      // ⚡ Dark mode par défaut
      document.body.classList.remove('light-mode', 'dark-mode');
      document.body.classList.add('dark-mode');
      localStorage.setItem('theme', 'dark'); // enregistre pour les prochaines fois
    }
  }
  /* --------------------------------------------------------------------
 * Réseau en cours
 * ------------------------------------------------------------------*/
  chainId: number | null = null;            // ex. 1, 42161, 137…
  chainInfo: { name: string; icon: string } | null = null;
  private sub!: Subscription;
  /** Table de correspondance : ajoute tes réseaux si besoin */
  userTokens: any[] = [];
  popularTokens: any[] = [];
  showTokenModal = false;
  showBuyTokenModal = false;
  private _ssrTokens: any[] | null = null;
  private _ssrChainId: number | null = null;
  fiatLoading = true;
  balancesLoading = true;
  private firstPaintDone = false;
  /** Retourne un logo "local" immédiat si tokens non chargés, sinon le logo réel (avec fallback local). */
  getTokenLogo(symbol: string | null | undefined): string {
    const sym = (symbol || '').toUpperCase();
    // 1) Tant que la liste n’est pas disponible → logos locaux instantanés
    if (!this.tokensLoaded || !this.firstPaintDone) {
      return LOCAL_TOKEN_LOGO[sym] ?? LOCAL_TOKEN_LOGO['UNKNOWN'];
    }

    // 2) Liste dispo → essaye d'abord la vraie URL (logoURI), sinon fallback local
    const t = this.availableTokens?.find(x => (x.symbol || '').toUpperCase() === sym);
    const uri = t?.logoURI || t?.logo_uri || t?.logoUrl || t?.logo_url || '';
    if (uri && typeof uri === 'string') return uri;

    return LOCAL_TOKEN_LOGO[sym] ?? LOCAL_TOKEN_LOGO['UNKNOWN'];
  }
  private deeplink = new DeeplinkGate(1500, 800);

  // utilitaire pour fabriquer l'URL (schema unique : n’envoie pas 3 versions différentes)
  private buildMmUrl(displayUri?: string): string {
    if (!displayUri) return 'metamask://';      // foreground-only
    return `metamask://wc?uri=${encodeURIComponent(displayUri)}`;
  }

  /** Applique la paire par défaut "hot start" pour le réseau donné, sans écraser un choix explicite. */
  /** Applique la paire par défaut "hot start" pour le réseau donné,
 *  sans écraser un choix explicite et en évitant les incohérences. */
  private applyHotStartDefaults(chainId: number): void {
    const defaults = HOT_START_DEFAULTS[chainId] || HOT_START_DEFAULTS[1];

    // Si les deux sont déjà définis explicitement → ne rien faire
    if (this.sellTokenSymbol && this.buyTokenSymbol) {
      if (this.debug) {
        console.log('[applyHotStartDefaults] skip (déjà défini)', {
          chainId, sell: this.sellTokenSymbol, buy: this.buyTokenSymbol
        });
      }
      return;
    }

    const norm = (s?: string) => (s ?? '').trim().toUpperCase();

    // 1) Préparer les cibles (en respectant ce qui est déjà défini)
    let targetSell = this.sellTokenSymbol ? norm(this.sellTokenSymbol) : defaults.sell;
    let targetBuy = this.buyTokenSymbol ? norm(this.buyTokenSymbol) : defaults.buy;

    // 2) Éviter sell == buy (choisir un alt par chaîne)
    if (targetSell && targetBuy && targetSell === targetBuy) {
      const ALT_BUY: Record<number, string> = {
        1: 'ETH',        // Ethereum
        42161: 'ETH',    // Arbitrum
        137: 'MATIC',    // Polygon
        56: 'BNB',       // BNB Chain
      };
      // Si l'alt retombe encore sur la même valeur, basculer vers un classique ETH/USDC
      const proposed = ALT_BUY[chainId] || (targetBuy === 'ETH' ? 'USDC' : 'ETH');
      targetBuy = proposed === targetSell ? (proposed === 'ETH' ? 'USDC' : 'ETH') : proposed;
    }

    // 3) Validation par rapport au catalogue de tokens (si dispo)
    const hasTokensList = Array.isArray(this.allTokens) && this.allTokens.length > 0;
    const hasSymbol = (sym: string) =>
      hasTokensList
        ? this.allTokens.some(t => norm(t.symbol) === sym)
        : true; // si pas de liste, on fait confiance aux defaults

    if (!this.sellTokenSymbol) {
      if (hasSymbol(targetSell)) {
        this.sellTokenSymbol = targetSell;
      } else if (hasSymbol(defaults.sell)) {
        this.sellTokenSymbol = defaults.sell;
      }
    }

    if (!this.buyTokenSymbol) {
      if (hasSymbol(targetBuy)) {
        this.buyTokenSymbol = targetBuy;
      } else if (hasSymbol(defaults.buy)) {
        this.buyTokenSymbol = defaults.buy;
      }
    }

    // 4) Dernier garde-fou : encore identiques après validation ? → choisir un remplaçant présent
    if (norm(this.sellTokenSymbol) === norm(this.buyTokenSymbol)) {
      const candidates = ['ETH', 'USDC', 'USDT', 'MATIC', 'BNB'];
      const pick = candidates.find(sym =>
        sym !== norm(this.sellTokenSymbol) && hasSymbol(sym)
      );
      if (pick) this.buyTokenSymbol = pick;
    }

    if (this.debug) {
      console.log('[applyHotStartDefaults] appliqué', {
        chainId,
        sell: this.sellTokenSymbol,
        buy: this.buyTokenSymbol
      });
    }
  }


  ngAfterViewInit() {
    // Mesurer dès que le footer est peint
    this.measureFooter();
    // Re-mesurer après un tick pour capturer les polices/icônes
    setTimeout(() => this.measureFooter(), 50);
    setTimeout(() => { this.firstPaintDone = true; }, 0);
    const el = document.getElementById('app-root') || document.body;
    const bg = getComputedStyle(el).backgroundColor;
    if (bg) this.headerBackdropColor = bg;
    const update = () => {
      const h = this.mobileHeader?.nativeElement?.offsetHeight || 96;
      this.headerHpx = h;
    };
    // 1er calcul après rendu
    setTimeout(update, 0);
    // recalcule si orientation/viewport change
    window.addEventListener('resize', update);
    window.addEventListener('orientationchange', update);
  }
  @HostListener('document:click', ['$event'])
  onDocumentClick(ev: MouseEvent) {
    const target = ev.target as Node;

    // Footer
    if (this.showFooterMenu && this.footerMenuRoot && !this.footerMenuRoot.nativeElement.contains(target)) {
      this.showFooterMenu = false;
    }

    // Settings
    if (this.showSettings && this.settingsRoot && !this.settingsRoot.nativeElement.contains(target)) {
      this.showSettings = false;
    }


    // Menu des chaînes (trigger + liste fixe)
    if (this.showChainMenu) {
      const inTrigger = this.chainTrigger?.nativeElement.contains(target);
      const inMenu = this.chainMenuRoot?.nativeElement.contains(target);
      if (!inTrigger && !inMenu) {
        this.showChainMenu = false;
      }
    }


  }
  // SwapComponent.ts
  // Afficher le disque blanc uniquement pour certains symboles (ici, ETH)
  private readonly WHITE_DISK = new Set(['ETH']);
  hasWhiteDisk(sym?: string | null): boolean {
    return !!sym && this.WHITE_DISK.has(String(sym).toUpperCase());
  }

  private appliedCtaOnce = false;

  // Compat: accepte l'ancien schéma (from/to/chain) et le nouveau (tokenIn/tokenOut/chainId)


  // si pas déjà déclaré quelque part :


  private applyCtaDefaultsFromSeo(resolved: ResolvedSeo) {
    console.log('[SEO] applyCtaDefaultsFromSeo:start', { appliedCtaOnce: this.appliedCtaOnce, resolved });

    if (this.appliedCtaOnce) {
      console.log('[SEO] already applied → exit');
      return;
    }

    const cta = (resolved?.ctaParams || resolved?.page?.ctaParams) as CtaParamsCompat | undefined;
    console.log('[SEO] parsed CTA =', cta);
    if (!cta) {
      console.log('[SEO] no CTA found → exit');
      return;
    }

    // 1) priorité aux query params si présents
    const qp = this.route.snapshot.queryParamMap;
    const qpTokenIn = qp.get('tokenIn');
    const qpTokenOut = qp.get('tokenOut');
    const qpChainId = qp.get('chainId');
    const qpNetwork = qp.get('network');
    const hasQP = !!(qpTokenIn || qpTokenOut || qpChainId || qpNetwork);
    console.log('[SEO] query params =', { qpTokenIn, qpTokenOut, qpChainId, qpNetwork, hasQP });

    if (hasQP) {
      this.appliedCtaOnce = true;
      console.log('[SEO] query params present → skip CTA');
      return;
    }

    // 2) ne pas écraser un choix utilisateur persistant
    const persisted = localStorage.getItem('swap:lastSelection');
    console.log('[SEO] persisted selection =', persisted);
    if (persisted) {
      this.appliedCtaOnce = true;
      console.log('[SEO] persisted exists → skip CTA');
      return;
    }

    // 3) appliquer les valeurs CTA (compat ancien/nouveau)
    const tokenIn = (cta.tokenIn ?? cta.from)?.toUpperCase();
    const tokenOut = (cta.tokenOut ?? cta.to)?.toUpperCase();
    console.log('[SEO] computed tokens =', { tokenIn, tokenOut });

    if (tokenIn) {
      this.sellTokenSymbol = tokenIn;
      console.log('[SEO] set sellTokenSymbol =', this.sellTokenSymbol);
    }
    if (tokenOut) {
      this.buyTokenSymbol = tokenOut;
      console.log('[SEO] set buyTokenSymbol =', this.buyTokenSymbol);
    }

    // chainId direct (nouveau) ou fallback via slug (ancien)
    const chainId = cta.chainId ?? this.slugToChainId(cta.chain ?? '');
    console.log('[SEO] computed chainId =', chainId, '(from chainId:', cta.chainId, ', chain:', cta.chain, ')');

    if (chainId) {
      this.setChain(Number(chainId));
      this.seoChainId = Number(chainId);
      this.lockChainToSeo = true;
      this.selectedNetwork = this.seoChainId;
      console.log('[SEO] setChain done →', Number(chainId));
    }

    this.appliedCtaOnce = true;
    console.log('[SEO] applyCtaDefaultsFromSeo:done');
  }



  private slugToChainId(slug: string): number | null {
    const map: Record<string, number> = {
      ethereum: 1,
      arbitrum: 42161,
      base: 8453,
      polygon: 137,
      bsc: 56,
      celo: 42220,
      optimism: 10,
      avalanche: 43114
    };
    return map[slug.toLowerCase()] ?? null;
  }

  /** 
 * Installe une sonde de debug RPC (idempotente) pour logguer les appels
 * qui peuvent déclencher une popup MetaMask (switch réseau, request accounts,
 * envoi de transaction, signatures).
 *
 * ⚠️ Ne modifie PAS le comportement : elle se contente de logger.
 * À appeler par ex. dans setChain() ou juste après avoir attaché le provider.
 */
  private installRpcDebugProbe(label: string = 'probe'): void {
    const p: any = this.provider as any;
    if (!p) {
      this.addLog(`[rpc] debug probe skipped (${label}): no provider`);
      return;
    }
    // éviter d'installer plusieurs fois
    if ((p as any).__rpcDebugProbeInstalled) {
      return;
    }

    const SENSITIVE = new Set<string>([
      'wallet_switchEthereumChain',
      'wallet_addEthereumChain',
      'eth_requestAccounts',
      'eth_sendTransaction',
      'eth_sign',
      'personal_sign',
      'eth_signTypedData',
      'eth_signTypedData_v3',
      'eth_signTypedData_v4'
    ]);

    // wrap request()
    if (typeof p.request === 'function') {
      const origReq = p.request.bind(p);
      p.request = async (args: { method: string; params?: any[] }) => {
        try {
          if (args && args.method && SENSITIVE.has(args.method)) {
            this.addLog(`[rpc][${label}] ${args.method} params=${JSON.stringify(args.params ?? [])}`);
          }
        } catch { /* no-op */ }
        return origReq(args);
      };
    }

    // wrap send() — certains providers appellent send(method, params)
    if (typeof p.send === 'function') {
      const origSend = p.send.bind(p);
      p.send = async (method: string, params?: any[]) => {
        try {
          if (method && SENSITIVE.has(method)) {
            this.addLog(`[rpc][${label}] ${method} params=${JSON.stringify(params ?? [])}`);
          }
        } catch { /* no-op */ }
        return origSend(method, params);
      };
    }

    (p as any).__rpcDebugProbeInstalled = true;
    this.addLog(`[rpc] debug probe installed (${label})`);
  }

  private getOpenProbeState(): 'active' | 'paused' {
    try { return (sessionStorage.getItem('st/openProbeState') as any) === 'active' ? 'active' : 'paused'; } catch { return 'paused'; }
  }
  private pauseOpenProbe(reason = 'boot'): void {
    try { sessionStorage.setItem('st/openProbeState', 'paused'); } catch { }
    this.addLog?.(`[open-probe] state=paused reason=${reason}`);
  }
  private resumeOpenProbe(reason = 'connected'): void {
    try { sessionStorage.setItem('st/openProbeState', 'active'); } catch { }
    this.addLog?.(`[open-probe] state=active reason=${reason}`);
  }


  // ⚙️ Sonde navigateur: log tout window.open / location.* (deeplinks iOS)
  // Et applique un "deny-by-default" pour metamask://, metamask.app.link, wc:
  private installWindowOpenProbe(label: 'ngOnInit' | 'setChain' | 'attach' | 'fetchQuote') {
    const shortStack = () => {
      try {
        const e = new Error();
        const lines = (e.stack || '').split('\n').slice(2, 7); // skip 2 premières lignes
        return lines.join(' | ');
      } catch {
        return '(no stack)';
      }
    };

    const w: any = window as any;
    if (w.__openProbeInstalled) {
      this.addLog?.('[open-probe] already installed');
      return;
    }

    try {
      // Helper : détecte un lien WC/MetaMask
      const isMetaLink = (url: string) =>
        /metamask\.app\.link|metamask:|wc:/i.test(url || '');

      // Helper : extrait le wcUri depuis les différentes formes possibles
      const extractWcUri = (rawUrl: string): string | null => {
        if (!rawUrl) return null;
        const url = String(rawUrl);

        // Cas 1 : schéma direct wc:...
        if (/^wc:/i.test(url)) {
          // On garde tel quel, MetaMask saura décoder le wcUri complet
          return url;
        }

        // Cas 2 : ...?uri=<ENCODED>
        const m = url.match(/[?&]uri=([^&]+)/i);
        if (m && m[1]) {
          try {
            return decodeURIComponent(m[1]);
          } catch {
            return m[1];
          }
        }

        return null;
      };

      // Helper : capture wcUri + normalise l'URL en metamask://wc?uri=...
      const captureAndNormalizeMetaUrl = (rawUrl: string): string => {
        const href = String(rawUrl || '');
        if (!isMetaLink(href)) return href;

        const wcUri = extractWcUri(href);
        if (!wcUri) {
          this.addLog?.(`[open-probe] meta-link sans wcUri exploitable → href=${href}`);
          return href;
        }

        // 📝 Capture locale de l'URI pour debug et kick manuel éventuel
        try { (this as any)._wcLastUri = wcUri; } catch { }
        try { (this as any).wcUri = wcUri; } catch { }
        try { (this as any)._wcUri$?.next?.(wcUri); } catch { }

        try {
          sessionStorage.setItem('st/wcLastUri', wcUri);
        } catch { /* no-op */ }


        const mmUrl =
          typeof this.buildMmUrl === 'function'
            ? this.buildMmUrl(wcUri)
            : `metamask://wc?uri=${encodeURIComponent(wcUri)}`;

        this.addLog?.(
          `[open-probe] capture wcUri (len=${wcUri.length}) → normalize → ${mmUrl.startsWith('metamask://') ? 'metamask://...' : mmUrl}`
        );

        return mmUrl;
      };

      // Gatekeeper temporel pour blocage conditionnel
      const shouldBlock = (url: string): boolean => {
        const now = Date.now();

        try {
          const sup = Number(sessionStorage.getItem('st/suppressWcUriUntil') || '0');
          const allow = Number(sessionStorage.getItem('st/allowWcDeeplinkUntil') || '0');
          const allowRunId = Number(sessionStorage.getItem('st/allowWcRunId') || '0');
          const skipAutoRestoreOnce = sessionStorage.getItem('st/skipAutoRestoreOnce') === '1';

          // 🔒 Suppression globale (hard reload/cancel récent)
          if (Number.isFinite(sup) && now < sup) {
            this.addLog?.(
              `[open-probe] BLOCK (global suppress) url=${url} | left=${sup - now}ms`
            );
            return true;
          }

          // MetaMask / WC → deny-by-default si pas de fenêtre d'allow
          if (isMetaLink(url)) {
            if (!Number.isFinite(allow) || now >= allow) {
              this.addLog?.(
                `[open-probe] BLOCK meta-link (deny-by-default) url=${url} | allowUntil=${allow}`
              );
              return true;
            }

            // Optionnel : ici tu peux croiser avec allowRunId si tu encodes le runId dans tes URLs
            this.addLog?.(
              `[open-probe] ALLOW meta-link (window ok) url=${url} | allowUntil=${allow} runId=${allowRunId}`
            );
          }

          // auto-restore skip flag (anti-boucle)
          if (skipAutoRestoreOnce && !isMetaLink(url)) {
            this.addLog?.(
              `[open-probe] skipAutoRestoreOnce actif → BLOCK url=${url}`
            );
            return true;
          }

        } catch {
          // en cas de doute, ne bloque pas plus que nécessaire
        }

        return false;
      };

      // ─────────────────────────────────────────────
      // Patch window.open
      // ─────────────────────────────────────────────
      const origOpen = w.open?.bind(w);
      if (typeof origOpen === 'function') {
        w.open = (...args: any[]) => {
          const raw = args?.[0];
          let url = String(raw ?? '');
          this.addLog?.(`[open] url=${url} | stack=${shortStack()}`);

          if (shouldBlock(url)) return null;

          // ✨ Normalisation WC/MetaMask ici (une fois que le gatekeeper a laissé passer)
          if (isMetaLink(url)) {
            const normalized = captureAndNormalizeMetaUrl(url);
            args[0] = normalized;
            url = normalized;
          }

          return origOpen(...args);
        };
      }

      // ─────────────────────────────────────────────
      // Patch location.assign
      // ─────────────────────────────────────────────
      try {
        const loc = w.location;
        const a0 = loc.assign.bind(loc);
        loc.assign = (u: any) => {
          const raw = String(u || '');
          this.addLog?.(`[open] location.assign → ${raw} | stack=${shortStack()}`);
          if (shouldBlock(raw)) return;

          let newUrl = raw;
          if (isMetaLink(newUrl)) {
            newUrl = captureAndNormalizeMetaUrl(newUrl);
          }
          return a0(newUrl);
        };

        const r0 = loc.replace.bind(loc);
        loc.replace = (u: any) => {
          const raw = String(u || '');
          this.addLog?.(`[open] location.replace → ${raw} | stack=${shortStack()}`);
          if (shouldBlock(raw)) return;

          let newUrl = raw;
          if (isMetaLink(newUrl)) {
            newUrl = captureAndNormalizeMetaUrl(newUrl);
          }
          return r0(newUrl);
        };
      } catch { /* no-op */ }

      // ─────────────────────────────────────────────
      // Patch <a href="..."> (deeplinks)
      // ─────────────────────────────────────────────
      document.addEventListener(
        'click',
        (ev: any) => {
          const a = ev?.target?.closest?.('a[href]');
          if (!a) return;
          const href = String(a.getAttribute('href') || '');
          if (!href) return;
          if (!isMetaLink(href)) return;

          this.addLog?.(`[open] anchor-click → ${href} | stack=${shortStack()}`);

          if (shouldBlock(href)) {
            try {
              ev.preventDefault?.();
              ev.stopPropagation?.();
            } catch { }
            return;
          }

          // Gatekeeper a laissé passer → normaliser l'URL avant navigation
          const normalized = captureAndNormalizeMetaUrl(href);
          if (normalized !== href) {
            a.setAttribute('href', normalized);
          }
        },
        { capture: true, passive: true }
      );

      (w as any).__openProbeInstalled = true;
      this.addLog?.(`[open-probe] installed (${label})`);
    } catch (e: any) {
      this.addLog?.(
        `[open-probe] install failed (soft): ${e?.message || e}`
      );
    }
  }





  /** Anti-spam hard reload (max 1 toutes les 20s) */
  private _reconnectLockUntil = 0;

  /** Détecte toutes les variantes “annulation utilisateur” */
  private isUserRejected(e: any): boolean {
    const code = e?.code ?? e?.error?.code;
    const msg = (e?.message || e?.reason || e?.error?.message || '').toLowerCase();
    return (
      code === 4001 ||                       // EIP-1193 standard
      code === 5000 ||                       // MetaMask mobile
      code === 'ACTION_REJECTED' ||          // ethers v6
      /action_rejected/.test(String(code).toLowerCase()) ||
      /denied|rejected|user denied|user rejected/.test(msg)
    );
  }
  async disconnectWalletReload() {
    await this.wallet.disconnect();
    this.takerAddress = null;
    // 🧹 cleanup portfolio subs (anti refresh/debug leaks)
    try { this._portfolioOwnedSub?.unsubscribe(); } catch { }
    try { this._portfolioBalSub?.unsubscribe(); } catch { }
    this._portfolioOwnedSub = undefined;
    this._portfolioBalSub = undefined;
    this._portfolioKey = null;
    this._portfolioWarmKey = null;
    this._portfolioWarmUntil = 0;
    this._portfolioReadyKey = null;
    this._portfolioReadyAt = 0;
    this._portfolioWarmingKey = null;
    this._portfolioWarmingUntil = 0;
    this._connectUnlockAfterPortfolioKey = null;
    this.userCachedTokens = [];
    this.tokenCachedBalances = {};
  }

  // ─────────────────────────────────────────────
  // Portfolio bind/warmup (cache-first) — anti refresh/debug race
  // ─────────────────────────────────────────────
  private _portfolioKey: string | null = null;
  private _portfolioOwnedSub?: Subscription;
  private _portfolioBalSub?: Subscription;
  private _portfolioWarmKey: string | null = null;
  private _portfolioWarmUntil = 0;
  
    // readiness: évite les faux "fonds insuffisant" juste après un connect (CTA)
    private _portfolioReadyKey: string | null = null;
 private _portfolioReadyAt = 0;

    // warming: diagnostic (non-bloquant) — clé en cours de refresh
    private _portfolioWarmingKey: string | null = null;
  private _portfolioWarmingUntil = 0;

    // connect CTA: on ne déverrouille la validation qu'après warmUp "done" sur la bonne key
    private _connectUnlockAfterPortfolioKey: string | null = null;

   private isPortfolioReadyForKey(key: string): boolean {
      // "ready" = au moins un forceRefresh terminé pour cette key (addr+cid)
        return this._portfolioReadyKey === key && this._portfolioReadyAt > 0;
   }

    private markPortfolioNotReady(key: string): void {
 this._portfolioReadyKey = null;
    this._portfolioReadyAt = 0;
    // warming state reset (propre)
      this._portfolioWarmingKey = key;
   this._portfolioWarmingUntil = Date.now() + 15_000;
  }


  private bindPortfolioIfReady(reason: string): void {
    const cid = Number(this.chainId || 0);
    const addr = (this.takerAddress || '').toLowerCase();

    if (!cid || !addr) {
      this.addLog?.(`[portfolio] bind skip | reason=${reason} addr=${!!addr} cid=${cid || 'null'}`);
      return;
    }

    const key = `${addr}_${cid}`;
    if (this._portfolioKey === key) {
      this.addLog?.(`[portfolio] bind noop | reason=${reason} key=${key}`);
      // même si noop, on tente un warmUp (cas reload/debug=1)
      this.maybeWarmUpPortfolio(reason, key, addr, cid);
      return;
    }

    // cleanup old subs
    try { this._portfolioOwnedSub?.unsubscribe(); } catch { }
    try { this._portfolioBalSub?.unsubscribe(); } catch { }
    this._portfolioOwnedSub = undefined;
    this._portfolioBalSub = undefined;

    this._portfolioKey = key;
       // nouveau couple (addr+chain) => on marque non-prêt jusqu'au warmUp done
          this.markPortfolioNotReady(key);
    this.addLog?.(`[portfolio] bind start | reason=${reason} key=${key}`);

    try { this.portfolio.ensure(cid); } catch { }

    this._portfolioOwnedSub = this.portfolio.ownedTokens$(addr, cid).subscribe(list => {
      this.userCachedTokens = list;
      this.addLog?.(`[portfolio] ownedTokens updated | key=${key} count=${list?.length ?? 0}`);
    });

    this._portfolioBalSub = this.portfolio.tokenBalances$(addr, cid).subscribe(patch => {
      Object.assign(this.tokenCachedBalances, patch);
      this.addLog?.(`[portfolio] tokenBalances patch | key=${key} keys=${Object.keys(patch || {}).length}`);
    });

    this.maybeWarmUpPortfolio(reason, key, addr, cid);
  }

  private maybeWarmUpPortfolio(reason: string, key: string, addr: string, cid: number): void {
    const now = Date.now();
        const force = (this.connectInFlight && this._connectUnlockAfterPortfolioKey === key) || reason === 'legacy-connected';
        if (!force && this._portfolioWarmKey === key && now < this._portfolioWarmUntil) {
            this.addLog?.(`[portfolio] warmUp skip (cooldown) | reason=${reason} key=${key}`);
            return;
          }
        if (force) {
            this.addLog?.(`[portfolio] warmUp FORCE (bypass cooldown) | reason=${reason} key=${key}`);
          }
    // 5s
    // 5s cooldown per key: avoids spam on route changes / debug reloads
    this._portfolioWarmKey = key;
    this._portfolioWarmUntil = now + 5000;

    // next tick: WC silent reattach settles
    setTimeout(async () => {
      try {
        if (!this.isConnected) {
          this.addLog?.(`[portfolio] warmUp abort (not connected) | key=${key}`);
          return;
        }
        this.addLog?.(`[portfolio] warmUp start | reason=${reason} key=${key}`);
               // warming marker (diagnostic)
                  this._portfolioWarmingKey = key;
               this._portfolioWarmingUntil = Date.now() + 15_000;
        await this.portfolio.forceRefresh(addr, cid);

                // READY: un refresh complet vient de finir pour cette key
                  this._portfolioReadyKey = key;
                this._portfolioReadyAt = Date.now();
                this._portfolioWarmingKey = null;
                this._portfolioWarmingUntil = 0;
        


        this.addLog?.(`[portfolio] warmUp done | key=${key}`);


        
                  // 🔓 si ce warmUp correspond à un connect via CTA, on déverrouille maintenant
                  if (this._connectUnlockAfterPortfolioKey === key && this.connectInFlight) {
                      this.connectInFlight = false;
                      this.connectInFlightUntil = 0;
                      this._connectUnlockAfterPortfolioKey = null;
                      this.addLog?.('[CONNECT][flag] connectInFlight=false (after portfolio warmUp done)');
                   }








      } catch (e: any) {
                this.addLog?.(`[portfolio] warmUp error | key=${key} msg=${e?.message ?? e}`);
                // clear warming marker
                  if (this._portfolioWarmingKey === key) {
                      this._portfolioWarmingKey = null;
                      this._portfolioWarmingUntil = 0;
                    }
                // unlock connect mutex even on error (évite blocage UX)
                  if (this._connectUnlockAfterPortfolioKey === key && this.connectInFlight) {
                      this.connectInFlight = false;
                      this.connectInFlightUntil = 0;
                      this._connectUnlockAfterPortfolioKey = null;
                      this.addLog?.('[CONNECT][flag] connectInFlight=false (after portfolio warmUp error)');
                    }
      }
    }, 0);
  }

    private setChain(id: number, source: string = 'ui') {
      const prev = this.chainId;
      const next = Number(id);
  
        // ✅ Guard: ignore invalid chain ids (prevents "null → 137" weird races)
        if (!Number.isFinite(next) || next <= 0) {
            this.addLog(`[wallet] setChain IGNORED (invalid) | source=${source} prev=${prev ?? 'null'} now=${String(id)}`);
            return;
          }
  
        // ✅ Guard: no-op (avoid re-bind + extra balance calls)
        if (prev === next) {
            this.addLog(`[wallet] setChain NOOP | source=${source} chainId=${next}`);
            // still try bind if needed (addr might have arrived after chain)
              this.bindPortfolioIfReady(`setChain(noop:${source})`);
           return;
          }
  
        this.chainId = next;
      this.chainInfo = CHAIN_MAP[next] ?? null;
    
        // Persist last chain (helps restore make sense)
      try { sessionStorage.setItem('st/lastChainId', String(next)); } catch { }

      
          // ✅ Persist desired chain (used by connect flow to avoid fallback to 1)
          try {
              sessionStorage.setItem('st/desiredChainId', String(next));
              this.addLog(`[wallet] desiredChainId set | source=${source} desired=${next}`);
            } catch (e: any) {
                this.addLog(`[wallet] desiredChainId set FAIL | source=${source} desired=${next} err=${e?.message || String(e)}`);
              }

  
        if (!CHAIN_MAP[next]) {
            this.addLog(`[wallet] setChain WARN unknown chainId in CHAIN_MAP | source=${source} now=${next}`);
          }
  
        this.addLog(`[wallet] setChain applied | source=${source} prev=${prev ?? 'null'} now=${next}`);
  
        this.installRpcDebugProbe(`setChain:${source}`);
      this.installRpcDebugProbeOnWindow(`setChain:${source}`);
  
        // ✅ bind tokens/portfolio quand (addr+chainId) sont prêts (anti race)
        this.bindPortfolioIfReady(`setChain:${source}`);
  
        // Si on est connecté, relire la balance (debounce simple)
        if (this.isConnected) {
            clearTimeout((this as any).__nb_to);
           (this as any).__nb_to = setTimeout(() => {
                this.refreshNativeBalance();
                this.addLog(`[wallet] setChain → refreshNativeBalance() triggered | source=${source} chainId=${next}`);
              }, 200);
          }
    }
  private refreshTokensForChain() {
    const logRT = (msg: string, extra?: any) => {
      try {
        const e = extra !== undefined ? ` | ${JSON.stringify(extra)}` : '';
        this.addLog?.(`[swap][refreshTokens] ${msg}${e}`);
      } catch {
        this.addLog?.(`[swap][refreshTokens] ${msg}`);
      }
    };

    if (!this.tokensLoaded || !this.chainId) {
      console.warn('[refreshTokens] Ignored (tokens or chainId not ready)', {
        tokensLoaded: this.tokensLoaded, chainId: this.chainId
      });
      logRT('IGNORED (tokensLoaded/chainId not ready)', {
        tokensLoaded: this.tokensLoaded,
        chainId: this.chainId
      });
      return;
    }

    console.log('[refreshTokens] >>> ENTER chainId=', this.chainId,
      'sell=', this.sellTokenSymbol, 'buy=', this.buyTokenSymbol);

    logRT('ENTER', {
      chainId: this.chainId,
      sell: this.sellTokenSymbol ?? '',
      buy: this.buyTokenSymbol ?? '',
      allTokensCount: (this.allTokens || []).length
    });

    const normalizeNumber = (x: any): number => {
      if (typeof x === 'number') return x;
      if (typeof x === 'string') {
        // supprime espaces, gère virgule décimale, enlève séparateurs de milliers
        let s = x.trim().replace(/\s/g, '');
        if (s.includes(',') && !s.includes('.')) s = s.replace(',', '.');
        s = s.replace(/,/g, '');
        const n = Number(s);
        return isFinite(n) ? n : NaN;
      }
      return NaN;
    };

    // 1) Filtre brut par chaîne
    const rawForChain = (this.allTokens || [])
      .filter(t => Number((t as any).chainId) === Number(this.chainId));

    logRT('rawForChain filtered', {
      chainId: this.chainId,
      rawForChainCount: rawForChain.length
    });

    // 2) Normalisation des tokens (snake → camel, types)
    const normalized = rawForChain.map((t: any) => {
      const chainId = Number(t.chainId);

      // ⚠️ IMPORTANT: c’est ici qu’on veut détecter les schémas d’adresse non gérés
      const address = String((t.address ?? t.address_lower ?? '') || '').toLowerCase();

      const logoURI = t.logoURI ?? t.logo_uri ?? t.logoUrl ?? t.logo_url ?? '';
      const priceUSD = t.priceUSD ?? t.price_usd ?? t.priceUsd;
      const volumeRaw = t.volumeUsd24h ?? t.volume_usd_24h ?? t.volume_usd24h ?? t.volumeUsd24H;

      return {
        ...t,
        chainId,                                // number
        address,                                // lowercase
        logoURI,                                // camelCase
        priceUSD: priceUSD,                     // conserve la source, on normalise pour le map
        volumeUsd24h: normalizeNumber(volumeRaw) || 0,
        symbol: t.symbol,
        name: t.name ?? t.fname ?? t.tokenName ?? t.symbol
      };
    })
      .filter((t: any) => !!t.symbol)
      .sort((a: any, b: any) => (a.symbol || '').localeCompare(b.symbol || ''));

    this.availableTokens = normalized;

    // 🔎 Sanity: combien de tokens sans address ?
    const missingAddrCount = this.availableTokens
      .filter((t: any) => !String(t?.address ?? '').trim()).length;

    logRT('availableTokens ready', {
      chainId: this.chainId,
      availableCount: this.availableTokens.length,
      missingAddrCount
    });

    // 🔎 Snapshot ciblé: tokens qu’on a vus casser la quote (LINK/USDE/ETH) + stables
    const focusSyms = ['USDC', 'USDT', 'DAI', 'ETH', 'WETH', 'LINK', 'USDE'];
    for (const s of focusSyms) {
      const sym = s.toUpperCase();
      const tokAny: any = this.availableTokens.find((t: any) => String(t?.symbol ?? '').toUpperCase() === sym);

      if (!tokAny) {
        logRT('focus token MISSING', { sym, chainId: this.chainId });
      } else {
        logRT('focus token FOUND', {
          sym,
          chainId: tokAny.chainId,
          address: tokAny.address || '',
          // champs suspects pour détecter schema mismatch si address=''
          raw_address: tokAny.address ?? null,
          raw_address_lower: tokAny.address_lower ?? null,
          tokenAddress: (tokAny as any).tokenAddress ?? null,
          contractAddress: (tokAny as any).contractAddress ?? null,
          token_address: (tokAny as any).token_address ?? null
        });
      }
    }

    // 3) priceMap[address_chainId] avec normalisation numérique robuste
    this.priceMap = {};
    for (const t of this.availableTokens as any[]) {
      const p = normalizeNumber((t as any).priceUSD);
      if (t.symbol && t.address && t.chainId && isFinite(p) && p > 0) {
        const key = `${t.address}_${t.chainId}`;
        this.priceMap[key] = p;
      } else {
        // log ciblé utile si un token clé manque (ex: LINK/56)
        if ((t.symbol?.toUpperCase?.() === 'LINK') && t.chainId === 56) {
          console.warn('⛔ LINK/56 skipped (priceUSD invalid)', { addr: t.address, raw: (t as any).priceUSD, parsed: p });
          logRT('LINK/56 skipped (priceUSD invalid)', { addr: t.address || '', raw: (t as any).priceUSD ?? null, parsed: p });
        }
      }
    }

    // 4) Fallback si le token sélectionné n’est plus présent (sans écraser si valide)
    const prefer = ['USDC', 'USDT', 'DAI'];
    const stable: any = this.availableTokens.find((t: any) => prefer.includes((t.symbol || '').toUpperCase()));
    const first = (this.availableTokens[0] as any)?.symbol;

    // SELL
    if (!this.sellTokenSymbol) {
      const fb = stable?.symbol ?? first ?? '';
      console.log('[refreshTokens] SELL vide → fallback', fb);
      logRT('SELL empty -> fallback', { from: this.sellTokenSymbol ?? '', to: fb });
      this.sellTokenSymbol = fb;
    } else if (!this.availableTokens.some((t: any) => t.symbol === this.sellTokenSymbol)) {
      const fb = stable?.symbol ?? first ?? this.sellTokenSymbol;
      console.log('[refreshTokens] SELL invalide sur chain', this.chainId, '→', this.sellTokenSymbol, '→', fb);
      logRT('SELL invalid on chain -> fallback', { chainId: this.chainId, from: this.sellTokenSymbol, to: fb });
      this.sellTokenSymbol = fb;
    } else {
      console.log('[refreshTokens] SELL conservé =', this.sellTokenSymbol);
      logRT('SELL kept', { sell: this.sellTokenSymbol });
    }

    // BUY
    if (!this.buyTokenSymbol) {
      const fb = stable?.symbol ?? first ?? '';
      console.log('[refreshTokens] BUY vide → fallback', fb);
      logRT('BUY empty -> fallback', { from: this.buyTokenSymbol ?? '', to: fb });
      this.buyTokenSymbol = fb;
    } else if (!this.availableTokens.some((t: any) => t.symbol === this.buyTokenSymbol)) {
      const fb = stable?.symbol ?? first ?? this.buyTokenSymbol;
      console.log('[refreshTokens] BUY invalide sur chain', this.chainId, '→', this.buyTokenSymbol, '→', fb);
      logRT('BUY invalid on chain -> fallback', { chainId: this.chainId, from: this.buyTokenSymbol, to: fb });
      this.buyTokenSymbol = fb;
    } else {
      console.log('[refreshTokens] BUY conservé =', this.buyTokenSymbol);
      logRT('BUY kept', { buy: this.buyTokenSymbol });
    }

    // 🔎 Check final: est-ce que les symboles sélectionnés ont une address ?
    const selSell = String(this.sellTokenSymbol ?? '').toUpperCase();
    const selBuy = String(this.buyTokenSymbol ?? '').toUpperCase();
    const sellTok: any = this.availableTokens.find((t: any) => String(t?.symbol ?? '').toUpperCase() === selSell);
    const buyTok: any = this.availableTokens.find((t: any) => String(t?.symbol ?? '').toUpperCase() === selBuy);

    logRT('selected tokens sanity', {
      chainId: this.chainId,
      sellSym: selSell,
      sellFound: !!sellTok,
      sellAddr: sellTok?.address || '',
      buySym: selBuy,
      buyFound: !!buyTok,
      buyAddr: buyTok?.address || ''
    });

    // 5) Listes affichées
    this.filteredSellTokens = this.availableTokens;
    this.filteredBuyTokens = this.availableTokens;

    // 6) Populaires + balances
    if (this.availableTokens.length > 0) {
      this.popularTokens = [...this.availableTokens].sort(
        (a: any, b: any) => (b.volumeUsd24h || 0) - (a.volumeUsd24h || 0)
      );
      if (this.takerAddress) {
        logRT('balances: loadBalancesOptimized()', { taker: this.takerAddress, chainId: this.chainId });
        this.loadBalancesOptimized();
      }
    } else {
      console.warn('[Tokens] Liste vide, balances non chargées');
      logRT('availableTokens EMPTY (balances skipped)', { chainId: this.chainId });
    }

    console.log('[refreshTokens] <<< EXIT chainId=', this.chainId,
      'sell=', this.sellTokenSymbol, 'buy=', this.buyTokenSymbol);

    logRT('EXIT', {
      chainId: this.chainId,
      sell: this.sellTokenSymbol ?? '',
      buy: this.buyTokenSymbol ?? '',
      availableCount: this.availableTokens.length
    });
  }



  get fullGasWeiForChild(): bigint {
    return this.debugBypassGasCheck ? this.ZERO_WEI : this.fullGasWei;
  }


  private lockBodyScroll(lock: boolean) {
    const el = document?.documentElement || document?.body;
    if (!el) return;
    if (lock) el.classList.add('overflow-hidden');
    else el.classList.remove('overflow-hidden');
  }



  copyDebugLogs(): void {
    if (!this.debugText) return;

    navigator.clipboard.writeText(this.debugText)
      .then(() => {
        alert('Logs copiés dans le presse-papier 📋');
      })
      .catch(err => {
        console.error('Erreur copie logs', err);
        alert('Impossible de copier les logs.');
      });
  }

  private isMobileDevice(): boolean {
    return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  }
  // de-dupe guard for mobile deeplinks
  private __dlLock = false;
  private __dlLast: { url: string; ts: number } = { url: '', ts: 0 };
  public closeQuoteUI(reason: string) {
    this.closeQuoteWithReason(reason);
  }

  private __dlOpenedForRun: number | null = null; // (déclarée dans la classe)

  /**
 * Open a wallet deeplink at most once per ~2.5s and only once “in flight”.
 * Logs what it does via this.addLog.
 */
  private openDeeplinkOnce(url: string, reason = 'wc', runId?: number): void {
    try {
      const now = Date.now();
      const allowRunId = Number(sessionStorage.getItem('st/allowWcRunId') || '0');
      const allowUntil = Number(sessionStorage.getItem('st/allowWcDeeplinkUntil') || '0');
      const deltaMs = allowUntil - now;

      this.addLog?.(
        `[deeplink][allow-check] reason=${reason} runId=${String(runId ?? '-')} ` +
        `allowRunId=${allowRunId} allowUntil=${allowUntil} now=${now} deltaMs=${deltaMs}`
      );

      // ⛔ Run gate : si un allowRunId est présent, il doit correspondre
      if (allowRunId && (typeof runId !== 'number' || runId !== allowRunId)) {
        this.addLog?.(
          `[deeplink] SKIP (runId mismatch) reason=${reason} runId=${String(runId)} allowRunId=${allowRunId}`
        );
        return;
      }

      // ⛔ Fenêtre d’autorisation expirée
      if (!allowUntil || now >= allowUntil) {
        this.addLog?.(
          `[deeplink] blocked (allow window expired) reason=${reason} now=${now} allowUntil=${allowUntil}`
        );
        return;
      }

      // ⛔ Une seule ouverture par run
      if (typeof runId === 'number' && this.__dlOpenedForRun === runId) {
        this.addLog?.(`[deeplink] skip (run-locked) reason=${reason} runId=${runId}`);
        return;
      }

      // ⛔ Garde globale anti hard reload / cancel récent
      try {
        const sup = Number(sessionStorage.getItem('st/suppressWcUriUntil') || '0');
        if (Number.isFinite(sup) && now < sup) {
          this.addLog?.(
            `[deeplink] global-suppress (${sup - now}ms left) reason=${reason} url=${url}`
          );
          return;
        }
      } catch { /* noop */ }

      // 🩹 HOTFIX : ne jamais ouvrir un metamask:// “nu” (écran 404 MetaMask)
      const u = (url || '').toLowerCase();
      if (u === 'metamask://' || u === 'metamask:' || u === 'metamask:///') {
        this.addLog?.(
          `[deeplink] SKIP bare metamask:// (évite 404 MetaMask) reason=${reason} runId=${String(runId ?? '-')}`
        );
        return;
      }

      // ⛔ Validation de l’URL
      if (!url.includes(':')) {
        this.addLog?.(
          `[deeplink] skip (suspicious url) reason=${reason} url=${String(url)}`
        );
        return;
      }

      // Throttle anti-spam court terme (2.5s)
      const sameUrl = url === this.__dlLast?.url;
      const within = now - (this.__dlLast?.ts || 0) < 2500;
      const bypassThrottle =
        typeof runId === 'number' && this.__dlOpenedForRun !== runId;

      if (this.__dlLock && !bypassThrottle) {
        this.addLog?.(`[deeplink] skip (locked) reason=${reason} url=${url}`);
        return;
      }

      if (sameUrl && within && !bypassThrottle) {
        this.addLog?.(
          `[deeplink] skip (throttled ${now - (this.__dlLast?.ts || 0)}ms) reason=${reason}`
        );
        return;
      }

      // ✅ Pose des marqueurs
      this.__dlLock = true;
      this.__dlLast = { url, ts: now };
      if (typeof runId === 'number') this.__dlOpenedForRun = runId;

      // 🚀 Ouverture réelle du deeplink
      this.addLog?.(`[deeplink] open (${reason}) → ${url}`);
      window.open(url, '_blank');

      // 🔓 Libération du lock quand la fenêtre reprend le focus ou après 2.5s
      const release = () => { this.__dlLock = false; };
      const onVisible = () => {
        if (!document.hidden) {
          release();
          document.removeEventListener('visibilitychange', onVisible);
        }
      };

      document.addEventListener('visibilitychange', onVisible, { once: true });

      setTimeout(() => {
        release();
        document.removeEventListener('visibilitychange', onVisible);
      }, 2500);

    } catch (e: any) {
      this.__dlLock = false;
      this.addLog?.(`[deeplink] open error: ${e?.message || e}`);
    }
  }




  private initVisualViewportSpacer() {
    const vv = (window as any).visualViewport as VisualViewport | undefined;
    if (!vv) return;
    this._vvSpacerEl = document.createElement('div');
    this._vvSpacerEl.style.width = '100%';
    this._vvSpacerEl.style.height = '0px';
    this._vvSpacerEl.style.pointerEvents = 'none';
    document.body.appendChild(this._vvSpacerEl);

    const handler = () => {
      const bottomInset = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
      if (this._vvSpacerEl) this._vvSpacerEl.style.height = `${bottomInset}px`;
    };
    vv.addEventListener('resize', handler);
    vv.addEventListener('scroll', handler);
    handler();

    this._vvCleanup = () => {
      vv.removeEventListener('resize', handler);
      vv.removeEventListener('scroll', handler);
    };
  }

  private teardownVisualViewportSpacer() {
    try { this._vvCleanup?.(); } finally { this._vvCleanup = undefined; }
    if (this._vvSpacerEl?.parentNode) this._vvSpacerEl.parentNode.removeChild(this._vvSpacerEl);
    this._vvSpacerEl = undefined;
    // Safety: s’assurer que le body n’est pas resté “fixed”
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
  }


  closeQuote() {
    this.quote = null;
    // Optionnel mais propre : on nettoie l’état de validation
    this.swapDisabled = false;
    this.swapReasons = [];
    this.swapStatus = 'idle';
    this.swapHash = null;
    this.swapError = null;

    this.lockBodyScroll(false); //
  }
  ngOnDestroy() {
    this.lockBodyScroll(false);
    try { this.teardownVisualViewportSpacer(); } catch { }
    try {
      const vv = (window as any).visualViewport;
      if (vv && this._vvHandlersAttached) {
        vv.removeEventListener('resize', this._onVvResize);
        vv.removeEventListener('scroll', this._onVvResize);
        this._vvHandlersAttached = false;
      }
    } catch { }
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }








  async ngOnInit(): Promise<void> {
    // ─────────────────────────────────────────────────────────────
    // [i18n boot] choisir la langue effective + synchroniser localStorage.lang
    // ─────────────────────────────────────────────────────────────
    try {
      // langues enregistrées dans Translate (si dispo)
      const langs = (this.translate.getLangs && this.translate.getLangs().length)
        ? this.translate.getLangs()
        : ['en', 'fr', 'es', 'pt', 'id', 'hi', 'af', 'zu']; // petit fallback défensif

      const stored = localStorage.getItem('lang') || '';
      const browserRaw = (navigator.language || (navigator.languages?.[0] || 'en'));
      const browser = browserRaw.split('-')[0]; // "fr-FR" → "fr"

      let effective = '';

      // 1) priorité à la langue déjà choisie par l’utilisateur (si encore supportée)
      if (stored && langs.includes(stored)) {
        effective = stored;
      }
      // 2) sinon, langue du navigateur si supportée
      else if (browser && langs.includes(browser)) {
        effective = browser;
      }
      // 3) sinon, fallback sur defaultLang ou 'en'
      else {
        effective = (this.translate.getDefaultLang && this.translate.getDefaultLang()) || 'en';
      }

      this.translate.use(effective);
      localStorage.setItem('lang', effective);
      this.addLog?.(`[i18n] boot | stored=${stored || '-'} browser=${browser} → effective=${effective}`);
    } catch (e: any) {
      this.addLog?.('[i18n] boot error ' + (e?.message || e));
    }

    // ─────────────────────────────────────────────────────────────
    // Helpers RESET WC v2 (1) teardown AppKit (2) kill sessions (3) purge IndexedDB
    // ─────────────────────────────────────────────────────────────
    const teardownAppKit = () => {
      try {
        const w: any = window as any;
        // différentes impls possibles selon ta version d’AppKit
        w?.appkit?.destroy?.();
        w?.appKit?.destroy?.();
        w?.modal?.destroy?.();
        // coupe aussi un éventuel provider déjà créé
        w?.appkit?.getProvider?.()?.disconnect?.();
      } catch { }
    };

    const killWalletConnectV2 = async () => {
      try {
        const client = await SignClient.init({
          projectId: '8d74b0ff39c361ecaa9c3dd96ac0055c' // ⬅️ ton projectId
        });
        // sessions
        const sessions = client.session.getAll?.() ?? [];
        for (const s of sessions) {
          try {
            await client.disconnect({
              topic: s.topic,
              reason: { code: 6000, message: 'user reset' }
            });
          } catch { }
        }
        // pairings
        const pairings = client.core?.pairing?.getPairings?.() ?? [];
        for (const p of pairings) {
          try {
            await client.core.pairing.disconnect({ topic: p.topic });
          } catch { }
        }
      } catch (e) {
        this.addLog?.('[RESET] killWalletConnectV2 error ' + e);
      }
    };
    // ─────────────────────────────────────────────────────────
    // Pont global pour display_uri → wallet.wcUri$
    // ─────────────────────────────────────────────────────────
    try {
      (window as any).__onWcDisplayUri = (uri: string) => {
        const safe = uri || '';
        (window as any)._wcLastUri = safe; // 🔍 trace brute globale

        this.addLog?.(
          `[wc][display_uri] received | len=${safe.length} | head=${safe.slice(0, 32)}…`
        );

        // 🧪 Voir ce que AppKit a dans sa modale au moment du display_uri
        try {
          const w: any = window as any;
          this.addLog?.(
            '[wc][display_uri][SAFE] ' +
            safeJson(
              {
                uri: safe,
                appKitModalKeys: Object.keys(w.appKitModal || {}),
                appKitModal: w.appKitModal,
                lastAppkitDisplayUri: w._appkit_last_display_uri,
              },
              1
            )
          );
        } catch (e: any) {
          this.addLog?.('[wc][display_uri][SAFE] error ' + (e?.message || e));
        }


        try {
          this.wallet.wcUri$.next(safe || null);
          this.addLog?.('[wc][display_uri] pushed into wallet.wcUri$');
        } catch (err: any) {
          this.addLog?.(
            `[wc][display_uri] push error | ${err?.message ?? err}`
          );
        }
      };

      this.addLog?.('[wc][display_uri] hook installed in ngOnInit');
    } catch {
      // no-op
    }

    const purgeWCIndexedDB = async () => {
      const dbs = [
        'walletconnect',
        'wc@2:client',
        'appkit',
        'wagmi',
        'web3modal'
      ];
      await Promise.allSettled(
        dbs.map(
          name =>
            new Promise<void>(resolve => {
              let done = false;
              const finish = () => { if (!done) { done = true; resolve(); } };
              const req = indexedDB.deleteDatabase(name);
              req.onsuccess = finish;
              req.onerror = finish;
              req.onblocked = finish;
            })
        )
      );
    };
    try {
      const params = new URLSearchParams(location.search);
      if (params.get('resetwc') === '1') {
        const clear = (store: Storage, match: (k: string) => boolean) => {
          const keys: string[] = [];
          for (let i = 0; i < store.length; i++) {
            const k = store.key(i)!;
            if (match(k)) keys.push(k);
          }
          keys.forEach(k => { try { store.removeItem(k); } catch { } });
        };

        // 🔑 Listes exhaustives de clés connues (LS/SS) à purger
        const EXACT_KEYS_LS = [
          // pending swap/bridge (anciennes & nouvelles variantes)
          'swap/pendingTx/v1', 'bridge/pendingTx/v1',
          'swap.pending.hash', 'swap.pending.addr', 'swap.pending.chainId', 'swap.pending.ts',
          'bridge.pending.hash', 'bridge.pending.addr', 'bridge.pending.chainId', 'bridge.pending.ts',
          // choix/deeplink web3modal/appkit
          'WALLETCONNECT_DEEPLINK_CHOICE', 'WCM_SELECTED_WALLET',
          'appkit:preferred_wallet', 'reown:recent_wallet'
        ];
        const EXACT_KEYS_SS = [
          // gates deeplink / cooldown flags (avec et sans préfixe st/)
          'st/allowWcDeeplinkUntil', 'st/allowWcRunId',
          'st/suppressWcUriUntil', 'st/supWcUriUntil',
          'st/supAutoRestoreUntil', 'st/supWcAutoRestoreUntil',
          'st/skipWcDeeplinkOnce', 'st/skipAutoRestoreOnce',
          'allowWcDeeplinkUntil', 'allowWcRunId',
          'suppressWcUriUntil', 'skipWcDeeplinkOnce', 'skipAutoRestoreOnce'
        ];

        // (1) Teardown AppKit pour empêcher la réhydratation auto
        teardownAppKit();

        // (2) Kill TOUTES les sessions + pairings WalletConnect v2
        await killWalletConnectV2();

        // (3) Purge IndexedDB (walletconnect/appkit/wagmi/web3modal)
        await purgeWCIndexedDB();

        // (4) Nettoyage mémoire & flags runtime (optionnel mais propre)
        try {
          const w: any = window as any;
          (w as any)._wcLastUri = null;
          (w as any).__wcActiveUri = null;
          (w as any).__dlOpenedForRun = null;
        } catch { }
        try {
          sessionStorage.removeItem('st/allowWcDeeplinkUntil');
          sessionStorage.removeItem('st/allowWcRunId');
          sessionStorage.removeItem('skipWcDeeplinkOnce');
          sessionStorage.removeItem('st/suppressWcUriUntil');
          // Purge ciblée SS (exactes)
          for (const k of EXACT_KEYS_SS) { try { sessionStorage.removeItem(k); } catch { } }
        } catch { }

        const matcher = (k: string) =>
          // pending states & runtime flags
          /^(swap|bridge)\.pending/i.test(k) ||
          /^st\//i.test(k) ||
          // walletconnect / wc core / appkit / wagmi / web3modal / reown namespaces
          /^(wc@2:|wc:|walletconnect|appkit|wagmi|web3modal|reown)/i.test(k) ||
          // web3modal choices/selection
          /WALLETCONNECT_DEEPLINK_CHOICE|WCM_SELECTED_WALLET/i.test(k);

        // Purge ciblée LS (exactes) + regex matcher
        for (const k of EXACT_KEYS_LS) { try { localStorage.removeItem(k); } catch { } }
        clear(localStorage, matcher);
        clear(sessionStorage, matcher);

        this.addLog('[RESET] WC/AppKit: teardown + kill sessions/pairings + purge IDB + clear LS/SS');
        // reload propre sans query
        location.replace(location.pathname);
      }
    } catch (err) {
      this.addLog('[RESET] erreur durant purge ' + err);
    }

    // ─────────────────────────────────────────────────────────────
    // Installation d'une sonde globale pour intercepter window.open
    // ─────────────────────────────────────────────────────────────
    const w: any = window as any;
    if (!(w as any).__openProbeInstalled) {
      (w as any).__openProbeInstalled = true;
      const origOpen = w.open.bind(w);
      w.open = (url: string, target?: string, feat?: string) => {
        try {
          const allow = Number(sessionStorage.getItem('st/allowWcDeeplinkUntil') || '0');
          const allowRun = Number(sessionStorage.getItem('st/allowWcRunId') || '0');
          const now = Date.now();
          if (!Number.isFinite(allow) || now >= allow) {
            console.warn(`[deeplink][probe] BLOCK url=${url} reason=deny-by-default allowRunId=${allowRun}`);
            return null;
          }
          const match = typeof allowRun === 'number' && allowRun > 0;
          if (match && !String(url).includes('metamask://') && !String(url).includes('wc?')) {
            console.warn(`[deeplink][probe] BLOCK url=${url} reason=not-wallet-link allowRunId=${allowRun}`);
            return null;
          }
          console.log(`[deeplink][probe] ALLOW url=${url} allowRunId=${allowRun}`);
          // One-shot: clear immédiatement après ouverture
          sessionStorage.removeItem('st/allowWcDeeplinkUntil');
          sessionStorage.removeItem('st/allowWcRunId');
          return origOpen(url, target, feat);
        } catch (e) {
          console.error(`[deeplink][probe] EXC ${e}`);
          return origOpen(url, target, feat);
        }
      };
      this.addLog?.('[open-probe] installed (ngOnInit)');
    } else {
      this.addLog?.('[open-probe] already installed (ngOnInit)');
    }












    // au tout début de ngOnInit()
    this.initVisualViewportSpacer();
    this._installQuotePropDebugHook();
    let skipDeeplinkOnce = false;
    let suppressWcUriUntil = 0;
    try {
      skipDeeplinkOnce = sessionStorage.getItem('skipWcDeeplinkOnce') === '1';
      if (skipDeeplinkOnce) sessionStorage.removeItem('skipWcDeeplinkOnce');

      const sup = Number(sessionStorage.getItem('st/suppressWcUriUntil') || '0');
      suppressWcUriUntil = Number.isFinite(sup) ? sup : 0;
    } catch { }


    this.installWindowOpenProbe('ngOnInit');
    // 1) Récupérer l’état SSR si présent
    this._ssrTokens = this.ts.get(TOKENS_SSR_KEY, null as any);
    this._ssrChainId = this.ts.get(CHAIN_SSR_KEY, null as any);
    this.route.queryParamMap.subscribe(p => {
      if (p.get('debug') === '1') {
        this.showDebug = true;
        this.addLog('🪵 Debug mode enabled via ?debug=1');
      }
    });
    const pending = this.loadPendingSwap?.();
    if (pending?.hash && Number.isFinite(pending.chainId)) {
      this.addLog(`🧯 [boot] pending swap found → resume watch ${pending.hash}`);
      // ne ferme pas l’UI; remet en pending et surveille
      try { await this.watchSwapReceiptUntilFinal(pending.hash, pending.chainId); } catch { }
    }
    if (Array.isArray(this._ssrTokens) && this._ssrTokens.length > 0) {
      // ✅ Reuse SSR → pas de refetch
      console.info('[Client] tokens reused from SSR:', this._ssrTokens.length);

      this.allTokens = this._ssrTokens;     // ⚠️ adapte si ton backing store a un autre nom
      this.tokensLoaded = true;

      // Chaîne initiale: priorité SEO, sinon SSR, sinon 1
      const initialChain = this.seoChainId ?? this._ssrChainId ?? 1;
      if (!this.chainId) this.chainId = initialChain;
      this.chainInfo = CHAIN_MAP[this.chainId] ?? null;
      this.swapApi.setChainId(this.chainId);

      // Normalisation + listes + popular + (balances si address déjà connue)
      this.refreshTokensForChain();

    } else {
      // ❌ Pas de SSR → fallback client (appel unique)
      console.info('[Client] no SSR tokens → fallback to client fetch');

      this.swapApi.getAvailableTokens().subscribe({
        next: tokens => {
          this.allTokens = tokens ?? [];
          this.tokensLoaded = true;

          // Si aucune chaîne fixée, prends SEO si dispo, sinon 1
          if (!this.chainId) {
            const cid = this.seoChainId ?? 1;
            this.chainId = cid;
            this.chainInfo = CHAIN_MAP[cid] ?? null;
            this.swapApi.setChainId(cid);
            console.log('[INIT] chainId initialisé via', this.seoChainId ? 'SEO' : 'fallback', '→', cid);
          }
          this.applyHotStartDefaults(this.chainId!);
          this.refreshTokensForChain();

          // 👉 si tu as des "defaults UI" (USDC/ETH, nearby lists…), garde ton bloc tel quel ici.
        },
        error: err => console.error('Erreur récupération tokens :', err)
      });
    }

    // 2) Non-bloquant après paint (client only)
    if (isPlatformBrowser(this.platformId)) {
      if (this.takerAddress) {
        this.balancesLoading = true;
        this.loadBalancesOptimized().finally(() => this.balancesLoading = false);
      } else {
        // pas d’adresse → pas de chargement de balances, enlève le skeleton
        this.balancesLoading = false;
      }
    }
    const skip = localStorage.getItem('st/skipAutoRestoreOnce') === '1';
    const eth = (window as any).ethereum;
    const ua = navigator.userAgent || '';

    this.isMMInApp = !!eth?.isMetaMask && /MetaMaskMobile/i.test(ua);
    this.hasMMExt = !!eth?.isMetaMask && !/MetaMaskMobile/i.test(ua);
    this.isMobile = /iPhone|iPad|iPod|Android/i.test(ua);

    // Desktop sans MetaMask → init WalletConnect v2
    if (!this.isMobile && !this.hasMMExt) {
      this.addLog?.('[wc2] init requested (desktop, no MM extension)');
      try {
        await this.wc2.init('8d74b0ff39c361ecaa9c3dd96ac0055c');
        this.addLog?.('[wc2] init done (no error thrown)');
      } catch (e: any) {
        this.addLog?.('[wc2] init ERROR ' + (e?.message || e));
      }
    }


    // Address → ferme la modale WC si connecté
    this.wallet.address$.subscribe(addr => {
      if (addr) {
        this.showWcModal = false;
        this.wcUri = '';
      }
    });

    // Devise & taux fiat
    // Devise & taux fiat
    const savedCurrency = localStorage.getItem('currency');
    if (savedCurrency) this.defaultFiat = savedCurrency;

    this.fiatLoading = true;
    this.price.fetchFiatRates().subscribe({
      next: rates => {
        this.fiatRates = rates;
        this.fiatLoading = false;      // ✅ débloque l’affichage
      },
      error: err => {
        console.warn('[fiat] fetchFiatRates failed', err);
        this.fiatRates = { USD: 1 };   // petit fallback
        this.fiatLoading = false;      // ✅ ne laisse pas l’UI bloquée
      }
    });


    // ---- (1) chainId$ : ne pas écraser le réseau imposé par le SEO tant que lock actif
    this.sub = this.wallet.chainId$.subscribe(id => {
      this.zone.run(() => {
        this.addLog(`[wallet] chainId$ emitted → ${id}`);
        if (this.lockChainToSeo && this.seoChainId != null) {
          if (id === this.seoChainId) {
            this.lockChainToSeo = false;        // le wallet a rejoint le réseau SEO → on déverrouille
          } else {
            this.addLog(`[wallet] chainId ignored due to SEO lock (seoChainId=${this.seoChainId}, got=${id})`);
            return;                              // on ignore tant que le wallet est sur un autre réseau
          }
        }
        const prev = this.chainId;
        this.chainId = id;
        this.chainInfo = id ? CHAIN_MAP[id] ?? null : null;
        this.swapApi.setChainId(id);
        this.refreshTokensForChain();
        this.refreshNativeBalance();
        this.cd.detectChanges();
        this.addLog(`[wallet] chainId set | prev=${prev ?? 'null'} now=${id}`);
      });
    });

    // ---- (2) wallet address
    this.wallet.address$.subscribe(addr => {
      this.addLog(`[wallet] address$ emitted → ${addr || '(null)'}`);
      const prev = this.takerAddress;
      this.takerAddress = addr;

      if (addr) {
        this.balancesLoading = true;
        this.loadBalancesOptimized().finally(() => this.balancesLoading = false);
        this.refreshNativeBalance();
        this.addLog(`[wallet] takerAddress set | prev=${prev || '(null)'} now=${addr}`);
        if (this.takerAddress && this.chainId != null) {
          console.log(`portfolio.warmUp`);
          this.allChainIds = [1, 137, 42161, 56];
          this.portfolio.warmUp(this.takerAddress, this.chainId, this.allChainIds);




          this.portfolio.ownedTokens$(this.takerAddress, this.chainId).subscribe(list => {
            this.userCachedTokens = list;                                // ✅ mêmes clés / même variable
          });

          // Soldes (patches) → fusion dans tokenBalances
          this.portfolio.tokenBalances$(this.takerAddress, this.chainId).subscribe(patch => {
            Object.assign(this.tokenCachedBalances, patch);              // ✅ mêmes clés "<addr>_<cid>"
          });
        }
      } else {
        // reset propre si déconnexion
        this.tokenCachedBalances = {};
        this.userTokens = [];
        this.balancesLoading = false;
        this.currentNativeBalanceWei = 0n;
        this.addLog('[wallet] cleared state after disconnect');
      }
    });


    // ---- (3) WalletConnect URI (QR / deep-link)
    this.wallet.wcUri$.subscribe(uri => {
      this.wcUri = uri ?? '';
      this.showWcModal = !!uri;

      const lastRaw = (window as any)._wcLastUri || '';
      const same = !!uri && !!lastRaw && uri === lastRaw;

      this.addLog(
        `[wc][uri$] got=${!!uri}` +
        (uri ? ` | len=${uri.length}` : '') +
        (lastRaw
          ? ` | lastRaw.len=${lastRaw.length} sameAsLast=${same}`
          : ' | lastRaw=(empty)')
      );

      // (legacy) skip exact one-shot
      if (skipDeeplinkOnce) {
        this.addLog('[deeplink] skip once due to cancel/hard-reload');
        skipDeeplinkOnce = false;
        return;
      }

      if (Date.now() < suppressWcUriUntil) {
        this.addLog(
          `[deeplink] suppressed by cooldown (${suppressWcUriUntil - Date.now()}ms left)`
        );
        return;
      }

      if (uri) {
        this.addLog('[wc][uri$] modal only (no auto-deeplink)');
      }
    });


    try {
      const cached = sessionStorage.getItem('st/wcLastUri') || '';
      if (cached && /^wc:/i.test(cached)) {
        this.addLog?.(
          `[wc][uri$][restore] reusing cached wcUri from sessionStorage | len=${cached.length}`
        );
        (this as any)._wcLastUri = cached;
        this.wcUri = cached;
        (this as any)._wcUri$?.next?.(cached);
      } else {
        this.addLog?.('[wc][uri$][restore] no cached wcUri');
      }
    } catch {
      this.addLog?.('[wc][uri$][restore] error reading sessionStorage');
    }


    // ---- (4) Restauration session locale
    const savedWallet = !skip ? localStorage.getItem('wallet') : null;
    if (savedWallet) this.takerAddress = savedWallet;

    if (!modal) initAppKit('8d74b0ff39c361ecaa9c3dd96ac0055c');
    const last = loadSimpleSession();
    if (last) {
      this.setChain(last.chainId);              // ⚠️ n’affirme pas la connexion provider
      this.isConnected = false;
    }

    this.subscribeEvmChanges();
    void this.restoreSessionDocStyle();
    void this.restoreSessionIfAny();

    // ---- (5) Chargement des tokens
    this.swapApi.getAvailableTokens().subscribe({
      next: tokens => {
        this.allTokens = tokens;
        this.tokensLoaded = true;

        // Si aucun chainId n’est fixé, prends SEO si dispo, sinon 1 (Ethereum)
        if (!this.chainId) {
          const forced = this.seoChainId;
          const cid = forced ?? 1;
          this.chainId = cid;
          this.chainInfo = CHAIN_MAP[cid];
          this.swapApi.setChainId(cid);
          console.log('[INIT] chainId initialisé via', forced ? 'SEO' : 'fallback', '→', cid);
        }
        this.refreshTokensForChain();

        // Defaults UI (gardés, n'écrasent pas une sélection valide)
        const defaultSellSymbol = 'USDC';
        const defaultBuySymbol = 'ETH';  // garde ETH si c’est ton buy par défaut

        const sellValid = this.availableTokens.some(t => t.symbol === this.sellTokenSymbol);
        const buyValid = this.availableTokens.some(t => t.symbol === this.buyTokenSymbol);

        if (!sellValid) {
          console.log('[defaultsUI] apply SELL →', defaultSellSymbol);
          this.sellTokenSymbol = defaultSellSymbol;
        } else {
          console.log('[defaultsUI] keep SELL =', this.sellTokenSymbol);
        }

        if (!buyValid) {
          console.log('[defaultsUI] apply BUY →', defaultBuySymbol);
          this.buyTokenSymbol = defaultBuySymbol;
        } else {
          console.log('[defaultsUI] keep BUY =', this.buyTokenSymbol);
        }

        // Construire les listes autour de la sélection finale (sans la changer)
        const indexSell = this.availableTokens.findIndex(t => t.symbol === this.sellTokenSymbol);
        const indexBuy = this.availableTokens.findIndex(t => t.symbol === this.buyTokenSymbol);
        const getNearby = (i: number) => this.availableTokens.slice(Math.max(0, i - 10), i + 10);
        this.filteredSellTokens = getNearby(indexSell);
        this.filteredBuyTokens = getNearby(indexBuy);


        // Query params → pré-remplissage + auto-quote
        this.route.queryParams.subscribe((params: Params) => {
          const tokenIn = params['tokenIn'];
          const tokenOut = params['tokenOut'];
          const amountInRaw = params['amountIn'];

          // NEW: support fromChainId (fallback sur chainId)
          const fromChainIdRaw = params['fromChainId'] ?? params['chainId'];
          const fromChainId = Number(fromChainIdRaw);
          if (fromChainId && !Number.isNaN(fromChainId)) {
            this.setChain(fromChainId);              // met à jour chainId + chainInfo
            this.selectedNetwork = fromChainId;      // garde l’UI en phase
            this.swapApi.setChainId(fromChainId);
            this.refreshTokensForChain();
          }

          if (tokenIn) this.sellTokenSymbol = tokenIn;
          if (tokenOut) this.buyTokenSymbol = tokenOut;

          if (amountInRaw) {
            const amountIn = parseFloat(amountInRaw);
            if (!isNaN(amountIn) && amountIn > 0) this.sellAmount = amountIn.toString();
          }

          //if (this.sellTokenSymbol && this.buyTokenSymbol && this.sellAmount && (params['tokenIn'] || params['fromChainId'])) {
          //  this.fetchQuote();
          //}
        });


        // ---------- (6) SEO depuis la route parente (SeoLandingComponent) ----------
        const applyResolved = (resolved: ResolvedSeo | undefined) => {
          if (!resolved) return;

          // a) langue = celle du resolver (URL) → cohérence UI + SEO
          // utilitaire compact
          const getParam = (r: ActivatedRoute, k: string): string => {
            // 1) route courante
            const v1 = r.snapshot.paramMap.get(k);
            if (v1) return v1;

            // 2) parent direct
            const v2 = r.parent?.snapshot.paramMap.get(k);
            if (v2) return v2;

            // 3) premier enfant de la racine (au cas où)
            const v3 = r.root.firstChild?.snapshot.paramMap.get(k);
            return v3 ?? '';
          };

          // ---
          const urlLoc = getParam(this.route, 'locale').toLowerCase();
          console.log('locale from URL =', urlLoc || '(empty)');
          const loc = urlLoc || 'en'; // ou 'hi' si tu veux forcer un défaut
          this.translate.use(loc);
          localStorage.setItem('lang', loc);

          this.translate.use(loc);
          localStorage.setItem('lang', loc);

          // b) base i18n optionnelle (si tu utilises des clés)
          this.tBase = resolved.tKey ? `SEO_PAGES.${resolved.tKey}` : 'SEO_PAGES';

          // c) valeurs SEO (priorité aux textes fournis par le resolver)
          const title =
            resolved.page?.title ??
            this.translate.instant(`${this.tBase}.TITLE`) ??
            'Swap Tokens';

          const meta =
            resolved.page?.metaDescription ??
            this.translate.instant(`${this.tBase}.META`) ??
            'Swap instantané sur EVM (Polygon, Arbitrum, BSC, Ethereum).';

          const h1 =
            resolved.page?.h1 ??
            this.translate.instant(`${this.tBase}.H1`) ??
            'Swap Tokens (EVM)';

          const ed =
            resolved.page?.editorial ??
            this.translate.instant(`${this.tBase}.EDITORIAL`) ??
            'Comparez les meilleurs taux via notre agrégateur (Uniswap, 1inch, Paraswap…).';

          // d) UI
          this.editorialH1 = h1;
          this.editorialBody = ed;

          // e) Balises <title> + <meta> + FAQ JSON-LD
          this.appSeo.apply(
            {
              slug: resolved.slug,
              tKey: resolved.tKey,
              ctaParams: resolved.ctaParams,
              title,
              metaDescription: meta,
              h1,
              editorial: ed,
              faq: resolved.page?.faq ?? []
            } as any,
            this.seoContent.getDefaults(),
            window?.location?.href || resolved.canonicalPath
          );
          this.faqJsonLd = this.seoContent.buildFaqJsonLd(
            resolved,
            window?.location?.href || resolved.canonicalPath
          );

          // f) CTA de la page SEO (sans écraser les choix user / query params)
          if (resolved.ctaParams || resolved.page?.ctaParams) {
            this.applyCtaDefaultsFromSeo(resolved);
          }
        };

        // Lecture réactive des données du resolver (mise à jour quand :locale/:slug changent)
        this.route.parent?.data.subscribe(d => {
          // Le resolver met son résultat sous la clé 'seo'
          const wrap = d['seo'] as UniversalSeoResolved | ResolvedSeo | null | undefined;

          // Supporte les deux cas: wrapper {type, resolved} ou ResolvedSeo direct
          const resolved: ResolvedSeo | undefined =
            wrap && 'resolved' in (wrap as any) ? (wrap as any).resolved as ResolvedSeo
              : (wrap as ResolvedSeo | undefined);

          if (resolved) {
            this.seoResolved = resolved;
            applyResolved(resolved);
          } else if (this.seoPage && this.swapPrefill) {
            // fallback @Input (comme tu l’avais)
            const urlLoc = (this.route.parent?.snapshot.paramMap.get('locale') || '').toLowerCase();
            const loc = urlLoc || 'en';
            const fake: ResolvedSeo = {
              locale: 'hi',
              slug: '',
              tKey: this.tBase?.split('.').pop() || '',
              ctaParams: this.swapPrefill!,
              canonicalPath: window?.location?.pathname || '/',
              page: {
                tKey: '',
                ctaParams: this.swapPrefill!,
                title: this.seoPage?.title,
                metaDescription: this.seoPage?.metaDescription,
                h1: this.seoPage?.h1,
                editorial: this.seoPage?.editorial,
                faq: this.seoPage?.faq
              }
            };
            this.seoResolved = fake;
            applyResolved(fake);
          } else {
            console.warn('[SEO] ni parent.data.seo ni @Input seoPage/swapPrefill → UI par défaut');
          }
        });
        // --------------------------------------------------------------------------
      },
      error: err => console.error('Erreur récupération tokens :', err)
    });


    const vv = (window as any).visualViewport;
    if (vv && !this._vvHandlersAttached) {
      vv.addEventListener('resize', this._onVvResize);
      vv.addEventListener('scroll', this._onVvResize);
      this._vvHandlersAttached = true;
      // première mesure
      this._onVvResize();
    }
  }

  // 🔹 Ajoute ça dans ton component (ou un utils partagé)
  private getSimFailLabel(err: any): string {
    try {
      const raw: string | undefined =
        err?.error?.data ?? err?.data ?? err?.info?.error?.data ?? err?.reason;

      // Panic(uint256)
      if (typeof raw === 'string' && raw.startsWith('0x4e487b71')) {
        const code = Number(BigInt('0x' + raw.slice(74, 138)));
        const table: Record<number, string> = {
          0x01: 'assertion', 0x11: 'overflow/underflow', 0x12: 'div by zero',
          0x21: 'invalid enum', 0x22: 'bytes OOB', 0x31: 'pop empty array',
          0x32: 'array OOB', 0x41: 'alloc error', 0x51: 'abi.decode OOB'
        };
        return `panic:${table[code] ?? 'unknown'}`;
      }

      // Error(string)
      if (typeof raw === 'string' && raw.startsWith('0x08c379a0')) {
        try {
          const msg = ethers.toUtf8String('0x' + raw.slice(138));
          // tronquer proprement si trop long
          const short = msg.length > 80 ? msg.slice(0, 77) + '…' : msg;
          return `revert:${short}`;
        } catch { /* ignore */ }
      }

      // Custom errors usuelles (nom seul, sans args)
      try {
        const ifc = new ethers.Interface([
          'error InsufficientOutput()',
          'error SlippageExceeded()',
          'error TooLittleReceived()',
          'error TransferFailed()',
          'error InsufficientAllowance()',
          'error InvalidPermit()',
          'error SignatureExpired()',
        ]);
        const dec = ifc.parseError(raw as any);
        if (dec?.name) return `revert:${dec.name}`;
      } catch { /* ignore */ }

      // Messages provider courts si dispo
      if (typeof err?.error?.message === 'string') return err.error.message;
      if (typeof err?.message === 'string') return err.message;
    } catch { /* ignore */ }

    return 'execution reverted';
  }


  private async refreshNativeBalance(): Promise<void> {
    const TAG = '[swap][nativeBalance]';
    try {
      const addr = this.takerAddress;
      const cid = this.chainId;

      // 0) Garde-fous
      if (!addr || !cid) {
        this.currentNativeBalanceWei = 0n;
        this.addLog(`${TAG} skip: missing addr/chainId | addr=${!!addr} cid=${cid ?? 'null'}`);
        return;
      }

      // 1) Provider valide ?
      const prov = this.provider as unknown as ethers.Provider | null;
      const hasGetBal = !!prov && typeof (prov as any).getBalance === 'function';
      if (!hasGetBal) {
        this.currentNativeBalanceWei = 0n;
        this.addLog(`${TAG} skip: provider invalid (no getBalance) | provider=${!!prov}`);
        return;
      }

      // 2) Contexte chaîne (pour lecture rapide des logs)
      const sym =
        cid === 137 ? 'POL' :
          cid === 42161 ? 'ETH' :
            cid === 56 ? 'BNB' :
              'ETH';

      // 3) Fetch + chronométrage
      const t0 = (typeof performance !== 'undefined' ? performance.now() : Date.now());
      this.addLog(`${TAG} fetching… addr=${addr} | chainId=${cid} (${sym})`);
      let bal = await (prov as any).getBalance(addr);
      const t1 = (typeof performance !== 'undefined' ? performance.now() : Date.now());
      const ms = Math.round(t1 - t0);

      // 4) Normalisation -> bigint
      const asBig = typeof bal === 'bigint' ? bal : BigInt(bal ?? 0);
      this.currentNativeBalanceWei = asBig;

      // 5) Lecture humaine (⚠️ seulement pour debug/affichage)
      const human = (() => {
        try { return ethers.formatEther(asBig); } catch { return '0'; }
      })();

      // 6) Logs détaillés
      this.addLog(`${TAG} ok in ${ms}ms | wei=${asBig.toString()} | ~${human} ${sym}`);

      // 7) Forcer le rafraîchissement UI
      this.cd.detectChanges();
    } catch (e: any) {
      console.warn(`${TAG} failed`, e);
      this.addLog(`${TAG} error: ${e?.message ?? e}`);
      this.currentNativeBalanceWei = 0n;
    }
  }

  private async attachEthersProvider(eip1193: any): Promise<void> {
    if (!eip1193 || typeof eip1193.request !== 'function') {
      console.warn('[attachEthersProvider] Provider invalide');
      return;
    }

    const TAG = '[attachEthersProvider]';

    try {
      // ─────────────────────────────────────────────
      // 1️⃣ Log et analyse du provider brut
      // ─────────────────────────────────────────────
      this.addLog?.(`${TAG} raw=${!!eip1193} has.request=${typeof eip1193?.request === 'function'} isMM=${!!eip1193?.isMetaMask} isWC=${!!eip1193?.isWalletConnect}`);
      console.log(`${TAG} Raw provider`, eip1193);

      // ─────────────────────────────────────────────
      // 2️⃣ Création du provider ethers
      // ─────────────────────────────────────────────
      this.provider = new BrowserProvider(eip1193);
      this.rawProvider = eip1193;

      try {
        const uri = (eip1193 as any)?.uri;
        if (uri && typeof uri === 'string' && /^wc:/i.test(uri)) {
          const same = uri === (this as any)._wcLastUri;
          this.addLog?.(
            `[restoreSession][wcUri] from provider.uri | len=${uri.length} sameAsLast=${same}`
          );
          (this as any)._wcLastUri = uri;
          this.wcUri = uri;
          (this as any)._wcUri$?.next?.(uri);
          try { sessionStorage.setItem('st/wcLastUri', uri); } catch { }
        }
      } catch { /* no-op */ }


      // Installe les sondes globales (RPC debug)
      this.installRpcDebugProbe?.('attach');
      this.installRpcDebugProbeOnWindow?.('attach');
      this.installWindowOpenProbe('attach');
      // ─────────────────────────────────────────────
      // 3️⃣ Sondes sur provider interne (inner) d’ethers
      // ─────────────────────────────────────────────
      try {
        const inner: any = (this.provider as any)?.provider ?? null;
        if (inner && !inner.__rpcDebugProbeInstalled) {
          const SENSITIVE = new Set([
            'wallet_switchEthereumChain',
            'wallet_addEthereumChain',
            'eth_requestAccounts',
            'eth_sendTransaction',
            'eth_sign',
            'personal_sign',
            'eth_signTypedData',
            'eth_signTypedData_v3',
            'eth_signTypedData_v4'
          ]);
          const tag = '[rpc][attach-inner]';

          if (typeof inner.request === 'function') {
            const orig = inner.request.bind(inner);
            inner.request = async (a: { method: string; params?: any[] }) => {
              if (a?.method && SENSITIVE.has(a.method)) {
                this.addLog?.(`${tag} ${a.method} params=${JSON.stringify(a.params ?? [])}`);
              }
              return orig(a);
            };
          }

          if (typeof inner.send === 'function') {
            const s0 = inner.send.bind(inner);
            inner.send = async (m: string, p?: any[]) => {
              if (m && SENSITIVE.has(m)) {
                this.addLog?.(`${tag} ${m} params=${JSON.stringify(p ?? [])}`);
              }
              return s0(m, p);
            };
          }

          inner.__rpcDebugProbeInstalled = true;
          this.addLog?.('[rpc] inner provider probe installed');
        }
      } catch (err) {
        this.addLog?.(`${TAG} inner probe install failed: ${err}`);
      }

      // ─────────────────────────────────────────────
      // 4️⃣ Écouteurs EIP-1193 (événements natifs)
      // ─────────────────────────────────────────────
      try {
        const raw = eip1193;
        const ev = (name: string, fn: any) => {
          try {
            (raw?.removeListener ?? raw?.off)?.(name, fn);
            (raw?.on ?? raw?.addListener)?.(name, fn);
          } catch { }
        };
        ev('accountsChanged', (a: any) => this.addLog?.(`[evm][accountsChanged] ${JSON.stringify(a)}`));
        ev('chainChanged', (c: any) => this.addLog?.(`[evm][chainChanged] ${c}`));
        ev('connect', (i: any) => this.addLog?.(`[evm][connect] ${JSON.stringify(i)}`));
        ev('disconnect', (e: any) => this.addLog?.(`[evm][disconnect] ${JSON.stringify(e)}`));
        this.addLog?.('[rpc] EIP-1193 event listeners attached');
      } catch (err) {
        this.addLog?.(`${TAG} EIP-1193 events failed: ${err}`);
      }

      // ─────────────────────────────────────────────
      // 5️⃣ Récupération du signer / address / chainId
      // ─────────────────────────────────────────────
      const signer = await this.provider.getSigner();
      const address = await signer.getAddress();
            const net0 = await this.provider.getNetwork();
            const providerChainId0 = Number(net0?.chainId);
      
              // ✅ source of truth = UI desired chain (fallback to current chainId, then provider)
              const uiDesired = Number((this as any).desiredChainId ?? this.chainId ?? providerChainId0);
      
              this.addLog?.(
                  `${TAG} network(before) providerChainId=${providerChainId0} uiDesired=${uiDesired} currentChainId=${this.chainId ?? 'null'}`
                );

      // Met à jour l’état du composant
      this.takerAddress = address;
      this.isConnected = true;

            // ✅ Do NOT let provider overwrite UI choice
              this.setChain(uiDesired, 'attach');
      
              // ✅ If provider is on another chain, try to switch to UI desired chain
              if (Number.isFinite(uiDesired) && uiDesired > 0 && providerChainId0 !== uiDesired) {
                  const toHex = (n: number) => '0x' + n.toString(16);
                  try {
                      this.addLog?.(`${TAG} switching chain | from=${providerChainId0} to=${uiDesired}`);
                      await (this.rawProvider as any)?.request?.({
 method: 'wallet_switchEthereumChain',
                          params: [{ chainId: toHex(uiDesired) }]
                      });
                    this.addLog?.(`${TAG} switch request sent`);
                  } catch (e: any) {
                      this.addLog?.(`${TAG} switch FAILED | err=${e?.message ?? String(e)}`);
                    }
      
                // Re-check network after switch attempt
                try {
                    const net1 = await this.provider.getNetwork();
                    const providerChainId1 = Number(net1?.chainId);
                    this.addLog?.(`${TAG} network(after) providerChainId=${providerChainId1} uiDesired=${uiDesired}`);
                    this.setChain(providerChainId1, 'attach');
                  } catch (e: any) {
                      this.addLog?.(`${TAG} network(after) read FAILED | err=${e?.message ?? String(e)}`);
                    }
            }
     

      // ✅ rebind portfolio après setChain + addr ready (anti debug=1 reload)
      this.bindPortfolioIfReady('attachEthersProvider');

      this.addLog?.(`${TAG} ✅ connected addr=${address} chainId=${Number(this.chainId)}`);

      //try {
      //  const rawChain = await (this.provider as any).send?.('eth_chainId', []);
      //  this.addLog?.(`${TAG} provider eth_chainId=${rawChain}`);
      //} catch {
      //  this.addLog?.(`${TAG} eth_chainId fetch failed`);
      //}

      console.log(`${TAG} AVANT refresh: sell=${this.sellTokenSymbol} buy=${this.buyTokenSymbol}`);

      // 🔁 Premier refresh de balance post-connexion
      await this.refreshNativeBalance();
      this.addLog?.(`${TAG} balance refreshed after connect`);

      // Recharge les tokens et balances
      await this.refreshTokensForChain();
      console.log(`${TAG} APRÈS refreshTokensForChain: sell=${this.sellTokenSymbol} buy=${this.buyTokenSymbol}`);
      console.log(`${TAG} availableTokens=`, this.availableTokens.map(t => t.symbol));

      // Sélection des tokens par défaut seulement si rien ou invalide
      if (!this.availableTokens.some(t => t.symbol === this.sellTokenSymbol)) {
        const sellToken = this.getDefaultSellTokenForChain(Number(this.chainId ?? uiDesired));
        console.log(`${TAG} SELL invalide → fallback`, sellToken?.symbol);
        if (sellToken?.symbol) this.selectSellToken(sellToken.symbol);
      } else {
        console.log(`${TAG} SELL conservé =`, this.sellTokenSymbol);
      }

      if (!this.availableTokens.some(t => t.symbol === this.buyTokenSymbol)) {
        const buyToken = this.getDefaultBuyTokenForChain(Number(this.chainId ?? uiDesired));
        console.log(`${TAG} BUY invalide → fallback`, buyToken?.symbol);
        if (buyToken?.symbol) this.selectBuyToken(buyToken.symbol);
      } else {
        console.log(`${TAG} BUY conservé =`, this.buyTokenSymbol);
      }

      console.log(`${TAG} FINAL: sell=${this.sellTokenSymbol} buy=${this.buyTokenSymbol}`);

      this.cd.detectChanges();

    } catch (err) {
      console.error('[attachEthersProvider] ❌ erreur', err);
      this.takerAddress = null;
      this.isConnected = false;
      this.provider = null;
    }
  }





  private async restoreSessionIfAny(): Promise<void> {
    const TAG = '[restoreSession]';
    const sleep = (ms: number) => new Promise(r => setTimeout(r, ms));

    // 🔍 Lecture des flags (uniquement pour log/diag, on NE bloque PAS la restauration)
    let suppressWcUriUntil = 0;
    let suppressAutoRestoreUntil = 0;
    let skipAutoRestoreOnce = false;
    try {
      suppressWcUriUntil = Number(sessionStorage.getItem('st/suppressWcUriUntil') || '0') || 0;
      suppressAutoRestoreUntil = Number(localStorage.getItem('st/suppressAutoRestoreUntil') || '0') || 0;
      skipAutoRestoreOnce = localStorage.getItem('st/skipAutoRestoreOnce') === '1';
    } catch { /* no-op */ }

    this.addLog?.(`${TAG} boot-flags | supWcUriUntil=${suppressWcUriUntil} (${Math.max(0, suppressWcUriUntil - Date.now())}ms left) | supAutoRestoreUntil=${suppressAutoRestoreUntil} (${Math.max(0, suppressAutoRestoreUntil - Date.now())}ms left) | skipAutoRestoreOnce=${skipAutoRestoreOnce}`);

    // ✅ IMPORTANT : on NE bloque plus la restauration par cooldown ici.
    // Si tu veux consommer le one-shot "skipAutoRestoreOnce", on le loggue puis on le consomme,
    // mais on n'empêche pas la réhydratation silencieuse.
    if (skipAutoRestoreOnce) {
      this.addLog?.(`${TAG} skipAutoRestoreOnce present → consumed (but continuing silent restore)`);
      try { localStorage.removeItem('st/skipAutoRestoreOnce'); } catch { }
    }

    // 🔎 état global au démarrage (window.ethereum) + installation de la sonde si absente
    try {
      const winEth: any = (window as any)?.ethereum;
      this.addLog?.(`${TAG} boot | hasWindowEth=${!!winEth}`);
      if (winEth && !(winEth as any).__rpcDebugProbeInstalled) {
        this.installRpcDebugProbeOnWindow?.('restoreSession');
      }
    } catch { /* no-op */ }

    // 🧩 Hook post-attach : synchronise services + balance + sonde provider
    const afterAttach = async () => {
      try {
        this.isConnected = true;
        if (this.takerAddress) this.wallet.address$.next(this.takerAddress);
        if (this.chainId) this.wallet.chainId$.next(this.chainId);
        await this.refreshNativeBalance();
        this.addLog?.(`${TAG} provider attached → synced + balance refreshed`);
        this.installRpcDebugProbe?.('restoreSession');

        // 🧠 Nouveau : on ne garde l'état "connecté" que si on a un wcLastUri valide
        this.syncIsConnectedWithWcLastUri('restore-afterAttach');
      } catch (e: any) {
        this.addLog?.(`${TAG} afterAttach error: ${e?.message ?? e}`);
      }
    };

    // 0) Stratégie doc-style : getProvider('eip155') × 5 (réhydratation silencieuse, SANS créer d'URI)
    if (typeof (modal as any).getProvider === 'function') {
      for (let i = 1; i <= 5; i++) {
        try {
          this.addLog?.(`${TAG} getProvider try #${i}`);
          const raw = await (modal as any).getProvider('eip155');
          const prov = raw?.provider ?? raw ?? null;

          if (prov && typeof (prov as any).request === 'function') {
            this.addLog?.(`${TAG} getProvider -> FOUND existing provider (silent reattach)`);
            await this.attachEthersProvider(prov);
            // 🔎 sonde sur le provider + window.ethereum
            this.installRpcDebugProbe?.('restoreSession');
            this.installRpcDebugProbeOnWindow?.('restoreSession');
            await afterAttach();
            return;
          } else {
            this.addLog?.(`${TAG} getProvider -> no provider (null or missing request)`);
          }
        } catch (e: any) {
          this.addLog?.(`${TAG} getProvider try #${i} failed: ${e?.message ?? e}`);
        }
        await sleep(2000);
      }
    } else {
      this.addLog?.(`${TAG} getProvider not available on modal`);
    }

    // 1) Stratégie legacy : getWalletProvider('eip155') (toujours sans créer d'URI)
    try {
      if (typeof (modal as any).getWalletProvider === 'function') {
        this.addLog?.(`${TAG} getWalletProvider (legacy)`);
        const raw = await (modal as any).getWalletProvider('eip155');
        const prov = raw?.provider ?? raw ?? null;

        if (prov && typeof (prov as any).request === 'function') {
          this.addLog?.(`${TAG} legacy provider -> FOUND (silent reattach)`);
          await this.attachEthersProvider(prov);
          // 🔎 sonde sur le provider + window.ethereum
          this.installRpcDebugProbe?.('restoreSession');
          this.installRpcDebugProbeOnWindow?.('restoreSession');
          await afterAttach();
          return;
        } else {
          this.addLog?.(`${TAG} legacy provider -> none`);
        }
      } else {
        this.addLog?.(`${TAG} getWalletProvider not available on modal`);
      }
    } catch (e: any) {
      this.addLog?.(`${TAG} getWalletProvider error: ${e?.message ?? e}`);
    }

    // 2) Fallback : subscribeProviders (laisser WC v2 se réhydrater) + poll doux (60s)
    if (typeof (modal as any).subscribeProviders === 'function') {
      this.addLog?.(`${TAG} subscribeProviders armed (fallback)`);
      let pollTimer: any = null;

      const unsub = (modal as any).subscribeProviders((state: any) => {
        const prov = state?.['eip155']?.provider ?? state?.['eip155'] ?? null;
        this.addLog?.(`${TAG} subscribeProviders event → prov=${!!prov}`);
        if (!prov || typeof (prov as any).request !== 'function') return;

        try { unsub?.(); } catch { /* no-op */ }
        if (pollTimer) clearInterval(pollTimer);

        (async () => {
          try {
            this.addLog?.(`${TAG} subscribeProviders -> attaching silent provider`);
            await this.attachEthersProvider(prov);
            this.installRpcDebugProbe?.('restoreSession');
            this.installRpcDebugProbeOnWindow?.('restoreSession');
            await afterAttach();
          } catch (e: any) {
            this.addLog?.(`${TAG} subscribeProviders attach failed: ${e?.message ?? e}`);
          }
        })();
      });

      // 🔁 Poll léger du state (2s × 30 ≈ 60s), sans générer d'URI
      let polls = 0;
      pollTimer = setInterval(async () => {
        polls++;
        try {
          const st = (modal as any).getState?.();
          const prov = st?.eip155?.provider ?? st?.eip155 ?? null;
          this.addLog?.(`${TAG} poll #${polls} → prov=${!!prov}`);

          if (prov && typeof (prov as any).request === 'function') {
            try { unsub?.(); } catch { /* no-op */ }
            if (pollTimer) clearInterval(pollTimer);
            this.addLog?.(`${TAG} poll -> attaching silent provider`);
            await this.attachEthersProvider(prov);
            this.installRpcDebugProbe?.('restoreSession');
            this.installRpcDebugProbeOnWindow?.('restoreSession');
            await afterAttach();
          } else if (polls >= 30) {
            try { unsub?.(); } catch { /* no-op */ }
            if (pollTimer) clearInterval(pollTimer);
            this.addLog?.(`${TAG} poll timeout (no provider after 60s)`);
          }
        } catch (e: any) {
          this.addLog?.(`${TAG} poll error: ${e?.message ?? e}`);
        }
      }, 2000);

      // ⛔ Très important : on ne tente PAS de "connect()" ici → donc pas de nouvelle session, pas d'URI, pas de deeplink.
      this.addLog?.(`${TAG} passive mode: will NOT initiate new pairing or wc uri at boot`);
      return;
    }

    // Si on arrive ici, aucune stratégie n'a trouvé de provider silencieux.
    this.addLog?.(`${TAG} no provider found (all strategies exhausted)`);
  }




  // 🔄 Sanity check: on ne se dit "connecté" que si on a un wcLastUri valide
  private syncIsConnectedWithWcLastUri(source: string): void {
    const TAG = '[restoreSession][wcSync]';
    let hasLast = false;
    let len = 0;
    try {
      const raw = sessionStorage.getItem('st/wcLastUri') || '';
      hasLast = !!raw;
      len = raw.length;
    } catch { /* no-op */ }


    this.addLog?.(`${TAG} ${source} hasLast=${hasLast} len=${len}`);

    if (!hasLast) {
      // 🧨 Mode hard : on considère que la session WC est zombie → teardown complet
      this.addLog?.(
        `${TAG} ${source} hasLast=false len=${len} → HARD disconnect (no wcLastUri, forcing reset)`
      );

      try {
        // fire-and-forget : on ne peut pas "await" dans une méthode sync,
        // mais le disconnectWallet gère déjà ses propres try/catch.
        this.disconnectWallet?.();
      } catch (e: any) {
        this.addLog?.(
          `${TAG} ${source} hard disconnect error: ${e?.message ?? e}`
        );
      }

      // Double sécurité locale au cas où disconnectWallet ne serait pas branché
      this.isConnected = false;
      this.takerAddress = null;
      this.chainId = null;
      try { this.wallet.address$.next(null); } catch { /* no-op */ }
      try { this.wallet.chainId$.next(null); } catch { /* no-op */ }
      /*   try { this.wallet.setConnected(false); } catch { *//* no-op *//* }*/
      return;
    }

    this.addLog?.(`${TAG} ${source} wcLastUri present → keep connected`);
  }






  private async logWalletConnectStorage() {
    try {
      // 📦 Dump localStorage complet
      const lsKeys = Object.keys(localStorage);

      // 🎯 Dump des clés commençant par wc@2
      const wcKeys = lsKeys.filter(k => k.startsWith('wc@2'));
      wcKeys.forEach(k => {
      });

      // 📦 Dump IndexedDB pour WalletConnect v2
      if ('indexedDB' in window) {
        const dbs = await (indexedDB as any).databases?.();
        if (dbs) {
        } else {
        }

        // Ouvrir la DB du SignClient si présente
        const wcDbName = dbs?.find((d: any) => d.name?.includes('walletconnect'))?.name;

        if (wcDbName) {
          const request = indexedDB.open(wcDbName);
          request.onsuccess = () => {
            const db = request.result;
          };
          request.onerror = () => {
          };
        }
      } else {
      }
    } catch (err) {
    }
  }







  private async restoreSessionDocStyle() {
    try {
      if (!modal) return;

      await this.logWalletConnectStorage();

      // 📦 Log du contenu localStorage lié à WalletConnect / AppKit
      const wcKeys = Object.keys(localStorage).filter(k => k.startsWith('wc@2:'));
      const wcDump = wcKeys.map(k => `${k}=${localStorage.getItem(k)}`).join(' | ');


      const address = await modal.getAddress?.();
      const chainId = await modal.getChainId?.();
      const provider: any = await modal.getWalletProvider?.();



      if (address && provider?.request) {
        this.provider = new BrowserProvider(provider);
        this.addLog('resumeOpenProbe');
        this.resumeOpenProbe('session-restored');
        // this.takerAddress = address;
        this.isConnected = true;
        if (chainId != null) this.setChain(Number(chainId));
        this.cd.detectChanges();

      } else {

      }
    } catch (e: any) {

    }
  }
  private subscribeEvmChanges() {
    if (!modal?.subscribeProviders) return;


    modal.subscribeProviders((state: any) => {
      const evm = state?.['eip155'];
      if (!evm) return;

      if ('address' in evm) {
        this.takerAddress = evm.address ?? null;
        this.isConnected = !!evm.address;
      }
      if ('chainId' in evm && evm.chainId != null) {
        this.setChain(Number(evm.chainId));
      }
      this.cd.detectChanges();
    });
  }
  get hasInsufficientGasBuffer(): boolean {
    const nativeSymbol = this.getNativeTokenSymbol(this.chainId ?? 1);
    const isNativeToken = this.sellTokenSymbol === nativeSymbol;
    const balance = +this.getTokenBalance(this.sellTokenSymbol) || 0;
    const amount = +this.sellAmount || 0;
    const gas = Number(this.fullGasWei) / 1e18;

    if (!isNativeToken || !this.takerAddress || amount <= 0) return false;

    // Petite marge de sécurité de 5 %
    return (amount + gas * 1.05) > balance;
  }


  getNativeTokenSymbol(chainId: number): string {
    return {
      1: 'ETH',
      42161: 'ETH',
      137: 'MATIC',
      56: 'BNB'
      // … ajoute d'autres si besoin
    }[chainId] ?? 'ETH';
  }

  getTokenLabel(symbol: string): string {
    const key = 'TOKENS.' + symbol.toUpperCase();
    const translated = this.translate.instant(key);
    return translated !== key ? translated : symbol;
  }

  /* swap.component.ts */
  onCurrencyChanged(code: string) {
    this.defaultFiat = code;

    // Pas besoin de changer les prix en CAD ici :
    // garde des prix USD et laisse getSellFiatValue() convertir via fiatRates
    if (this.availableTokens.length) {
      this.price.fetchPricesByTokens(this.availableTokens, 'usd')
        .subscribe(map => {
          this.priceMap = map; // ← clés address_chainId
          console.log('💱 priceMap (USD) remis à jour', this.priceMap);
        });
    }
  }



  // swap.component.ts  (ou swap-alert.component.ts)
  //getTokenLogo(symbol: string): string {
  //  return (
  //    this.availableTokens.find(t => t.symbol === symbol)?.logoURI ||
  //    'assets/tokens/unknown.svg'          // fallback très léger
  //  );
  //}
  getNetworkLogo(network: string): string {
    switch (network) {
      case 'ethereum': return 'assets/networks/ethereum.png';
      case 'arbitrum': return 'assets/networks/arbitrum.png';
      case 'optimism': return 'assets/networks/optimism.png';
      default: return 'assets/networks/default.png';
    }
  }

  getNetworkLabel(network: string): string {
    switch (network) {
      case 'ethereum': return 'Ethereum';
      case 'arbitrum': return 'Arbitrum';
      case 'optimism': return 'Optimism';
      default: return 'Unknown';
    }
  }

  selectNetwork(id: number) {
    this.selectedNetwork = id;
  }

  selectBuyNetwork(id: number) {
    this.selectedBuyNetwork = id;
  }
  getSellFiatValue(): string {
    const amount = parseFloat(this.sellAmount || '0');
    if (!amount) return '';

    const sym = this.sellTokenSymbol?.toUpperCase();
    const tok = this.availableTokens.find(t =>
      t.symbol?.toUpperCase() === sym && Number(t.chainId) === Number(this.chainId ?? 1)
    );
    const key = tok ? `${tok.address?.toLowerCase()}_${Number(tok.chainId)}` : null;

    // prix USD depuis le map actuel (address_chainId)
    const unitUsd =
      (key && typeof this.priceMap[key] === 'number') ? this.priceMap[key] : 0;

    // conversion USD -> devise courante
    const fiatCode = this.defaultFiat?.toUpperCase?.() || 'USD';
    const usdToFiat = this.fiatRates?.[fiatCode] ?? 1;

    // fallback pour stables si le prix n'est pas encore peuplé
    const isStable = ['USDC', 'USDT', 'DAI', 'FDUSD', 'USDC.E'].includes(sym || '');
    const unitFiat = unitUsd > 0 ? unitUsd * usdToFiat : (isStable ? usdToFiat : 0);

    const total = amount * unitFiat;
    if (!total) return '';

    const locale = this.defaultFiat === 'EUR' ? 'fr-FR' : 'en-US';
    const formatted = total.toLocaleString(locale, {
      style: 'currency',
      currency: fiatCode,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    return '~ ' + formatted;
  }





  private closeQuoteWithReason(reason: string) {
    const BLOCK_WHILE_EXEC = new Set(['']);
    // Raisons qui DOIVENT pouvoir fermer la modale même en cours d’exécution
    const TERMINAL_REASONS = new Set([
      'success',
      'error',
      'fatal-error',
      'user-cancel',
      'user-rejected',
      'timeout',
      'forceReconnectWalletSession',
      'softReloadAfterNetworkSwitch',
      'networkChanged',
      'force-close'
    ]);

    const status = this.swapStatus ?? 'idle';
    const isExecPhase = BLOCK_WHILE_EXEC.has(status);
    const isTerminal = TERMINAL_REASONS.has(reason);

    if (isExecPhase && !isTerminal) {
      // Empêche la fermeture intempestive (ex: 'child-close') pendant approve/pending/executing
      this.addLog(`🧯 [quote] close BLOCKED by=${reason} | swapStatus=${status}`);
      return;
    }

    this.addLog(`🧯 [quote] close by=${reason} | swapStatus=${status}`);
    if (reason == 'child-close')
      try { this.closeQuote?.(); } catch { /* noop */ }
  }




  getGasFeeFiat(): string {
    if (!this.fullGasWei || !this.nativeTokenUsd) return '';

    const feeEth = Number(this.fullGasWei) / 1e18;
    const fiat = feeEth * this.nativeTokenUsd;

    return fiat.toLocaleString(
      this.defaultFiat === 'EUR' ? 'fr-FR' : 'en-US',
      {
        style: 'currency',
        currency: this.defaultFiat,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }
    );
  }


  async changeChain(id: number) {
    this.lockChainToSeo = false;
    this.showChainMenu = false;
    this.closeQuoteWithReason('changeChain');
    try {
      const isConnected = !!this.provider && this.isConnected; // vrai provider prêt

      if (isConnected) {
                // ✅ KISS: pose l'intention AVANT le switch wallet (évite "force back" pendant softReload/attach)
                  const prevCid = this.chainId;
                try {
                    this.setChain(id, 'ui'); // => persist st/desiredChainId + update chainId local
                    this.addLog?.(`[changeChain] intent applied | prev=${prevCid ?? 'null'} next=${id}`);
                  } catch (e: any) {
                      this.addLog?.(`[changeChain] intent FAILED | next=${id} err=${e?.message || String(e)}`);
                    }
        // 1) Demande au wallet de changer réellement de réseau
                try {
                    await this.rawProvider.request({
 method: 'wallet_switchEthereumChain',
                        params: [{ chainId: '0x' + id.toString(16) }]
                    });
                  this.addLog?.(`[changeChain] wallet_switchEthereumChain OK | next=${id}`);
                } catch (e: any) {
                    // rollback local intent si le wallet refuse
                      try {
                          if (prevCid != null) this.setChain(Number(prevCid), 'ui');
                          this.addLog?.(`[changeChain] rollback local intent -> prev=${prevCid ?? 'null'}`);
                        } catch { /* noop */ }
                    throw e;
                  }
        //// 2) Soft-reload complet du provider + chainId + address, comme au boot
        await this.softReloadAfterNetworkSwitch('changeChain');

        // 2) Puis on applique la glue UI (tokens/SELL/BUY) sur la chaîne effectivement active
        await this.applyChainUi(this.chainId ?? id);
      } else {
        // Pas de wallet => on fait juste le switch local (UI + tokens)
        await this.applyChainUi(id);
      }

    } catch (e) {
      console.error('⛔️ Erreur de changement de réseau', e);
      alert('Impossible de changer de réseau : ' + (e as any).message);
    }
  }

  /**
 * Switch réseau côté wallet de façon SILENCIEUSE,
 * en réutilisant la logique robuste de changeChain :
 * - appelle wallet_switchEthereumChain
 * - puis softReloadAfterNetworkSwitch pour resynchroniser provider / chain / address
 * - ne touche PAS à l'UI (pas de closeQuote, pas d'applyChainUi, pas d'alert)
 */
  private async switchWalletNetworkSilent(targetChainId: number, reason: string): Promise<void> {
    const hexChainId = '0x' + targetChainId.toString(16);

    try {
      const raw: any = this.rawProvider || this.provider;

      if (!raw || typeof raw.request !== 'function') {
        this.addLog?.(
          `[NETWORK][SILENT] skip switch (no rawProvider.request) reason=${reason} target=${targetChainId}`
        );
        return;
      }

      this.addLog?.(
        `[NETWORK][SILENT] wallet_switchEthereumChain → ${targetChainId} (${hexChainId}) reason=${reason}`
      );

      await raw.request({
        method: 'wallet_switchEthereumChain',
        params: [{ chainId: hexChainId }]
      });

      this.addLog?.(
        `[NETWORK][SILENT] switchEthereumChain OK → softReloadAfterNetworkSwitch(${reason})`
      );

      // On réutilise ta mécanique déjà testée pour resync provider/chain/address
      await this.softReloadAfterNetworkSwitch(reason);

    } catch (e: any) {
      this.addLog?.(
        `[NETWORK][SILENT] switchEthereumChain EXC (${reason}) → ${e?.message ?? e}`
      );
      // ⚠️ ici pas d'alert / pas d'UI agressive : on log seulement
    }
  }


  /**
 * "Glue" : met l’UI dans le même état logique que si on avait booté sur cette chaîne.
 * - met à jour chainId/chainInfo (setChain)
 * - aligne swapApi
 * - reconstruit les listes de tokens
 * - recalcule les tokens SELL/BUY par défaut si besoin
 */
  private async applyChainUi(id: number): Promise<void> {
    // 🧠 setChain(id) → met à jour chainId/chainInfo + rebind TokenPortfolioCacheService
    this.setChain(id);

    // aligne l’API de swap sur la chaîne courante
    this.swapApi.setChainId(id);

    // 🔄 Rebuild des listes de tokens (availableTokens / popularTokens) pour le nouveau chainId
    await this.refreshTokensForChain();

    // Vérifier que popularTokens n'est pas vide (debug visuel)
    this.addLog("popularTokens après refresh" + this.popularTokens);

    // Sélectionner les tokens par défaut **uniquement si la sélection courante est invalide**
    const sellIsValid = this.availableTokens.some(t => t.symbol === this.sellTokenSymbol);
    const buyIsValid = this.availableTokens.some(t => t.symbol === this.buyTokenSymbol);

    if (!sellIsValid) {
      const sellToken = this.getDefaultSellTokenForChain(id);
      this.addLog("[changeChain] SELL invalide → fallback " + sellToken?.symbol);
      if (sellToken?.symbol) this.selectSellToken(sellToken.symbol);
    } else {
      this.addLog("[changeChain] SELL conservé =" + this.sellTokenSymbol);
    }

    if (!buyIsValid) {
      const buyToken = this.getDefaultBuyTokenForChain(id);
      this.addLog("[changeChain] BUY invalide → fallback " + buyToken?.symbol);
      if (buyToken?.symbol) this.selectBuyToken(buyToken.symbol);
    } else {
      this.addLog("[changeChain] BUY conservé =" + this.buyTokenSymbol);
    }

    this.cd.detectChanges();
  }

  getDefaultSellTokenForChain(chainId: number): any {
    const tokens = this.popularTokens
      .filter(t => t.chainId === chainId)
      .sort((a, b) => b.volumeUsd24h - a.volumeUsd24h);

    return tokens.length > 0 ? tokens[0] : undefined;
  }

  getDefaultBuyTokenForChain(chainId: number): any {
    const tokens = this.popularTokens
      .filter(t => t.chainId === chainId)
      .sort((a, b) => b.volumeUsd24h - a.volumeUsd24h);

    return tokens.length > 1 ? tokens[1] : undefined;
  }




  async isPermit2Approved(owner: string, token: string, spender: string): Promise<boolean> {
    const abi = [
      "function allowance(address,address,address) view returns (uint160 amount,uint48 expiration,uint48 nonce)",
    ];
    const c = new Contract(PERMIT2_ADDRESS, abi, this.provider);
    const [amount] = await c['allowance'](owner, token, spender);
    return BigInt(amount) > 0n;
  }

  async buildPermit2Signature() {
    if (!this.enablePermit2) return;
    if (!this.provider) {
      alert("Connecte ton wallet avant de signer le permit.");
      return;
    }
    const signer = await this.provider.getSigner();
    const owner = await signer.getAddress();
    const token = this.sellTokenAddress;
    const spender = this.quote.target;
    const amount = this.quote.value.takerTokenAmount;

    // récupérer le nonce
    const allowanceAbi = [
      'function allowance(address,address,address) view returns (uint160,uint48,uint48)'
    ];
    const c = new Contract(PERMIT2_ADDRESS, allowanceAbi, this.provider);
    const [, , nonceBig] = await c['allowance'](owner, token, spender);
    const nonce = Number(nonceBig);

    // … puis buildPermitSingle + signTypedData comme montré
  }

  // Normaliser une valeur "wei" (déjà en wei) vers bigint
  private parseWei(v: any): bigint {
    try {
      if (typeof v === 'bigint') return v;
      if (typeof v === 'number') return BigInt(Math.trunc(v));
      if (typeof v === 'string') return v.startsWith('0x') ? BigInt(v) : BigInt(v || '0');
    } catch { }
    return 0n;
  }

  // MM-like EXPECTED-first pour le gating; fallbacks: mmNetwork → mmMax
  private pickMmExpectedWei(r: any): bigint {
    return this.parseWei(r?.mmExpectedNetworkFeeWei ?? r?.mmNetworkFeeWei ?? r?.mmMaxNetworkFeeWei ?? 0);
  }


  // swap.component.ts
  isSwapDisabled(): boolean {
    // 0) Pas de quote → on bloque proprement
    if (!this.quote) {
      this.swapDisabled = true;
      this.swapReasons = [this.translate.instant('SWAP_TX_MISSING')];
      return true;
    }
        // 0.5) ✅ Garde-fou: wallet OK mais portfolio pas encore "ready" (évite faux INSUFFICIENT_*)
          if (this.isConnected && !!this.takerAddress && !!this.chainId) {
              const key = balanceKey(this.takerAddress, Number(this.chainId));
              if (!this.isPortfolioReadyForKey(key)) {
                  const k = 'SWAP_REASON_BALANCES_LOADING';
                  const t = this.translate.instant(k);
                  const msg = (t && t !== k) ? t : 'Chargement des soldes…';
                  this.swapDisabled = true;
                  this.swapReasons =[msg];
                  this.addLog?.(`[VALIDATION] skip funds check: portfolio not ready | key=${key}`);
                  return true;
                }
            }
    // 1) Gating "métier" standard (BalanceValidator)
    const args = {
      takerAddress: this.takerAddress,
      chainId: this.chainId ?? 1,
      sellTokenSymbol: this.sellTokenSymbol,
      sellAmount: this.sellAmount,
      fullGasWei: this.pickMmExpectedWei(this.quote),
      availableTokens: this.availableTokens,
      tokenBalances: this.tokenCachedBalances,
      getNativeTokenSymbol: (cid: number) => this.getNativeTokenSymbol(cid),
      marginPct: 0.05,
    };
    const base = this.balanceValidator.isSwapDisabled(args);

    // 2) Surcouche : si la route principale a échoué à la simulation
    const mainKey = this.getProviderKey(this.quote);
    const simFailedOnMain =
      this.swapStatus === 'error' &&
      !!this.lastSimFailedKey &&
      !!mainKey &&
      mainKey === this.lastSimFailedKey;

    let disabled = base.disabled || simFailedOnMain;

    // Raisons (fusion propre + message de sim échouée)
    let reasons: string[] = Array.isArray(base.reasons) ? [...base.reasons] : [];
    if (simFailedOnMain) {
      const msg = this.translate.instant('ROUTE_DISABLED_AFTER_SIM') || 'Route disabled after simulation failure.';
      if (!reasons.includes(msg)) reasons.push(msg);
    }

    // 3) 🔧 Bypass UI du check gas en mode debug
    //    -> on retire "INSUFFICIENT_NATIVE_GAS" des raisons
    //    -> si c'était la seule raison, on ré-active (sauf si simFailedOnMain)
    if ((this as any).debugBypassGasCheck) {
      reasons = reasons.filter(r => r !== 'INSUFFICIENT_NATIVE_GAS');
      if (!simFailedOnMain && reasons.length === 0) {
        disabled = false;
      }
    }

    // 4) Propagation UI
    this.swapDisabled = disabled;
    this.swapReasons = reasons;

    return disabled;
  }





  // ⬇️ Ajoute près d’isSwapDisabled()
  private altValidationCache = new WeakMap<any, { disabled: boolean; reasons: string[] }>();

  /** Construit les args de validation, en priorisant les données de la route si présentes */
  private buildValidationArgsForRoute(route: any) {
    const routeChainId = Number(
      route?.chainId ??
      route?.transactionRequest?.chainId ??
      this.chainId ?? 1
    );

    // Gas par route si dispo, sinon fallback sur le gas courant
    const routeFullGasWei =
      (typeof route?.gas?.fullWei === 'bigint' ? route?.gas?.fullWei :
        route?.gas?.fullWei ? BigInt(route?.gas?.fullWei) :
          typeof route?.fullGasWei === 'bigint' ? route?.fullGasWei :
            route?.fullGasWei ? BigInt(route?.fullGasWei) :
              this.fullGasWei) ?? 0n;

    return {
      takerAddress: this.takerAddress,
      chainId: routeChainId,
      sellTokenSymbol: this.sellTokenSymbol,
      sellAmount: this.sellAmount,
      fullGasWei: routeFullGasWei,
      availableTokens: this.availableTokens,
      tokenBalances: this.tokenCachedBalances,
      getNativeTokenSymbol: (cid: number) => this.getNativeTokenSymbol(cid),
      marginPct: 0.05, // même marge que ta quote principale
    };
  }

  /** Validation d’une route alternative : mêmes règles que le bouton principal */
  validateAlternativeRoute = (route: any): { disabled: boolean; reasons: string[] } => {
    const cached = this.altValidationCache.get(route);
    if (cached) return cached;


       // ✅ Même garde-fou que le bouton principal (portfolio pas prêt après connect CTA)
          if (this.isConnected && !!this.takerAddress && !!this.chainId) {
              const key = balanceKey(this.takerAddress, Number(this.chainId));
              if (!this.isPortfolioReadyForKey(key)) {
                  const k = 'SWAP_REASON_BALANCES_LOADING';
                  const t = this.translate.instant(k);
                  const msg = (t && t !== k) ? t : 'Chargement des soldes…';
                  const out = { disabled: true, reasons: [msg] };
                  this.altValidationCache.set(route, out);
                  return out;
                }
            }

    const args = this.buildValidationArgsForRoute(route);
    const res = this.balanceValidator.isSwapDisabled(args); // ✅ ta logique actuelle

    // ➕ surcouche : si cette alternative a échoué à la simulation
    const key = this.getProviderKey(route);
    if (this.failedAltKeys.has(key)) {
      res.disabled = true;
      res.reasons = [...(res.reasons || []), this.translate.instant('ALT_DISABLED_AFTER_SIM')];
    }

    this.altValidationCache.set(route, res);
    return res;
  };


  private getProviderKey(x: any): string {
    const raw =
      x?.providerKey ?? x?.ProviderKey ??
      x?.toolKey ?? x?.ToolKey ??
      x?.tool ?? x?.Tool ??
      x?.source ?? x?.Source ??
      x?.providerName ?? x?.ProviderName ??
      x?.name ?? '';
    return String(raw || '').toLowerCase().trim();
  }
  validateAlternative(route: any): { disabled: boolean; reasons: string[] } {
    const key = this.getProviderKey(route);
    const disabled = !!(this.swapStatus === 'error' && this.lastSimFailedKey && key === this.lastSimFailedKey);
    const reasons = disabled ? [this.translate.instant('ALT_DISABLED_AFTER_SIM')] : [];
    return { disabled, reasons };
  }
  async loadBalancesUniswapStyle() {
    if (!this.takerAddress) return;

    const dbg = (window as any).debugLog;
    dbg?.('🚀 [loadBalancesUniswapStyle] start');

    this.userTokens = [];

    // 1️⃣ Priorité : top tokens par volume
    const topTokens = [...this.availableTokens]
      .sort((a, b) => (b.volumeUsd24h || 0) - (a.volumeUsd24h || 0))
      .slice(0, 20);

    // 2️⃣ Autres tokens à charger en arrière-plan
    const otherTokens = this.availableTokens.filter(t => !topTokens.includes(t));

    // 3️⃣ Charger les top tokens en priorité
    await this.loadBalancesForTokens(topTokens, true);

    // 4️⃣ Charger les autres sans bloquer l’UI
    setTimeout(() => {
      this.loadBalancesForTokens(otherTokens, false);
    }, 300);
  }
  async loadBalancesOptimized() {
    if (!this.takerAddress) return;



    // 1️⃣ Récupère uniquement les adresses possédées
    const ownedAddresses = await this.wallet.getOwnedTokensRaw(this.takerAddress, this.chainId ?? 1);


    if (!ownedAddresses.length) {
      console.warn("⚠️ Aucun token whitelisté trouvé");
      return;
    }

    // 2️⃣ Map vers availableTokens (logo, decimals, etc.)
    const ownedTokens = this.availableTokens.filter(t =>
      ownedAddresses.includes((t.address || '').toLowerCase())
    );


    // 2️⃣bis Ajout forcé du token natif si présent dans availableTokens
    const nativeToken = this.availableTokens.find(t =>
      t.address === '0x0000000000000000000000000000000000000000'
    );
    if (nativeToken && !ownedTokens.includes(nativeToken)) {
      ownedTokens.push(nativeToken);

    }


    if (!ownedTokens.length) {
      console.warn("⚠️ Aucun token de la whitelist trouvé dans le portefeuille");
      return;
    }

    // 3️⃣ Charge uniquement les balances pour ces tokens
    await this.loadBalancesForTokens(ownedTokens, true);


    // 4️⃣ Mets à jour la liste 'Vos tokens'
    // 4️⃣ Mets à jour la liste 'Vos tokens'
    //this.userTokens = ownedTokens.filter(t => {
    //  const key = `${t.address.toLowerCase()}_${t.chainId}`;
    //  return parseFloat(this.tokenBalances[key] || '0') > 0;
    //});

    console.log("🎯 Tokens affichés dans 'Vos tokens':", this.userTokens);

    // 5️⃣ Trie des populaires
    this.popularTokens = [...this.availableTokens].sort(
      (a, b) => (b.volumeUsd24h || 0) - (a.volumeUsd24h || 0)
    );


  }









  private async loadBalancesForTokens(tokens: any[], isPriority: boolean) {
    if (!this.takerAddress) return;



    const limitConcurrency = isPriority ? 10 : 5;
    let index = 0;

    //const worker = async () => {
    //  while (index < tokens.length) {
    //    const token = tokens[index++];

    //    try {
    //      let balance = '0';


    //      balance = await this.swapApi.getBalance(
    //        token,
    //        this.takerAddress!,
    //        token.chainId
    //      );

    //      // 🔑 Clé unique : chainId + address
    //      const key = `${token.address.toLowerCase()}_${token.chainId}`;
    //      this.tokenBalances[key] = balance;
    //     /* this.cd.detectChanges();*/
    //      if (parseFloat(balance) > 0) {
    //        /*this.userTokens.push(token);*/
    //        this.cd.detectChanges();
    //      }
    //    } catch (err) {
    //      console.error(`❌ Erreur lors de la récupération du solde pour ${token.symbol}`, err);
    //      const key = `${token.chainId}_${(token.address || '').toLowerCase()}`;
    //      this.tokenBalances[key] = '0';
    //    }
    //  }
    //};

    //const workers = Array.from({ length: limitConcurrency }, () => worker());
    //await Promise.allSettled(workers);
  }




  /** Called when user clicks “Valider” on an alternative row */
  /** Called when user clicks “Valider” on an alternative row */
  /** Called when user clicks “Valider” on an alternative row */
  //onAlternativeSelected(route: any) {
  //  // Reset UI léger
  //  this.swapStatus = 'idle';
  //  this.swapHash = null;
  //  this.swapError = null;

  //  // 1) mémoriser la sélection
  //  const key = this.getRouteKey(route);
  //  this.selectedAltKey = key;
  //  this.selectedAlternative = route;

  //  // 2) extraire la TX de la route (formats possibles)
  //  const rawTx = route?.transactionRequest ?? (
  //    route?.to && route?.data ? { to: route.to, data: route.data, value: route?.value } : null
  //  );

  //  if (!rawTx?.to || !rawTx?.data) {
  //    this.addLog(`[ALT] route sélectionnée SANS transactionRequest (provider=${route?.providerName || route?.tool || route?.source || '(?)'})`);
  //    return;
  //  }

  //  // 🔧 2bis) Sanitize: on enlève tout ce qui peut bloquer / influencer le gas
  //  const tx = sanitizeTxForWallet(rawTx); // retire gas/gasLimit/gasPrice/maxFeePerGas/maxPriorityFeePerGas/type

  //  // 3) injecter uniquement les champs que executeSwap consomme
  //  this.quote = {
  //    ...this.quote,
  //    transactionRequest: {
  //      to: tx.to,
  //      data: tx.data,
  //      value: tx.value ?? this.quote?.transactionRequest?.value ?? '0x0',
  //    },
  //    // champs utilisés pour allowance & logs
  //    fromTokenAddress: route?.fromTokenAddress ?? route?.inTokenAddress ?? this.quote?.fromTokenAddress,
  //    inTokenAddress: route?.inTokenAddress ?? this.quote?.inTokenAddress,
  //    allowanceTarget: route?.allowanceTarget ?? this.quote?.allowanceTarget,
  //    inputAmountRaw: route?.inputAmountRaw ?? this.quote?.inputAmountRaw,
  //  };

  //  // 🧹 Par sécurité: purge de tout hint gas restant
  //  delete (this.quote as any).transactionRequest.gas;
  //  delete (this.quote as any).transactionRequest.gasLimit;
  //  delete (this.quote as any).transactionRequest.gasPrice;
  //  delete (this.quote as any).transactionRequest.maxFeePerGas;
  //  delete (this.quote as any).transactionRequest.maxPriorityFeePerGas;
  //  delete (this.quote as any).transactionRequest.type;

  //  // 🟣 DEBUG: ne laisse pas une simu échouée re-désactiver le bouton alt
  //  if (this.debugBypassGasCheck) {
  //    this.lastSimFailedKey = null;
  //    try { this.failedAltKeys?.clear?.(); } catch { }
  //    this.swapDisabled = false;
  //    this.swapReasons = [];
  //  }

  //  this.addLog(`[ALT] adopt TX (no refresh): key=${key} to=${String(tx.to).slice(0, 6)}… dataLen=${(tx.data || '').length}`);

  //  // 4) go!
  //  this.executeSwap();
  //}
  /** Trace compacte de l’état ALT/quote (sans refactor) */
  private logAltState(tag: string) {
    try {
      this.addLog(
        `[ALT][VIS] ${tag} | hasQuote=${!!this.quote} | selectedAltKey=${this.selectedAltKey ?? 'null'} | selAlt=${this.selectedAlternative ? 'y' : 'n'} | status=${this.swapStatus}`
      );
    } catch { /* no-op */ }
  }

  async onAlternativeSelected(route: any): Promise<void> {
    // 🔁 Soft reset deeplink/cooldown pour ce NOUVEAU run ALT
    await this.softReloadBeforeRunIfNeeded('alt');
    this.logAltState('onAltSelected:enter');
    // Reset léger de l’UI (on repart propre)
    this.swapStatus = 'idle';
    this.swapHash = null;
    this.swapError = null;

    // 1) Mémoriser la sélection (et verrouiller tout de suite l’UI sur CETTE alt)
    const key = this.getRouteKey(route);
    this.selectedAltKey = key;
    this.selectedAlternative = route;
    this.validatingKey = key;        // ✅ annonce immédiate de la route en cours
    this.swapStatus = 'pending';     // ✅ feedback instantané (avant toute async)
    this.logAltState('onAltSelected:after-select+pending');

    this.addLog?.(
      `[ALT][select] key=${key} routeId=${route?.routeId ?? route?.id ?? '∅'} step=enrich`
    );
    // ✅ Cooldown + reset de la session WC entre 2 quotes (ALT → nouvelle confirmation MM)
    await this.cooldownAndResetWcSession('alt');
    this.logAltState('onAltSelected:after-cooldown');
    // 1bis) ⚠️ NE PLUS armer le deeplink ici en ALT.
    //       L’annonce/deeplink sera déplacée juste avant l’envoi de la TX
    //       dans executeSwap() pour éviter toute ouverture prématurée.
    this.addLog('[ALT] pre-deeplink deferred: will announce just-before-send');
    this.logAltState('onAltSelected:before-enrich/approve-triplet');
    try {
      // 2) Extraire la TX depuis la route (plusieurs formats possibles)
      const rawTx =
        route?.transactionRequest ??
        (route?.to && route?.data ? { to: route.to, data: route.data, value: route?.value } : null);

      if (!rawTx?.to || !rawTx?.data) {
        this.addLog(
          `[ALT] route sélectionnée SANS transactionRequest (provider=${route?.providerName || route?.tool || route?.source || '(?)'})`
        );
        // Pas de TX → on annule proprement l’état d’UI
        this.validatingKey = null;
        this.swapStatus = 'idle';
        return;
      }

      // 3) Sanitize: retirer tout hint gas pour laisser le wallet/ RPC décider
      const tx = sanitizeTxForWallet(rawTx); // enlève gas/gasLimit/gasPrice/maxFeePerGas/maxPriorityFeePerGas/type

      // 4) Injecter uniquement ce que executeSwap consomme (sans refetch de quote)
      //    + normaliser token/spender/amount pour l’approve binaire SWAP
      const altTokenAddr =
        (route?.fromTokenAddress ||
          route?.inTokenAddress ||
          route?.action?.fromToken?.address ||
          this.quote?.sellTokenAddress ||
          this.quote?.inTokenAddress ||
          this.quote?.fromTokenAddress || '').toLowerCase();

      const altSpender =
        (route?.allowanceTarget ||
          route?.estimate?.approvalAddress ||
          this.quote?.allowanceTarget || '').toLowerCase();


      // 🔎 DEBUG: dump des sources potentielles AVANT le pick
      try {
        this.addLog('[SWAP][ALT][NEEDED][DUMP][route.inputAmountRaw] ' + String((route as any)?.inputAmountRaw ?? '(null)'));
        this.addLog('[SWAP][ALT][NEEDED][DUMP][route.fromAmount] ' + String((route as any)?.fromAmount ?? '(null)'));
        this.addLog('[SWAP][ALT][NEEDED][DUMP][route.estimate?.fromAmount] ' + String((route as any)?.estimate?.fromAmount ?? '(null)'));
        this.addLog('[SWAP][ALT][NEEDED][DUMP][quote.inputAmountRaw] ' + String((this as any)?.quote?.inputAmountRaw ?? '(null)'));
        this.addLog('[SWAP][ALT][NEEDED][DUMP][quote.sellAmount] ' + String((this as any)?.quote?.sellAmount ?? '(null)'));
        this.addLog('[SWAP][ALT][NEEDED][DUMP][quote.SellAmount] ' + String((this as any)?.quote?.SellAmount ?? '(null)'));
        this.addLog('[SWAP][ALT][NEEDED][DUMP][quote.fromAmount] ' + String((this as any)?.quote?.fromAmount ?? '(null)'));
      } catch { /* noop debug */ }

      // fromAmount peut être en hex → normalisation en string décimale
      let rawNeeded: string | number | null =
        route?.inputAmountRaw ??
        route?.fromAmount ??
        route?.estimate?.fromAmount ??
        this.quote?.inputAmountRaw ??   // si déjà posé par le backend
        (this.quote as any)?.sellAmount ?? // camelCase backend
        (this.quote as any)?.SellAmount ??
        this.quote?.fromAmount ??
        null;

      if (rawNeeded == null) {
        this.addLog('⛔ [ALT][needed] introuvable → abandon pour éviter inputAmountRaw=0');
        this.validatingKey = null;
        this.swapStatus = 'error';
        this.swapError = 'Montant introuvable pour la route sélectionnée';
        return;
      }

      const neededDec =
        typeof rawNeeded === 'string' && rawNeeded.startsWith('0x')
          ? BigInt(rawNeeded).toString()
          : String(rawNeeded);

      this.addLog(`[SWAP][ALT][NEEDED][FINAL] raw=${String(rawNeeded)} → neededDec=${neededDec}`);
      this.quote = {
        ...this.quote,
        transactionRequest: {
          to: tx.to,
          data: tx.data,
          value: tx.value ?? this.quote?.transactionRequest?.value ?? '0x0',
        },
        // Champs utiles pour allowance binaire SWAP
        // (source unique et déterministe)
        sellTokenAddress: altTokenAddr,      // ✅ attendu par ensureAllowanceForRoute
        inTokenAddress: altTokenAddr,        // (on duplique pour compat si le front lit encore ce champ)
        allowanceTarget: altSpender,         // ✅ spender canon
        SellAmount: neededDec,               // ✅ montant exact consommé (base units, décimal)
        // (optionnel: conserver pour debug/legacy UI)
        fromTokenAddress: altTokenAddr,
        inputAmountRaw: neededDec,
      };

      // 4bis) Purge défensive des hints gas restants au cas où
      delete (this.quote as any).transactionRequest.gas;
      delete (this.quote as any).transactionRequest.gasLimit;
      delete (this.quote as any).transactionRequest.gasPrice;
      delete (this.quote as any).transactionRequest.maxFeePerGas;
      delete (this.quote as any).transactionRequest.maxPriorityFeePerGas;
      delete (this.quote as any).transactionRequest.type;

      // 5) Mode debug: bypass des flags de simulation échouée
      if (this.debugBypassGasCheck) {
        this.lastSimFailedKey = null;
        try { this.failedAltKeys?.clear?.(); } catch { }
        this.swapDisabled = false;
        this.swapReasons = [];
      }

      this.addLog(
        `[ALT] adopt TX (no refresh): key=${key} to=${String(tx.to).slice(0, 6)}… dataLen=${(tx.data || '').length}`
      );

      // 6) Go exécution (success/error seront gérés par executeSwap + finalize)
      await this.executeSwap();

    } catch (err: any) {
      // Sécurité: si une exception sync/await remonte, on affiche proprement l’erreur
      this.swapStatus = 'error';
      this.swapError = err?.message || String(err);
      this.addLog(`[ALT] executeSwap error | key=${key} | ${this.swapError}`);
    } finally {
      // 1) Si l’utilisateur a fermé la quote / changé d’ALT entre-temps → reset d’office
      const sameRouteStillSelected =
        this.selectedAltKey === key && this.selectedAlternative === route;
      const panelStillOpen = !!this.quote?.transactionRequest;

      if (!sameRouteStillSelected || !panelStillOpen) {
        if (this.validatingKey === key) this.validatingKey = null;

        // on ne remet à 'idle' que si ce n'est PAS un état terminal
        if (!isTerminal(this.swapStatus)) {
          this.swapStatus = 'idle';
        }
        return;
      }

      // 2) Si executeSwap a throw et qu’aucun finalize n’a reset, on montre l’erreur
      if (this.swapStatus === 'error') {
        setTimeout(() => {
          // Sécurité: ne reset que si on est toujours sur la même alt/clé
          if (
            this.validatingKey === key &&
            this.selectedAltKey === key &&
            this.selectedAlternative === route
          ) {
            this.validatingKey = null;
            if (this.swapStatus === 'error') this.swapStatus = 'idle';
          }
        }, 1500);
      }
    }
  }


  private finalizeSwap(ok: boolean, hash?: string) {
    this.swapStatus = ok ? 'success' : 'error';
    if (ok && hash) this.swapHash = hash;
    // petit délai si tu veux laisser l’état visible, sinon reset direct :
    setTimeout(() => {
      this.swapStatus = 'idle';
      this.validatingKey = null;      // ✅ très important
    }, 1500);
  }

  // pense aussi à faire this.validatingKey = null; lors d’un closeQuote()/hard/soft reload


  /** Extract a provider key from a route (supports several backends) */
  private getRouteKey(r: any): string {
    const raw =
      r?.providerKey ?? r?.ProviderKey ??
      r?.toolKey ?? r?.tool ??
      r?.source ?? r?.Source ??
      r?.providerName ?? r?.name ??
      r?.routeId ?? r?.id ?? '';

    let key = String(raw).trim();
    if (!key) {
      const chain = r?.chainId ?? r?.fromChainId ?? r?.chain ?? 'na';
      const sell = (r?.sellToken?.symbol ?? r?.fromToken?.symbol ?? r?.sellTokenSymbol ?? 'SELL').toUpperCase();
      const buy = (r?.buyToken?.symbol ?? r?.toToken?.symbol ?? r?.buyTokenSymbol ?? 'BUY').toUpperCase();
      key = `main:${chain}:${sell}->${buy}`;
    }
    return key.toLowerCase();
  }

  get selectedLanguage(): string {
    const l = this.translate.currentLang || localStorage.getItem('lang') || 'en';
    return l.toLowerCase();
  }

  /**
 * Construit et signe un PermitSingle pour Permit2.
 * Nécessite :
 *  - this.provider    : BrowserProvider déjà initialisé
 *  - this.quote       : l’objet quote renvoyé par OpenOcean (= contient target et takerTokenAmount)
 *  - this.sellTokenAddress : token vendu (USDC ici)
 */
  /**
   * Construit et signe un PermitSingle pour Permit2.
   * 
   * @param params (optionnel) : objet contenant les champs spécifiques pour 0x Permit2
   */
  async buildPermitAndSign(params?: {
    token: string;
    amount: bigint;
    expiration: bigint;
    nonce: bigint;
    spender: string;
    sigDeadline: bigint;
  }): Promise<{ permit: PermitSingle; signature: string }> {
    if (!this.provider) {
      throw new Error('Wallet non connecté');
    }

    const signer = await this.provider.getSigner();
    const owner = await signer.getAddress();
    const { chainId } = await this.provider.getNetwork();
    const chainIdNum = Number(chainId);

    // ----------------------------
    // 1️⃣ Lecture des paramètres
    // ----------------------------
    let token: string;
    let amount: bigint;
    let expiration: bigint;
    let nonce: bigint;
    let spender: string;
    let sigDeadline: bigint;

    if (params) {
      token = params.token;
      amount = params.amount;
      expiration = params.expiration;
      nonce = params.nonce;
      spender = params.spender;
      sigDeadline = params.sigDeadline;
    } else {
      token = this.sellTokenAddress;
      spender = this.quote.target;
      amount = BigInt(this.quote.value?.takerTokenAmount ?? '0');

      // 🔍 Récupération du nonce on-chain si pas fourni
      const allowanceAbi = [
        'function allowance(address,address,address) view returns (uint160,uint48,uint48)'
      ];
      const permit2 = new Contract(PERMIT2_ADDRESS, allowanceAbi, this.provider);
      const [, , rawNonce] = await permit2['allowance'](owner, token, spender);
      nonce = BigInt(rawNonce);

      const defaultDeadline = BigInt(Math.floor(Date.now() / 1000) + 60 * 30);
      expiration = defaultDeadline;
      sigDeadline = defaultDeadline;
    }

    // ----------------------------
    // 2️⃣ Clamp automatique du nonce à uint48
    // ----------------------------
    const nonceMax = (1n << 48n) - 1n;
    const safeNonce = nonce > nonceMax ? nonce % (nonceMax + 1n) : nonce;

    // ----------------------------
    // 3️⃣ Construction PermitSingle
    // ----------------------------
    const permit: PermitSingle = {
      details: {
        token,
        amount,
        expiration,
        nonce: safeNonce // ✅ Utilisation du nonce corrigé
      },
      spender,
      sigDeadline
    };

    // ----------------------------
    // 4️⃣ Domain & Types EIP-712
    // ----------------------------
    const domain: TypedDataDomain = {
      name: 'Permit2',
      chainId: chainIdNum,
      verifyingContract: PERMIT2_ADDRESS
    };

    const types = {
      PermitSingle: [
        { name: 'details', type: 'PermitDetails' },
        { name: 'spender', type: 'address' },
        { name: 'sigDeadline', type: 'uint256' }
      ],
      PermitDetails: [
        { name: 'token', type: 'address' },
        { name: 'amount', type: 'uint160' },
        { name: 'expiration', type: 'uint48' },
        { name: 'nonce', type: 'uint48' } // ⚠️ uint48 => safeNonce garanti
      ]
    };

    // ----------------------------
    // 5️⃣ Signature EIP-712
    // ----------------------------
    const signature: string = await signer.signTypedData(domain, types, permit);

    return { permit, signature };
  }



  formatTokenAmount(raw: string | number | bigint,
    decimals: number): string {

    // 0. Protection
    if (raw === '' || raw === null || raw === undefined) return '';

    // 1. Conversion → JS number pour l’affichage
    const valueNum = Number(raw.toString());

    // 2. Choix dynamique des décimales
    let min = 2, max = 2;
    const abs = Math.abs(valueNum);

    if (abs >= 100) { max = 2; }            // 123 → “123.45”
    else if (abs >= 1) { max = 4; }            // 7 → “7.003”
    else if (abs >= 0.01) { max = 6; }            // 0.31
    else { min = 4; max = Math.min(decimals, 8); }

    // 3. NumberFormat caché (perf mobile)
    const key = `${min}-${max}`;
    if (!this.nfCache.has(key)) {
      this.nfCache.set(key, new Intl.NumberFormat('en-US', {
        minimumFractionDigits: min,
        maximumFractionDigits: max,
      }));
    }
    return this.nfCache.get(key)!.format(valueNum);
  }

  toggleSettings() {
    this.showSettings = !this.showSettings;
  }


  getTokenBalance(symbol: string): string {
    const token = this.userCachedTokens.find(
      t => t.symbol === symbol && t.chainId === this.chainId
    );
    if (!token) return '';

    const key = `${token.address.toLowerCase()}_${token.chainId}`;
    const balance = this.tokenCachedBalances[key];
    if (!balance) return '';

    const parsed = parseFloat(balance);
    return formatTokenAmount(parsed);
  }

  selectBuyToken(symbol: string) {
    console.log('[selectBuyToken] →', symbol);
    console.trace();
    this.buyTokenSymbol = symbol;

    // ⚡ règle auto : choisir le premier token ≠ buy dans popularTokens (trié par volume)
    if (this.sellTokenSymbol == symbol) {
      const next = this.popularTokens.find(t => t.symbol !== symbol);
      if (next) {
        this.sellTokenSymbol = next.symbol;
      }
    }
  }

  async loadAllBalances() {
    const dbg = (window as any).debugLog;

    if (!this.takerAddress) {
      dbg?.('❌ [loadAllBalances] takerAddress undefined');
      console.warn('[loadAllBalances] ❌ takerAddress undefined');
      return;
    }

    dbg?.('🚀 [loadAllBalances] start pour', this.takerAddress);
    console.group(`[loadAllBalances] Chargement balances pour ➜ ${this.takerAddress}`);

    // 1️⃣ Vérif qu’on a bien les tokens
    if (!this.availableTokens?.length) {
      dbg?.('⚠️ [loadAllBalances] availableTokens vide');
      console.warn('[loadAllBalances] Tokens list is empty');
    }

    //for (const token of this.availableTokens) {
    //  dbg?.('🔁 appel getBalance sur', token.symbol);
    //  console.groupCollapsed(`[${token.symbol}] récupération balance`);

    //  try {
    //    const balance = await this.swapApi.getBalance(token, this.takerAddress, token.chainId);
    //    dbg?.(`✅ ${token.symbol} balance`, balance);
    //    console.debug(`✅ ${token.symbol} balance ➜`, balance);
    //    const key = this.tokenKey(token);
    //    this.tokenBalances[key] = balance ?? '0';
    //  } catch (err) {
    //    dbg?.(`❌ ${token.symbol} erreur`, err);
    //    console.error(`❌ Erreur récupération balance ${token.symbol}`, err);
    //    const key = this.tokenKey(token);
    //    this.tokenBalances[key] = '0';
    //  }

    //  console.groupEnd();
    //}

    //dbg?.('📊 [loadAllBalances] tableau final', this.tokenBalances);
    //console.table(this.tokenBalances);
    //console.groupEnd();
    // 🔎 dérive toujours la clé address_chainId pour lire la balance
    //this.userTokens = this.availableTokens.filter(t => {
    //  const key = `${(t.address || '').toLowerCase()}_${Number(t.chainId)}`;
    //  const balance = parseFloat(this.tokenBalances[key] || '0');
    //  return balance > 0;
    //});

    this.popularTokens = [...this.availableTokens].sort((a, b) =>
      (b.volumeUsd24h || 0) - (a.volumeUsd24h || 0)
    );

    //console.log('[📊 tokenBalances] Composant :', this.constructor.name);
    //console.table(this.tokenBalances);

  }
  get isBridge(): boolean {
    return this.route.snapshot.queryParamMap.get('bridge') === '1';
  }

  get bridgeLabel(): string {
    return this.isSwap ? 'Go to bridge' : 'Go to swap';
  }

  get bridgeQuery(): any {
    return { bridge: this.isBridge ? '0' : '1' };
  }

  get bridgeGradient(): string {
    return this.isBridge
      ? 'bg-gradient-to-r from-blue-400 via-blue-500 to-blue-600'
      : 'bg-gradient-to-r from-purple-300 via-purple-500 to-indigo-600';
  }

  get invBridgeLogo(): string {
    return this.isSwap
      ? 'text-purple-500'
      : 'text-blue-500';
  }
  get invBridgeGradientDark(): string {
    return this.isSwap
      ? 'text-transparent bg-clip-text bg-gradient-to-r from-purple-500 via-purple-600 to-purple-600'
      : 'text-transparent bg-clip-text bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700';
  }

  get invBridgeGradient(): string {
    return this.isSwap
      ? 'bg-gradient-to-r from-purple-500 via-purple-600 to-purple-700'
      : 'bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700';
  }

  get isArabicLang(): boolean {
    return this.translate.currentLang === 'ar' || this.translate.currentLang === 'zh';
  }

  /**
 * Connecte le wallet :
 *  • Desktop : MetaMask extension
 *  • Mobile : WalletConnect v2 + MetaMask mobile
 *  • Restaure la session WalletConnect si elle existe déjà
 */
  /**
 * Ouvre une connexion :
 *  • Desktop  → MetaMask extension (eth_requestAccounts)
 *  • Mobile   → WalletConnect v2 + MetaMask mobile  (1 seule autorisation)
 */
  /* Dans ta classe */
  private pollId: any = null;

  /* … */
  openWcModal(uri: string) { this.wcUri = uri; this.showWcModal = true; }
  closeWcModal() { this.showWcModal = false; this.wcUri = ''; }



  async connectWallet(): Promise<void> {
    try {
      /* this.closeQuote(); */

      // Empêche tout auto-restore pendant que l'utilisateur initie un connect
      sessionStorage.setItem('st/skipAutoRestoreOnce', '1');

      if (!modal) initAppKit('8d74b0ff39c361ecaa9c3dd96ac0055c');
      await initSignClient();

      // ✅ Autorise temporairement le deeplink MetaMask pour cette action utilisateur
      (window as any).__allowWcDeeplinkFor?.(15_000);

      await modal!.open({ view: 'Connect', namespace: 'eip155' });

      // Attendre que le provider EIP-1193 soit prêt
      const provider: any = await new Promise((resolve) => {
        let done = false;
        const unsub = modal!.subscribeProviders?.((state: any) => {
          if (done) return;
          const evm = state?.['eip155'];
          if (!evm) return;
          const p = evm.provider ?? evm;
          if (p) {
            done = true;
            try { unsub?.(); } catch { }
            resolve(p);
          }
        });
      });

      const pType = modal!.getWalletProviderType?.();

      if (typeof provider.request !== 'function') {
        throw new Error('Invalid EIP-1193 provider');
      }

      this.provider = new BrowserProvider(provider);

      const signer = await this.provider.getSigner();
      const address = await signer.getAddress();
      const { chainId } = await this.provider.getNetwork();

      this.takerAddress = address;
      this.isConnected = true;

      // Sauvegarde simple de session locale (pour ton restore)
      saveSimpleSession({
        address,
        chainId: Number(chainId),
        providerType: pType ?? 'unknown',
        ts: Date.now(),
      });

      // 💾 Sauvegarde WalletConnect (si tu l’utilises)
      await backupSession();

      // Sync UI + tokens
      this.setChain(Number(chainId));
      await this.refreshTokensForChain();

      // Vérifs de tokens côté UI
      const sellValid = this.availableTokens.some(t => t.symbol === this.sellTokenSymbol);
      const buyValid = this.availableTokens.some(t => t.symbol === this.buyTokenSymbol);

      if (!sellValid) {
        const sellToken = this.getDefaultSellTokenForChain(Number(chainId));
        console.log('[attachEthersProvider] SELL invalide → fallback', sellToken?.symbol);
        if (sellToken?.symbol) this.selectSellToken(sellToken.symbol);
      } else {
        console.log('[attachEthersProvider] SELL conservé =', this.sellTokenSymbol);
      }

      if (!buyValid) {
        const buyToken = this.getDefaultBuyTokenForChain(Number(chainId));
        console.log('[attachEthersProvider] BUY invalide → fallback', buyToken?.symbol);
        if (buyToken?.symbol) this.selectBuyToken(buyToken.symbol);
      } else {
        console.log('[attachEthersProvider] BUY conservé =', this.buyTokenSymbol);
      }

      this.cd.detectChanges();

      // Connexion OK → on peut lever le skip auto-restore
      sessionStorage.removeItem('st/skipAutoRestoreOnce');

    } catch (err: any) {
      // Nettoyage minimal en cas d'échec
      sessionStorage.removeItem('st/skipAutoRestoreOnce');
      alert('Connexion échouée: ' + (err?.message || 'Unknown error'));
    }
  }





  //async connectWallet(): Promise<void> {
  //  try {
  //    if (!modal) initAppKit('8d74b0ff39c361ecaa9c3dd96ac0055c');

  //    await modal!.open({ view: 'Connect', namespace: 'eip155' });



  //    const provider: any = await new Promise((resolve) => {
  //      let done = false;
  //      const unsub = modal!.subscribeProviders?.((state: any) => {
  //        if (done) return;

  //        const evm = state?.['eip155'];
  //        if (!evm) return;

  //        // Supporte les deux formes : provider direct ou inclus dans .provider
  //        const p = evm.provider ?? evm;
  //        if (p) {
  //          done = true;
  //          try { unsub?.(); } catch { }

  //          resolve(p);
  //        }
  //      });
  //    });

  //    const pType = modal!.getWalletProviderType?.();


  //    if (typeof provider.request !== 'function') {

  //      throw new Error('Invalid EIP-1193 provider');
  //    }


  //    this.provider = new BrowserProvider(provider);

  //    const signer = await this.provider.getSigner();
  //    const address = await signer.getAddress();
  //    const { chainId } = await this.provider.getNetwork();

  //    this.takerAddress = address;
  //    this.isConnected = true;
  //    this.setChain(Number(chainId));
  //    // 🔄 Attendre le rechargement réel des tokens
  //    await this.refreshTokensForChain();

  //    // Vérifier que popularTokens n'est pas vide
  //    console.log("popularTokens après refresh", this.popularTokens);

  //    // Sélectionner les tokens par défaut
  //    const sellToken = this.getDefaultSellTokenForChain(Number(chainId));
  //    const buyToken = this.getDefaultBuyTokenForChain(Number(chainId));

  //    console.log("sellToken =", sellToken);
  //    console.log("buyToken =", buyToken);

  //    if (sellToken?.symbol) this.selectSellToken(sellToken.symbol);
  //    if (buyToken?.symbol) this.selectBuyToken(buyToken.symbol);

  //      this.cd.detectChanges();

  //  } catch (err: any) {
  //    alert('Connexion échouée: ' + (err?.message || 'Unknown error'));
  //  }
  //}
  async disconnectWallet() {
    try {
      this.closeQuoteWithReason('disconnectWallet');
      localStorage.removeItem('wallet');
      localStorage.setItem('st/skipAutoRestoreOnce', '1');

      // ❌ await this.wc2.disconnect(); ✅ tu gardes si tu l’as déjà
      await this.wc2.disconnect().catch(() => { });

      // ❌ killWalletConnectV2(this.wc2?.signClient)
      // ✅
      await killWalletConnectV2(signClient);

      // MetaMask/injected revoke (inchangé)
      const eth: any = (window as any).ethereum;
      try {
        eth?.removeAllListeners?.();
        if (typeof eth?.request === 'function') {
          await eth.request({
            method: 'wallet_revokePermissions',
            params: [{ eth_accounts: {} }]
          }).catch(() => { });
        }
        if (typeof eth?.disconnect === 'function') {
          await eth.disconnect().catch(() => { });
        }
      } catch (e) {
        console.warn('[disconnect] MM revoke/disconnect:', e);
      }

      // Purge localStorage (inchangé)
      try {
        ['wallet', 'walletconnect', 'walletconnect_session', 'wc_session_id'].forEach(k => localStorage.removeItem(k));
        Object.keys(localStorage)
          .filter(k => k.startsWith('wc@2:') || k.startsWith('w3m') || k.startsWith('wagmi') || k.toLowerCase().includes('appkit'))
          .forEach(k => localStorage.removeItem(k));
      } catch { }

      // IndexedDB
      await purgeWCIndexedDB();

      // ❌ teardownAppKit(this.modal); this.modal = undefined;
      // ✅
      teardownAppKit(modal);
      modal = undefined;

      // Reset UI/state
      this.takerAddress = null;
      this.provider = null;
      this.isConnected = false;
      //this.chainId = null;
      //this.chainInfo = null;
      this.showWcModal = false;
      this.wcUri = '';

    } finally {
      // pas de reload automatique
    }
  }





  getFormattedAddress(address: string | null): string {
    if (!address) return '';
    return `${address.slice(0, 6)}...${address.slice(-4)}`;
  }

  // Nouvelle méthode pour basculer entre les modes clair et sombre
  toggleTheme() {
    const body = document.body;
    if (body.classList.contains('light-mode')) {
      body.classList.remove('light-mode');
      body.classList.add('dark-mode');
      localStorage.setItem('theme', 'dark');
    } else {
      body.classList.remove('dark-mode');
      body.classList.add('light-mode');
      localStorage.setItem('theme', 'light');
    }
  }

  // Nouvelle méthode pour vérifier l'état du mode
  isDarkMode(): boolean {
    return document.body.classList.contains('dark-mode');
  }

  formatAmount(value: string | number, decimals: number = 18, isSellAmount: boolean = false): string {
    try {
      const bigValue = BigInt(value.toString());
      if (isSellAmount) {
        return bigValue.toString() + '.000000';
      }
      const divisor = BigInt(Math.pow(10, decimals));
      const wholePart = bigValue / divisor;
      const fractionalPart = bigValue % divisor;
      const fractionalStr = fractionalPart.toString().padStart(decimals, '0').slice(0, 6);
      const result = `${wholePart}.${fractionalStr}`;
      return result === '0.000000' && bigValue > 0 ? '0.000001' : result;
    } catch (error) {
      console.error('Erreur dans formatAmount :', error, { value, decimals });
      return '0.000000';
    }
  }


  filterTokens(search: string, type: 'sell' | 'buy') {
    const target = search.toLowerCase();

    const filtered = this.availableTokens
      .filter(token => token.symbol.toLowerCase().startsWith(target))
      .sort((a, b) => a.symbol.localeCompare(b.symbol));

    if (type === 'sell') {
      this.filteredSellTokens = filtered;
      if (!filtered.some(t => t.symbol === this.sellTokenSymbol)) {
        this.sellTokenSymbol = filtered.length > 0 ? filtered[0].symbol : '';
      }
    } else {
      this.filteredBuyTokens = filtered;
      if (!filtered.some(t => t.symbol === this.buyTokenSymbol)) {
        this.buyTokenSymbol = filtered.length > 0 ? filtered[0].symbol : '';
      }
    }
  }







  private getTokenBySymbol(symLike: string | null | undefined, chainId: number) {
    const sym = String(symLike ?? '').toUpperCase();
    return this.availableTokens.find(
      (t: any) =>
        String(t?.symbol ?? '').toUpperCase() === sym &&
        Number(t?.chainId) === Number(chainId)
    );
  }

  getTokenAddress(symLike: string | null | undefined, chainId?: number): string {
    const cid = Number(chainId ?? this.chainId ?? 1);

    const raw = String(symLike ?? '').trim();
    // autoriser une adresse directe
    if (/^0x[a-fA-F0-9]{40}$/.test(raw)) return raw;

    const sym = raw.toUpperCase();

    // 1) whitelist / tokens disponibles
    const tok = this.getTokenBySymbol(sym, cid);
    if (tok?.address) return tok.address;

    // 2) fallback connu
    const fb = FALLBACK_TOKEN_ADDRESSES[cid]?.[sym];
    if (fb) return fb;

    // 3) rien trouvé
    return '';
  }





  getTokenDecimalsByAddress(address: string): number | undefined {
    const allTokens = [...this.filteredSellTokens, ...this.filteredBuyTokens];
    const token = allTokens.find(t => t.address?.toLowerCase() === address?.toLowerCase());
    return token?.decimals;
  }


  async fetchNativeTokenUsd(): Promise<number> {
    const symbol = this.getNativeTokenSymbol(this.chainId ?? 1);
    try {
      const prices = await firstValueFrom(this.price.fetchPrices([symbol], 'usd'));
      return prices[symbol] ?? 0;
    } catch (err) {
      console.warn(`❌ Erreur CoinGecko (${symbol}/USD) :`, err);
      return 0;
    }
  }

  private applyGasFromQuote(q: any) {
    try {
      const toBig = (v: any): bigint => {
        if (v === null || v === undefined) return 0n;
        if (typeof v === 'bigint') return v;
        const s = String(v).trim();
        if (!s) return 0n;
        // hex ou décimal entier
        return s.startsWith('0x') ? BigInt(s) : BigInt(s);
      };
      const pick = <T>(...vals: T[]): T | undefined =>
        vals.find(v => v !== undefined && v !== null && v !== '');

      // --- 1) gasPriceWei (priorité backend → LiFi → tx)
      let gasPriceWei = toBig(
        pick(
          q?.gasPriceWei, q?.GasPriceWei,
          q?.estimate?.gasCosts?.[0]?.price,
          q?.includedSteps?.find((s: any) => s?.estimate?.gasCosts?.length)?.estimate?.gasCosts?.[0]?.price,
          q?.transactionRequest?.gasPrice
        )
      );

      // --- 2) totalNetworkFee (wei) (priorité backend → somme LiFi)
      let totalGasWei = toBig(pick(q?.totalNetworkFee, q?.TotalNetworkFee));

      if (totalGasWei === 0n) {
        const top = (q?.estimate?.gasCosts ?? []).map((g: any) => toBig(g?.amount));
        const steps = (q?.includedSteps ?? [])
          .flatMap((s: any) => (s?.estimate?.gasCosts ?? []).map((g: any) => toBig(g?.amount)));
        totalGasWei = [...top, ...steps].reduce((acc: bigint, v: bigint) => acc + v, 0n);
      }

      // --- 3) fallback : EstimatedGas × GasPriceWei
      if (totalGasWei === 0n) {
        const estGasUnits = toBig(pick(q?.estimatedGas, q?.EstimatedGas));
        if (estGasUnits > 0n && gasPriceWei > 0n) {
          totalGasWei = estGasUnits * gasPriceWei;
        }
      }

      // --- 4) prix USD du token natif (priorité backend → LiFi)
      let nativeTokenUsd =
        Number(pick(q?.gasTokenPriceUsd, q?.GasTokenPriceUsd)) ||
        Number(
          pick(
            q?.estimate?.gasCosts?.[0]?.token?.priceUSD,
            q?.includedSteps?.find((s: any) => s?.estimate?.gasCosts?.length)?.estimate?.gasCosts?.[0]?.token?.priceUSD
          ) ?? 0
        ) || 0;

      // ✅ met exactement à jour ce que faisait updateGasCost
      this.gasPriceWei = gasPriceWei;
      /* this.fullGasWei = totalGasWei;*/
      this.nativeTokenUsd = nativeTokenUsd;

      console.log('[💰 GAS from quote]',
        'fullGasWei=', this.fullGasWei.toString(),
        'gasPriceWei=', this.gasPriceWei.toString(),
        'nativeTokenUsd=', this.nativeTokenUsd);
    } catch (err) {
      console.warn('applyGasFromQuote() error', err);
      this.gasPriceWei = 0n;
      this.fullGasWei = 0n;
      this.nativeTokenUsd = 0;
    }
  }









  /** Montant du SOLDE (≠ sellAmount) dans la devise courante */
  getTokenFiatBalance(symbol: string): string {
    const bal = parseFloat(this.getTokenBalance(symbol) || '0');
    if (!bal) return '';

    const unit = this.priceMap[symbol] ??
      (['USDC', 'USDT'].includes(symbol) ? 1 : 0);

    const total = bal * unit;
    if (!total) return '';

    return total.toLocaleString(
      this.defaultFiat === 'EUR' ? 'fr-FR' : 'en-US',
      {
        style: 'currency',
        currency: this.defaultFiat,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }
    );
  }


  /** Calcule le prix payé et fees pour une route (ISO LiFi) */
  private async computeIsoFeeForRoute(route: any): Promise<{
    mode: 'legacy' | 'eip1559' | 'none',
    gasLimit: bigint,
    priceWei: bigint,
    feeWei: bigint
  }> {
    const tr: any = route?.transactionRequest ?? route?.TransactionRequest ?? route ?? {};
    const gasLimitHex = tr.gasLimit ?? tr.gas ?? null;
    const gasPriceHex = tr.gasPrice ?? null;              // legacy
    const maxFeeHex = tr.maxFeePerGas ?? null;          // eip-1559
    const maxPrioHex = tr.maxPriorityFeePerGas ?? null;

    if (!gasLimitHex || (!gasPriceHex && !(maxFeeHex && maxPrioHex))) {
      return { mode: 'none', gasLimit: 0n, priceWei: 0n, feeWei: 0n };
    }

    const gasLimit = BigInt(gasLimitHex);
    let priceWei: bigint;
    let mode: 'legacy' | 'eip1559' = 'legacy';

    if (gasPriceHex) {
      // Legacy
      mode = 'legacy';
      priceWei = BigInt(gasPriceHex);
    } else {
      // EIP-1559: prix « payé » estimé = min(maxFee, baseFee + tip)
      mode = 'eip1559';
      let baseFeeWei = 0n;
      try {
        const rpc: any = this.provider as any;
        const latest = await rpc.send('eth_getBlockByNumber', ['latest', false]);
        baseFeeWei = latest?.baseFeePerGas ? BigInt(latest.baseFeePerGas) : 0n;
      } catch { }
      const maxFee = BigInt(maxFeeHex);
      const maxPrio = BigInt(maxPrioHex);
      const paid = baseFeeWei > 0n ? (baseFeeWei + maxPrio) : maxFee;
      priceWei = paid < maxFee ? paid : maxFee;
    }

    const feeWei = priceWei * gasLimit;
    return { mode, gasLimit, priceWei, feeWei };
  }



  // 🔮 Calcule une preview quasi-identique à MetaMask (t=0)
  // 🔮 Calcule une preview quasi-identique à MetaMask (t=0) — tip dynamique P60 + uplift
  private async previewWalletFeesAligned(rawTx: any) {
    try {
      if (!this.provider || !this.chainId) return;
      if (this.chainId && isL2Chain(Number(this.chainId))) {
        const rpc: any = this.provider as any;
        const unitWei = BigInt(await rpc.send('eth_gasPrice', []));
        const tr0: any = this.quote?.transactionRequest ?? this.quote ?? {};
        const gasLimitHex = tr0.gasLimit ?? tr0.gas ?? this.quote?.estimatedGas ?? this.quote?.EstimatedGas;
        const gasLimit = gasLimitHex ? BigInt(gasLimitHex) : 21000n;

        this.mmUnitWei = unitWei;
        this.gasPriceWei = unitWei;
        this.fullGasWei = unitWei * gasLimit;

        return; // ⛔ pas de estimateGas sur L2
      }

      // 1) Nettoyer la tx (aucun champ de frais ni gasLimit)
      const cleanTx = sanitizeTxForWallet({
        from: this.takerAddress ?? undefined,
        to: rawTx?.to,
        data: rawTx?.data ?? '0x',
        value: rawTx?.value ?? 0n,
        chainId: this.chainId
      });

      const rpc: any = (this.provider as any);

      console.log("[FEE][preview][estimateGas cleanTx]", cleanTx);

      const gasLimit: bigint = await this.provider.estimateGas(cleanTx);
      const bufferedGasLimit: bigint = (gasLimit * 125n) / 100n; // +25%

      // 3) base fee (dernier bloc)
      let baseFeeWei = 0n;
      try {
        const latest = await rpc.send('eth_getBlockByNumber', ['latest', false]);
        baseFeeWei = BigInt(latest?.baseFeePerGas ?? '0x0');
      } catch { baseFeeWei = 0n; }

      // 3bis) priority fee (tip) dynamique = avg(P60 sur 5 blocs) + 0.3 gwei, clampé
      const fallbackTip = 1_500_000_000n; // 1.5 gwei si feeHistory indispo
      let tipWei = fallbackTip;
      try {
        const blocks = 5;
        const percentiles = [70]; // P60 pour un léger biais conservateur
        const fh = await rpc.send('eth_feeHistory', [blocks, 'latest', percentiles]);

        let sum = 0n, n = 0n;
        for (const r of (fh?.reward ?? [])) { if (r?.[0]) { sum += BigInt(r[0]); n++; } }
        const avgP60 = n > 0n ? (sum / n) : 0n;

        const uplift = 300_000_000n;  // +0.3 gwei
        const minTip = 500_000_000n;  // 0.5 gwei
        const maxTip = 3_000_000_000n; // 3 gwei

        const dynamic = avgP60 > 0n ? (avgP60 + uplift) : fallbackTip;
        tipWei = dynamic < minTip ? minTip : (dynamic > maxTip ? maxTip : dynamic);

        // Log de traçage (optionnel)
        console.log('[FEE][tip]', {
          minTip: Number(minTip),
          maxTip: Number(maxTip),
          dynamic: Number(dynamic)
        });

        // Log de traçage (optionnel)
        console.log('[FEE][tip]', {
          p60Gwei: Number(avgP60) / 1e9,
          upliftGwei: Number(uplift) / 1e9,
          usedGwei: Number(tipWei) / 1e9
        });
      } catch {
        tipWei = fallbackTip;
      }

      // 4) MetaMask-style "Marché": maxFeePerGas = 2*baseFee + tip
      const maxWeiPerGas = (baseFeeWei * 2n) + tipWei;


      this.mmBaseFeeWei = baseFeeWei;
      this.mmTipWei = tipWei;
      this.mmUnitWei = maxWeiPerGas;            // prix unitaire “MM-like”
      this.mmBufferedGasLimit = bufferedGasLimit; // juste informatif
      // 5) Coût max affiché (single line "comme MetaMask")
      const feeWei = bufferedGasLimit * maxWeiPerGas;
      this.fullGasWei = feeWei;

      // 6) Conversion USD (prise de prix natif)
      const nativeUsd = await getOnChainNativeUsd(this.chainId, this.provider);
      if (nativeUsd) this.nativeTokenUsd = nativeUsd;

      const feeEth = Number(feeWei) / 1e18;
      const feeUsdRaw = this.nativeTokenUsd ? feeEth * this.nativeTokenUsd : 0;

      // 7) Logs de contrôle — valeurs brutes (pas d’arrondi ici)
      console.log('[FEE][preview][MM-like]', {
        chain: this.chainId,
        gasLimit: gasLimit.toString(),
        bufferedGasLimit: bufferedGasLimit.toString(),
        baseFeeGwei: Number(baseFeeWei) / 1e9,
        tipGwei: Number(tipWei) / 1e9,
        maxFeePerGasGwei: Number(maxWeiPerGas) / 1e9,
        feeEthRaw: feeEth,
        feeUsdRaw: feeUsdRaw
      });
    } catch (e) {
      console.warn('[FEE][preview] fallback on wallet only', e);
    }
  }



  // dans export class SwapComponent { ... ICI ... }

  // ──────────────────────────────────────────────────────────────
  // Helper d'affichage (facultatif)
  private async normalizeAltRoute(
    rIn: any,
    opts: {
      mode: 'no-wallet' | 'l2' | 'l1',
      nativeUsd?: number,
      unitWei?: bigint,            // L2: eth_gasPrice
      paidPerGas?: bigint,         // L1: min(maxFee, baseFee+tip)
      baseFeeWei?: bigint,         // L1 (info)
      tipWei?: bigint,             // L1 (info)
      bufferPct?: number,          // % buffer sur gasLimit
      lifiFallbackCap?: boolean,   // no-wallet: prendre maxFee fourni
      snapshotLiFi?: boolean,      // garder l’affichage "LiFi" par route
      minTipWei?: bigint,
      // affichage reçu estimé
      buyTokenDecimals?: number,
      buyTokenSymbol?: string,
      buyTokenUsdPrice?: number
    }
  ): Promise<any> {
    const r = { ...(rIn ?? {}) }; // clone modifiable
    const tr: any = r?.transactionRequest ?? r?.TransactionRequest ?? r ?? {};
    const dbg = Boolean((this as any).debugAltNormalize);
    const id =
      r?.providerName || r?.tool || r?.provider || r?.routeId || r?.id || r?.name || 'alt';

    const nz = (v: any) => {
      try {
        const s = String(v);
        return (s === '' || s === '0' || s === '0x0' || s === '0x') ? null : s;
      } catch { return null; }
    };
    const toWei = (v: any): bigint => {
      try {
        if (typeof v === 'bigint') return v;
        if (typeof v === 'number') return BigInt(Math.trunc(v));
        if (typeof v === 'string' && v) return v.startsWith('0x') ? BigInt(v) : BigInt(v);
      } catch { }
      return 0n;
    };
    const toEth = (w: any): number => {
      try {
        const n =
          typeof w === 'bigint' ? Number(w) :
            typeof w === 'number' ? w :
              (w != null ? (String(w).startsWith('0x') ? Number(BigInt(w)) : Number(w)) : 0);
        return n / 1e18;
      } catch { return 0; }
    };
    const usd = Number(r.lifiGasTokenPriceUsd ?? opts.nativeUsd ?? 0);

    /* ── 1) Snapshot LiFi (affichage) ─────────────────────── */
    if (opts.snapshotLiFi) {
      const est = r?.estimate ?? r?.Estimate ?? r?.step?.estimate ?? null;
      const toTok = est?.toToken ?? r?.toToken ?? r?.action?.toToken ?? null;

      // a) reçu estimé
      r.toAmountRaw = String(est?.toAmount ?? r?.toAmountRaw ?? 0);
      r.toAmountUsd = est?.toAmountUSD ?? r?.toAmountUsd ?? null;
      r.toTokenDecimals = Number(r?.toTokenDecimals ?? toTok?.decimals ?? opts.buyTokenDecimals ?? 18);
      r.buyTokenSymbol = r.buyTokenSymbol ?? toTok?.symbol ?? opts.buyTokenSymbol;
      if (!r.formattedBuyAmount && r.toAmountRaw && r.toTokenDecimals >= 0) {
        r.formattedBuyAmount = Number(r.toAmountRaw) / Math.pow(10, r.toTokenDecimals);
      }
      r.buyTokenUsdPrice = Number(r.buyTokenUsdPrice ?? opts.buyTokenUsdPrice ?? 0);

      // b) frais LiFi pour affichage
      r.lifiEstimatedGas = r.lifiEstimatedGas ?? r.estimatedGas ?? est?.gasCosts?.[0]?.estimate ?? null;
      r.lifiGasPriceWei = r.lifiGasPriceWei ?? r.gasPriceWei ?? est?.gasCosts?.[0]?.price ?? null;
      r.lifiGasAmountWei = r.lifiGasAmountWei ?? r.gasAmountWei ?? est?.gasCosts?.[0]?.amount ?? null;
      r.lifiGasFeeUsd = r.lifiGasFeeUsd ?? r.gasFeeUsd ?? est?.gasCosts?.[0]?.amountUSD ?? null;
      r.lifiGasTokenPriceUsd = Number(r.lifiGasTokenPriceUsd ?? r.gasTokenPriceUsd ?? opts.nativeUsd ?? 0);
    }

    /* ── 2) MM expected/network/max : flatten depuis singleRoutes[0] ── */
    const sr0 = r?.singleRoutes?.[0] ?? null;
    const mmExpectedFromPayload =
      toWei((r as any).MmExpectedNetworkFeeWei) ||
      toWei((r as any).mmExpectedNetworkFeeWei) ||
      toWei(sr0?.mmExpectedNetworkFeeWei) ||
      0n;
    const mmNetworkFromPayload =
      toWei((r as any).MmNetworkFeeWei) ||
      toWei((r as any).mmNetworkFeeWei) ||
      toWei(sr0?.mmNetworkFeeWei) ||
      0n;
    const mmMaxFromBackend =
      toWei((r as any).MmMaxNetworkFeeWei) ||
      toWei((r as any).mmMaxNetworkFeeWei) ||
      toWei(sr0?.mmMaxNetworkFeeWei) ||
      0n;

    // Exposition au niveau route (pour l’enfant/CTA)
    if (!r.mmExpectedNetworkFeeWei && mmExpectedFromPayload > 0n) r.mmExpectedNetworkFeeWei = mmExpectedFromPayload;
    if (!r.mmNetworkFeeWei && mmNetworkFromPayload > 0n) r.mmNetworkFeeWei = mmNetworkFromPayload;
    if (!r.mmMaxNetworkFeeWei && mmMaxFromBackend > 0n) r.mmMaxNetworkFeeWei = mmMaxFromBackend;

    if (dbg) {
      console.log('[SWAP][ALT][NORM][IN]', {
        id, mode: opts.mode, usd,
        topLevel: {
          mmExpected: (r as any).mmExpectedNetworkFeeWei ?? null,
          mmNetwork: (r as any).mmNetworkFeeWei ?? null,
          mmMax: (r as any).mmMaxNetworkFeeWei ?? null,
        },
        sr0: {
          mmExpected: sr0?.mmExpectedNetworkFeeWei ?? null,
          mmNetwork: sr0?.mmNetworkFeeWei ?? null,
          mmMax: sr0?.mmMaxNetworkFeeWei ?? null,
        },
        lifi: {
          estGas: r.lifiEstimatedGas ?? null,
          priceWei: r.lifiGasPriceWei ?? null,
          amountWei: r.lifiGasAmountWei ?? null,
          feeUsd: r.lifiGasFeeUsd ?? null,
        }
      });
    }

    /* ── 3) Cap MM-like local (si backend muet) ───────────────── */
    const rawLimit =
      toWei(r.lifiEstimatedGas) || toWei(r.estimatedGas) ||
      toWei(tr.gasLimit) || toWei(tr.gas) || 0n;

    const bufferPct = Math.max(0, Number(opts.bufferPct ?? 0));
    const bufferedLimit = rawLimit > 0n ? (rawLimit * BigInt(100 + bufferPct)) / 100n : 0n;

    let mmMaxLocal: bigint = 0n;
    if (opts.mode === 'l1') {
      const pricePerGas = toWei(opts.paidPerGas ?? 0n); // min(maxFee, baseFee+tip) fourni par le parent
      if (bufferedLimit > 0n && pricePerGas > 0n) mmMaxLocal = bufferedLimit * pricePerGas;
    } else if (opts.mode === 'l2') {
      const unitWei = toWei(opts.unitWei ?? 0n);        // eth_gasPrice côté L2
      if (bufferedLimit > 0n && unitWei > 0n) mmMaxLocal = bufferedLimit * unitWei;
    } else {
      // no-wallet: on prend ce qu’on a (backend mm / sinon rien)
      mmMaxLocal = mmMaxFromBackend;
    }

    // Fallback LiFi si aucun MM n’est disponible
    const liFiWei =
      toWei(r.lifiGasAmountWei) ||
      (() => {
        const p = toWei(r.lifiGasPriceWei);
        const g = toWei(r.lifiEstimatedGas);
        return (p > 0n && g > 0n) ? p * g : 0n;
      })();

    // Choix final pour la "cap" exposée à l’enfant (legacy): max-backend → max-local → lifi
    const mmFullWei = (mmMaxFromBackend > 0n ? mmMaxFromBackend :
      (mmMaxLocal > 0n ? mmMaxLocal :
        (liFiWei > 0n ? liFiWei : 0n)));

    // Exposer pour l’enfant (compat: gas.fullWei est une cap/worst-case)
    (r as any).gas = (r as any).gas || {};
    (r as any).gas.fullWei = mmFullWei;

    if (true) {
      const expEth = toEth(r.mmExpectedNetworkFeeWei);
      const netEth = toEth(r.mmNetworkFeeWei);
      const maxEth = toEth(r.mmMaxNetworkFeeWei);
      const lifiEth = toEth(liFiWei);
      const locMaxEth = toEth(mmMaxLocal);
      const fullEth = toEth(mmFullWei);
      const reason =
        (r.mmExpectedNetworkFeeWei ? 'expected_present' :
          r.mmNetworkFeeWei ? 'fallback_mmNetwork' :
            r.mmMaxNetworkFeeWei ? 'fallback_mmMax' :
              liFiWei > 0n ? 'fallback_liFi' : 'missing_all');

      console.log('[SWAP][ALT][NORM][OUT]', {
        id, mode: opts.mode, bufferPct,
        rawLimit: Number(rawLimit), bufferedLimit: Number(bufferedLimit),
        mmExpectedWei: r.mmExpectedNetworkFeeWei ?? null,
        mmNetworkWei: r.mmNetworkFeeWei ?? null,
        mmMaxBackendWei: mmMaxFromBackend || null,
        mmMaxLocalWei: mmMaxLocal || null,
        liFiWei: liFiWei || null,
        gasFullWei: mmFullWei || null,
        mmExpectedEth: expEth, mmExpectedUsd: expEth && usd ? expEth * usd : null,
        mmNetworkEth: netEth, mmNetworkUsd: netEth && usd ? netEth * usd : null,
        mmMaxEth: maxEth, mmMaxUsd: maxEth && usd ? maxEth * usd : null,
        liFiEth: lifiEth, liFiUsd: lifiEth && usd ? lifiEth * usd : null,

        gasFullEth: fullEth, gasFullUsd: fullEth && usd ? fullEth * usd : null,
        reason
      });
    }

    return r;
  }



  private installRpcDebugProbeOnWindow(label: string = 'global'): void {
    const w: any = (window as any);
    const p: any = w?.ethereum;
    if (!p) { this.addLog(`[rpc] debug probe skipped (${label}): no window.ethereum`); return; }
    if (p.__rpcDebugProbeInstalled) return;

    const SENSITIVE = new Set([
      'wallet_switchEthereumChain', 'wallet_addEthereumChain', 'eth_requestAccounts',
      'eth_sendTransaction', 'eth_sign', 'personal_sign',
      'eth_signTypedData', 'eth_signTypedData_v3', 'eth_signTypedData_v4'
    ]);

    if (typeof p.request === 'function') {
      const origReq = p.request.bind(p);
      p.request = async (args: { method: string; params?: any[] }) => {
        try {
          if (args?.method && SENSITIVE.has(args.method)) {
            this.addLog(`[rpc][${label}] ${args.method} params=${JSON.stringify(args.params ?? [])}`);
          }
        } catch { }
        return origReq(args);
      };
    }
    if (typeof p.send === 'function') {
      const origSend = p.send.bind(p);
      p.send = async (method: string, params?: any[]) => {
        try {
          if (method && SENSITIVE.has(method)) {
            this.addLog(`[rpc][${label}] ${method} params=${JSON.stringify(params ?? [])}`);
          }
        } catch { }
        return origSend(method, params);
      };
    }
    p.__rpcDebugProbeInstalled = true;
    this.addLog(`[rpc] debug probe installed (${label}) on window.ethereum`);
  }

  private _installQuotePropDebugHook() {
    const self: any = this as any;
    if (!('quote' in self)) return;

    let _q = self['quote'];
    try {
      Object.defineProperty(self, 'quote', {
        configurable: true,
        enumerable: true,
        get() { return _q; },
        set(v: any) {
          if (_q && !v) {
            const st = new Error().stack?.split('\n').slice(1, 4).map(s => s.trim()).join(' | ');
            self.addLog(`🧯 [modal] quote -> falsy (FERMETURE SANS closeQuote*) | stack=${st || 'n/a'}`);
          }
          _q = v;
        }
      });
      this.addLog('🔧 [modal] debug hook installed on quote');
    } catch (e) {
      this.addLog(`⚠️ [modal] hook install failed on quote: ${e}`);
    }
  }


  async fetchQuote() {
    // NOTE: logs only — on veut savoir si le click arrive vraiment ici
    try {
      const ev: any = (typeof event !== 'undefined') ? (event as any) : null;
      this.addLog?.(`[quote][ui] click -> fetchQuote | hasEvent=${!!ev} type=${ev?.type || '-'} target=${ev?.target?.tagName || '-'} disabled=${!!this.swapDisabled} loading=${!!this.isLoadingQuote}`);
      ev?.preventDefault?.();
      ev?.stopPropagation?.();
    } catch (e: any) {
      this.addLog?.(`[quote][ui] event hook error: ${e?.message || e}`);
    }

    this.addLog?.(`[quote][flow] entering fetchQuote | status=${this.swapStatus || 'idle'} quotePresent=${!!this.quote}`);
    this.closeQuoteWithReason('fetchQuote');
    this.swapDisabled = false;
    this.isLoadingQuote = true;
    this.quoteErrorMessage = null;

    const effectiveChain = this.chainId ?? (this as any).chainIdFromSeo ?? 1;
    const MIN_TIP = 1_000_000_000n; // 1 gwei

    this.sellTokenAddress = this.getTokenAddress(this.sellTokenSymbol, effectiveChain);
    this.buyTokenAddress = this.getTokenAddress(this.buyTokenSymbol, effectiveChain);

    // 🔍 snapshot des inputs au moment du click
    this.addLog?.(
      `[quote][inputs] chainId=${this.chainId ?? '(null)'} effectiveChain=${effectiveChain} ` +
      `addr=${this.takerAddress ?? '(null)'} sellSym=${this.sellTokenSymbol} buySym=${this.buyTokenSymbol} ` +
      `sellAmount=${this.sellAmount ?? '(null)'} sellAddr=${this.sellTokenAddress ?? '(null)'} buyAddr=${this.buyTokenAddress ?? '(null)'}`
    );

    const norm = this.normalizeAmountForApi(this.sellAmount);
    this.addLog?.(`[amount][normalize] raw='${norm.rawStr}' -> api='${norm.apiStr}' num=${norm.num ?? 'null'}`);

    if (!norm.num || !this.sellTokenAddress || !this.buyTokenAddress || !this.chainId) {
      this.addLog?.(
        `[quote][guard] BLOCK missing/invalid params | sellAmountOk=${!!norm.num} sellAddr=${!!this.sellTokenAddress} buyAddr=${!!this.buyTokenAddress} chainId=${!!this.chainId} | raw='${norm.rawStr}' api='${norm.apiStr}'`
      );
      console.error('❌ Paramètres manquants pour fetchQuote');
      this.isLoadingQuote = false;
      return;
    }

    // 🔎 Contexte & sonde RPC (pour capturer toute popup déclenchée pendant la quote)
    this.addLog(`[quote] start | chain=${this.chainId} addr=${this.takerAddress ?? '(null)'} sell=${this.sellTokenSymbol}/${this.sellTokenAddress} buy=${this.buyTokenSymbol}/${this.buyTokenAddress}`);
    this.installRpcDebugProbe('fetchQuote');
    this.installRpcDebugProbeOnWindow('fetchQuote');
    this.installWindowOpenProbe('fetchQuote');
    try {
      const p: any = this.provider as any;
      const winEth: any = (window as any)?.ethereum;
      this.addLog(`[quote][probe] providerPresent=${!!p} probeOnProvider=${!!p?.__rpcDebugProbeInstalled} probeOnWinEth=${!!winEth && !!winEth.__rpcDebugProbeInstalled}`);
      this.addLog('[quote][guard] willUseSigner=false (read-only path expected)');
    } catch { /* no-op */ }

    const rawSellAmount = norm.apiStr; // ✅ always dot format for API
    console.log('🔍 Tentative quote ULTRA :', rawSellAmount, this.sellTokenAddress, this.buyTokenAddress, this.chainId);
    this.addLog(`[quote][api] calling getQuote amount=${rawSellAmount} chain=${this.chainId}`);
    const t0 = Date.now();

    this.swapApi.getQuote(
      this.sellTokenAddress,
      this.buyTokenAddress,
      rawSellAmount,
      this.takerAddress ?? environment.defaultTaker,
      this.chainId
    )
      .pipe(timeout(90000))
      .subscribe({
        next: async (resp) => {
          this.addLog?.(`[quote][api] next received in ${Date.now() - t0}ms | respKeys=${Object.keys(resp || {}).slice(0, 12).join(',')}`);
          const data = resp.data ?? resp;
          console.log('🧠 [RAW quote response] =', JSON.stringify(data, null, 2));
          this.addLog('[quote][api] next | (read-only: EXPECT no popup here)');

          // 🔎 sanity minimal sur la payload
          try {
            const trAny: any = data?.transactionRequest ?? data?.TransactionRequest ?? null;
            this.addLog?.(
              `[quote][api] payload sanity | hasData=${!!data} ` +
              `hasTxReq=${!!trAny} to=${trAny?.to || data?.to || data?.target || '-'} ` +
              `hasCalldata=${!!(trAny?.data || data?.data)}`
            );
          } catch { }

          // 0) Log immédiat des champs gas livrés par LiFi (brut)
          const tr0: any = data?.transactionRequest ?? data?.TransactionRequest ?? data ?? {};
          console.log('[quote.tx] dapp-suggested gas fields', {
            gas: tr0.gas, gasLimit: tr0.gasLimit,
            gasPrice: tr0.gasPrice,
            maxFeePerGas: tr0.maxFeePerGas,
            maxPriorityFeePerGas: tr0.maxPriorityFeePerGas
          });

          // 1) Prépare la quote et permit (structure de base + UI)
          this.addLog?.('[quote][prep] prepareUltraQuoteAndPermit() start');
          await this.prepareUltraQuoteAndPermit(data);
          this.addLog?.('[quote][prep] prepareUltraQuoteAndPermit() done');

          // 2) USD natif : LiFi d’abord, puis Chainlink si dispo
          const lifiUsd = Number(data?.gasTokenPriceUsd ?? data?.GasTokenPriceUsd ?? 0);
          if (lifiUsd > 0) this.nativeTokenUsd = lifiUsd;
          try {
            if (this.chainId) {
              const onchainUsd = await this.nativeTokenPrice.getOnChainUsd(this.chainId as number, this.provider ?? null);
              if (onchainUsd && onchainUsd > 0) this.nativeTokenUsd = onchainUsd;
            }
          } catch (e) {
            console.warn('[fetchQuote][USD] Chainlink indisponible, on garde =', this.nativeTokenUsd, e);
          }

          // 2bis) Snapshot des frais LiFi “tels quels” (pour l’affichage LiFi)
          const liFiWei = BigInt(String(
            data?.totalNetworkFee ?? data?.TotalNetworkFee ??
            data?.gasAmountWei ?? data?.GasAmountWei ?? 0
          ));
          (this.quote as any).lifiNetworkFeeWei = liFiWei.toString();
          (this.quote as any).lifiNetworkFeeNative = Number(liFiWei) / 1e18;
          if ((this.nativeTokenUsd ?? 0) > 0) {
            (this.quote as any).lifiNetworkFeeUsd =
              (this.quote as any).lifiNetworkFeeNative * this.nativeTokenUsd!;
          }

          // 3) Applique les champs gas du backend pour initialiser l’UI (fallback no-wallet)
          this.applyGasFromQuote(data);
          this.addLog?.(`[quote][gas] applyGasFromQuote() done | fullGasWei=${this.fullGasWei ? String(this.fullGasWei) : '(null)'}`);
          const estBackend = BigInt(String(
            data?.estimatedGas ?? data?.EstimatedGas ??
            this.quote?.estimatedGas ?? this.quote?.EstimatedGas ?? 0
          ));
          console.log('[fetchQuote] Backend gas estimate =', estBackend.toString());

          // 3bis) Si wallet + taker → prévisualisation alignée MetaMask (expected & max)
          try {
            const txForPreview =
              data?.transactionRequest ??
              this.quote?.transactionRequest ??
              (data?.to && data?.data ? { to: data.to, data: data.data, value: data?.value } : null);

            if (txForPreview && this.provider && this.takerAddress) {
              this.addLog(`[quote][preview] txForPreview=${!!txForPreview} provider=${!!this.provider} taker=${!!this.takerAddress}`);
              await this.previewWalletFeesAligned(txForPreview);
              const mmGasLimit: bigint =
                ((this as any).mmBufferedGasLimit && (this as any).mmBufferedGasLimit > 0n)
                  ? (this as any).mmBufferedGasLimit
                  : (estBackend > 0n ? estBackend : 21000n);

              const basePlusTip = ((this as any).mmBaseFeeWei ?? 0n) + ((this as any).mmTipWei ?? 0n);
              const maxFee = (this as any).mmUnitWei ?? 0n;

              const paidPerGas = basePlusTip < maxFee ? basePlusTip : maxFee;   // min(maxFee, baseFee+tip)
              const mmExpected = mmGasLimit * paidPerGas;
              const mmMax = mmGasLimit * maxFee;

              // ✅ solvabilité = VRAI plafond
              this.fullGasWei = mmMax;

              (this.quote as any).mmExpectedNetworkFeeWei = mmExpected.toString();
              (this.quote as any).mmExpectedNetworkFeeNative = Number(mmExpected) / 1e18;
              (this.quote as any).mmMaxNetworkFeeWei = mmMax.toString();
              (this.quote as any).mmMaxNetworkFeeNative = Number(mmMax) / 1e18;
              if ((this.nativeTokenUsd ?? 0) > 0) {
                (this.quote as any).mmExpectedNetworkFeeUsd =
                  (this.quote as any).mmExpectedNetworkFeeNative * this.nativeTokenUsd!;
                (this.quote as any).mmMaxNetworkFeeUsd =
                  (this.quote as any).mmMaxNetworkFeeNative * this.nativeTokenUsd!;
              }
            }
          } catch (e) {
            console.warn('[FEE][preview] skipped', e);
          }

          /* ─────────────────────────────────────────────
           * 4) PAS DE WALLET → reflète LiFi + normalizeAltRoute()
           * ───────────────────────────────────────────── */
          if (!this.provider) {
            await this.updateGasCost(estBackend);

            try {
              const routes: any[] = (data?.singleRoutes ?? data?.SingleRoutes ?? []).filter(Boolean);
              const nativeUsdForAlts =
                this.nativeTokenUsd ??
                Number(data?.gasTokenPriceUsd ?? data?.GasTokenPriceUsd ?? 0) ?? 0;

              const normalized = await Promise.all(routes.map(r =>
                this.normalizeAltRoute(r, {
                  mode: 'no-wallet',
                  nativeUsd: nativeUsdForAlts,
                  snapshotLiFi: true,
                  lifiFallbackCap: true,
                  minTipWei: MIN_TIP,
                  // ✨ infos de token/symbole pour “Token reçu estimé”
                  buyTokenDecimals: (this.quote?.buyTokenDecimals ?? this.quote?.BuyTokenDecimals ?? 18),
                  buyTokenSymbol: (this.quote?.buyTokenSymbol ?? this.quote?.BuyTokenSymbol ?? this.buyTokenSymbol),
                  buyTokenUsdPrice: (this.quote?.buyTokenUsdPrice ?? data?.buyTokenUsdPrice ?? 0)
                })
              ));

              // 👉 IMPORTANT : le composant enfant lit quote.singleRoutes
              this.quote.singleRoutes = normalized;
              (this as any).otherRoutes = normalized; // optionnel, si tu l’utilises ailleurs
            } catch (e) {
              console.warn('[ALT] Normalisation ISO LiFi (no-wallet) impossible', e);
            }

            // Sans wallet, MM attendu/max = LiFi (principale)
            (this.quote as any).mmExpectedNetworkFeeWei = liFiWei.toString();
            (this.quote as any).mmExpectedNetworkFeeNative = Number(liFiWei) / 1e18;
            (this.quote as any).mmMaxNetworkFeeWei = liFiWei.toString();
            (this.quote as any).mmMaxNetworkFeeNative = Number(liFiWei) / 1e18;
            if ((this.nativeTokenUsd ?? 0) > 0) {
              (this.quote as any).mmExpectedNetworkFeeUsd =
                (this.quote as any).mmExpectedNetworkFeeNative * this.nativeTokenUsd!;
              (this.quote as any).mmMaxNetworkFeeUsd =
                (this.quote as any).mmMaxNetworkFeeNative * this.nativeTokenUsd!;
            }
            this.fullGasWei = liFiWei;
            this.ultraMode = false;
            console.log('📦 Quote ULTRA prête (no wallet):', this.quote);
            return;
          }

          /* ─────────────────────────────────────────────
           * 5) Wallet présent → vérifier chainId
           * ───────────────────────────────────────────── */
          try {
            const net = await this.provider.getNetwork().catch(() => null);
            const currentChain = Number(net?.chainId ?? 0);
            const expectedChain = Number(this.chainId ?? 1);
            this.addLog(`[quote][net] providerChain=${currentChain} expectedChain=${expectedChain} mismatch=${currentChain !== expectedChain}`);
            if (currentChain && expectedChain && currentChain !== expectedChain) {
              console.warn('[fetchQuote] Wallet chain mismatch -> garde backend', { currentChain, expectedChain });
              await this.updateGasCost(estBackend);
              this.ultraMode = false;
              return;
            }

            // 6) Construire la tx pour d’éventuels estimates
            const tr: any = data?.transactionRequest ?? data?.TransactionRequest ?? {};
            const to = tr?.to ?? data?.target ?? data?.Target;
            const rawV = tr?.value ?? data?.value ?? data?.Value ?? null;
            const valHex = rawV != null
              ? (String(rawV).startsWith('0x') ? String(rawV) : '0x' + BigInt(String(rawV)).toString(16))
              : '0x0';
            const tx: any = { to, data: tr?.data ?? data?.data ?? data?.Data, value: valHex };

            if (!tx.to || !tx.data) {
              console.warn('[fetchQuote] tx incomplète pour estimateGas -> backend only');
              await this.updateGasCost(estBackend);
              this.ultraMode = false;
              return;
            }

            /* ─────────────────────────────────────────────
             * 7) L2 → unit = gasPrice ; alternatives via normalizeAltRoute()
             * ───────────────────────────────────────────── */
            if (isL2Chain(Number(this.chainId))) {
              const rpc: any = this.provider as any;
              this.addLog('[quote][L2] eth_gasPrice');
              const unitWei = BigInt(await rpc.send('eth_gasPrice', []));

              const gasLimitHex =
                tr.gasLimit ?? tr.gas ??
                data?.estimatedGas ?? data?.EstimatedGas ??
                this.quote?.estimatedGas ?? this.quote?.EstimatedGas;
              const gasLimit = gasLimitHex ? BigInt(gasLimitHex) : (estBackend > 0n ? estBackend : 21000n);
              this.addLog(`[quote][L2] gasLimit source=${gasLimitHex ? 'quote|est' : 'backend|fallback'} value=${gasLimit.toString()}`);

              const mmWei = unitWei * gasLimit;
              (this.quote as any).mmExpectedNetworkFeeWei = mmWei.toString();
              (this.quote as any).mmExpectedNetworkFeeNative = Number(mmWei) / 1e18;
              (this.quote as any).mmMaxNetworkFeeWei = mmWei.toString();
              (this.quote as any).mmMaxNetworkFeeNative = Number(mmWei) / 1e18;
              if ((this.nativeTokenUsd ?? 0) > 0) {
                (this.quote as any).mmExpectedNetworkFeeUsd =
                  (this.quote as any).mmExpectedNetworkFeeNative * this.nativeTokenUsd!;
                (this.quote as any).mmMaxNetworkFeeUsd =
                  (this.quote as any).mmMaxNetworkFeeNative * this.nativeTokenUsd!;
              }
              this.fullGasWei = mmWei;

              // 🌟 Alternatives via normalizeAltRoute()
              try {
                const routes: any[] = (data?.singleRoutes ?? data?.SingleRoutes ?? []).filter(Boolean);
                const nativeUsdForAlts =
                  this.nativeTokenUsd ??
                  Number(data?.gasTokenPriceUsd ?? data?.GasTokenPriceUsd ?? 0) ?? 0;

                const normalized = await Promise.all(routes.map(r =>
                  this.normalizeAltRoute(r, {
                    mode: 'l2',
                    nativeUsd: nativeUsdForAlts,
                    unitWei,                     // eth_gasPrice
                    snapshotLiFi: true,
                    bufferPct: 0,
                    buyTokenDecimals: (this.quote?.buyTokenDecimals ?? this.quote?.BuyTokenDecimals ?? 18),
                    buyTokenSymbol: (this.quote?.buyTokenSymbol ?? this.quote?.BuyTokenSymbol ?? this.buyTokenSymbol),
                    buyTokenUsdPrice: (this.quote?.buyTokenUsdPrice ?? data?.buyTokenUsdPrice ?? 0)
                  })
                ));

                this.quote.singleRoutes = normalized;   // ✅ important
                (this as any).otherRoutes = normalized;
              } catch (e) {
                console.warn('[L2][ALT] Normalisation impossible', e);
              }

              this.ultraMode = false;
              console.log('📦 Quote ULTRA prête (L2 ISO-LiFi):', this.quote);
              return;
            }

            /* ─────────────────────────────────────────────
             * 8) L1 → baseFee+tip ; alternatives via normalizeAltRoute()
             * ───────────────────────────────────────────── */
            const signer = await this.provider.getSigner();
            const from = await signer.getAddress();

            // gasLimit via provider (fallback backend)
            let mmGasLimit: bigint;
            try {
              this.addLog(`[quote][L1] estimateGas (from=${from})`);
              const est = await this.provider.estimateGas({ from, to: tx.to, data: tx.data, value: tx.value });
              mmGasLimit = BigInt(est.toString());
            } catch (err) {
              console.warn('[fetchQuote] estimateGas MetaMask a échoué -> fallback backend', err);
              mmGasLimit = estBackend > 0n ? estBackend : 21000n;
            }

            // baseFee
            const browser: any = this.provider as any;
            let baseFeeWei = 0n;
            try {
              this.addLog('[quote][L1] eth_getBlockByNumber latest');
              const latest = await browser.send('eth_getBlockByNumber', ['latest', false]);
              baseFeeWei = latest?.baseFeePerGas ? BigInt(latest.baseFeePerGas) : 0n;
            } catch (e) {
              console.warn('[fetchQuote][baseFee] eth_getBlockByNumber KO → baseFee=0 (legacy?)', e);
            }

            // priorityFee (min 1 gwei)
            let tipWei = 0n;
            try {
              this.addLog('[quote][L1] eth_maxPriorityFeePerGas | fallback=feeHistory');
              const tipHex = await browser.send('eth_maxPriorityFeePerGas', []);
              if (tipHex) tipWei = BigInt(tipHex);
            } catch {
              try {
                const fh = await browser.send('eth_feeHistory', [6, 'latest', [50, 75]]);
                const avg = (arr: string[]) => arr.length ? arr.map(x => BigInt(x)).reduce((a, b) => a + b, 0n) / BigInt(arr.length) : 0n;
                const p50s: string[] = fh.reward.map((r: string[]) => r[0]);
                const p75s: string[] = fh.reward.map((r: string[]) => r[1]);
                tipWei = avg(p50s) || avg(p75s) || 0n;
              } catch { /* keep 0n */ }
            }
            if (tipWei < MIN_TIP) tipWei = MIN_TIP;

            const quoteTx = data?.transactionRequest ?? data;
            const maxFeePerGasWei = quoteTx?.maxFeePerGas ? BigInt(quoteTx.maxFeePerGas) : null;

            const basePlusTip = (baseFeeWei > 0n)
              ? (baseFeeWei + tipWei)
              : (() => { try { return BigInt(browser.send('eth_gasPrice', [])); } catch { return 2_000_000_000n; } })();

            const paidPerGas = maxFeePerGasWei
              ? (basePlusTip < maxFeePerGasWei ? basePlusTip : maxFeePerGasWei)
              : basePlusTip;

            const mmExpected = mmGasLimit * paidPerGas;
            const mmMax = mmGasLimit * (maxFeePerGasWei ?? paidPerGas);

            // ✅ solvabilité = VRAI plafond
            this.fullGasWei = mmMax;

            (this.quote as any).mmExpectedNetworkFeeWei = mmExpected.toString();
            (this.quote as any).mmExpectedNetworkFeeNative = Number(mmExpected) / 1e18;
            (this.quote as any).mmMaxNetworkFeeWei = mmMax.toString();
            (this.quote as any).mmMaxNetworkFeeNative = Number(mmMax) / 1e18;
            if ((this.nativeTokenUsd ?? 0) > 0) {
              (this.quote as any).mmExpectedNetworkFeeUsd =
                (this.quote as any).mmExpectedNetworkFeeNative * this.nativeTokenUsd!;
              (this.quote as any).mmMaxNetworkFeeUsd =
                (this.quote as any).mmMaxNetworkFeeNative * this.nativeTokenUsd!;
            }

            // 🌟 Alternatives via normalizeAltRoute()
            try {
              const routesRaw: any[] = (data?.singleRoutes ?? data?.SingleRoutes ?? []);
              console.log("routesRaw");
              console.log(routesRaw);
              const routes: any[] = routesRaw.filter(Boolean);

              const nativeUsdForAlts =
                this.nativeTokenUsd ??
                Number(data?.gasTokenPriceUsd ?? data?.GasTokenPriceUsd ?? 0) ?? 0;

              const normalized = await Promise.all(routes.map(r =>
                this.normalizeAltRoute(r, {
                  mode: 'l1',
                  nativeUsd: nativeUsdForAlts,
                  paidPerGas,                 // min(maxFee, baseFee+tip)
                  baseFeeWei,
                  tipWei,
                  minTipWei: MIN_TIP,
                  snapshotLiFi: true,
                  bufferPct: 25,              // +25% de marge
                  buyTokenDecimals: (this.quote?.buyTokenDecimals ?? this.quote?.BuyTokenDecimals ?? 18),
                  buyTokenSymbol: (this.quote?.buyTokenSymbol ?? this.quote?.BuyTokenSymbol ?? this.buyTokenSymbol),
                  buyTokenUsdPrice: (this.quote?.buyTokenUsdPrice ?? data?.buyTokenUsdPrice ?? 0)
                })
              ));

              this.quote.singleRoutes = normalized;   // ✅ important
              (this as any).otherRoutes = normalized;
            } catch (e) {
              console.warn('[ALT] Normalisation (MM-like) impossible', e);
            }

          } catch (e) {
            console.warn('[fetchQuote] Alignement impossible -> fallback backend', e);
            await this.updateGasCost(estBackend);
          }

          this.ultraMode = false;
          console.log('📦 Quote ULTRA prête :', this.quote);
          this.addLog(`[quote] done | ultraMode=${this.ultraMode} mmMaxWei=${this.fullGasWei?.toString?.() || 'n/a'}`);
        },
        error: (err: any) => {
          const msg = err?.message || err?.error?.message || String(err);
          this.addLog?.(`[quote][api] ERROR in ${Date.now() - t0}ms | ${msg.slice(0, 220)}`);
          try { console.error('[fetchQuote] getQuote error', err); } catch { }
          this.isLoadingQuote = false;
          this.quoteErrorMessage = msg;
        },
        complete: () => {
          this.addLog?.(`[quote][api] complete in ${Date.now() - t0}ms | loading=${!!this.isLoadingQuote} quotePresent=${!!this.quote}`);
        }

      })
      .add(() => {
        this.isLoadingQuote = false;
        this.addLog('[quote] complete');
      });

    this.lockBodyScroll(true);  // ⬅️ bloque le scroll de l’arrière-plan
  }
















  get isSwap(): boolean {
    const value = this.route.snapshot.queryParamMap.get('bridge');
    return value === null || value === '0';
  }

  // Mapping simple des décimales par token symbol
  async prepareUltraQuoteAndPermit(data: any): Promise<void> {
    try {
      if (!this.sellAmount || !this.sellTokenSymbol || !this.buyTokenSymbol) {
        throw new Error('Paramètres de swap incomplets.');
      }

      this.sellTokenAddress = this.getTokenAddress(this.sellTokenSymbol);
      this.buyTokenAddress = this.getTokenAddress(this.buyTokenSymbol);

      if (!this.sellTokenAddress || !this.buyTokenAddress) {
        throw new Error('Impossible de déterminer les adresses des tokens.');
      }

      this.buildUltraQuote(data);  // ✅ Quote enrichie, mais sans signature

      console.log('✅ [prepareUltraQuoteAndPermit] Quote prête (sans signature)');

    } catch (err: any) {
      console.error('❌ Erreur prepareUltraQuoteAndPermit :', err.message ?? err);
      /*this.quote = null;*/
      this.permit = undefined;
      this.permitSig = undefined;
    }
  }



  buildUltraQuote(data: any): void {
    if (!this.sellTokenAddress || !this.buyTokenAddress || !this.sellAmount) {
      console.error("❌ Paramètres manquants pour buildUltraQuote");
      return;
    }

    const sellDecimals = this.getTokenDecimals(this.sellTokenSymbol);
    const buyDecimals = this.getTokenDecimals(this.buyTokenSymbol);

    const sellAmountRaw = this.toAmountDecimals(this.sellAmount, this.sellTokenSymbol);
    const gasPriceDecimals = this.gasPriceWei?.toString() ?? '0';

    this.quote = {
      ...data,
      IsPermit2: data.isPermit2 === true,
      inTokenAddress: this.sellTokenAddress,
      outTokenAddress: this.buyTokenAddress,
      amountDecimals: sellAmountRaw,
      flag: data.flag ?? '0',
      permitSig: this.permitSig ?? '',
      feeAmount1: data.feeAmount1 ?? '0',
      feeAmount2: data.feeAmount2 ?? '0',
      gasPriceDecimals,
      nonce: data.nonce ?? '0',
      deadline: data.deadline ?? Math.floor(Date.now() / 1000 + 1800).toString(),
      permit: this.permit ?? data.permit ?? '',

      // UI
      formattedSellAmount: this.formatAmount(sellAmountRaw, sellDecimals),
      formattedBuyAmount: this.formatAmount(data.buyAmount, buyDecimals),
      formattedGasFee: this.formatAmount(data.totalNetworkFee ?? '0', 18),
      sellTokenSymbol: this.sellTokenSymbol,
      buyTokenSymbol: this.buyTokenSymbol
    };

    console.log('✅ [buildUltraQuote] Quote enrichie :', this.quote);
  }

  private getTokenDecimals(symbol: string): number {
    const map: Record<string, number> = {
      ETH: 18, WETH: 18,
      USDC: 6, USDT: 6,
      DAI: 18, MATIC: 18
      // ajoute d’autres si besoin
    };
    return map[symbol?.toUpperCase()] ?? 18;
  }
  /** Poll on-chain until allowance >= needed (or timeout/partial). */
  private async pollAllowanceUntil(
    tokenAddr: string,
    spender: string,
    owner: string,
    needed: bigint,
    opts: { timeoutMs?: number; intervalMs?: number } = {}
  ): Promise<'ok' | 'partial' | 'timeout'> {
    const { timeoutMs = 60_000, intervalMs = 1_000 } = opts;
    if (!this.provider) return 'timeout';
    const signer = await this.provider.getSigner();
    const erc20 = new Contract(tokenAddr, ERC20_ABI, signer);
    const t0 = Date.now();
    let last = 0n;

    this.addLog(`[SWAP][APPROVE][POLL] start | token=${tokenAddr} spender=${spender} needed=${needed}`);

    while (true) {
      try {
        const cur = await (erc20['allowance'] as (o: string, s: string) => Promise<bigint>)(owner, spender);
        if (cur !== last) {
          this.addLog(`[SWAP][APPROVE][POLL] tick | allowance=${cur}`);
          last = cur;
        }
        if (cur >= needed) {
          this.addLog(`[SWAP][APPROVE][POLL] ok | allowance=${cur} ≥ needed=${needed}`);
          // IMPORTANT: si l’approve a été lent, on annule le timeout local "approve".
          // (ça évite un faux cancel alors que l'allowance est bien passée.)
          try { this.cfOnHash?.('apprv'); } catch { }
          return 'ok';
        }
      } catch { /* transient RPC read; ignore */ }

      if (Date.now() - t0 > timeoutMs) {
        this.addLog(`[SWAP][APPROVE][POLL] timeout ${timeoutMs}ms | last=${last}`);
        return last > 0n && last < needed ? 'partial' : 'timeout';
      }
      await new Promise(r => setTimeout(r, intervalMs));
    }
  }

  async fetchBridgeQuote() {
    this.isLoadingQuote = true;
    this.quoteErrorMessage = null;

    const sellToken = this.sellTokenSymbol;
    const buyToken = this.buyTokenSymbol;

    if (!this.sellAmount || !sellToken || !buyToken) {
      console.error('❌ Paramètres manquants pour fetchBridgeQuote');
      this.isLoadingQuote = false;
      return;
    }

    const decimals = tokenDecimalsMap[sellToken];
    if (decimals === undefined) {
      console.error(`❌ Décimales inconnues pour ${sellToken}`);
      this.isLoadingQuote = false;
      return;
    }

    // Convertir sellAmount en wei string
    const rawSellAmount = this.toWei(this.sellAmount, decimals);

    const taker = this.takerAddress ?? environment.defaultTaker;
    const fromChainId = this.selectedNetwork ?? 1;    // réseau de vente
    const toChainId = this.selectedBuyNetwork ?? 137; // réseau d’achat
    const slippage = 100;
    const bridge = 'openocean';

    console.log('➡️ Paramètres API bridge:', {
      sellToken,
      buyToken,
      rawSellAmount,
      taker,
      fromChainId,
      toChainId,
      slippage,
      bridge
    });

    try {
      const resp = await firstValueFrom(
        this.bridgeApi.getQuote(
          sellToken,
          buyToken,
          rawSellAmount,
          taker,
          fromChainId,
          toChainId,
          slippage,
          bridge
        )
      );

      if (!resp.success) {
        throw new Error(resp.message || 'Erreur bridge quote');
      }

      const data = resp.data ?? resp;

      this.quote = {
        ...data,
        formattedSellAmount: resp.formattedSellAmount,
        formattedBuyAmount: resp.formattedBuyAmount,
        formattedGasFee: resp.formattedGasFee ?? this.formatAmount(data.totalNetworkFee ?? '0', 18)
      };

      this.applyGasFromQuote(data);

      if (this.provider && data.estimatedGas) {
        await this.updateGasCost(BigInt(data.estimatedGas));
      }

      this.ultraMode = false;

      console.log('📦 Bridge quote reçue :', this.quote);

    } catch (err: any) {
      console.error('❌ Erreur fetchBridgeQuote :', err);

      this.quoteErrorMessage = "⚠️ Devis momentanément indisponible. Veuillez réessayer plus tard.";
      this.flashCta(this.translate.instant('CTA_QUOTE_UNAVAILABLE_RETRY'), 5000, 3000);

      this.quote = null;
    } finally {
      this.isLoadingQuote = false;
    }
  }

  // Convertir une quantité décimale en string entière wei
  toWei(amount: number | string, decimals: number): string {
    const amt = typeof amount === 'string' ? parseFloat(amount) : amount;
    return (BigInt(Math.floor(amt * Math.pow(10, decimals)))).toString();
  }


  toAmountDecimals(amount: string | number, symbol: string): string {
    const decimals = TOKEN_DECIMALS_MAP[symbol] ?? 18;
    const amt = typeof amount === 'string' ? parseFloat(amount) : amount;
    return (BigInt(Math.floor(amt * Math.pow(10, decimals)))).toString();
  }



  async simulateSwap() {
    if (!this.quote || !this.provider || !this.quote.value) {
      console.warn("🚫 Quote, Provider ou quote.value manquant pour simulateSwap");
      console.log("Debug :", {
        quote: this.quote,
        provider: this.provider,
        quoteValue: this.quote?.value
      });
      return;
    }

    const signer = await this.provider.getSigner();
    const domain = this.quote.domain;
    const types = this.quote.types;
    const value = this.quote.value;

    const takerToken = value.takerToken.toLowerCase();

    // ✅ Liste des tokens compatibles Permit2
    const permitTokens = [
      '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48', // USDC
      '0xdac17f958d2ee523a2206206994597c13d831ec7', // USDT
      '0x6b175474e89094c44da98b954eedeac495271d0f', // DAI
      '0xc02aaA39b223fe8d0a0e5c4f27ead9083c756cc2'  // WETH
      // Ajoute d’autres tokens compatibles Permit2 si nécessaire
    ];
    console.log(`🧪 Vérification Permit2 : token = ${takerToken}`);
    const isPermit2Compatible = this.enablePermit2 && permitTokens.includes(takerToken);

    if (isPermit2Compatible) {
      console.log("🪪 Token compatible Permit2 → génération d’un PermitSingle");

      try {
        const result = await this.buildPermitAndSign();
        this.permit = result.permit;
        this.permitSig = result.signature;
        this.signature = null;
        console.log("✅ Permit2 signé avec succès");
      } catch (err) {
        console.error("❌ Erreur buildPermitAndSign :", err);
        this.permit = undefined;
        this.permitSig = undefined;

      }

    } else {
      console.log("✍️ Signature classique EIP-712 (non-Permit2)");

      try {
        this.signature = await signer.signTypedData(domain, types, value);
        this.permit = undefined;
        this.permitSig = undefined;

        console.log('✍️ Signature générée :', this.signature);
      } catch (err) {
        console.error('❌ Erreur lors de la génération de signature classique :', err);
      }
    }
  }





  /** 
   * 1 seule pop-up si this.ultraMode === true
   * 2 pop-ups sinon (approve + swap)
   */
  /**
 * Exécute le swap :
 *  • ULTRA  : 1 seule pop-up (Permit2 + routeur gasless)
 *  • CLASSIC : approve éventuel puis swap (2 pop-ups max)
 */
  /**
 * Exécute le swap :
 *  • ULTRA  : Permit2 + routeur gasless → 1 pop-up
 *  • CLASSIC : approve éventuelle + swap → 2 pop-ups
 */
  //async executeSwap() {
  //  console.log('🧾 [ULTRA] executeSwap =\n');
  //  //------------------------------------------------------------------
  //  // 0️⃣  Vérifs communes
  //  //------------------------------------------------------------------
  //  if (!this.quote || !this.provider || !this.takerAddress) {
  //    console.error('Quote / provider / address manquants');
  //    return;
  //  }

  //  //------------------------------------------------------------------
  //  // ULTRA MODE  (Permit2 / 1 pop-up)
  //  //------------------------------------------------------------------
  //  if (this.quote.IsPermit2) {
  //    const {
  //      inTokenAddress, outTokenAddress, amountDecimals,
  //      flag, feeAmount1, feeAmount2, gasPriceDecimals,
  //      nonce, deadline, permit
  //    } = this.quote as any;

  //    // ✓ champs obligatoires
  //    for (const [k, v] of Object.entries({
  //      inTokenAddress, outTokenAddress, amountDecimals,
  //      flag, gasPriceDecimals, nonce, deadline, permit
  //    })) {
  //      if (!v && v !== '0') {
  //        console.error(`❌ Champ manquant dans quote → ${k}`);
  //        return;
  //      }
  //    }

  //    // 1. Body backend
  //    const swapBody = {
  //      from: this.takerAddress, inTokenAddress, outTokenAddress,
  //      amountDecimals, flag,
  //      feeAmount1: feeAmount1 ?? '0',
  //      feeAmount2: feeAmount2 ?? '0',
  //      gasPriceDecimals, nonce, deadline, permit
  //    };

  //    console.log('🧾 [ULTRA] swapBody to OpenOcean =\n' + JSON.stringify(swapBody, null, 2));
  //    // 2. Appel backend
  //    let swapResp;
  //    try {
  //      swapResp = await firstValueFrom(this.swapApi.getGaslessSwap(swapBody));
  //    } catch (err) {
  //      console.error('❌ /swap 500 (ULTRA)', err);
  //      return;
  //    }
  //    if (!swapResp?.to || !swapResp?.data) {
  //      console.error('❌ Réponse ULTRA incomplète', swapResp);
  //      return;
  //    }

  //    // 3. Envoi TX
  //    try {
  //      this.swapStatus = 'pending';

  //      const signer = await this.provider.getSigner();
  //      const tx = await signer.sendTransaction({
  //        to: swapResp.to,
  //        data: swapResp.data,
  //        value: BigInt(swapResp.value ?? '0'),
  //        gasLimit: BigInt(300_000)          // ← évite estimateGas
  //      });

  //      console.log('🚀 TX ULTRA :', tx.hash);
  //      await tx.wait();

  //      this.swapStatus = 'success';
  //      this.swapHash = tx.hash;
  //      this.swapError = null;
  //    } catch (e: any) {
  //      console.error('❌ ULTRA fail :', e);
  //      this.swapStatus = 'error';
  //      this.swapHash = null;
  //      this.swapError = e?.message || 'Unknown error';
  //    }
  //    return;                                // ← FIN ULTRA
  //  }

  //  //------------------------------------------------------------------
  //  // CLASSIC  (approve éventuelle + swap)
  //  //------------------------------------------------------------------
  //  const signer = await this.provider.getSigner();
  //  const owner = await signer.getAddress();
  //  const isETH = this.quote.value.takerToken.toLowerCase() ===
  //    '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee';
  //  const target = this.quote.target;
  //  const valueToSend = isETH ? this.quote.value.takerTokenAmount : 0n;

  //  try {
  //    //--------------------------------------------------------
  //    // 1️⃣  Approve si nécessaire
  //    //--------------------------------------------------------
  //    if (!isETH) {
  //      const erc20 = new Contract(
  //        this.quote.value.takerToken,
  //        [
  //          'function allowance(address,address) view returns(uint256)',
  //          'function approve(address,uint256) returns(bool)'
  //        ],
  //        signer
  //      );

  //      const allowance: bigint = await erc20['allowance'](owner, target);
  //      const required: bigint = BigInt(this.quote.value.takerTokenAmount);

  //      if (allowance < required) {
  //        this.swapStatus = 'approve';
  //        const txA = await erc20['approve'](target, required);
  //        await txA.wait();
  //        console.log('✅ Approve confirmé');
  //      }
  //    }

  //    //--------------------------------------------------------
  //    // 2️⃣  Swap
  //    //--------------------------------------------------------
  //    this.swapStatus = 'pending';

  //    const tx = await signer.sendTransaction({
  //      to: target,
  //      data: this.quote.data,
  //      value: valueToSend,
  //      gasLimit: BigInt(350_000)            // ← fixe le gas, pas d’estimation
  //    });

  //    console.log('🚀 TX Classique :', tx.hash);
  //    await tx.wait();

  //    this.swapStatus = 'success';
  //    this.swapHash = tx.hash;
  //    this.swapError = null;

  //  } catch (e: any) {
  //    console.error('❌ Classic fail :', e);
  //    const msg = e?.message || '';
  //    const simErr = msg.includes('SafeERC20') || msg.includes('execution reverted');

  //    this.swapStatus = 'error';
  //    this.swapHash = null;
  //    this.swapError = simErr
  //      ? 'La transaction est partie, mais la simulation gas a échoué. Vérifie sur Etherscan.'
  //      : msg;
  //  }
  //}
  //buildSwapBodyForUltra(): any {
  //  if (!this.quote || !this.permit || !this.permitSig) {
  //    throw new Error('❌ Données manquantes pour construire le swapBody ULTRA.');
  //  }

  //  // 🔁 fallback deadline si jamais absent
  //  const defaultDeadline = Math.floor(Date.now() / 1000 + 1800); // +30 min

  //  const swapBody = {
  //    from: this.takerAddress,
  //    inTokenAddress: this.quote.inTokenAddress,
  //    outTokenAddress: this.quote.outTokenAddress,
  //    amountDecimals: this.quote.amountDecimals,
  //    flag: Number(this.quote!.flag ?? 0),
  //    feeAmount1: this.quote.feeAmount1 ?? '0',
  //    feeAmount2: this.quote.feeAmount2 ?? '0',
  //    gasPriceDecimals: this.quote.gasPriceDecimals,
  //    nonce: this.quote.nonce ?? 0,
  //    deadline: Number(this.quote!.deadline ?? 0),

  //    // ✅ Format attendu par OpenOcean
  //    permit: {
  //      details: {
  //        token: this.permit.details.token,
  //        amount: this.permit.details.amount,
  //        expiration: this.permit.details.expiration,
  //        nonce: this.permit.details.nonce
  //      },
  //      spender: this.permit.spender,
  //      sigDeadline: this.permit.sigDeadline,
  //      signature: this.permitSig
  //    }
  //  };

  //  console.log('📦 [buildSwapBodyForUltra] Ready to send:', JSON.stringify(swapBody, (_, v) =>
  //    typeof v === 'bigint' ? v.toString() : v, 2));

  //  return swapBody;
  //}

  buildSwapBodyForUltra(): any {
    return {
      from: this.takerAddress,
      to: this.quote!.target,
      data: this.quote!.data,
      amountDecimals: this.quote!.amountDecimals,
      feeAmount1: this.quote.feeAmount1 ?? '0',
      feeAmount2: this.quote.feeAmount2 ?? '0',
      flag: Number(this.quote!.flag ?? 0),
      gasPriceDecimals: this.quote.gasPriceDecimals,
      deadline: Number(this.quote!.deadline ?? 0),
      inToken: this.quote!.inTokenAddress,
      outToken: this.quote!.outTokenAddress,
      nonce: this.quote.nonce ?? 0,
      permit: this.quote.permit, // ✅ déjà encodé (0x...)
      usdvaluation: Number(this.quote!.usdValuation ?? 0.03)
    };
  }



  /** Récupère la TX (to/data/value/chainId) depuis la quote courante */
  /** Récupère la TX (to/data/value/chainId) depuis la quote ou une route alternative */
  private getTxFromQuote(
    quoteOrAlt: any
  ): { to: string; data: string; value?: string; chainId?: number } | null {
    try {
      // ── Contexte minimal pour diag (visu des clés dispo sur l’objet)
      const srcKeys = quoteOrAlt ? Object.keys(quoteOrAlt).join(',') : '(null)';
      this.addLog?.(`[tx:get] start | hasQuote=${!!quoteOrAlt} | srcKeys=[${srcKeys}]`);

      if (!quoteOrAlt) {
        this.addLog?.('[tx:get] abort: no quoteOrAlt');
        return null;
      }

      // 1) Normalisation des différentes formes (ordre existant, sans régression)
      //    - Merkle/Merkl : transactionRequest
      //    - LiFi : transaction
      //    - Fallbacks : tx, stepTransaction, ou {to,data,value} à plat
      const raw =
        quoteOrAlt?.transactionRequest ??
        quoteOrAlt?.transaction ??
        quoteOrAlt?.tx ??
        quoteOrAlt?.stepTransaction ??
        ((quoteOrAlt?.to && quoteOrAlt?.data)
          ? { to: quoteOrAlt.to, data: quoteOrAlt.data, value: quoteOrAlt?.value, chainId: quoteOrAlt?.chainId }
          : null);

      const picked =
        raw === quoteOrAlt?.transactionRequest ? 'transactionRequest' :
          raw === quoteOrAlt?.transaction ? 'transaction' :
            raw === quoteOrAlt?.tx ? 'tx' :
              raw === quoteOrAlt?.stepTransaction ? 'stepTransaction' :
                (raw ? 'flat' : 'none');

      this.addLog?.(`[tx:get] picked=${picked}`);

      if (!raw) {
        this.addLog?.('[tx:get] abort: no raw tx container');
        return null;
      }

      // 2) Extraction brute (sans mutation, on log juste)
      const to: any = (raw as any).to ?? null;
      const data: any = (raw as any).data ?? null;
      const valueAny: any = (raw as any).value ?? undefined;
      const chainId: number = Number((raw as any).chainId ?? this.chainId ?? 1);

      try {
        const dlen = String(data ?? '').length;
        const sel = typeof data === 'string' ? data.slice(0, 10) : '';
        this.addLog?.(
          `[tx:get] raw.to=${to} raw.data.len=${dlen} raw.val=${valueAny} chainId=${chainId}`
        );
        this.addLog?.(
          `[tx:get] ok | to=${to} selector=${sel} value=${valueAny ?? '0x0'} chainId=${chainId}`
        );
      } catch { /* best-effort logging */ }

      // 3) Retour inchangé (zéro normalisation pour éviter toute régression)
      return { to, data, value: valueAny, chainId };
    } catch (e: any) {
      this.addLog?.(`[tx:get] error: ${e?.message || e}`);
      return null;
    }
  }




  /** URL RPC par défaut (fallback si aucun provider connecté) */
  private getRpcUrlForChain(chainId: number): string {
    switch (Number(chainId)) {
      case 1: return 'https://eth-mainnet.g.alchemy.com/v2/YOUR_KEY';
      case 42161: return 'https://arb-mainnet.g.alchemy.com/v2/YOUR_KEY';
      case 137: return 'https://polygon-mainnet.g.alchemy.com/v2/YOUR_KEY';
      case 56: return 'https://bsc-dataseed.binance.org'; // public OK
      default: return 'https://eth-mainnet.g.alchemy.com/v2/YOUR_KEY';
    }
  }

  // ✔️ Nouveau simulateur: estimateGas => fallback call
  //private async simulateTxPreflight(tx: { to: string; data: string; value?: string; chainId?: number })
  //: Promise<{ ok: boolean; error?: string; raw?: any }> {
  //  const chainId = Number(tx.chainId ?? this.chainId ?? 1);
  //  const provider = this.provider ?? new ethers.JsonRpcProvider(this.getRpcUrlForChain(chainId), chainId);
  //  const from = this.takerAddress;

  //  try {
  //    const gas = await provider.estimateGas({
  //      from,
  //      to: tx.to,
  //      data: tx.data,
  //      value: tx.value ?? '0x0'
  //    });
  //    return { ok: true, raw: gas.toString() };
  //  } catch (egErr: any) {
  //    try {
  //      const res = await provider.call({
  //        from,
  //        to: tx.to,
  //        data: tx.data,
  //        value: tx.value ?? '0x0'
  //      });
  //      return { ok: true, raw: res }; // même "0x" = OK (pas une erreur)
  //    } catch (callErr: any) {
  //      console.error('🔍 simulateTxPreflight error:', callErr);
  //      const msg = this.extractRevertReason(callErr);
  //      return { ok: false, error: msg, raw: callErr };
  //    }
  //  }
  //}
  // state pour la comparaison
  private simulatedFeeWei: bigint = 0n;
  private simulatedMaxFeePerGasWei: bigint = 0n;

  get lifiFeeFiat(): string | null {
    if (!this.fullGasWei || !this.nativeTokenUsd) return null;
    const eth = Number(this.fullGasWei) / 1e18;
    const fiat = eth * this.nativeTokenUsd;
    return fiat.toLocaleString(this.defaultFiat === 'EUR' ? 'fr-FR' : 'en-US', {
      style: 'currency', currency: this.defaultFiat, minimumFractionDigits: 2, maximumFractionDigits: 2
    });
  }
  get simulatedFeeFiat(): string | null {
    if (!this.simulatedFeeWei || !this.nativeTokenUsd) return null;
    const eth = Number(this.simulatedFeeWei) / 1e18;
    const fiat = eth * this.nativeTokenUsd;
    return fiat.toLocaleString(this.defaultFiat === 'EUR' ? 'fr-FR' : 'en-US', {
      style: 'currency', currency: this.defaultFiat, minimumFractionDigits: 2, maximumFractionDigits: 2
    });
  }

  /** Récupère le estimatedGas de la quote (backend/alternatives), en bigint */
  private getBestEstimatedGasFromQuote(q: any): bigint {
    if (!q) return 0n;

    // priorité au champ normalisé du backend
    let raw =
      q?.estimatedGas ?? q?.EstimatedGas ??
      q?.transactionRequest?.gas ?? q?.transactionRequest?.gasLimit ??
      q?.TransactionRequest?.gas ?? q?.TransactionRequest?.gasLimit;

    // fallback: première route (LiFi/SingleRouteOption)
    if (!raw && Array.isArray(q?.singleRoutes) && q.singleRoutes.length > 0) {
      const r0 = q.singleRoutes[0];
      raw = r0?.estimatedGas ?? r0?.EstimatedGas ?? r0?.gasLimit ?? r0?.GasLimit;
    }

    if (!raw) return 0n;
    const s = String(raw);
    return s.startsWith('0x') ? BigInt(s) : BigInt(s);
  }

  /** Construit la tx exacte à estimer côté wallet (mêmes champs que la quote) */
  private buildTxForEstimation() {
    const q = this.quote ?? {};
    const tr = q?.transactionRequest ?? q?.TransactionRequest ?? {};

    // to / data / value depuis la quote
    const to = tr.to ?? q?.target ?? q?.Target ?? null;
    const data = tr.data ?? q?.data ?? q?.Data ?? null;

    // value peut être "0x...", decimal string, number, ou null
    let valueHex: string | undefined;
    const rawVal = tr.value ?? q?.value ?? q?.Value ?? null;
    if (rawVal != null) {
      const s = String(rawVal);
      valueHex = s.startsWith('0x') ? s : '0x' + BigInt(s).toString(16);
    }

    return { to, data, value: valueHex };
  }



  private parseHexOrDecToBigIntSafe(v: any): bigint {
    if (v == null) return 0n;
    const s = String(v);
    try { return s.startsWith('0x') ? BigInt(s) : BigInt(s); }
    catch { return 0n; }
  }

  private async updateGasCost(estimatedGasFromBackend?: bigint): Promise<void> {
    try {
      const estBackend =
        (estimatedGasFromBackend && estimatedGasFromBackend > 0n)
          ? estimatedGasFromBackend
          : this.parseHexOrDecToBigIntSafe(this.quote?.estimatedGas ?? this.quote?.EstimatedGas);

      // Pas de wallet → on garde backend
      if (!this.provider) {
        const priceWei = this.parseHexOrDecToBigIntSafe(this.quote?.gasPriceWei ?? this.quote?.GasPriceWei);
        this.gasPriceWei = priceWei || 0n;
        //this.fullGasWei = (priceWei && estBackend) ? priceWei * estBackend : 0n;
        this.cd?.detectChanges?.();
        return;
      }

      // Vérifie la chaîne du wallet
      const net = await this.provider.getNetwork().catch(() => null);
      const currentChain = Number(net?.chainId ?? 0);
      const expectedChain = Number(this.chainId ?? (this as any).chainIdFromSeo ?? 1);
      if (!currentChain || currentChain !== expectedChain) {
        console.warn('[updateGasCost] Wallet chain mismatch → fallback backend', { currentChain, expectedChain });
        const priceWei = this.parseHexOrDecToBigIntSafe(this.quote?.gasPriceWei ?? this.quote?.GasPriceWei);
        this.gasPriceWei = priceWei || 0n;
        //this.fullGasWei = (priceWei && estBackend) ? priceWei * estBackend : 0n;
        this.cd?.detectChanges?.();
        return;
      }

      // Construit la tx et estime le gas côté MetaMask
      const { to, data, value } = this.buildTxForEstimation();
      const signer = await this.provider.getSigner();
      const from = await signer.getAddress();

      let mmGasLimit: bigint;
      if (to && data) {
        try {
          const est = await this.provider.estimateGas({ from, to, data, value });
          mmGasLimit = BigInt(est.toString());
        } catch (e) {
          console.warn('[updateGasCost] estimateGas MM a échoué → fallback backend', e);
          mmGasLimit = estBackend > 0n ? estBackend : 21000n;
        }
      } else {
        console.warn('[updateGasCost] tx incomplète → fallback backend');
        mmGasLimit = estBackend > 0n ? estBackend : 21000n;
      }

      // Prix EIP-1559 “site suggéré ~12s”
      let priceWei: bigint;
      try {
        const { priceWei: p, baseFeeWei, priorityWei, factor } =
          await getSuggestedEip1559Price(this.provider, "slow");
        priceWei = p;
        console.log('[EIP-1559][suggested]', {
          baseFeeGwei: Number(baseFeeWei) / 1e9,
          tipGwei: Number(priorityWei) / 1e9,
          factor,
          priceGwei: Number(priceWei) / 1e9
        });
      } catch (e) {
        console.warn('[updateGasCost] EIP-1559 price fail → eth_gasPrice', e);
        try {
          const hex = await this.provider.send('eth_gasPrice', []);
          priceWei = BigInt(hex);
        } catch {
          priceWei = 2_000_000_000n; // 2 gwei plancher
        }
      }

      // Applique
      this.gasPriceWei = priceWei;
      /*this.fullGasWei = priceWei * mmGasLimit;*/

      // (facultatif) pousser ces valeurs dans la quote pour sync le preview
      this.quote = {
        ...(this.quote ?? {}),
        estimatedGas: mmGasLimit.toString(),
        EstimatedGas: mmGasLimit.toString(),
        gasPriceWei: priceWei.toString(),
        GasPriceWei: priceWei.toString(),
        totalNetworkFee: (priceWei * mmGasLimit).toString(),
        TotalNetworkFee: (priceWei * mmGasLimit).toString(),
      };

      console.log('[MetaMask fee calc]', {
        chainId: expectedChain,
        gasLimit: mmGasLimit.toString(),
        priceGwei: Number(priceWei) / 1e9,
        feeEth: Number(this.fullGasWei) / 1e18
      });

      this.cd?.detectChanges?.();
    } catch (e) {
      console.warn('[updateGasCost] fallback zeros', e);
      this.gasPriceWei = 0n;
      this.fullGasWei = 0n;
      this.cd?.detectChanges?.();
    }
  }




  private async flushBackendLogs(
    outcome: 'success' | 'error' | 'cancelled',
    reason?: string,
    details?: string
  ): Promise<void> {
    try {
      const runId = String(this._runSeq || Date.now());
      const sessionId = (localStorage.getItem('wc_session_id') || this.takerAddress || 'na') + '';
      const traceId = crypto?.randomUUID?.() || Math.random().toString(36).slice(2);

      // Payload compact
      const body = {
        sessionId,
        traceId,
        outcome,
        reason: reason || null,
        details: details || null,
        lines: this.debugLogs.slice(-180) // garde les 180 dernières lignes max
      };

      await fetch(`${environment.backendUrl}/admin/runs/${encodeURIComponent(runId)}/ingest`, {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
          'x-run-id': runId,
          'x-session-id': sessionId
        },
        body: JSON.stringify(body),
        // Hint réseau faible: laisse le navigateur gérer la compression (HTTP/2 + gzip/brotli)
      }).catch(() => { /* silencieux */ });
    } catch {
      // ne jamais bloquer l'UX si l’ingestion échoue
    } finally {
      // Nettoyage local si tu veux
      // this.debugLogs = [];
    }
  }















  /**
   * Préflight avant envoi (SWAP) :
   *  1) 💸 Vérifie que le solde natif couvre (fees + value) avec estimation robuste.
   *  2) 🧪 Lance une simulation EVM (estimateGas → fallback call).
   *
   * - Si alt fournie → on marque l’alt comme échouée (désactivation ciblée)
   * - Sinon → on désactive le bouton principal
   * Retourne true si OK, false sinon (et met à jour l’UI + message clair).
   */
  private async simulateTxPreflight(alt?: any): Promise<boolean> {
    const quoteOrAlt = alt ?? this.quote;
    const tx = this.getTxFromQuote(quoteOrAlt);

    if (!this.provider || !tx) {
      console.warn('[Swap] simulateTxPreflight: provider/tx manquants');
      this.flushBackendLogs('error', 'CLIENT_STATE_INVALID', 'provider/tx missing').catch(() => { });
      return false;
    }

    // 🔧 En bypass, on NE SKIPPE PLUS : on exécute le préflight mais on log
    if ((this as any).debugBypassGasCheck) {
      this.addLog?.('🔧 debugBypassGasCheck → preflight forcé (no skip)');
    }

    // 🔎 Args visibles pour corrélation
    try {
      const sel = typeof tx.data === 'string' ? tx.data.slice(0, 10) : '';
      this.addLog?.(`[SIM] preflight args | to=${tx.to} selector=${sel} value=${tx.value ?? '0x0'}`);
    } catch { /* no-op */ }

    try {
      const provider = this.provider;
      const signer = await provider.getSigner();
      const userAddress = await signer.getAddress();

      /* ────────────────────────────────────────────────
       * 1) 💸 Vérif du solde natif (fees + value)
       * ──────────────────────────────────────────────── */
      const userBalance = await provider.getBalance(userAddress);

      // 1.a GasLimit : estimateGas → fallback quote → 21000
      let gasLimit: bigint;
      try {
        const est = await provider.estimateGas({
          from: userAddress,
          to: tx.to!,
          data: tx.data!,
          value: tx.value ?? '0x0',
        });
        gasLimit = BigInt(est.toString());
        this.addLog?.(`[SIM][estimateGas] ok gas=${gasLimit.toString()}`);
      } catch (egErr: any) {
        // 🔴 Trace fine sur l’échec d’estimation
        const label = this.getSimFailLabel(egErr);
        this.addLog?.(`⛔ [SIM][estimateGas] ${label}`);
        const code = egErr?.code ?? egErr?.error?.code;
        const reason = egErr?.reason || egErr?.error?.message || egErr?.message || '(n/a)';
        const dataHd = (egErr?.data || egErr?.error?.data || '').toString().slice(0, 10);
        this.addLog?.(`⛔ [SIM][estimateGas] code=${String(code)} reason=${reason} dataHead=${dataHd}`);
        // ➕ mémorise la raison pour le fallback POST-sim
        (this as any).lastPreflightError = reason || dataHd || code || 'estimateGas_error';

        const qGas = quoteOrAlt?.transactionRequest?.gasLimit ?? quoteOrAlt?.TransactionRequest?.gasLimit;
        const gl = qGas != null ? BigInt(String(qGas)) : 21000n;
        gasLimit = gl > 0n ? gl : 21000n;
      }

      // 1.b Prix du gas : JAMAIS de getFeeData() (évite eth_maxPriorityFeePerGas)
      const tr = quoteOrAlt?.transactionRequest ?? quoteOrAlt?.TransactionRequest ?? {};
      let maxFeePerGas: bigint | null = tr.maxFeePerGas ? BigInt(String(tr.maxFeePerGas)) : null;
      let gasPriceLegacy: bigint | null = tr.gasPrice ? BigInt(String(tr.gasPrice)) : null;

      // Legacy universel
      if (!gasPriceLegacy) {
        try {
          const gp = await (provider as any).send?.('eth_gasPrice', []);
          if (gp) gasPriceLegacy = BigInt(gp);
        } catch { /* ignore */ }
      }

      // Cap EIP-1559 si baseFee dispo (sans appeler maxPriority)
      if (!maxFeePerGas) {
        try {
          const latest = await (provider as any).send?.('eth_getBlockByNumber', ['latest', false]);
          if (latest?.baseFeePerGas) {
            const base = BigInt(latest.baseFeePerGas);
            const tip = 1_500_000_000n; // ~1.5 gwei
            maxFeePerGas = base * 2n + tip;
          }
        } catch { /* ignore */ }
      }

      // 1.c Fee estimée (pessimiste mais raisonnable)
      let feeWei: bigint;
      if (maxFeePerGas) feeWei = gasLimit * maxFeePerGas;
      else if (gasPriceLegacy) feeWei = gasLimit * gasPriceLegacy;
      else feeWei = gasLimit * 1_500_000_000n; // 1.5 gwei fallback

      this.simulatedFeeWei = feeWei;
      this.simulatedMaxFeePerGasWei = (maxFeePerGas ?? gasPriceLegacy ?? 0n);

      // Log résumé gas/fees (best-effort)
      try {
        const gasP = (maxFeePerGas ?? gasPriceLegacy ?? 0n).toString();
        this.addLog?.(
          `[SIM][gas] gasLimit=${gasLimit.toString()} ` +
          `priceWei=${gasP} feeWei=${this.simulatedFeeWei.toString()}`
        );
      } catch { /* no-op */ }

      // 1.d Value (souvent 0) — conversion hex-safe
      const valueWei = (() => {
        if (!tx.value) return 0n;
        const v: string = String(tx.value);
        return (v.startsWith('0x') || v.startsWith('0X')) ? BigInt(v) : BigInt(v);
      })();

      const requiredWei = feeWei + valueWei;

      // Log balances vs requirement
      try {
        this.addLog?.(
          `[SIM] balances | nativeWei=${userBalance.toString()} ` +
          `requiredWei=${requiredWei.toString()} (feeWei=${feeWei.toString()} valueWei=${valueWei.toString()})`
        );
      } catch { /* no-op */ }

      if (userBalance < requiredWei) {
        // Message UX (identique à ta version)
        const nat = this.getNativeTokenSymbol(this.chainId ?? this.selectedNetwork ?? 1) || 'ETH';
        const deficit = requiredWei - userBalance;
        const deficitEth = Number(deficit) / 1e18;
        const fiat = this.nativeTokenUsd ? (deficitEth * this.nativeTokenUsd) : null;

        const fiatStr = fiat
          ? fiat.toLocaleString(
            this.defaultFiat === 'EUR' ? 'fr-FR' : 'en-US',
            { style: 'currency', currency: this.defaultFiat, minimumFractionDigits: 2, maximumFractionDigits: 2 }
          )
          : null;

        const friendly =
          this.translate?.instant?.('SWAP_GAS_DEFICIT_MSG', {
            amountEth: deficitEth.toFixed(6).replace(/\.?0+$/, ''),
            symbol: nat,
            amountFiat: fiatStr ?? ''
          }) ||
          `Le swap n’est pas possible pour l’instant : votre solde ${nat} est insuffisant pour les frais réseau. ` +
          `Ajoutez ~${deficitEth.toFixed(6)} ${nat}` + (fiatStr ? ` (${fiatStr})` : '') + `, puis réessayez.`;

        const lifiEth = this.fullGasWei ? (Number(this.fullGasWei) / 1e18).toFixed(6) : null;
        const simEth = this.simulatedFeeWei ? (Number(this.simulatedFeeWei) / 1e18).toFixed(6) : null;

        if (lifiEth && simEth) {
          const lifiFiat = this.lifiFeeFiat;
          const simFiat = this.simulatedFeeFiat;
          this.swapError =
            `[ux] ${friendly}\n\n` +
            `Comparatif frais réseau:\n` +
            `- LiFi: ${lifiEth} ${nat}` + (lifiFiat ? ` (${lifiFiat})` : '') + `\n` +
            `- Simulation: ${simEth} ${nat}` + (simFiat ? ` (${simFiat})` : '');
        } else {
          this.swapError = `[ux] ${friendly}`;
        }

        const isBypass = !!(this as any).debugBypassGasCheck;

        if (!isBypass) {
          // ---- Comportement BLOQUANT inchangé (bypass OFF) ----
          this.swapStatus = 'error';

          // Marquage “route échouée” (alt vs main)
          const mainKey = this.getProviderKey(this.quote);
          if (alt) {
            const altKey = this.getProviderKey(alt);
            if (altKey) this.failedAltKeys.add(altKey);
            this.lastSimFailedKey = altKey || 'alt';
          } else {
            this.lastSimFailedKey = mainKey || 'main';
            this.swapDisabled = true;
            const label = this.translate?.instant?.('NEED_NATIVE_FOR_GAS') || `Ajoutez du ${nat} pour payer les frais réseau.`;
            if (Array.isArray(this.swapReasons) && !this.swapReasons.includes(label)) {
              this.swapReasons.push(label);
            }
          }

          this.cd?.detectChanges?.();
          this.flushBackendLogs('error', 'INSUFFICIENT_NATIVE_GAS', friendly).catch(() => { });
          return false; // bloquant si bypass OFF
        }

        // ---- Mode BYPASS : warning non-bloquant ----
        this.addLog?.('⚠️ [SWAP] Gas natif insuffisant mais bypass actif → non bloquant');
        this.cd?.detectChanges?.();
        return true;
      }

      /* ────────────────────────────────────────────────
       * 2) 🧪 Simulation logique EVM (estimateGas → call)
       * ──────────────────────────────────────────────── */
      try {
        await provider.estimateGas({ from: userAddress, to: tx.to!, data: tx.data!, value: tx.value ?? '0x0' });
      } catch (egErr2: any) {
        // On log l’erreur d’estimation puis on tente eth_call
        try {
          const callRes = await provider.call({ from: userAddress, to: tx.to!, data: tx.data!, value: tx.value ?? '0x0' });
          const head = String(callRes ?? '').slice(0, 10);
          this.addLog?.(`[SIM][eth_call] ok head=${head}`);
        } catch (callErr: any) {
          const label = this.getSimFailLabel(callErr);
          this.addLog?.(`⛔ [SIM][eth_call] ${label}`);
          // 🔴 Trace fine revert call
          const code = callErr?.code ?? callErr?.error?.code;
          const reason = callErr?.reason || callErr?.error?.message || callErr?.message || '(n/a)';
          const dataHd = (callErr?.data || callErr?.error?.data || '').toString().slice(0, 10);
          this.addLog?.(`⛔ [SIM][eth_call] code=${String(code)} reason=${reason} dataHead=${dataHd}`);
          // ➕ mémorise la raison pour le fallback POST-sim
          (this as any).lastPreflightError = reason || dataHd || code || 'eth_call_error';

          const msg = this.extractRevertReason(callErr);
          this.swapStatus = 'error';
          this.swapError = msg || (this.translate?.instant?.('SIMULATION_FAILED') || 'La simulation a échoué pour cette route.');

          if (alt) {
            const altKey = this.getProviderKey(alt);
            if (altKey) this.failedAltKeys.add(altKey);
            this.lastSimFailedKey = altKey || 'alt';
          } else {
            const mainKey = this.getProviderKey(this.quote);
            this.lastSimFailedKey = mainKey || 'main';
            this.swapDisabled = true;
            const label = this.translate?.instant?.('ALT_DISABLED_AFTER_SIM') || 'La simulation a échoué pour cette route.';
            if (Array.isArray(this.swapReasons) && !this.swapReasons.includes(label)) {
              this.swapReasons.push(label);
            }
          }

          this.cd?.detectChanges?.();

          this.flushBackendLogs('error', 'EXECUTION_REVERTED', reason).catch(() => { });
          return false;
        }
      }

      // ✅ Tout est OK
      return true;
    } catch (e: any) {
      this.swapStatus = 'error';
      const extracted = this.extractRevertReason(e as any);
      this.swapError = extracted;
      // ➕ mémorise aussi ici (catch global) — accès safe au message
      const safeMsg =
        (e && typeof e === 'object' && 'message' in e)
          ? (e as any).message
          : String(e ?? '');
      (this as any).lastPreflightError = extracted || safeMsg || 'preflight_catch';

      if (alt) {
        const altKey = this.getProviderKey(alt);
        if (altKey) this.failedAltKeys.add(altKey);
        this.lastSimFailedKey = altKey || 'alt';
      } else {
        const mainKey = this.getProviderKey(this.quote);
        this.lastSimFailedKey = mainKey || 'main';
        this.swapDisabled = true;
        const label = this.translate?.instant?.('ALT_DISABLED_AFTER_SIM') || 'La simulation a échoué pour cette route.';
        if (Array.isArray(this.swapReasons) && !this.swapReasons.includes(label)) {
          this.swapReasons.push(label);
        }
      }

      this.cd?.detectChanges?.();
      const reason = this.extractRevertReason(e) || (this as any).lastPreflightError || 'preflight_catch';
      this.flushBackendLogs('error', 'INTERNAL_ERROR', reason).catch(() => { });
      return false;
    }
  }






  private extractRevertReason(err: any): string {
    try {
      const data: string = err?.error?.data ?? err?.data ?? err?.info?.error?.data ?? null;
      if (data && typeof data === 'string' && data.startsWith('0x08c379a0')) {
        // Error(string)
        const reason = ethers.toUtf8String('0x' + data.slice(10 + 64));
        return `execution reverted: ${reason}`;
      }
      if (err?.error?.message) return err.error.message;
      if (err?.message) return err.message;
    } catch { }
    return 'execution reverted (unknown reason)';
  }


  private async forceReconnectWalletSession(reason: string) {
    //if (Date.now() < this._reconnectLockUntil) return;
    //this._reconnectLockUntil = Date.now() + 20_000;
    //this.addLog(`🔁 WC force reconnect → HARD RELOAD | reason=${reason}`);

    //try {
    //  // (1) couper la session
    //  try { await this.disconnectWalletReload?.(); } catch { }

    //  // (1bis) PURGE EXPLICITE des pairings WalletConnect v2 (si dispo)
    //  try {
    //    const sc = (window as any).__wcSignClient || (this as any).wcSignClient || (this as any).appKit?.getSignClient?.();
    //    const core = sc?.core;
    //    const pairing = core?.pairing;
    //    const list = pairing?.getPairings?.() || [];
    //    for (const p of list) { try { await pairing.delete({ topic: p.topic }); } catch { } }
    //  } catch (e: any) {
    //    this.addLog('[reconnect] pairings purge skipped: ' + (e?.message || e));
    //  }
    //  //this.closeQuoteWithReason('forceReconnectWalletSession');
    //  // (2) UI propre
    // /* try { this.closeQuote?.(); } catch { }*/

    //  // (3) geler deeplink + auto-restore et poser un **one-shot anti reattach**
    //  try {
    //    const until = Date.now() + 8000;
    //    sessionStorage.setItem('st/suppressWcUriUntil', String(until));
    //    localStorage.setItem('st/suppressAutoRestoreUntil', String(until));
    //    sessionStorage.setItem('skipWcDeeplinkOnce', '1');
    //    localStorage.setItem('st/skipAutoRestoreOnce', '1');
    //    // ➕ nouveau flag pour empêcher le silent reattach une fois
    //    sessionStorage.setItem('st/skipSilentReattachOnce', '1');

    //    // (optionnel, très ciblé) nettoyer les hints d’auto-connect de web3modal/appkit
    //    Object.keys(localStorage).forEach(k => {
    //      if (k.startsWith('W3M') || k.startsWith('w3m') || k.startsWith('wc@2:')) {
    //        try { localStorage.removeItem(k); } catch { }
    //      }
    //    });
    //  } catch { }

    //  // (4) hard reload
    //  this.hardReloadBridge();
    //} catch (err: any) {
    //  this.addLog('⚠️ reconnect failed: ' + (err?.message || err));
    //  this.hardReloadBridge();
    //}
  }






  private hardReloadBridge(): void {
    //try {
    //  // si tu utilises le Router:
    //  // this.router.navigateByUrl('/bridge', { replaceUrl: true });
    //  // sinon rechargement plein
    //  window.location.reload();
    //} catch {
    //  window.location.href = window.location.href;
    //}
  }













  // ✅ Pas de dépendances exotiques : utilise seulement window/location + ton wallet service
  private async hardReloadAfterCancel(reason: string) {
    const t0 = Date.now();
    try {
      this.addLog(`🧨 [hard-reload] start | reason=${reason}`);

      // (A) Déconnexion propre du wallet (si dispo chez toi)
      try { await this.wallet.disconnect(); }
      catch (e) { this.addLog(`⚠️ [hard-reload] wallet.disconnect error: ${String(e)}`); }

      // (B) Purge locale minimale (optionnelle mais safe)
      try {
        // évite que l’UI revive en "approve" après reload
        this.swapStatus = 'idle';
        this.swapError = null;
        this.swapHash = null;
        this.quote = null;
        // si tu stockes un URI WC / modale dans l’état
        this.showWcModal = false as any;
        this.wcUri = '' as any;
      } catch (e) { this.addLog(`⚠️ [hard-reload] purge state error: ${String(e)}`); }

      // (C) Petite pause pour laisser WC fermer la session côté app
      await new Promise(r => setTimeout(r, 250));

      // (D) Reload “fort” avec cache-busting & conservation de debug
      const u = new URL(window.location.href);
      u.searchParams.set('reloadTs', String(Date.now()));
      u.searchParams.set('reloadReason', reason);
      // conserve ?debug=1 si présent
      if (/\bdebug=1\b/.test(window.location.search)) u.searchParams.set('debug', '1');

      this.addLog(`🔁 [hard-reload] redirect → ${u.pathname}${u.search}`);
      window.location.replace(u.toString()); // fin du monde actuel 🌋
    } catch (e) {
      this.addLog(`❌ [hard-reload] failed: ${String(e)} | fallback window.location.reload()`);
      try { window.location.reload(); } catch { }
    } finally {
      this.addLog(`⏱️ [hard-reload] elapsed=${Date.now() - t0}ms`);
    }
  }

  private showPreflightError(msgKey: string, fallback: string) {
    this.swapStatus = 'error';
    this.swapError = this.translate.instant(msgKey) || fallback;
    this.addLog(`⛔ [SIM] Probable échec: ${this.swapError}`);
  }


  /** Faut-il réveiller le wallet pour la TX principale (WC mobile) ? */
  private shouldWakeForWcTx(): boolean {
    // aujourd’hui, on conditionne au flag global
    return !!(this as any).wakeEnabled;
  }

  /** Petit helper async pour temporiser */
  private delay(ms: number): Promise<void> {
    return new Promise(res => setTimeout(res, ms));
  }

  /** Réveil conditionnel du wallet (no-op si pas nécessaire) */
  // avant
  // private async wakeWalletIfNeeded(_reason?: string): Promise<void> {

  // après
  // ─────────────────────────────────────────────────────────────
  // Réveil MetaMask / WC sur mobile
  //  - 1 seul deeplink par run (via __dlOpenedForRun)
  //  - jamais de réveil auto au boot (appelée seulement depuis les CTA)
  //  - plus de blocage agressif sur isWcSilentAttached()
  // ─────────────────────────────────────────────────────────────
  private async wakeWalletIfNeeded(ctx?: string, runId?: number): Promise<void> {
    try {
      this.addLog?.(
        `[deeplink][wake] ENTER ctx=${ctx ?? 'n/a'} runId=${String(runId ?? '-')}`
      );

      // 0) feature flag global
      if (!this.shouldWakeForWcTx?.()) {
        this.addLog?.('[deeplink][wake] skip: wake disabled by shouldWakeForWcTx()');
        return;
      }

      // 1) provider requis
      if (!this.provider) {
        this.addLog?.('[deeplink][wake] skip: missing provider');
        return;
      }

      // 2) seulement en mobile
      const isMobile = this.isMobileDevice?.() ?? false;
      if (!isMobile) {
        this.addLog?.('[deeplink][wake] skip: not mobile');
        return;
      }

      // 3) runId obligatoire
      if (typeof runId !== 'number') {
        this.addLog?.('[deeplink][wake] skip: missing runId');
        return;
      }

      // 4) phase logique (1 wake par phase)
      const phase: 'apprv' | 'trx' =
        ctx && ctx.startsWith('apprv') ? 'apprv' : 'trx';

      // --- anti-fenêtres fantômes : 1 wake max PAR PHASE et PAR RUN ---
      // store structure: { lastRunId: number, opened: { apprv?: boolean, trx?: boolean } }
      const selfAny = this as any;

      if (selfAny.__dlWakeState?.lastRunId !== runId) {
        selfAny.__dlWakeState = { lastRunId: runId, opened: { apprv: false, trx: false } };
        this.addLog?.(`[deeplink][wake] state reset for new runId=${runId}`);
      }

      const openedForPhase = !!selfAny.__dlWakeState?.opened?.[phase];
      if (openedForPhase) {
        this.addLog?.(
          `[deeplink][wake] skip: already foregrounded for runId=${runId} phase=${phase}`
        );
        return;
      }

      // 5) log état silent (info)
      const silentFlag = selfAny.isWcSilentAttached?.();
      if (typeof silentFlag !== 'undefined') {
        this.addLog?.(`[deeplink][wake] info: isWcSilentAttached=${String(silentFlag)}`);
      }

      // 6) réveil "doux" best-effort (sans deeplink)
      try {
        const signer = await this.provider.getSigner();
        await selfAny?.txFlow?.wakeWalletSilentlyIfNeeded?.(signer);
      } catch (err: any) {
        this.addLog?.(
          `[deeplink][wake] silent-wake error: ${err?.message ?? String(err)}`
        );
        // best-effort: on continue
      }

      this.addLog?.(
        `[deeplink][wake] OK → foregroundMetaMaskGeneric phase=${phase} runId=${runId}`
      );

      try {
        // ouverture réelle
        selfAny.foregroundMetaMaskGeneric?.(runId, phase);

        // marque "servi" pour CETTE phase uniquement
        if (!selfAny.__dlWakeState) {
          selfAny.__dlWakeState = { lastRunId: runId, opened: { apprv: false, trx: false } };
        }
        selfAny.__dlWakeState.opened[phase] = true;

        this.addLog?.(
          `[deeplink][wake] MARK opened runId=${runId} phase=${phase} | opened=${JSON.stringify(
            selfAny.__dlWakeState.opened
          )}`
        );
      } catch (err: any) {
        this.addLog?.(
          `[deeplink][wake] ERR foregroundMetaMaskGeneric ctx=${ctx ?? 'n/a'} runId=${String(
            runId
          )} phase=${phase} e=${err?.message ?? String(err)}`
        );
      }
    } catch (err: any) {
      this.addLog?.(
        `[deeplink][wake] ERR wrapper ctx=${ctx ?? 'n/a'} runId=${String(
          runId ?? '-'
        )} e=${err?.message ?? String(err)}`
      );
    }
  }






  // --- BRIDGE COMPAT SHIMS -------------------------------------------------

  /** Switch réseau via EIP-1193 (shim Bridge) */
  private async switchToChain(targetChainId: number): Promise<void> {
    try {
      const hex = '0x' + Number(targetChainId).toString(16);
      const eth: any = (window as any).ethereum || (this as any).rawProvider;
      if (eth?.request) {
        this.addLog(`[wallet] wallet_switchEthereumChain → ${hex}`);
        await eth.request({ method: 'wallet_switchEthereumChain', params: [{ chainId: hex }] });
      }
    } catch (e: any) {
      this.addLog(`[wallet] switchToChain failed: ${e?.message || e}`);
      // on ne jette pas : certains wallets sont déjà sur le bon réseau
    }
    // aligne l’UI locale (même si le wallet était déjà good)
    try { this.setChain(Number(targetChainId)); } catch { }
  }

  /** “txFlow” simplifié : proxy vers l’envoi + watcher existants */
  private txFlow = {
    wakeWalletSilentlyIfNeeded: async (_signer: any) => {
      // noop volontaire: Bridge réveille parfois l’app mobile, ici on s’appuie déjà sur le deeplink
    },
    sendViaSignerWithWatchdog: async (signer: any, tx: any) => {
      const sent = await signer.sendTransaction(tx);
      this.addLog(`[EXEC] sent | hash=${sent.hash}`);
      // Dès que l’envoi est confirmé par le wallet, on supprime la fenêtre d’auto-deeplink
      try {
        sessionStorage.removeItem('st/allowWcDeeplinkUntil');
        sessionStorage.removeItem('st/allowWcRunId');
        this.addLog('[deeplink] allow cleared (post-send)');
      } catch { /* noop */ }
      const net = await this.provider!.getNetwork();
      await this.watchSwapReceiptUntilFinal(sent.hash, Number(net.chainId));
    },
    markUserCancelled: () => {
      this.swapStatus = 'cancelled';
      this.swapError = null;
    }
  };

  // 👇 près des autres const utilitaires
  private static readonly TOPIC_TRANSFER =
    '0xddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef';

  // ⬇️ remplace intégralement la version shim
  async startHashlessWatchExecution(opts: {
    owner: string; chainId: number;
    routerTo?: string | null;
    tokenIn?: string | null; expectedInWei?: bigint | null;
    tokenOut?: string | null; expectedOutWei?: bigint | null;
  }): Promise<void> {
    const p = this.provider;
    if (!p) return;

    const watchRunId = this._runSeq;

    const owner = (opts.owner || '').toLowerCase();
    const router = (opts.routerTo || '').toLowerCase();
    const tIn = (opts.tokenIn || '').toLowerCase();
    const tOut = (opts.tokenOut || '').toLowerCase();
    const chainId = opts.chainId;

    this.addLog(`[SWAP][HASHLESS] start | runId=${watchRunId} owner=${owner} chain=${chainId} router=${router} tIn=${tIn} tOut=${tOut}`);

    const pad = (a: string) => '0x' + a.replace(/^0x/, '').padStart(64, '0');

    const filters: any[] = [];
    if (tIn && router) filters.push({ address: tIn, topics: [SwapComponent.TOPIC_TRANSFER, pad(owner), pad(router)] });
    if (tOut && router) filters.push({ address: tOut, topics: [SwapComponent.TOPIC_TRANSFER, null, pad(owner)] });

    if (!filters.length) {
      this.addLog('[SWAP][HASHLESS] skip: no filters (missing token/router)');
      return;
    }

    let resolved = false;

    const teardown = () => {
      try { for (const f of filters) p.off(f, onLog); } catch { }
    };

    const onLog = async (log: any) => {
      if (resolved) return;

      // anti cross-run
      if (watchRunId !== this._runSeq) {
        this.addLog(`[SWAP][HASHLESS] abort stale runId: started=${watchRunId} current=${this._runSeq}`);
        resolved = true;
        teardown();
        return;
      }

      try {
        const txHash = String(log?.transactionHash || '');
        if (!txHash) return;

        resolved = true;
        this.swapHash = txHash;

        // IMPORTANT: annule le timeout local "trx" dès qu’on a un hash.
        try { this.cfOnHash?.('trx'); } catch { }

        this.addLog(`[SWAP][HASHLESS] log hit → tx=${txHash} | runId=${watchRunId}`);

        // Dès que le hash est connu, on enlève la fenêtre d’auto-deeplink
        try {
          sessionStorage.removeItem('st/allowWcDeeplinkUntil');
          sessionStorage.removeItem('st/allowWcRunId');
          this.addLog('[deeplink] allow cleared (post-hash detection)');
        } catch { /* noop */ }

        // IMPORTANT: détecteur ONLY → pas de watcher receipt ici
        this.addLog(`[SWAP][HASHLESS] hash detected → receipt watcher delegated to main flow | tx=${txHash}`);

        // On démonte direct pour éviter multiple hits
        teardown();
      } catch (e: any) {
        this.addLog(`[SWAP][HASHLESS][warn] ${e?.message || e}`);
        // si erreur, on garde l'écoute
      }
    };

    // remplace un ancien teardown si présent
    try { (this as any).__hashlessTeardown?.(); } catch { }
    (this as any).__hashlessTeardown = teardown;

    for (const f of filters) p.on(f, onLog);
  }

  private wakeEnabled = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  // ✅ KISS: modal WC unique (Approve + Swap TX)
  // On réutilise *strictement* le bloc existant swap.component.html (showWcModal + wcUri).
  // Objectif: pas de nouvelle UI, pas d'auto-deeplink, uniquement un clic user.
  public wcModalPhase: 'approve' | 'tx' | null = null;
  public wcModalCtx: string | null = null;
  public wcModalRunId: number | null = null;


  // Auto-close hooks (close WC modal as soon as user leaves the page to the wallet)
  private _wcAutoCloseInstalled = false;
  private _wcAutoCloseRunId: number | null = null;
  private _wcOnVisibility: any = null;
  private _wcOnBlur: any = null;
  private _wcOnPageHide: any = null;

  private _installWcModalAutoClose(runId: number) {
    try {
      // Always reset (avoid duplicate handlers)
      this._uninstallWcModalAutoClose('reinstall');

      this._wcAutoCloseInstalled = true;
      this._wcAutoCloseRunId = runId;

      this._wcOnVisibility = () => {
        try {
          const hidden = !!(document as any)?.hidden;
          // Only close for current run, and only if still visible
          if (hidden && this.showWcModal && this.wcModalRunId === runId) {
            this.addLog?.(`🧭 [WALLET][MODAL] autoclose | reason=visibility:hidden runId=${runId}`);
            this._hideWcModal('autoclose:visibility:hidden');
          }
        } catch (e: any) {
          this.addLog?.(`🧭 [WALLET][MODAL] autoclose visibility error: ${e?.message || e}`);
        }
      };

      this._wcOnBlur = () => {
        try {
          if (this.showWcModal && this.wcModalRunId === runId) {
            this.addLog?.(`🧭 [WALLET][MODAL] autoclose | reason=window:blur runId=${runId}`);
            this._hideWcModal('autoclose:window:blur');
          }
        } catch { }
      };

      this._wcOnPageHide = () => {
        try {
          if (this.showWcModal && this.wcModalRunId === runId) {
            this.addLog?.(`🧭 [WALLET][MODAL] autoclose | reason=pagehide runId=${runId}`);
            this._hideWcModal('autoclose:pagehide');
          }
        } catch { }
      };

      document?.addEventListener?.('visibilitychange', this._wcOnVisibility, { passive: true } as any);
      window?.addEventListener?.('blur', this._wcOnBlur, { passive: true } as any);
      window?.addEventListener?.('pagehide', this._wcOnPageHide, { passive: true } as any);

      this.addLog?.(`🧭 [WALLET][MODAL] autoclose hooks installed | runId=${runId}`);
    } catch (e: any) {
      this.addLog?.(`🧭 [WALLET][MODAL] autoclose install error: ${e?.message || e}`);
    }
  }

  private _uninstallWcModalAutoClose(reason: string) {
    try {
      if (!this._wcAutoCloseInstalled) return;

      document?.removeEventListener?.('visibilitychange', this._wcOnVisibility as any);
      window?.removeEventListener?.('blur', this._wcOnBlur as any);
      window?.removeEventListener?.('pagehide', this._wcOnPageHide as any);

      this._wcAutoCloseInstalled = false;
      this._wcAutoCloseRunId = null;
      this._wcOnVisibility = null;
      this._wcOnBlur = null;
      this._wcOnPageHide = null;

      this.addLog?.(`🧭 [WALLET][MODAL] autoclose hooks removed | reason=${reason}`);
    } catch { }
  }
  private _showWcModalForPhase(phase: 'approve' | 'tx', ctx: string, runId: number) {
    try {
      this.wcModalPhase = phase;
      this.wcModalCtx = ctx;
      this.wcModalRunId = runId;
      this.showWcModal = true;
      this.addLog?.(`🧭 [WALLET][MODAL] show phase=${phase} ctx=${ctx} runId=${runId}`);
      // 🔥 auto-close as soon as wallet takes focus (iOS / Android)
      this._installWcModalAutoClose(runId);
      this.cd?.detectChanges?.();
    } catch (e: any) {
      this.addLog?.(`🧭 [WALLET][MODAL] show error: ${e?.message || e}`);
    }
  }

  private _hideWcModal(reason: string) {
    try {
      if (this.showWcModal) {
        this.showWcModal = false;
        this.addLog?.(`🧭 [WALLET][MODAL] hide reason=${reason}`);
        // cleanup hooks whenever we hide
        this._uninstallWcModalAutoClose(`hide:${reason}`);
        this.cd?.detectChanges?.();
      }
    } catch { }
  }

  async executeSwap(intentToken?: string) {
    // ─────────────────────────────────────────────────────────────
    // RUN LOCK
    // ─────────────────────────────────────────────────────────────
    const runId = ++this._runSeq;
    this.addLog(`[RUN] executeSwap runId=${runId}`);

    // Reset cancel-flow state PER RUN
    try {
      const cf: any = (this as any).cancelFlowV1;
      if (cf?.timers) {
        for (const t of cf.timers.values()) { try { window.clearTimeout(t); } catch { } }
        cf.timers.clear();
      }
      if (cf?.hasHash) { cf.hasHash.apprv = false; cf.hasHash.trx = false; }
      cf.runId = runId;
    } catch { }

    // ─────────────────────────────────────────────────────────────
    // RADICAL: NO AUTO-DEEPLINK
    // ─────────────────────────────────────────────────────────────
    this.addLog('🔥 [START] executeSwap (NO-AUTO-DEEPLINK)');

    // ─────────────────────────────────────────────────────────────
    // Helpers (modal + parsing)
    // ─────────────────────────────────────────────────────────────

    // ✅ Modal unique Approve + TX
    const showWalletModal = (phase: 'approve' | 'tx', ctx: string) => {
      try {
        (this as any).walletModal = {
          visible: true,
          phase,
          title: phase === 'approve' ? 'Confirm in wallet' : 'Confirm swap in wallet',
          message: phase === 'approve'
            ? 'Open your wallet app and confirm the approval.'
            : 'Open your wallet app and confirm the swap transaction.',
          actionLabel: 'Open wallet',
          ctx,
          runId
        };
        this.addLog(`🧭 [WALLET][MODAL] show phase=${phase} ctx=${ctx} runId=${runId}`);
        this.cd?.detectChanges?.();
      } catch (e: any) {
        this.addLog(`🧭 [WALLET][MODAL] show error: ${e?.message || e}`);
      }
    };

    const hideWalletModal = (reason: string) => {
      try {
        const m: any = (this as any).walletModal;
        if (m?.visible) {
          m.visible = false;
          this.addLog(`🧭 [WALLET][MODAL] hide reason=${reason}`);
          this.cd?.detectChanges?.();
        }
      } catch { }
    };

    // 🔘 À brancher sur le bouton du modal : (click)="onWalletModalOpenWallet()"
    (this as any).onWalletModalOpenWallet = () => {
      try {
        const uri = (this as any).wcUri;
        // User-initiated only (deterministic) ✅
        if (uri) {
          this.addLog(`[WALLET][MODAL] open wallet via wcUri (user click)`);
          window.open(uri, '_blank');
        } else {
          this.addLog(`[WALLET][MODAL] no wcUri → user must open wallet manually`);
        }
      } catch (e: any) {
        this.addLog(`[WALLET][MODAL] open wallet error: ${e?.message || e}`);
      }
    };

    const toAddr = (x: any) => String(x ?? '').trim().toLowerCase();
    const isAddr = (a?: string) => {
      const s = toAddr(a);
      return !!(s && s.startsWith('0x') && s.length === 42 && s !== '0x0000000000000000000000000000000000000000');
    };

    const pickBigInt = (v: any): bigint | null => {
      try {
        if (v == null) return null;
        if (typeof v === 'bigint') return v;
        if (typeof v === 'object' && typeof v.toString === 'function') {
          const s = v.toString().trim();
          if (!s) return null;
          if (/^0x[0-9a-f]+$/i.test(s)) return BigInt(s);
          if (/^\d+$/.test(s)) return BigInt(s);
          return null;
        }
        const s = String(v).trim();
        if (!s) return null;
        if (/[.,]/.test(s) && !/^0x/i.test(s)) return null;
        if (/^0x[0-9a-f]+$/i.test(s)) return BigInt(s);
        if (/^\d+$/.test(s)) return BigInt(s);
        if (typeof v === 'number' && Number.isFinite(v)) return BigInt(Math.trunc(v));
        return null;
      } catch { return null; }
    };

    // Cache balance string->wei (optionnel, utile si tu veux checker "insufficient balance" sans read live)
    const cachedErc20BalanceWei = (token: string, chainIdNum: number): bigint => {
      try {
        if (!token || token.length !== 42) return 0n;
        const key = `${token.toLowerCase()}_${chainIdNum}`;
        const raw = (this.tokenCachedBalances as any)?.[key]; // "12.34"
        if (!raw) return 0n;

        const t = (this.userTokens || []).find(
          (x: any) => String(x?.address).toLowerCase() === token.toLowerCase() && Number(x?.chainId) === chainIdNum
        );
        const decimals = Number(t?.decimals ?? t?.tokenDecimals ?? 18);
        if (!Number.isFinite(decimals) || decimals < 0 || decimals > 36) return 0n;

        const s = String(raw).trim();
        if (!s) return 0n;
        const parts = s.split('.');
        const intPart = parts[0].replace(/\D/g, '') || '0';
        const fracPart = (parts[1] || '').replace(/\D/g, '');
        const fracPadded = (fracPart + '0'.repeat(decimals)).slice(0, decimals);
        const weiStr = (intPart + (decimals ? fracPadded : '')).replace(/^0+/, '') || '0';
        return BigInt(weiStr);
      } catch { return 0n; }
    };

    // ─────────────────────────────────────────────────────────────
    // 0) GUARDS
    // ─────────────────────────────────────────────────────────────
    if ((!this.quote && !this.selectedAlternative) || !this.provider || !this.takerAddress) {
      this.addLog('⛔ [GUARD] missing quote/provider/takerAddress');
      this.swapStatus = 'error';
      this.swapError = this.translate.instant('SWAP_TX_MISSING');
      return;
    }

    const isAlt = !!this.selectedAlternative;
    const routeObj = this.selectedAlternative ?? this.quote;
    const currentKey = this.getProviderKey(routeObj);
    this.addLog(`[CTX] isAlt=${isAlt} key=${currentKey || 'main'} chainId=${this.chainId} addr=${this.takerAddress}`);

    const tx = this.getTxFromQuote(routeObj);

    // Snapshot (safe)
    try {
      this.dbg?.logRouteSnapshot?.(this.addLog.bind(this), routeObj, tx, currentKey || 'main');
    } catch (e: any) {
      this.addLog(`[DBG] logRouteSnapshot error: ${e?.message || e}`);
    }

    if (!tx) {
      this.addLog('⛔ [GUARD] tx missing from route');
      this.swapStatus = 'error';
      this.swapError = this.translate.instant('SWAP_TX_MISSING');
      if (isAlt) { if (currentKey) this.failedAltKeys.add(currentKey); }
      else { this.lastSimFailedKey = currentKey || 'main'; }
      return;
    }

    // ─────────────────────────────────────────────────────────────
    // 1) CONTEXTE WALLET + APPROVE PARAMS
    // ─────────────────────────────────────────────────────────────
    const provider = this.provider!;
    let signer = await provider.getSigner();
    const owner = await signer.getAddress();

    const approveSpender = toAddr(
      routeObj?.allowanceTarget ||
      routeObj?.approvalAddress ||
      routeObj?.estimate?.approvalAddress ||
      routeObj?.spender ||
      routeObj?.value?.approvalAddress ||
      routeObj?.transactionRequest?.to || tx?.to || ''
    );

    const tokenAddr = [
      routeObj?.sellTokenAddress,
      routeObj?.inTokenAddress,
      routeObj?.sellToken?.address,
      routeObj?.tokenIn?.address,
      routeObj?.inToken?.address,
      this?.quote?.sellTokenAddress,
      this?.quote?.inTokenAddress,
      this?.quote?.sellToken?.address,
      this?.quote?.tokenIn?.address,
      this?.quote?.inToken?.address,
      this.sellTokenAddress
    ].map(toAddr).find(isAddr) || '';

    // native sell ?
    let isNativeSell = false;
    try { isNativeSell = BigInt(String(tx?.value ?? '0')) > 0n; } catch { isNativeSell = false; }
    if (!isNativeSell && isAddr(tokenAddr)) {
      try {
        const chainIdNum = Number((await provider.getNetwork()).chainId);
        if (this.isNativeToken?.(tokenAddr, chainIdNum)) isNativeSell = true;
      } catch { }
    }

    // needed (wei) from route/quote fields
    const rawSources: Array<[string, any]> = [
      ['route.inputAmountRaw', (routeObj as any)?.inputAmountRaw],
      ['route.rawInputWei', (routeObj as any)?.rawInputWei],
      ['route.rawInput', (routeObj as any)?.rawInput],
      ['route.fromAmount', (routeObj as any)?.fromAmount],
      ['route.amount', (routeObj as any)?.amount],
      ['route.sellAmount', (routeObj as any)?.sellAmount],
      ['route.estimate.fromAmount', (routeObj as any)?.estimate?.fromAmount],

      ['quote.inputAmountRaw', (this as any)?.quote?.inputAmountRaw],
      ['quote.rawInputWei', (this as any)?.quote?.rawInputWei],
      ['quote.rawInput', (this as any)?.quote?.rawInput],
      ['quote.fromAmount', (this as any)?.quote?.fromAmount],
      ['quote.amount', (this as any)?.quote?.amount],
      ['quote.sellAmount', (this as any)?.quote?.sellAmount],
      ['quote.estimate.fromAmount', (this as any)?.quote?.estimate?.fromAmount],

      ['tx.value', (tx as any)?.value],
    ];

    let needed: bigint = 0n;
    let pickedKey = 'n/a';
    for (const [k, v] of rawSources) {
      const b = pickBigInt(v);
      if (b != null) { needed = b; pickedKey = k; break; }
    }
    if (isNativeSell) { needed = 0n; pickedKey = 'native-sell'; }

    this.addLog(`[SWAP][APPROVE] inputs | spender=${approveSpender} token=${tokenAddr} isNative=${isNativeSell} needed=${needed} (picked=${pickedKey})`);

    // optional probe cache
    try {
      const chainIdNum = Number(this.chainId);
      const balCacheWei = tokenAddr ? cachedErc20BalanceWei(tokenAddr, chainIdNum) : 0n;
      this.addLog(`[PROBE][cache] token=${tokenAddr} bal(cache)=${balCacheWei} wei`);
    } catch { }

    // ─────────────────────────────────────────────────────────────
    // 2) APPROVE + POLL
    // ─────────────────────────────────────────────────────────────
    const ERC20_ABI = [
      "function allowance(address owner, address spender) view returns (uint256)",
      "function approve(address spender, uint256 value) returns (bool)"
    ];

    const readAllowance = async (token: string, _owner: string, _spender: string): Promise<bigint> => {
      if (!this.provider || !token) return 0n;
      const erc20 = new Contract(token, ERC20_ABI, this.provider);
      try {
        const cur = await (erc20['allowance'] as (o: string, s: string) => Promise<any>)(_owner, _spender);
        return BigInt(cur.toString());
      } catch { return 0n; }
    };

    const pollAllowanceUntil = async (
      token: string,
      spender: string,
      _owner: string,
      amount: bigint,
      opts: { timeoutMs?: number; intervalMs?: number } = {}
    ): Promise<'ok' | 'partial' | 'timeout'> => {
      const { timeoutMs = 60_000, intervalMs = 1_000 } = opts;
      if (!this.provider) return 'timeout';
      const erc20 = new Contract(token, ERC20_ABI, this.provider);
      this.addLog(`[SWAP][APPROVE][POLL] start | token=${token} spender=${spender} needed=${amount}`);
      const t0 = Date.now();
      let last = 0n;
      let firstTick = true;

      while (true) {
        try {
          const curAny = await (erc20['allowance'] as (o: string, s: string) => Promise<any>)(_owner, spender);
          const cur = BigInt(curAny.toString());
          if (cur !== last) { this.addLog(`[SWAP][APPROVE][POLL] tick | allowance=${cur}`); last = cur; }
          if (!firstTick && cur >= amount) {
            this.addLog(`[SWAP][APPROVE][POLL] ok | ${cur} ≥ ${amount}`);
            try { this.cfDone?.('apprv'); } catch { }
            return 'ok';
          }
          firstTick = false;
        } catch { }

        if (Date.now() - t0 > timeoutMs) {
          this.addLog(`[SWAP][APPROVE][POLL] timeout ${timeoutMs}ms | last=${last}`);
          return last > 0n && last < amount ? 'partial' : 'timeout';
        }
        await new Promise(r => setTimeout(r, intervalMs));
      }
    };

    let mustApproveFirst = false;
    if (!isNativeSell && approveSpender && tokenAddr && tokenAddr.length === 42 && needed > 0n) {
      const preAllowance = await readAllowance(tokenAddr, owner, approveSpender);
      this.addLog(`[SWAP][APPROVE] pre-check | allowance=${preAllowance} needed=${needed}`);
      mustApproveFirst = preAllowance < needed;
    } else {
      this.addLog('[SWAP][APPROVE] skip pre-check (native sell or missing params)');
    }

    if (mustApproveFirst) {
      this.addLog(`[FLOW] approve required (allowance < needed)`);
      this.swapStatus = 'approve';

      // ✅ SAME MODAL (Approve) — showWcModal (no auto deeplink)
      this._showWcModalForPhase('approve', 'swap:approve', runId);

      // Start poll AFTER approve call has been triggered
      let pollP: Promise<'ok' | 'partial' | 'timeout'> | null = null;

      if (typeof this.ensureAllowanceForRoute === 'function') {
        const token = intentToken || this.gate.generateIntent('swap-allowance', (m) => this.addLog(m));
        this.addLog(`[gate][approve] token=${token}`);

        const res = await this.gate.requestWithIntentEx(
          token,
          async () => {
            this.addLog('[approve] ensureAllowanceForRoute ENTER');
            await this.ensureAllowanceForRoute(routeObj);
            this.addLog('[approve] ensureAllowanceForRoute EXIT');
          },
          { ctx: 'swap:approve', log: (m) => this.addLog(m), preserveTokenOnSuccess: true, timeoutMs: 180_000 }
        );

        this.addLog(`[approve] requestWithIntentEx done | ok=${res?.ok}`);
        if (!res.ok) {
          this._hideWcModal('approve-failed');
          if (this.swapStatus === 'approve') this.swapStatus = 'idle';
          const why = res.reason || 'unknown';
          this.addLog(`⛔ [approve] aborted reason=${why} → abort wc + reconnect`);
          try { await (this as any).abortWalletConnectSafely?.call?.(this, why); } catch { }
          try { await this.forceReconnectWalletSession(why); } catch { }
          return;
        }

        pollP = pollAllowanceUntil(tokenAddr, approveSpender, owner, needed, { timeoutMs: 60_000, intervalMs: 1_000 });
      }

      if (!pollP) {
        this._hideWcModal('approve-poll-missing');
        this.addLog('⛔ [approve] poll not started');
        this.swapStatus = 'error';
        this.swapError = 'APPROVE_POLL_NOT_STARTED';
        return;
      }

      const pollRes = await pollP;
      this.addLog(`[approve] poll result=${pollRes}`);

      if (pollRes !== 'ok') {
        this._hideWcModal('approve-not-effective');
        this.addLog(pollRes === 'partial'
          ? '⚠️ [SWAP][APPROVE] partial: allowance < needed'
          : '⏳ [SWAP][APPROVE] timeout: no on-chain effect');
        this.swapStatus = 'error';
        this.swapError = 'APPROVE_NOT_EFFECTIVE';
        this.cd?.detectChanges?.();
        return;
      }

      // Approve ok → hide modal
      this._hideWcModal('approve-ok');

      this.addLog('🟢 [SWAP] allowance effective → go simulation');
      this.swapStatus = 'pending';
      this.swapError = null;
      this.cd?.detectChanges?.();
    } else {
      this.addLog('🟢 [SWAP][APPROVE] skip: allowance sufficient or native sell');
    }

    // ─────────────────────────────────────────────────────────────
    // 2.b) Post-approve chain safety
    // ─────────────────────────────────────────────────────────────
    try {
      const q: any = this.quote;
      const expectedChainId =
        (q?.fromChainId as number | undefined) ??
        (q?.chainId as number | undefined) ??
        ((this as any).chainId as number | undefined);

      if (expectedChainId && this.provider) {
        const ctxForNet: 'main' | 'alt' = isAlt ? 'alt' : 'main';
        await this._forceChainForRunIfNeeded(ctxForNet, 2, expectedChainId);
      }
    } catch (e: any) {
      this.addLog?.('[NETWORK][POST-APPROVE] warn: ' + (e?.message ?? e));
    }

    // ─────────────────────────────────────────────────────────────
    // 3) SIMULATION (preflight)
    // ─────────────────────────────────────────────────────────────
    this.addLog('[SIM] preflight start');
    let preflightOk = false;
    try {
      preflightOk = await this.simulateTxPreflight(isAlt ? routeObj : undefined);
    } catch (e: any) {
      this.addLog('⛔ [SIM] preflight exception: ' + (e?.message ?? e));
      preflightOk = false;
    }

    if (!preflightOk) {
      this.addLog(`⛔ [SIM] fail on ${currentKey ?? 'unknown'} (isAlt=${isAlt})`);
      if (isAlt) { if (currentKey) this.failedAltKeys.add(currentKey); }
      else { this.lastSimFailedKey = currentKey || 'main'; }
      return;
    }

    this.addLog('[SIM] preflight ok');
    this.swapStatus = 'pending';
    this.swapError = null;
    this.cd?.detectChanges?.();

    // ─────────────────────────────────────────────────────────────
    // 4) EXECUTION (NO AUTO-DEEPLINK)
    // ─────────────────────────────────────────────────────────────
    const netNow = await provider.getNetwork();
    const chainId = Number(netNow.chainId);
    const routeObjExec = this.selectedAlternative ?? this.quote;
    const txSrc = this.getTxFromQuote?.(routeObjExec) ?? routeObjExec?.transactionRequest;

    if (!txSrc?.to) {
      this.addLog('⛔ [EXEC] tx missing');
      this.swapStatus = 'error';
      this.swapError = this.translate.instant('SWAP_TX_MISSING');
      return;
    }

    let txToSend = sanitizeTxForWallet({
      from: await signer.getAddress(),
      to: txSrc.to,
      data: txSrc.data ?? '0x',
      value: txSrc.value ?? '0x0',
    });

    // Resync chain pre-send
    {
      const n = await provider.getNetwork();
      if (Number(n.chainId) !== chainId) {
        this.addLog(`🔁 [EXEC] resync chain: current=${Number(n.chainId)} → target=${chainId}`);
        await this.switchToChain(chainId);
        await new Promise(r => setTimeout(r, 250));
        signer = await provider.getSigner();
        const from2 = this.takerAddress ?? (await signer.getAddress());
        txToSend = { ...txToSend, from: from2 };
      }
    }

    // ✅ SAME MODAL (TX)
    const sendCtx: 'alt-cta' | 'main-cta' = isAlt ? 'alt-cta' : 'main-cta';
    this.cfPreDeeplink?.('trx', runId);
    this._showWcModalForPhase('tx', `swap:tx:${sendCtx}`, runId);

    // Hashless watcher (balance tokenOut ↑) — keep as you already have it
    // (je laisse ton bloc tel quel si tu veux, sinon on le refactor après)
    try {
      const routerTo = String(txSrc.to || '').toLowerCase();
      const ownerAddr = this.takerAddress!;

      const cand = {
        alt_buyTokenAddress: toAddr(this.selectedAlternative?.buyTokenAddress),
        alt_outTokenAddress: toAddr(this.selectedAlternative?.outTokenAddress),
        alt_toToken_addr: toAddr(this.selectedAlternative?.toToken?.address),
        q_buyTokenAddress: toAddr(this.quote?.buyTokenAddress),
        q_toTokenAddress: toAddr(this.quote?.toTokenAddress),
        q_toToken_addr: toAddr(this.quote?.toToken?.address),
        ui_buyTokenAddress: toAddr(this.buyTokenAddress),
      };

      const buyAddr =
        cand.alt_buyTokenAddress ||
        cand.alt_outTokenAddress ||
        cand.alt_toToken_addr ||
        cand.q_buyTokenAddress ||
        cand.q_toTokenAddress ||
        cand.q_toToken_addr ||
        cand.ui_buyTokenAddress ||
        '';

      const outSym =
        this.selectedAlternative?.buyTokenSymbol ||
        this.quote?.buyTokenSymbol ||
        this.buyTokenSymbol ||
        '';

      const isNativeOut =
        !buyAddr || this.isNativeToken?.(buyAddr, chainId) === true ||
        ['ETH', 'MATIC', 'BNB'].includes(String(outSym).toUpperCase());

      const ERC20_ABI_BAL = ['function balanceOf(address) view returns (uint256)'];

      const readOutBalance = async (): Promise<bigint> => {
        try {
          if (isNativeOut) {
            const b = await provider.getBalance(ownerAddr);
            return BigInt(b.toString());
          }
          const c = new Contract(buyAddr, ERC20_ABI_BAL, provider);
          const v = await (c['balanceOf'] as (o: string) => Promise<any>)(ownerAddr);
          return BigInt(v.toString());
        } catch { return 0n; }
      };

      const baseline = await readOutBalance();
      void (async () => {
        const t0 = Date.now();
        const timeoutMs = 180_000;
        const intervalMs = 2_000;
        let tick = 0;

        while (Date.now() - t0 < timeoutMs) {
          await new Promise(r => setTimeout(r, intervalMs));
          tick++;
          const cur = await readOutBalance();
          if (cur > baseline) {
            this.addLog(`[HASHLESS] ✅ success by balance delta after tick=${tick}`);
            this._hideWcModal('hashless-success');
            try { this.swapStatus = 'success'; this.swapError = null; this.cd?.detectChanges?.(); } catch { }
            return;
          }
        }
        this.addLog('[HASHLESS] ⏳ timeout (no balance delta)');
      })();

      const tokenIn = String(this.quote?.fromTokenAddress || this.quote?.fromToken?.address || '').toLowerCase();
      const tokenOut = buyAddr;
      let expectedInWei: bigint | null = null; try { expectedInWei = BigInt(String(this.quote?.inputAmountRaw ?? '0')); } catch { }
      let expectedOutWei: bigint | null = null; try { expectedOutWei = BigInt(String(this.quote?.outputAmountRaw ?? '0')); } catch { }

      void this.startHashlessWatchExecution?.({ owner: ownerAddr, chainId, routerTo, tokenIn, tokenOut, expectedInWei, expectedOutWei });
    } catch (e: any) {
      this.addLog(`[HASHLESS] setup error: ${e?.message || e}`);
    }

    this.addLog('🚀 [EXEC] sending (hashless, no auto-deeplink)…');

    const sendP = this.txFlow.sendViaSignerWithWatchdog(signer, txToSend);

    let watchArmed = false;
    const armByHash = (h?: string) => {
      if (watchArmed || !h) return;
      watchArmed = true;
      this.addLog(`[SWAP][TX] sent | hash=${h}`);
      this._hideWcModal('hash-received');
      try { this.savePendingSwap?.(h, chainId); } catch { }
      this.watchSwapReceiptUntilFinal?.(h, chainId, { initialDelayMs: 1200, maxDelayMs: 8000 })
        ?.catch((e: any) => this.addLog(`[SWAP][WATCH][err] ${e?.message || e}`));
    };

    sendP
      .then((resp: any) => armByHash(resp?.hash))
      .catch((e: any) => {
        const msg = String(e?.message || e?.reason || e?.error?.message || '').toLowerCase();
        const code = e?.code ?? e?.error?.code;
        const userRejected =
          code === 4001 || code === 5000 || code === 'ACTION_REJECTED' ||
          /action_rejected/.test(String(code)) || /denied|rejected|user denied|user rejected/.test(msg);

        if (userRejected) {
          this._hideWcModal('user-rejected');
          this.txFlow.markUserCancelled?.();
          this.swapStatus = 'cancelled';
          this.swapError = null;
          this.addLog('🚫 [EXEC] user rejected');
          try { this.validatingKey = null; } catch { }
          this.cd?.detectChanges?.();
        } else {
          this.addLog(`[EXEC] error: ${code || ''} ${e?.message || e}`);
        }
      });

    return;
  }










  private recoverySeq = 0;
  private lastRecoveryAt = 0;



  // ✅ version qui n’utilise que des choses déjà présentes dans SwapComponent
  private async wcSoftRecovery(reason: string) {
    const seq = ++this.recoverySeq;
    this.lastRecoveryAt = Date.now();
    this.addLog(`🧯 [recovery#${seq}] soft start | reason=${reason}`);
    try { await this.wallet.disconnect(); } catch (e) { this.addLog(`[recovery#${seq}] disconnect error: ${String(e)}`); }
    try {
      this.takerAddress = null;
      this.provider = null;
      this.quote = null;
      this.swapStatus = 'idle';
      this.swapError = null;
      this.swapHash = null;
      this.tokenCachedBalances = {};
      this.showWcModal = false as any;
      this.wcUri = '' as any;
    } catch (e) { this.addLog(`[recovery#${seq}] purge error: ${String(e)}`); }
    await new Promise(r => setTimeout(r, 900));
    this.addLog(`[recovery#${seq}] done → cooldown 1500ms`);
    await new Promise(r => setTimeout(r, 1500));
  }





  private _inWalletFlow: boolean = false;        // bloque fermetures & handlers pendant MM
  private _pauseQuoteTtl: boolean = false;       // met en pause l'expiration de la quote
  private _txPromptLockUntil: number = 0;
  /** WC “silent reattach” détecté : pas de window.ethereum, provider actif et connecté */
  private isWcSilentAttached(): boolean {
    try {
      const hasWinEth = !!(window as any).ethereum;
      const prov: any = (this.provider as any)?.provider || this.rawProvider || null;
      const isEip1193 = !!prov && typeof prov.request === 'function';
      return !hasWinEth && isEip1193 && !!this.isConnected;
    } catch { return false; }
  }

  // Petit helper pour consommer le flag "skip une fois" du deeplink WC
  private shouldSkipWcDeeplinkOnce(reason?: string, runId?: number): boolean {
    try {
      const raw = sessionStorage.getItem('st/skipWcDeeplinkOnce');
      if (raw === '1') {
        // on consomme le flag (one-shot)
        sessionStorage.removeItem('st/skipWcDeeplinkOnce');
        this.addLog?.(
          `[deeplink][skipOnce] reason=${reason ?? '(n/a)'} runId=${runId ?? -1}`
        );
        return true;
      }
    } catch {
      // storage indispo → on ne bloque pas
    }
    return false;
  }

  /** Fallback générique : juste foregrounder MetaMask (sans wc?uri=...) */
  private foregroundMetaMaskGeneric(runId: number, phase: 'apprv' | 'trx'): void {
    try {
      this.addLog?.(`[MM][fg] ENTER phase=${phase} runId=${runId}`);

      // 1) Respecter skipOnce (cas recovery / debug)
      if (this.shouldSkipWcDeeplinkOnce('mm-foreground', runId)) {
        this.addLog?.('[MM][fg] skip: skipOnce=true');
        return;
      }

      // 2) Lire wcLastUri depuis le storage
      let url = '';
      try {
        url = sessionStorage.getItem('st/wcLastUri') || '';
      } catch {
        url = '';
      }

      if (!url || url.length < 4) {
        this.addLog?.('[MM][fg] skip: no usable wcLastUri in storage');
        return;
      }

      // 3) Normaliser “wc...” → “wc:...”
      if (url.startsWith('wc') && !url.startsWith('wc:')) {
        const old = url;
        url = 'wc:' + url.slice(2);
        this.addLog?.(`[MM][fg] normalize url "${old}" -> "${url}"`);
      }

      if (!url.startsWith('wc:')) {
        this.addLog?.(`[MM][fg] skip: uri does not start with "wc:" | uri=${url}`);
        return;
      }

      // 4) Garde anti-doublon par (phase, runId)
      try {
        const w = window as any;
        const key = `${phase}:${runId}`;
        w.__dlOpenedForRun = w.__dlOpenedForRun || {};
        if (w.__dlOpenedForRun[key]) {
          this.addLog?.(`[MM][fg] skip: already opened for ${key}`);
          return;
        }
        w.__dlOpenedForRun[key] = true;
      } catch {
        // best-effort, on ne bloque pas si ça plante
      }

      // 5) Rediriger Safari vers l’URI wc:…
      this.addLog?.(`[MM][fg] OPEN uri=${url}`);
      const href = window.location.href;
      this.addLog?.(`[MM][fg] href(before)=${href}`);
      window.location.href = url;
      this.addLog?.('[MM][fg] href(after)=<changed>');

    } catch (e: any) {
      this.addLog?.(`[MM][fg] EXC ${e?.message || e}`);
    }
  }






  //
  // ─────────────────────────────────────────────────────────────
  // Helper: vérifie/pose l'allowance du tokenIn pour le spender
  // de la route sélectionnée (Sushi, 1inch, Kyber, …)
  // ─────────────────────────────────────────────────────────────
  // ─────────────────────────────────────────────────────────────
  // Approve guardé (multi-agrégateurs / multi-shapes de quote/route)
  // ─────────────────────────────────────────────────────────────
  private async ensureAllowanceForRoute(spenderParam?: string): Promise<void> {
    if (!this.provider) return;

    const log = (m: string) => this.addLog?.(`[SWAP][APPROVE] ${m}`);

    // --- DEBUG WC FINGERPRINT (local safe to avoid minifier issues)
    const safe = (x: any) => { try { return JSON.stringify(x); } catch { try { return String(x); } catch { return '(unserializable)'; } } };
    const wcDiag = (ctx: string) => {
      const p: any = (this as any)?.provider;
      const raw: any = p?.provider ?? p;
      const flags = {
        hasProvider: !!p,
        hasRequest: !!p?.request,
        isWalletConnectFlag: !!(p?.isWalletConnect || (this as any)?.isWalletConnect),
        hasWcObj: !!raw?.wc,
        hasSession: !!raw?.session || !!raw?.wc?.session || !!p?.session,
        addrKnown: !!this.takerAddress,
        chainKnown: !!this.chainId
      };
      const ctors = {
        provCtor: p?.constructor?.name,
        rawCtor: raw?.constructor?.name
      };
      const actives = {
        addr: this.takerAddress || null,
        chainId: this.chainId ?? null
      };
      this.addLog?.(`[WC][detect][${ctx}] flags=${safe(flags)}`);
      this.addLog?.(`[WC][detect][${ctx}] ctors=${safe(ctors)}`);
      this.addLog?.(`[WC][detect][${ctx}] actives=${safe(actives)}`);
    };
    // Log immédiatement à l’entrée (toujours exécuté si provider présent)
    wcDiag('approve:enter');
    const ZERO = '0x0000000000000000000000000000000000000000';
    const toAddr = (x: any) => String(x ?? '').trim().toLowerCase();
    const now = () => new Date().toISOString().slice(11, 23); // HH:MM:SS.mmm

    // Validation d’adresse légère
    const isAddr = (a?: string) => {
      const s = toAddr(a);
      return !!(s && s.startsWith('0x') && s.length === 42 && s !== ZERO);
    };

    // ---- Helpers de pick + logs ------------------------------------------------
    const pickSpenderFromRoute = (route: any, tx?: { to?: string }, manual?: string) => {
      const cands = [
        route?.allowanceTarget,
        route?.transactionRequest?.to ?? route?.transactionTo,
        route?.target,
        tx?.to,
        manual
      ].map(toAddr);

      log(`${now()} [pickSpender] candidates=` +
        cands.map((c, i) => `c${i + 1}=${c || '(empty)'}`).join(' | '));

      const picked = cands.find(isAddr) || '';
      log(`${now()} [pickSpender] picked=${picked || '(none)'}`);
      return picked;
    };

    const pickSellTokenAddress = (route: any, quote: any, ui?: { sellToken?: { address?: string } }): string => {
      const cands = [
        // standards intégrateurs
        route?.sellTokenAddress,
        route?.inTokenAddress,
        route?.sellToken?.address,
        route?.tokenIn?.address,
        route?.inToken?.address,

        // variantes côté quote
        quote?.sellTokenAddress,
        quote?.inTokenAddress,
        quote?.sellToken?.address,
        quote?.tokenIn?.address,
        quote?.inToken?.address,

        // fallback UI local si dispo
        ui?.sellToken?.address,
        this.sellTokenAddress // dernier recours si tu stockes la sélection UI ici
      ].map(toAddr);

      log(`${now()} [pickToken] cands=${cands.join(' | ')}`);
      return cands.find(isAddr) || '';
    };


    // ---- Concrétisation sur la route sélectionnée ------------------------------
    const route = (this as any).selectedAlternative ?? (this as any).quote ?? null;
    const txLike = this.getTxFromQuote?.(route) ?? route?.transactionRequest ?? null;
    const approveSpender = pickSpenderFromRoute(route, txLike, spenderParam);
    const tokenIn = pickSellTokenAddress(route, (this as any).quote, { sellToken: { address: this.sellTokenAddress } });

    if (!approveSpender || !tokenIn) {
      log(`${now()} [guard] rien à approuver (spender=${approveSpender || '(none)'} tokenIn=${tokenIn || '(none)'})`);
      return;
    }







    // Approve "fire-and-return" (aucun await) + fallback zero-reset + logs verbeux
    const safeApprove = async (erc20: any, spender: string, needed: bigint) => {
      try {
        log(`${now()} [approve] fire-and-return BEGIN | spender=${spender} amount=${needed}`);
        const p = erc20.approve(spender, needed);
        p.then((tx: any) => {
          log(`${now()} [approve] sent | hash=${tx?.hash ?? '(no-hash)'}`);
          if (tx?.hash) { this.cfOnHash?.('apprv'); }   // ← annule le timeout local
        })
          .catch((e: any) => {
            const code = e?.code ?? e?.error?.code;
            const msg = (e?.message || e?.reason || e?.error?.message || '').toLowerCase?.() || '';
            const userRejected =
              code === 4001 || code === 5000 || code === 'ACTION_REJECTED' ||
              /action_rejected/.test(String(code).toLowerCase()) ||
              /denied|rejected|user denied|user rejected/.test(msg);
            if (userRejected) { this.cfCancel?.('user_rejected', 'apprv'); } // ← cancel immédiat
            log(`${now()} [approve] send error | ${e?.message || e}`);
          });
        // ne rien attendre ici
        return;
      } catch (e1: any) {
        log(`${now()} [approve] direct failed → zero-reset then re-approve | errCode=${e1?.code} reason=${e1?.reason || ''} msg=${e1?.message || e1}`);
        try {
          const p0 = erc20.approve(spender, 0n);
          p0.then((tx: any) => {
            log(`${now()} [approve] zero-approve sent | hash=${tx?.hash ?? '(no-hash)'}`);
            if (tx?.hash) { this.cfOnHash?.('apprv'); }
          })
            .catch((e: any) => {
              const code = e?.code ?? e?.error?.code;
              const msg = (e?.message || e?.reason || e?.error?.message || '').toLowerCase?.() || '';
              const userRejected =
                code === 4001 || code === 5000 || code === 'ACTION_REJECTED' ||
                /action_rejected/.test(String(code).toLowerCase()) ||
                /denied|rejected|user denied|user rejected/.test(msg);
              if (userRejected) { this.cfCancel?.('user_rejected', 'apprv'); }
              log(`${now()} [approve] zero-approve error | ${e?.message || e}`);
            });
          const p1 = erc20.approve(spender, needed);
          p1.then((tx: any) => {
            log(`${now()} [approve] re-approve sent | hash=${tx?.hash ?? '(no-hash)'}`);
            if (tx?.hash) { this.cfOnHash?.('apprv'); }
          })
            .catch((e: any) => {
              const code = e?.code ?? e?.error?.code;
              const msg = (e?.message || e?.reason || e?.error?.message || '').toLowerCase?.() || '';
              const userRejected =
                code === 4001 || code === 5000 || code === 'ACTION_REJECTED' ||
                /action_rejected/.test(String(code).toLowerCase()) ||
                /denied|rejected|user denied|user rejected/.test(msg);
              if (userRejected) { this.cfCancel?.('user_rejected', 'apprv'); }
              log(`${now()} [approve] re-approve error | ${e?.message || e}`);
            });
          return;
        } catch (e2: any) {
          log(`${now()} [approve] fallback failed | errCode=${e2?.code} reason=${e2?.reason || ''} msg=${e2?.message || e2}`);
          throw e1;
        }
      }
    };

    try {
      const signer = await this.provider.getSigner();
      const owner = toAddr(await signer.getAddress());
      const chainId = Number((await this.provider.getNetwork()).chainId);
      const tx = this.getTxFromQuote(this.quote);
      const routeObj: any = this.selectedAlternative ?? this.quote ?? {};
      const v: any = routeObj;

      log(`${now()} [ctx] chainId=${chainId} owner=${owner}`);
      log(`${now()} [ctx] tx.to=${toAddr(tx?.to)} tx.value=${tx?.value ?? '0'}`);

      // Dump des clés utiles pour comprendre pourquoi token est vide
      const dbg = {
        sellTokenAddress: toAddr(v?.sellTokenAddress),
        inTokenAddress: toAddr(v?.inTokenAddress),
        sellToken_addr: toAddr(v?.sellToken?.address),
        tokenIn_addr: toAddr(v?.tokenIn?.address),
        inToken_addr: toAddr(v?.inToken?.address),
        quote_sellToken: toAddr(this?.quote?.sellToken?.address),
      };
      log(`${now()} [debugKeys] ${JSON.stringify(dbg)}`);

      // 1) Token (robuste)
      const token = pickSellTokenAddress(v, this.quote, { sellToken: { address: this.sellTokenAddress } });
      log(`${now()} [derive] tokenPicked=${token || '(empty)'}`);

      // 2) Spender — multi-sources + coercition param
      let manualSpender = spenderParam;
      if (manualSpender && typeof manualSpender !== 'string') {
        log(`${now()} warn: spenderParam is not string → typeof=${typeof manualSpender}`);
        try {
          manualSpender = (manualSpender as any)?.to ?? (manualSpender as any)?.allowanceTarget ?? '';
        } catch { manualSpender = ''; }
        log(`${now()} coerced spenderParam → ${toAddr(manualSpender) || '(empty)'}`);
      }
      const spender = pickSpenderFromRoute(v, { to: tx?.to }, manualSpender);

      // 3) Détection "natif" (deux raisons possibles)
      let isNativeSell = false;
      let nativeReason = '';
      try {
        isNativeSell = BigInt(tx?.value ?? '0') > 0n;
        if (isNativeSell) nativeReason = 'value>0';
      } catch { /* no-op */ }
      if (!isNativeSell && token && token.length === 42) {
        const nativeByMap = this.isNativeToken(token, chainId); // gère 0xeeee..., 0x0, 0x1010…
        if (nativeByMap) { isNativeSell = true; nativeReason = 'known-native-address'; }
      }
      log(`${now()} [native] isNativeSell=${isNativeSell} reason=${nativeReason || 'n/a'} token=${token}`);

      if (isNativeSell) {
        log(`${now()} skip: native token (no approve)`);
        return;
      }

      // 4) Validations strictes + diagnostics
      if (!isAddr(spender)) {
        log(`${now()} abort: invalid spender | spender=${spender || '(empty)'} len=${(spender || '').length}`);
        return;
      }
      if (!isAddr(token)) {
        log(`${now()} abort: invalid token | token=${token || '(empty)'} len=${(token || '').length}`);
        return;
      }

      // 5) Montant "needed" — source canonique backend: ROOT sellAmount / SellAmount
      const rootSell = (this as any)?.quote?.sellAmount ?? (this as any)?.quote?.SellAmount ?? null;
      let needed = 0n;
      try {
        const s = String(rootSell ?? '').trim();
        needed = !s ? 0n : (s.startsWith('0x') || s.startsWith('0X')) ? BigInt(s) : BigInt(s);
      } catch { needed = 0n; }
      log(`${now()} [need] key=root.sellAmount value=${needed}`);

      if (needed <= 0n) {
        log(`${now()} skip: needed=0`);
        return;
      }

      // 6) Lecture allowance & décision
      const erc20 = new Contract(
        token,
        [
          'function allowance(address,address) view returns(uint256)',
          'function approve(address,uint256) returns(bool)'
        ],
        signer
      );

      const current: bigint = await erc20['allowance'](owner, spender);
      log(`${now()} [check] owner=${owner} spender=${spender} token=${token} allowance=${current} needed=${needed}`);

      if (current >= needed) {
        log(`${now()} ok: allowance suffisante → no approve`);
        return;
      }

      // 7) Approve — armer le deeplink-gate (deny-by-default conservé)
      // Génère un runId one-shot pour autoriser l’ouverture MetaMask de CETTE approve.

      const approveRunId = this._runSeq;
      log(`${now()} [gate] runId=${approveRunId} → preDeeplinkAnnounce(approve-cta)`);
      try {
        this.cfPreDeeplink('apprv', approveRunId);
        await this.preDeeplinkAnnounce?.('approve-cta', approveRunId);
        const until = Date.now() + 45_000;
        try {
          sessionStorage.setItem('st/allowWcDeeplinkUntil', String(until));
          sessionStorage.setItem('st/allowWcRunId', String(approveRunId));
          const nowTs = Date.now();
          log(`${now()} [deeplink][gate] allow set | until=${until} (deltaMs=${until - nowTs}) runId=${approveRunId}`);
        } catch { /* storage not available */ }
        if (this.isWcSilentAttached() && !this.wcUri) {
          // this.foregroundMetaMaskGeneric(approveRunId, 'apprv');
        }
        // Fenêtre d’autorisation côté open-probe (deny-by-default intact)

        // Compat éventuelle avec un helper existant
        (window as any).__allowWcDeeplinkFor?.(45_000);
      } catch { /* annonce optionnelle */ }

      safeApprove(erc20, spender, needed);


      // 🦿 Kick WC/MetaMask si la feuille n'apparaît pas sous ~6s
      // 🕒 Laisse l’armement actif quelques secondes pour laisser WC ouvrir la feuille
      setTimeout(() => {
        try {
          sessionStorage.removeItem('st/allowWcRunId');
          sessionStorage.removeItem('st/allowWcDeeplinkUntil');

          const nowTs = Date.now();
          log(`${now()} [deeplink][gate] cleared (post-approve grace) now=${nowTs}`);
        } catch { }
      }, 8000);

      // 🕒 Laisse l’armement actif quelques secondes pour laisser WC ouvrir la feuille
      setTimeout(() => {
        try {
          sessionStorage.removeItem('st/allowWcRunId');
          sessionStorage.removeItem('st/allowWcDeeplinkUntil');

          const nowTs = Date.now();
          log(`${now()} [deeplink][gate] cleared (post-approve grace) now=${nowTs}`);
        } catch { }
      }, 8000);

    } catch (e: any) {
      // Normalisation messages d’erreurs courantes
      const code = e?.code ?? e?.error?.code;
      const msg = (e?.message || e?.reason || e?.error?.message || '').toLowerCase();
      const userRejected =
        code === 4001 ||                           // EIP-1193
        code === 5000 ||                           // MetaMask Mobile
        code === 'ACTION_REJECTED' ||
        /action_rejected/.test(String(code).toLowerCase()) ||
        /denied|rejected|user denied|user rejected/.test(msg);

      log(`${now()} error: code=${code} reason=${e?.reason || ''} msg=${e?.message || e}`);
      // En cas d’erreur/annulation, on révoque aussi l’armement du deeplink
      try {
        sessionStorage.removeItem('st/allowWcRunId');
        sessionStorage.removeItem('st/allowWcDeeplinkUntil');
        log(`${now()} [gate] reset allow-runId (approve error)`);
      } catch { /* no-op */ }

      if (userRejected) {
        this.cfCancel?.('user_rejected', 'apprv');   // ← classe en cancel si rejet synchrone
        log(`${now()} note: user rejected approval`);
      }
      throw e;
    }
  }











  /**
   * Envoie immédiatement la TX de swap après l'approve (mobile/desktop).
   * - Récupère la tx depuis route/quote/selectedAlternative (transactionRequest ou {to,data,value})
   * - Sanitize la tx pour laisser le wallet estimer les frais
   * - Préflight SIM (anti route périmée), ouverture automatique du wallet, puis race wait⟂poll sur le receipt
   */
  private async autoSendSwapAfterApprove(route: any, parentRunId: string): Promise<void> {
    const runId = `${parentRunId}/swap-1`;
    this.addLog(`🟣 [auto-swap][${runId}] start | status=${this.swapStatus}`);

    // empêcher fermetures/TTL pendant le flow (mobile-safe)
    try { (this as any)._inWalletFlow = true; } catch { }
    try { (this as any)._pauseQuoteTtl = true; } catch { }

    let sigTicker: any = null;

    try {
      // 1) Source TX (ordre de priorité robuste)
      const q: any = (this as any).selectedAlternative ?? (this as any).quote ?? route ?? null;
      const rawTx: any =
        q?.transactionRequest ??
        (q?.to && q?.data ? { to: q.to, data: q.data, value: q?.value } : null) ??
        ((this as any).quote?.transactionRequest ??
          (((this as any).quote?.to && (this as any).quote?.data)
            ? { to: (this as any).quote.to, data: (this as any).quote.data, value: (this as any).quote?.value }
            : null));

      if (!rawTx?.to || !rawTx?.data) {
        this.addLog(`❌ [auto-swap][${runId}] no tx found on quote/route → abort`);
        return;
      }

      // 2) Nettoyage des champs de frais (laisser le wallet décider)
      const txReq: any = (this as any).sanitizeTxForWallet?.({
        from: (this as any).takerAddress ?? undefined,
        to: rawTx.to,
        data: rawTx.data,
        value: rawTx.value ?? '0x0',
        chainId: (rawTx.chainId ?? (this as any).chainId) as number | undefined,
      }) ?? {
        from: (this as any).takerAddress ?? undefined,
        to: rawTx.to,
        data: rawTx.data,
        value: rawTx.value ?? '0x0',
        chainId: (rawTx.chainId ?? (this as any).chainId) as number | undefined,
      };

      this.addLog(`📦 [auto-swap][${runId}] tx ready | to=${txReq.to} value=${String(txReq.value)} dataLen=${(txReq.data || '').length}`);

      // 2bis) PRE-FLIGHT SIM: éviter d’ouvrir une popup sur route périmée
      try {
        const preflight = (this as any).preflightSim;
        if (typeof preflight === 'function') {
          const ok = await preflight(txReq); // true/false
          if (!ok) throw new Error('SIM_FAIL');
        }
      } catch (e: any) {
        const m = (e?.message || '').toLowerCase();
        if (/return amount is not enough|insufficient output|minout/.test(m)) {
          this.addLog(`🔁 [auto-swap][${runId}] preflight=FAIL (minOut) → refresh quote`);
          try { const rq = (this as any).refreshQuote; if (typeof rq === 'function') await rq(); } catch { }
          // reconstruire la tx avec la quote fraîche
          const fresher: any = (this as any).selectedAlternative ?? (this as any).quote ?? route ?? null;
          const newRaw: any =
            fresher?.transactionRequest ??
            (fresher?.to && fresher?.data ? { to: fresher.to, data: fresher.data, value: fresher?.value } : null);

          if (!newRaw?.to || !newRaw?.data) {
            this.addLog(`❌ [auto-swap][${runId}] no fresh tx after refresh → abort`);
            (this as any).swapStatus = 'error';
            try { const toast = (this as any).addToast; if (typeof toast === 'function') toast({ kind: 'error', title: 'Route périmée', description: 'Impossible d’exécuter ce swap. Nouvelle cotation requise.' }); } catch { }
            return;
          }

          const txReq2: any = (this as any).sanitizeTxForWallet?.({
            from: (this as any).takerAddress ?? undefined,
            to: newRaw.to,
            data: newRaw.data,
            value: newRaw.value ?? '0x0',
            chainId: (newRaw.chainId ?? (this as any).chainId) as number | undefined,
          }) ?? {
            from: (this as any).takerAddress ?? undefined,
            to: newRaw.to,
            data: newRaw.data,
            value: newRaw.value ?? '0x0',
            chainId: (newRaw.chainId ?? (this as any).chainId) as number | undefined,
          };

          Object.assign(txReq, txReq2);
          this.addLog(`📦 [auto-swap][${runId}] tx refreshed | to=${txReq.to} value=${String(txReq.value)} dataLen=${(txReq.data || '').length}`);
        } else {
          // autre échec déterministe → on n’ouvre pas le wallet
          this.addLog(`⛔ [auto-swap][${runId}] preflight SIM fail (non-minOut) → abort`);
          (this as any).swapStatus = 'error';
          try { const toast = (this as any).addToast; if (typeof toast === 'function') toast({ kind: 'error', title: 'Simulation échouée', description: 'La transaction ne peut pas être exécutée dans l’état actuel.' }); } catch { }
          return;
        }
      }

      // 3) Prompt-lock (anti double ouverture mobile)
      const now = Date.now();
      if (now < (this as any)._txPromptLockUntil) {
        this.addLog(`⛔ [auto-swap][${runId}] prompt locked (until=${(this as any)._txPromptLockUntil})`);
        return;
      }
      (this as any)._txPromptLockUntil = now + 7000;
      try {
        (window as any).__allowWcDeeplinkFor?.(30_000);
        // au cas où un suppress est actif, on lève le blocage
        sessionStorage.setItem('st/suppressWcUriUntil', String(Date.now() - 1));
      } catch { }

      // 4) Envoi via signer (ouvre MM/WC automatiquement)
      const signer = await (this as any).provider!.getSigner();
      (this as any).swapStatus = 'pending';
      this.addLog(`🟠 [auto-swap][${runId}] awaiting wallet signature …`);

      // Watchdog signature: logs toutes 10s tant que la Promise n'a pas résolu
      try { sigTicker = setInterval(() => this.addLog(`⌛ [auto-swap][${runId}] still waiting user signature…`), 10_000); } catch { }

      const txResp = await signer.sendTransaction({
        to: txReq.to,
        data: txReq.data,
        value: typeof txReq.value === 'string' ? (txReq.value as any) : (txReq.value ?? 0n),
      });

      if (sigTicker) { try { clearInterval(sigTicker); } catch { } sigTicker = null; }

      (this as any).swapHash = txResp.hash;
      try { sessionStorage.setItem('st/swapHash', txResp.hash); } catch { }
      this.addLog(`🟢 [auto-swap][${runId}] user signed | tx=${txResp.hash}`);

      // 5) Réaction UX fiable via race (receipt ⟂ polling receipt)
      const provider = this.provider as any;

      const waitReceipt = (async () => {
        const rcpt = await txResp.wait(1); // peut être long en WC mobile
        return { ok: true as const, kind: 'wait' as const, rcpt };
      })();

      const pollReceipt = async () => {
        const start = Date.now();
        while (Date.now() - start < 120_000) { // 120s max
          try {
            const rcpt = await provider.getTransactionReceipt(txResp.hash);
            if (rcpt) return { ok: true as const, kind: 'poll' as const, rcpt };
          } catch { /* one-shot */ }
          this.addLog(`⏳ [auto-swap][${runId}] waiting receipt… (poll)`);
          await new Promise(r => setTimeout(r, 2000));
        }
        return { ok: false as const, kind: 'timeout' as const };
      };

      const first = await Promise.race([waitReceipt, pollReceipt()]);

      if ((first as any)?.ok) {
        const rcpt = (first as any).rcpt;
        const ok = rcpt?.status === 1 || rcpt?.status === '0x1';
        this.addLog(`✅ [auto-swap][${runId}] confirmed via ${(first as any).kind} | status=${rcpt?.status} block=${rcpt?.blockNumber}`);

        if (ok) {
          (this as any).swapStatus = 'success';
          (this as any).swapError = null;
          try { const fn = (this as any).refreshBalances; if (typeof fn === 'function') await fn.call(this); } catch { }
          try { const toast = (this as any).addToast; if (typeof toast === 'function') toast({ kind: 'success', title: 'Swap confirmé', description: `Tx ${txResp.hash.slice(0, 10)}…` }); } catch { }
          this.addLog(`🎉 [auto-swap][${runId}] done`);
        } else {
          // Revert on-chain: re-quote & garder l’UX utilisable
          this.addLog(`❌ [auto-swap][${runId}] reverted (likely minOut) → refresh & keep UI ready`);
          try { const rq = (this as any).refreshQuote; if (typeof rq === 'function') await rq(); } catch { }
          (this as any).swapStatus = 'idle'; // réactive le bouton sur la nouvelle quote
          try { const toast = (this as any).addToast; if (typeof toast === 'function') toast({ kind: 'error', title: 'Route périmée', description: 'Prix mis à jour. Vous pouvez réessayer.' }); } catch { }
        }
      } else {
        // ni wait() ni poll n’ont fini dans la fenêtre → feedback UX explicite
        (this as any).swapStatus = 'idle';
        try { const toast = (this as any).addToast; if (typeof toast === 'function') toast({ kind: 'warning', title: 'Confirmation retardée', description: 'On continue à surveiller. Ré-ouvrez l’app si besoin.' }); } catch { }
        this.addLog(`⏱️ [auto-swap][${runId}] timeout waiting for receipt`);
      }

    } catch (e: any) {
      if (sigTicker) { try { clearInterval(sigTicker); } catch { } sigTicker = null; }

      const code = e?.code ?? e?.error?.code;
      const msg = (e?.message || e?.reason || e?.error?.message || '').toLowerCase?.() ?? '';
      const userRejected =
        code === 4001 || code === 5000 ||
        String(code).toUpperCase() === 'ACTION_REJECTED' ||
        /denied|rejected|user denied|user rejected|action_rejected/.test(msg);

      this.addLog(`❌ [auto-swap][${runId}] failed | code=${String(code)} msg="${msg.slice(0, 120)}" rejected=${userRejected}`);

      if (userRejected) {
        try {
          // On passe par ton flow cancel unifié
          this.cfCancel?.('user_rejected', 'trx');
        } catch {
          // fallback au cas où
          (this as any).swapStatus = 'cancelled';
          (this as any).swapError = 'USER_REJECTED';
        }
        return;
      }
      (this as any).swapStatus = 'error';
      (this as any).swapError = e?.message || 'AUTO_SWAP_FAILED';

    } finally {
      // cleanup guards + hash persistant
      (this as any)._txPromptLockUntil = 0;
      try { (this as any)._pauseQuoteTtl = false; } catch { }
      try { (this as any)._inWalletFlow = false; } catch { }
      try { if (!(this as any).swapHash) sessionStorage.removeItem('st/swapHash'); } catch { }
      this.addLog(`↩️ [auto-swap][${runId}] end | status=${(this as any).swapStatus}`);
    }
  }





















  /* async executeSwap() {
    this.addLog('🔥 [START] executeSwap');
  
    if (!this.quote || !this.provider || !this.takerAddress) {
      this.addLog('❌ Params manquants: '
        + `quote=${!!this.quote}, provider=${!!this.provider}, taker=${this.takerAddress || 'null'}`);
      console.error('❌ Quote / provider / takerAddress missing');
      return;
    }
    return await this.executeSwapLifi();
  
  }*/



  private async executeWrapUnwrap() {
    if (!this.provider) {
      console.error('❌ Provider manquant');
      return;
    }

    const signer = await this.provider.getSigner();
    const amountWei = this.toAmountDecimals(this.sellAmount, this.quote.sellTokenSymbol);

    // Adresse WETH Mainnet
    const WETH_ADDRESS = '0xC02aaa39b223FE8D0A0e5C4F27eAD9083C756Cc2';
    const wethAbi = [
      "function deposit() payable",
      "function withdraw(uint256 wad)"
    ];
    const wethContract = new ethers.Contract(WETH_ADDRESS, wethAbi, signer);

    if (this.quote.sellTokenSymbol === 'ETH' && this.quote.buyTokenSymbol === 'WETH') {
      console.log(`🔄 Wrapping ${this.sellAmount} ETH → WETH`);
      const tx = await wethContract["deposit"]({ value: amountWei });
      console.log('📜 TX hash =', tx.hash);
      await tx.wait();
      console.log('✅ Wrap terminé');
    }

    if (this.quote.sellTokenSymbol === 'WETH' && this.quote.buyTokenSymbol === 'ETH') {
      console.log(`🔄 Unwrapping ${this.sellAmount} WETH → ETH`);
      const tx = await wethContract["withdraw"](amountWei);
      console.log('📜 TX hash =', tx.hash);
      await tx.wait();
      console.log('✅ Unwrap terminé');
    }
  }
  async onClickExecuteSwap() {
    // 🔁 Soft reset deeplink/cooldown pour ce NOUVEAU run MAIN
    await this.softReloadBeforeRunIfNeeded('main');
    // 0) Gardes minimales
    if (!this.quote) { this.addLog('[main] click ignored: no quote'); return; }
    if (!this.isConnected) {
      this.addLog('[main] click ignored: wallet not connected');
      this.swapDisabled = true;
      this.swapReasons = ['WALLET_DISCONNECTED'];
      return;
    }
      // 🚫 CRITICAL: ne jamais toucher au wallet pendant un connect en cours
        if (this.isConnectInFlight()) {
            this.addLog('[main] execute blocked: wallet CONNECTING (skip disconnect)');
            this.swapReasons =['WALLET_CONNECTING'];
            return;
          }
          // ✅ Apex rule: check strict seulement ICI (Execute), jamais au fetchQuote.
            const ready = await this.ensureWalletReadyForExecute();
          if (!ready) {
              this.swapReasons =['WALLET_NOT_READY'];
              this.addLog('[main] execute blocked: wallet not ready -> HARD disconnect + reopen connect modal');
      
                // Lock court pour éviter double tap pendant la séquence
                this.swapDisabled = true;
      
                try {
                    await this.disconnectWalletLegacy('execute-not-ready');
                    this.addLog('[main] disconnectWalletLegacy done (execute-not-ready)');
                  } catch (e: any) {
                      this.addLog(`[main] disconnectWalletLegacy ERROR (ignored): ${e?.message || e}`);
                    }
      
                //// iOS/AppKit: laisser le temps au cleanup (overlay / session) de se terminer
                //await new Promise<void>((resolve) => setTimeout(resolve, 350));
      
                //try {
                //    // si ta signature prend un reason, passe-le ; sinon laisse vide
                //      this.connectWalletLegacy('execute-not-ready');
                //    this.addLog('[main] connectWalletLegacy triggered (execute-not-ready)');
                //  } catch (e: any) {
                //      this.addLog(`[main] connectWalletLegacy ERROR: ${e?.message || e}`);
                //    } finally {
                //  this.swapDisabled = false;
                //}
      
                return;
           }


    // 1) Clé de la MAIN + purge du contexte ALT (évite "alternative is executing")
    const mainKey = (this.getRouteKey?.(this.quote) || 'main').toString().toLowerCase();
    this.selectedAltKey = null;
    this.selectedAlternative = null;

    // 2) Verrou UI immédiat sur la MAIN
    this.validatingKey = mainKey;   // ✅ clé explicite de la main
    this.swapStatus = 'pending';
    this.swapHash = null;
    this.swapError = null;

    await this.cooldownAndResetWcSession('main');


    // 3) Pas d’ouverture immédiate → WC pur, on garde l’armement (allow) actif
    this.addLog('[main] no immediate deeplink (WC-style, allow kept)');

    // 4) Exécution asynchrone (simulate/approve/send) – états finaux gérés ailleurs
    setTimeout(() => this.executeSwap(), 120);
  }




    // ─────────────────────────────────────────────────────────────
    // EIP-1193 raw provider resolver (anti wrapper ethers)
    // ─────────────────────────────────────────────────────────────
    private getEip1193Provider(): any {
      try {
          // priorité: rawProvider (si tu le set dans attachEthersProvider)
            const raw = (this as any).rawProvider;
          if (raw && typeof raw.request === 'function') return raw;
    
            // fallback: unwrap ethers BrowserProvider
            const p: any = (this as any).provider;
          const inner = p?.provider ?? p?._provider ?? null;
          if (inner && typeof inner.request === 'function') return inner;
    
            return null;
        } catch { return null; }
    }

    private async eip1193Call < T = any > (method: string, params: any[] = [], timeoutMs = 1200): Promise < T | null > {
    const raw = this.getEip1193Provider();
    if (!raw) return null;
    try {
        const work = raw.request({ method, params }) as Promise<T>;
        const timed = new Promise<T | null>((resolve) => setTimeout(() => resolve(null), timeoutMs));
        return await Promise.race([work, timed]);
      } catch (e: any) {
          try { this.addLog?.(`[wallet][execute-guard] eip1193 ${method} error: ${e?.message || e}`); } catch { }
          return null;
        }
  }



      private async ensureWalletReadyForExecute(): Promise < boolean > {
    const addr = (this.takerAddress || '').trim();
    const cid = this.chainId;
    const hasProvider = !!(this as any).provider;
    const raw = this.getEip1193Provider();

      // wcLastUri = signal restorable, PAS preuve de ready
      let wcLastLen = 0;
    try { wcLastLen = (sessionStorage.getItem('st/wcLastUri') || '').length; } catch { wcLastLen = 0; }

      if (!addr || !cid || !hasProvider) {
          this.addLog(`[wallet][execute-guard] not ready (missing addr/chainId/provider) | addr=${!!addr} cid=${cid ?? 'null'} provider=${hasProvider}`);
          return false;
        }

      if (!raw) {
          this.addLog('[wallet][execute-guard] not ready (missing raw EIP-1193 request) -> wrapper-only state');
          return false;
        }

      // 1) eth_accounts doit contenir addr
      const accounts = await this.eip1193Call<string[]>('eth_accounts', [], 1200);
    const hasAddr = Array.isArray(accounts) && accounts.some(a => (a || '').toLowerCase() === addr.toLowerCase());
    if (!hasAddr) {
        this.addLog(`[wallet][execute-guard] not ready (eth_accounts mismatch) | want=${addr} got=${JSON.stringify(accounts || [])}`);
        return false;
      }

      // 2) eth_chainId doit matcher chainId
        const chainRaw = await this.eip1193Call<string | number>('eth_chainId', [], 1200);

        const chainDec = (() => {
          try {
            if (typeof chainRaw === 'number') return chainRaw;

            if (typeof chainRaw === 'string') {
              // hex strict (0x89)
              if (chainRaw.startsWith('0x')) {
                return parseInt(chainRaw, 16);
              }
              // decimal string ("137")
              return parseInt(chainRaw, 10);
            }

            return null;
          } catch {
            return null;
          }
        })();


      // 3) WC signal (soft) : session OU wcLastUri (fallback)
      const hasSession = !!(raw?.session || raw?.wc?.session || (this as any).provider?.session);
    const wcSignal = hasSession || wcLastLen > 0;
    if (!wcSignal) {
        this.addLog('[wallet][execute-guard] not ready (no WC signal: no session + no wcLastUri)');
        return false;
      }

      this.addLog(`[wallet][execute-guard] READY | addr=${addr} chainId=${cid} hasSession=${hasSession} wcLastLen=${wcLastLen}`);
   return true;
  }


  async executeSwapLifi(intentToken?: string): Promise<void> {
    // Helper local : détecter toutes les annulations utilisateur (MM mobile, EIP-1193, ethers v6)
    const isUserRejected = (e: any) => {
      const code = e?.code ?? e?.error?.code;
      const msg = (e?.message || e?.reason || e?.error?.message || '').toLowerCase?.() || '';
      return (
        code === 4001 ||                          // EIP-1193 standard
        code === 5000 ||
        code === -32000 ||   // MetaMask Mobile
        code === 'ACTION_REJECTED' ||             // ethers v6
        /action_rejected/.test(String(code).toLowerCase()) ||
        /denied|rejected|user denied|user rejected|cancel/.test(msg)
      );
    };

    // Log util minimal : extrait toutes les infos d’erreur courantes
    const extractErr = (e: any) => ({
      code: e?.code,
      message: e?.message,
      reason: e?.reason,
      // chemins fréquents sous WalletConnect/MetaMask
      error_code: e?.error?.code,
      error_message: e?.error?.message,
      info_error_code: e?.info?.error?.code,
      info_error_message: e?.info?.error?.message,
      data_original_code: e?.data?.originalError?.code,
      data_original_message: e?.data?.originalError?.message,
    });

    this.addLog('🌉 [LiFi] start');

    if (!this.provider) {
      this.addLog('❌ [LiFi] provider absent → invite à connecter');
      alert('Connecte ton wallet avant d’exécuter le swap.');
      return;
    }
    if (!this.quote?.transactionRequest) {
      this.addLog('⚠️ [LiFi] transactionRequest manquante dans la quote');
      alert('Pas de transaction prête à être exécutée.');
      return;
    }

    // === Helper snapshot (logs uniquement, aucune logique) ===
    const snapshot = (tag: string) => {
      this.addLog(
        `[UI] ${tag} | swapStatus=${this.swapStatus} | ` +
        `validatingKey=${String(this.validatingKey)} | ` +
        `selectedAltKey=${String(this.selectedAltKey)} | ` +
        `quoteHasTx=${!!this.quote?.transactionRequest} | ` +
        `visible=${(typeof document !== 'undefined' ? document.visibilityState : 'n/a')}`
      );
    };

    try {
      this.swapStatus = 'pending';
      this.swapError = null;
      this.swapHash = null;
      snapshot('enter-pending');

      const signer = await this.provider.getSigner();
      const address = await signer.getAddress();
      const { chainId } = await this.provider.getNetwork();
      this.addLog(`👛 [LiFi] signer=${address}, chainId=${Number(chainId)}`);

      const sellTokenAddr =
        this.quote.fromTokenAddress?.toLowerCase?.() ||
        this.quote.inTokenAddress?.toLowerCase?.() || '';
      this.addLog(`🔎 [LiFi] sellToken=${sellTokenAddr || '(n/a)'}`);
      if (!sellTokenAddr) throw new Error('Adresse du token source introuvable dans la quote.');

      // ─────────────────────────────────────────────────────────────
      // 1) APPROVE (si ERC20)
      // ─────────────────────────────────────────────────────────────
      if (sellTokenAddr !== ethers.ZeroAddress) {
        const spender = this.quote.allowanceTarget || this.quote.transactionRequest.to;
        const erc20 = new ethers.Contract(
          sellTokenAddr,
          [
            'function allowance(address owner, address spender) view returns (uint256)',
            'function approve(address spender, uint256 value) returns (bool)'
          ],
          signer
        );

        const allowance: bigint = await erc20['allowance'](address, spender);
        const amountRequired = BigInt(this.quote.inputAmountRaw || 0);
        this.addLog(`💳 [LiFi] allowance=${allowance.toString()} | required=${amountRequired.toString()} | spender=${spender}`);

        if (allowance < amountRequired) {
          this.addLog('🔑 [LiFi] Approve nécessaire → approve MaxUint256…');

          const resApprove = await this.gate.requestWithIntentEx(
            intentToken || this.gate.generateIntent('swap-erc20-approve', (m) => this.addLog(m)),
            async () => {
              (window as any).__allowWcDeeplinkFor?.(12_000);
              try {
                const approveTx = await erc20['approve'](spender, ethers.MaxUint256);
                this.addLog(`📤 [LiFi] Approve tx sent: ${approveTx.hash}`);
                const approveRcpt = await approveTx.wait();
                this.addLog(`✅ [LiFi] Approve confirmé: status=${approveRcpt?.status}`);
              } catch (e: any) {
                const info = extractErr(e);
                this.addLog(`[LiFi][approve] ❌ catch | code=${String(info.code)} / err.code=${String(info.error_code)} / info.err.code=${String(info.info_error_code)} / data.orig.code=${String(info.data_original_code)} | msg="${info.message || info.reason || info.error_message || info.info_error_message || info.data_original_message || ''}"`);
                if (isUserRejected(e)) {
                  throw { __userRejected: true, code: info.code ?? info.error_code, message: info.message, meta: info };
                }
                throw e;
              }
            },
            {
              ctx: 'swap:erc20-approve',
              log: (m) => this.addLog(m),
              preserveTokenOnSuccess: true,
              timeoutMs: 180_000,
            }
          );

          if (!resApprove.ok) {
            this.addLog(`[gate][approve] not ok | reason=${resApprove.reason} | err=${JSON.stringify((resApprove as any).error ?? {}, null, 2).slice(0, 1000)}`);

            const canceled =
              resApprove.reason === 'user-rejected' ||
              (resApprove as any).error?.__userRejected === true;

            if (canceled) {
              this.addLog('⛔ [LiFi] Approve annulée → reset doux + hard reload + cooldown deeplink');
              try { setWcSuppressOnce?.(8000); } catch { }
              try { sessionStorage.setItem('st/skipWcDeeplinkOnce', '1'); } catch { }
              this.swapError = this.translate.instant('USER_CANCELLED');
              this.swapStatus = 'cancelled';
              //this.closeQuoteWithReason('cancel-approve');
              //await this.forceReconnectWalletSession('cancel-approve');
              return;
            }

            if (resApprove.reason === 'timeout') {
              this.addLog('⏱️ [LiFi] Approve timeout → STOP + cooldown deeplink');
              try { setWcSuppressOnce?.(8000); } catch { }
              try { sessionStorage.setItem('st/skipWcDeeplinkOnce', '1'); } catch { }
              this.swapStatus = 'idle';
              this.swapError = this.translate.instant('WALLET_TIMEOUT');
              //this.closeQuoteWithReason('cancel-approve');
              //await this.forceReconnectWalletSession('cancel-approve');

              return;
            }

            this.addLog('⚠️ [LiFi] Approve erreur → STOP');
            this.swapStatus = 'error';
            this.swapError = this.translate.instant('UNEXPECTED_ERROR');
            return;
          }
        } else {
          this.addLog('✅ [LiFi] Approve suffisante → pas d’approve');
        }
      } else {
        this.addLog('⛽ [LiFi] Token natif → skip approve');
      }

      // ─────────────────────────────────────────────────────────────
      // 2) SEND SWAP TX
      // ─────────────────────────────────────────────────────────────
      const tr = this.quote.transactionRequest;
      const txRequestRaw: any = {
        to: tr.to,
        data: tr.data,
        value: tr.value ?? '0x0',
        from: address
      };

      const sanitizeTxForWallet = (tx: any) => {
        const { gas, gasLimit, gasPrice, maxFeePerGas, maxPriorityFeePerGas, type, ...rest } = tx || {};
        return rest;
      };
      const txRequest = sanitizeTxForWallet(txRequestRaw);

      this.addLog(
        '📦 [LiFi] TX ready (wallet-estimated fees): ' +
        `to=${txRequest.to}, dataLen=${(txRequest.data || '').length}, ` +
        `value=${txRequest.value}, fees='(auto by wallet)'`
      );

      let txResponse: any;
      snapshot('before-send-intent');
      const resSend = await this.gate.requestWithIntentEx(
        intentToken || this.gate.generateIntent('swap-send', (m) => this.addLog(m)),
        async () => {
          (window as any).__allowWcDeeplinkFor?.(12_000);
          try {
            txResponse = await signer.sendTransaction(txRequest);
            this.addLog(`📤 [LiFi] TX sent: ${txResponse.hash}`);
            // 🔸 Hash obtenu → on désarme le timeout local "cancel:trx"
            if (txResponse?.hash) { this.cfOnHash?.('trx'); }
          } catch (e: any) {
            const info = extractErr(e);
            this.addLog(`[LiFi][send] ❌ catch | code=${String(info.code)} / err.code=${String(info.error_code)} / info.err.code=${String(info.info_error_code)} / data.orig.code=${String(info.data_original_code)} | msg="${info.message || info.reason || info.error_message || info.info_error_message || info.data_original_message || ''}"`);
            if (isUserRejected(e)) {
              this.cfCancel?.('user_rejected', 'trx');
              throw { __userRejected: true, code: info.code ?? info.error_code, message: info.message, meta: info };
            }
            throw e;
          }
        },
        {
          ctx: 'swap:send',
          log: (m) => this.addLog(m),
          preserveTokenOnSuccess: false,
          timeoutMs: 30_000,
        }
      );

      if (!resSend.ok) {
        snapshot('send-result-not-ok');
        this.addLog(`[gate][send] not ok | reason=${resSend.reason} | err=${JSON.stringify((resSend as any).error ?? {}, null, 2).slice(0, 1000)}`);

        const canceled =
          resSend.reason === 'user-rejected' ||
          (resSend as any).error?.__userRejected === true;

        if (canceled) {
          // 🔸 Cancel côté gate (aucun hash) → cancel-flow (trx)
          this.cfCancel?.('user_rejected', 'trx');
          this.addLog('⛔ [LiFi] Envoi annulé → reset doux + hard reload + cooldown deeplink');
          try { setWcSuppressOnce?.(8000); } catch { }
          try { sessionStorage.setItem('st/skipWcDeeplinkOnce', '1'); } catch { }
          this.swapStatus = 'cancelled';
          this.swapError = this.translate.instant('USER_CANCELLED');
          //this.closeQuoteWithReason('cancel-send');
          //await this.forceReconnectWalletSession('cancel-send');
          snapshot('after-cancel-reset');
          return;
        }

        if (resSend.reason === 'timeout') {
          // 🔸 Timeout avant hash → cancel-flow (trx: timeout)
          this.cfCancel?.('timeout', 'trx');
          this.addLog('⏱️ [LiFi] Envoi timeout → reset doux + force reconnect + cooldown deeplink');
          try { setWcSuppressOnce?.(8000); } catch { }
          try { sessionStorage.setItem('st/skipWcDeeplinkOnce', '1'); } catch { }

          this.swapStatus = 'idle';
          this.swapError = this.translate.instant('WALLET_TIMEOUT');

          // [+] abort explicite de la session WC (évite l’UI bloquée en "en cours")
          try { await (this as any).abortWalletConnectSafely?.call?.(this, 'timeout-send'); } catch { }


          //this.closeQuoteWithReason('timeout-send');
          //await this.forceReconnectWalletSession('timeout-send');
          snapshot('after-timeout-reset');
          try { this.validatingKey = null; } catch { }
          return;
        }

        this.addLog('⚠️ [LiFi] Envoi erreur → STOP');
        this.swapStatus = 'error';
        this.swapError = this.translate.instant('UNEXPECTED_ERROR');
        return;
      }

      snapshot('after-send-ok-waiting-receipt');
      this.addLog('⏳ [LiFi] Attente receipt…');
      const receipt = await txResponse.wait();
      this.addLog(`✅ [LiFi] TX confirmé: status=${receipt?.status}, block=${receipt?.blockNumber}`);

      this.swapStatus = 'success';
      this.swapHash = txResponse.hash;

    } catch (err: any) {
      snapshot('final-catch');
      const info = {
        code: err?.code,
        message: err?.message,
        reason: err?.reason,
        error_code: err?.error?.code,
        error_message: err?.error?.message,
        info_error_code: err?.info?.error?.code,
        info_error_message: err?.info?.error?.message,
        data_original_code: err?.data?.originalError?.code,
        data_original_message: err?.data?.originalError?.message,
      };
      this.addLog(`❌ [LiFi] Erreur (final catch): code=${String(info.code)} / err.code=${String(info.error_code)} / info.err.code=${String(info.info_error_code)} / data.orig.code=${String(info.data_original_code)} | msg="${info.message || info.reason || info.error_message || info.info_error_message || info.data_original_message || ''}"`);

      const msg = err?.message || String(err);
      this.swapStatus = 'error';
      this.swapError = msg;

    } finally {
      // [+] Normalisation UI : si on n’est plus en pending, on libère la clé de validation
      if (this.swapStatus !== 'pending') {
        if (this.validatingKey) { this.addLog(`[UI] finalize: clearing validatingKey=${this.validatingKey}`); }
        try { this.validatingKey = null; } catch { }
      }
    }
  }











  //async executeSwap() {
  //  console.log('🔥 [START] executeSwap triggered');

  //  if (!this.quote || !this.provider || !this.takerAddress) {
  //    console.error('❌ Quote / provider / takerAddress missing');
  //    return;
  //  }

  //  const sourceStr = String(this.quote.Source ?? this.quote.source ?? '').toLowerCase();
  //  const isZeroXPermit2 = sourceStr.includes('0x permit2');

  //  if (isZeroXPermit2 && this.quote.IsPermit2) {
  //    return await this.executeSwapOx();
  //  } else {
  //    return await this.executeSwapOpenOcean();
  //  }
  //}

  /**
   * 🔹 Mode 0x Permit2 → Envoi direct avec Permit2 signé
   */
  async executeSwapOx() {
    if (!this.provider) {
      console.error('❌ Provider non initialisé');
      return;
    }

    const signer = await this.provider.getSigner();
    console.log('🟣 Mode 0x Permit2 détecté (One‑Click)');

    // ✅ Récupération sécurisée des valeurs critiques
    const permitAmount =
      this.quote.PermitAmount ??
      this.quote.permitAmount ??
      this.quote.amountDecimals ??
      null;

    const sellTokenAddr = this.quote.SellTokenAddress ?? this.quote.sellTokenAddress ?? '';
    const permitDeadline = this.quote.PermitDeadline ?? this.quote.permitDeadline ?? '0';
    const permitNonce = this.quote.PermitNonce ?? this.quote.permitNonce ?? '0';
    const txTo = this.quote.TransactionTo ?? this.quote.transactionTo ?? '';
    const txData = this.quote.TransactionData
      ?? this.quote.transactionData
      ?? this.quote.data // fallback si TransactionData manquant
      ?? '';
    const txValue = this.quote.TransactionValue ?? this.quote.transactionValue ?? '0';

    // 🔍 Log des champs critiques pour debug
    console.log('🔍 Champs critiques 0x Permit2 :', {
      permitAmount,
      sellTokenAddr,
      permitDeadline,
      permitNonce,
      txTo,
      txValue,
      txDataPreview: txData ? txData.slice(0, 20) + '...' : '(vide)'
    });

    try {
      if (!permitAmount || permitAmount === '0') {
        throw new Error('Montant Permit2 manquant');
      }

      // 1️⃣ Génération de la signature Permit2 EIP‑712
      console.log('🔏 Génération de la signature Permit2...');
      const { permit, signature } = await this.buildPermitAndSign({
        token: sellTokenAddr,
        amount: BigInt(permitAmount),
        expiration: BigInt(permitDeadline),
        nonce: BigInt(permitNonce),
        spender: txTo,
        sigDeadline: BigInt(permitDeadline)
      });

      // 2️⃣ Encodage Permit2
      const encodedPermit = encodePermitSingle(await signer.getAddress(), permit, signature);
      this.permit = permit;
      this.permitSig = signature;
      this.quote.permit = encodedPermit;
      console.log('✅ Permit2 signé et encodé');

      // 3️⃣ Injection dans transactionData
      const finalTxData = this.injectPermitIntoCalldata(txData, encodedPermit);

      // 4️⃣ Envoi direct du swap
      this.swapStatus = 'pending';
      console.log('🚀 Envoi du swap avec Permit2 inclus...');
      const tx = await signer.sendTransaction({
        to: txTo,
        data: finalTxData,
        value: BigInt(txValue ?? '0'),
        gasLimit: BigInt(350_000)
      });

      console.log('📜 TX envoyée :', tx.hash);
      await tx.wait();

      this.swapStatus = 'success';
      this.swapHash = tx.hash;
      this.swapError = null;
    } catch (err: any) {
      console.error('❌ Swap 0x Permit2 failed:', err);
      this.swapStatus = 'error';
      this.swapError = err?.message || 'Swap Permit2 error';
    }
  }

  private injectPermitIntoCalldata(originalData: string, encodedPermit: string): string {
    const cleanPermit = encodedPermit.replace(/^0x/, '').toLowerCase();
    const cleanData = originalData.toLowerCase();

    // On cherche un placeholder rempli uniquement de zéros
    const zeroPattern = '0'.repeat(cleanPermit.length);
    const idx = cleanData.indexOf(zeroPattern);

    if (idx > 0) {
      console.log(`✅ Permit2 injecté dans calldata à l'offset ${idx}`);
      return '0x' + cleanData.substring(0, idx) + cleanPermit + cleanData.substring(idx + cleanPermit.length);

    }

    console.warn('⚠️ Impossible de trouver le placeholder du Permit2 dans calldata');
    return originalData.startsWith('0x') ? originalData : '0x' + originalData;
  }

  private async buildWrapUnwrapQuote() {
    // Estimation gas (unwrap ~20k gas, wrap ~23k gas)
    const estimatedGas = this.sellTokenSymbol === 'WETH' ? 20000 : 23000;

    // Récupère prix natif (ETH)
    const nativeUsd = await this.fetchNativeTokenUsd();

    // Convertit montant sell en wei
    const sellAmountWei = this.toAmountDecimals(this.sellAmount, this.sellTokenSymbol);

    // Calcule coût gas en wei
    const feeData = await this.provider?.getFeeData();
    const gasPriceWei = feeData?.gasPrice ?? 0n;
    const fullGasWei = BigInt(estimatedGas) * (gasPriceWei ?? 0n);

    this.quote = {
      sellTokenSymbol: this.sellTokenSymbol,
      buyTokenSymbol: this.buyTokenSymbol,
      formattedSellAmount: this.sellAmount,
      formattedBuyAmount: this.sellAmount, // wrap/unwrap = 1:1
      sellTokenUsdPrice: nativeUsd,
      buyTokenUsdPrice: nativeUsd,
      estimatedGas,
      gasPriceWei: gasPriceWei.toString(),
      totalNetworkFee: fullGasWei.toString(),
      source: 'Native Wrap/Unwrap',
    };

    this.fullGasWei = fullGasWei;
    this.gasPriceWei = gasPriceWei;
    this.nativeTokenUsd = nativeUsd;

    console.log('💡 Fake quote wrap/unwrap générée :', this.quote);
  }

  // 🛡️ Détection native synchronisée avec backend GetWrappedTokenAddress()
  private isNativeToken(address: string, chainId: number): boolean {
    const lower = address?.toLowerCase();
    if (!lower) return false;

    // Adresses natives génériques
    if (
      lower === '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee' ||
      lower === '0x0000000000000000000000000000000000000000'
    ) {
      return true;
    }

    // Adresses natives spécifiques par réseau
    const nativeByChain: Record<number, string[]> = {
      137: ['0x0000000000000000000000000000000000001010'], // MATIC sur Polygon
    };

    return nativeByChain[chainId]?.includes(lower) ?? false;
  }

  async executeSwapOpenOcean() {
    if (!this.provider) {
      console.error('❌ Provider non initialisé');
      return;
    }

    const signer = await this.provider.getSigner();
    const network = await this.provider.getNetwork();
    const chainId = Number(network.chainId);

    // 🔹 ULTRA mode (Permit2 / Gasless)
    if (this.enablePermit2 && this.quote.IsPermit2) {
      console.log('🟢 Mode OpenOcean ULTRA détecté');
      const swapBody = this.buildSwapBodyForUltra();

      try {
        this.swapStatus = 'pending';
        const swapResp = await firstValueFrom(this.swapApi.getGaslessSwap(swapBody));

        if (!swapResp?.to || !swapResp?.data) {
          throw new Error('Réponse incomplète du backend OpenOcean');
        }

        const tx = await signer.sendTransaction({
          to: swapResp.to,
          data: swapResp.data,
          value: BigInt(swapResp.value ?? '0'),
          gasLimit: BigInt(300_000)
        });

        console.log('🚀 TX ULTRA envoyée :', tx.hash);
        await tx.wait();

        this.swapStatus = 'success';
        this.swapHash = tx.hash;
        this.swapError = null;
      } catch (err: any) {
        console.error('❌ ULTRA OpenOcean fail:', err);
        this.swapStatus = 'error';
        this.swapError = err?.message || 'Erreur OpenOcean ULTRA';
      }
      return;
    }

    // 🔹 CLASSIQUE mode
    try {
      console.log('🟡 Mode OpenOcean Classique détecté');
      console.log('📦 Quote Classique reçue :', JSON.stringify(this.quote, null, 2));

      const takerTokenLower = this.quote.value?.takerToken?.toLowerCase();
      const isNative = this.isNativeToken(takerTokenLower, chainId);

      const target = this.quote.target ?? this.quote.Target ?? this.quote.to ?? this.quote.To ?? null;
      console.log("🎯 Target détecté pour Classic :", target);

      if (!target) {
        throw new Error("❌ Target manquant dans la quote classique");
      }

      const valueToSend = isNative ? BigInt(this.quote.value.takerTokenAmount) : 0n;

      // 🔍 Approve uniquement si ERC20
      if (!isNative) {
        console.log("🔍 Token ERC20 détecté → vérification allowance...");
        const erc20 = new Contract(
          this.quote.value.takerToken,
          [
            'function allowance(address,address) view returns(uint256)',
            'function approve(address,uint256) returns(bool)'
          ],
          signer
        );

        const owner = await signer.getAddress();
        const allowance: bigint = await erc20['allowance'](owner, target);
        const required: bigint = BigInt(this.quote.value.takerTokenAmount);

        if (allowance < required) {
          this.swapStatus = 'approve';
          const txA = await erc20['approve'](target, required);
          await txA.wait();
          console.log('✅ Approve confirmé');
        } else {
          console.log("✅ Allowance suffisante, approve inutile");
        }
      } else {
        console.log("💡 Pas d'approve nécessaire : token natif détecté");
      }

      // 🚀 Envoi de la transaction de swap
      this.swapStatus = 'pending';

      console.log("🧾 Dernière vérification avant envoi de TX :");
      console.log("🔹 Target        :", target);
      console.log("🔹 Amount        :", valueToSend.toString());
      console.log("🔹 Data (truncated) :", this.quote.data?.slice(0, 50) + '...');
      console.log("🔹 GasLimit     :", '350000');
      console.log("🔹 Token natif  :", isNative);
      console.log("🔹 TakerToken   :", this.quote.value?.takerToken);
      console.log("🔹 TakerAmount  :", this.quote.value?.takerTokenAmount);
      console.log("🔹 ChainId      :", chainId);

      const tx = await signer.sendTransaction({
        to: target,
        data: this.quote.data,
        value: valueToSend,
        gasLimit: BigInt(350_000)
      });

      console.log('🚀 TX Classique envoyée :', tx.hash);
      await tx.wait();

      this.swapStatus = 'success';
      this.swapHash = tx.hash;
      this.swapError = null;
    } catch (e: any) {
      console.error('❌ Classic fail :', e);
      this.swapStatus = 'error';
      this.swapError = e?.message || 'Erreur swap classique';
    }
  }










  selectSellToken(symbol: string) {
    console.log('[selectSellToken] →', symbol);
    console.trace();
    this.sellTokenSymbol = symbol;

    // ⚡ règle auto : choisir le premier token ≠ sell dans popularTokens (trié par volume)
    if (this.buyTokenSymbol == symbol) {
      const next = this.popularTokens.find(t => t.symbol !== symbol);
      if (next) {
        this.buyTokenSymbol = next.symbol;
      }
    }
  }


  getSellTokenName(symbol: string) {
    const t = this.filteredSellTokens.find(t => t.symbol === symbol);
    return t?.name || '';
  }












  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text);
    this.translate.get('COPY_SIGNATURE').subscribe((message: string) => {
      alert(message);
    });
  }
}





